/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import {
  cacheExchange,
  Resolver as GraphCacheResolver,
  UpdateResolver as GraphCacheUpdateResolver,
  OptimisticMutationResolver as GraphCacheOptimisticMutationResolver,
} from '@urql/exchange-graphcache';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
  /** Arbitrary JSON value */
  JSON: {
    input: Record<string, unknown> | unknown[] | string | number | boolean | null;
    output: Record<string, unknown> | unknown[] | string | number | boolean | null;
  };
};

/** Error when a user has an active payment method */
export type ActivePaymentMethodError = UserError & {
  readonly __typename?: 'ActivePaymentMethodError';
  readonly errorMessage: Scalars['String']['output'];
};

export type AddAddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type AddAddressResponseUnion = AddAddressSuccess | InvalidAddress | ValidationError;

export type AddAddressSuccess = {
  readonly __typename?: 'AddAddressSuccess';
  readonly address: Address;
};

export type AddAddressV2Input = {
  readonly city: Scalars['String']['input'];
  /** 2 letter country code */
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter state code */
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type AddLineItemBatchToCartInput = {
  readonly lineItems: ReadonlyArray<CartInput>;
};

export type AddLineItemToCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: InputMaybe<Scalars['Int']['input']>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type AddLineItemToCartResponseUnion =
  | AddLineItemToCartSuccess
  | LineItemModificationsInvalidException
  | LocationClosed
  | LoyaltyScanTokenExpired
  | MaxEntreeReached
  | MaxModificationsExceeded
  | OrderLocked
  | ProductOutOfStock
  | ProductUnavailable
  | RestaurantHoursMissing
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type AddLineItemToCartSuccess = {
  readonly __typename?: 'AddLineItemToCartSuccess';
  readonly cart: Order;
};

export type AddLineItemToCartWithLoyaltyInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  /** @deprecated Use customerToken instead */
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: InputMaybe<Scalars['Int']['input']>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type Addons = {
  readonly __typename?: 'Addons';
  readonly products: ReadonlyArray<Product>;
};

export type Address = {
  readonly __typename?: 'Address';
  readonly city: Scalars['String']['output'];
  /** 2 letter country code  */
  readonly country: Scalars['String']['output'];
  readonly deliveryPreference: DeliveryPreferenceType;
  /** @deprecated Migrating off google. Use lat/lng */
  readonly googlePlaceId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly notes: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  readonly secondaryStreet: Maybe<Scalars['String']['output']>;
  /** 2 letter state code  */
  readonly state: Scalars['String']['output'];
  /** Address Line 1 */
  readonly street: Scalars['String']['output'];
  readonly zipCode: Scalars['String']['output'];
};

/** Template last applied to a restaurant from SG Admin or Gravy Admin. A snapshot: the store's print order can differ after later template or Gravy edits, and it survives the template's deletion. */
export type AdminAppliedPrintTemplate = {
  readonly __typename?: 'AdminAppliedPrintTemplate';
  readonly appliedAt: Scalars['String']['output'];
  readonly appliedBy: Scalars['String']['output'];
  readonly templateId: Scalars['ID']['output'];
  readonly templateName: Scalars['String']['output'];
};

/** A change to a group ordering setting */
export type AdminGroupOrderSettingAudit = {
  readonly __typename?: 'AdminGroupOrderSettingAudit';
  /** create or update */
  readonly action: Scalars['String']['output'];
  readonly after: Maybe<Scalars['String']['output']>;
  /** The value before; null when created */
  readonly before: Maybe<Scalars['String']['output']>;
  /** Who made the change; null when unknown */
  readonly changedBy: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
};

/** Group ordering settings */
export type AdminGroupOrderSettings = {
  readonly __typename?: 'AdminGroupOrderSettings';
  /** Changes, newest first (at most 100) */
  readonly history: ReadonlyArray<AdminGroupOrderSettingAudit>;
  /** Max entrees per group order; 15 by default */
  readonly maxEntreeLimit: Scalars['Int']['output'];
  /** Whether the default limit applies */
  readonly maxEntreeLimitIsDefault: Scalars['Boolean']['output'];
};

/** Group ordering settings */
export type AdminGroupOrderSettingsHistoryArgs = {
  count?: Scalars['Int']['input'];
};

/** Global chit print zone; index is the default print order */
export type AdminMasterZone = {
  readonly __typename?: 'AdminMasterZone';
  readonly id: Scalars['Int']['output'];
  readonly index: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
};

export type AdminOrder = {
  readonly __typename?: 'AdminOrder';
  readonly couponDiscountCents: Maybe<Scalars['Int']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly creditAppliedCents: Maybe<Scalars['Int']['output']>;
  readonly customer: Maybe<AdminOrderCustomer>;
  readonly delivery: Maybe<AdminOrderDelivery>;
  readonly discounts: ReadonlyArray<AdminOrderDiscount>;
  readonly externalReferenceId: Maybe<Scalars['String']['output']>;
  readonly fees: ReadonlyArray<AdminOrderFee>;
  readonly fulfillmentRestaurantId: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lineItems: ReadonlyArray<AdminOrderLineItem>;
  readonly orderSource: Maybe<Scalars['String']['output']>;
  readonly orderType: AdminOrderType;
  readonly restaurant: AdminOrderRestaurant;
  /** Order-level special instruction notes */
  readonly specialInstructions: ReadonlyArray<Scalars['String']['output']>;
  /** Raw Gravy order state */
  readonly state: Maybe<Scalars['String']['output']>;
  readonly subtotalCents: Scalars['Int']['output'];
  readonly taxCents: Scalars['Int']['output'];
  /** The order's restaurant time zone, for store-local display */
  readonly timeZone: Scalars['String']['output'];
  readonly tipCents: Scalars['Int']['output'];
  readonly totalCents: Scalars['Int']['output'];
  readonly tracking: Maybe<Scalars['String']['output']>;
  readonly wantedTime: Maybe<Scalars['DateTime']['output']>;
};

export type AdminOrderAddress = {
  readonly __typename?: 'AdminOrderAddress';
  readonly city: Maybe<Scalars['String']['output']>;
  readonly notes: Maybe<Scalars['String']['output']>;
  readonly secondaryStreet: Maybe<Scalars['String']['output']>;
  readonly state: Maybe<Scalars['String']['output']>;
  readonly street: Maybe<Scalars['String']['output']>;
  readonly zipCode: Maybe<Scalars['String']['output']>;
};

export type AdminOrderCustomer = {
  readonly __typename?: 'AdminOrderCustomer';
  readonly email: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly phone: Maybe<Scalars['String']['output']>;
};

export type AdminOrderCustomerSummary = {
  readonly __typename?: 'AdminOrderCustomerSummary';
  readonly email: Maybe<Scalars['String']['output']>;
  readonly name: Maybe<Scalars['String']['output']>;
};

export type AdminOrderDelivery = {
  readonly __typename?: 'AdminOrderDelivery';
  readonly address: Maybe<AdminOrderAddress>;
  readonly courierTipCents: Maybe<Scalars['Int']['output']>;
  readonly deliveredAt: Maybe<Scalars['DateTime']['output']>;
  readonly deliveryFeeCents: Maybe<Scalars['Int']['output']>;
  readonly estimatedDeliveryTime: Maybe<Scalars['String']['output']>;
  readonly terminalStatus: Maybe<Scalars['String']['output']>;
  readonly vendor: Maybe<Scalars['String']['output']>;
};

export type AdminOrderDiscount = {
  readonly __typename?: 'AdminOrderDiscount';
  readonly amountCents: Scalars['Int']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
};

export type AdminOrderFee = {
  readonly __typename?: 'AdminOrderFee';
  readonly amountCents: Scalars['Int']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
};

export type AdminOrderLineItem = {
  readonly __typename?: 'AdminOrderLineItem';
  readonly costCents: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly modifiers: ReadonlyArray<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly quantity: Scalars['Int']['output'];
};

export type AdminOrderPage = {
  readonly __typename?: 'AdminOrderPage';
  readonly nextCursor: Maybe<Scalars['String']['output']>;
  readonly orders: ReadonlyArray<AdminOrderSummary>;
};

export type AdminOrderRestaurant = {
  readonly __typename?: 'AdminOrderRestaurant';
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
};

export enum AdminOrderState {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
}

export type AdminOrderSummary = {
  readonly __typename?: 'AdminOrderSummary';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly customer: Maybe<AdminOrderCustomerSummary>;
  readonly id: Scalars['ID']['output'];
  readonly orderSource: Maybe<Scalars['String']['output']>;
  readonly orderType: AdminOrderType;
  readonly restaurant: AdminOrderRestaurant;
  /** Raw Gravy order state */
  readonly state: Maybe<Scalars['String']['output']>;
  /** The order's restaurant time zone, for store-local display */
  readonly timeZone: Scalars['String']['output'];
  readonly totalCents: Scalars['Int']['output'];
  readonly tracking: Maybe<Scalars['String']['output']>;
  readonly wantedTime: Maybe<Scalars['DateTime']['output']>;
};

export enum AdminOrderType {
  Catering = 'CATERING',
  CateringDelivery = 'CATERING_DELIVERY',
  CateringPickup = 'CATERING_PICKUP',
  Delivery = 'DELIVERY',
  InStore = 'IN_STORE',
  Outpost = 'OUTPOST',
  Pickup = 'PICKUP',
}

export type AdminOrdersInput = {
  /** The previous page's nextCursor */
  readonly after?: InputMaybe<Scalars['String']['input']>;
  /** Exact lookup: the external reference id */
  readonly externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  /** Page size, 50 by default and at most 100 */
  readonly first?: InputMaybe<Scalars['Int']['input']>;
  /** Exact lookup: the Gravy order id */
  readonly orderId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter (all modes) */
  readonly orderSources?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Filter (all modes) */
  readonly orderTypes?: InputMaybe<ReadonlyArray<AdminOrderType>>;
  /** Browse mode: restrict to these Gravy restaurant ids (window <= 31 days) */
  readonly restaurantIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Filter (all modes). Defaults to [COMPLETE, CANCELED] */
  readonly states?: InputMaybe<ReadonlyArray<AdminOrderState>>;
  /** Exact lookup: the tracking code */
  readonly tracking?: InputMaybe<Scalars['String']['input']>;
  /** Browse mode: window start */
  readonly wantedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Browse mode: window end */
  readonly wantedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A reason for 86ing an item, from Gravy's active list */
export type AdminOutOfStockReason = {
  readonly __typename?: 'AdminOutOfStockReason';
  /** Pass as reasonKey */
  readonly key: Scalars['ID']['output'];
  readonly label: Scalars['String']['output'];
};

/** An ingredient in a restaurant print order zone */
export type AdminPrintOrderIngredient = {
  readonly __typename?: 'AdminPrintOrderIngredient';
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  /** The label the chit prints: print name, else name */
  readonly printName: Scalars['String']['output'];
};

/** One zone of a restaurant's current chit print order, grouped as Gravy's kitchen chit (Kitchen::IngredientsByZone) groups it */
export type AdminPrintOrderZone = {
  readonly __typename?: 'AdminPrintOrderZone';
  /** Master zone id; null for Undefined and for Not printed on chits */
  readonly id: Maybe<Scalars['Int']['output']>;
  /** Ingredients in print order */
  readonly ingredients: ReadonlyArray<AdminPrintOrderIngredient>;
  readonly name: Scalars['String']['output'];
};

/** Ingredient row available to the print priority template builder. Deliberately unfiltered: print priority is stored per ingredient row, so every row (retired included) belongs in the picker. */
export type AdminPrintPriorityIngredient = {
  readonly __typename?: 'AdminPrintPriorityIngredient';
  readonly active: Scalars['Boolean']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
};

/** Chit print priority template, shared with Gravy Admin. Applying a template to a restaurant rewrites its ingredient zones and per-ingredient print order. */
export type AdminPrintPriorityTemplate = {
  readonly __typename?: 'AdminPrintPriorityTemplate';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  /** ISO timestamp of last update */
  readonly updatedAt: Maybe<Scalars['String']['output']>;
  /** Zones in template print order */
  readonly zones: ReadonlyArray<AdminPrintPriorityTemplateZone>;
};

/** Ordered chit print zone within a print priority template */
export type AdminPrintPriorityTemplateZone = {
  readonly __typename?: 'AdminPrintPriorityTemplateZone';
  /** Master zone id */
  readonly id: Scalars['Int']['output'];
  /** Ingredient ids assigned to this zone, in print order */
  readonly ingredientIds: ReadonlyArray<Scalars['Int']['output']>;
};

export type AdminPrintPriorityTemplateZoneInput = {
  /** Master zone id */
  readonly id: Scalars['Int']['input'];
  /** Ingredient ids assigned to this zone, in print order. Defaults to empty. */
  readonly ingredientIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

/** One entry in the global product upsells' Gravy audit history */
export type AdminProductUpsellAudit = {
  readonly __typename?: 'AdminProductUpsellAudit';
  /** create, update or destroy */
  readonly action: Scalars['String']['output'];
  /** Who made the change; null when unknown */
  readonly changedBy: Maybe<Scalars['String']['output']>;
  readonly changes: ReadonlyArray<AdminProductUpsellAuditChange>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  /** Id of the changed record */
  readonly recordId: Scalars['ID']['output'];
  /** The product or category name; for a deleted category, its name when deleted; otherwise null when the record no longer exists */
  readonly recordName: Maybe<Scalars['String']['output']>;
  readonly recordType: AdminProductUpsellAuditRecordType;
};

/** One changed field of a product upsell audit entry */
export type AdminProductUpsellAuditChange = {
  readonly __typename?: 'AdminProductUpsellAuditChange';
  /** JSON-encoded value after the change; null when there is none */
  readonly after: Maybe<Scalars['String']['output']>;
  /** JSON-encoded value before the change; null when there was none */
  readonly before: Maybe<Scalars['String']['output']>;
  /** Column name, e.g. upsell_ranking */
  readonly field: Scalars['String']['output'];
};

/** Kind of Gravy record a product upsell audit entry changed */
export enum AdminProductUpsellAuditRecordType {
  /** A master product's upsell ranking or category */
  MasterProduct = 'MASTER_PRODUCT',
  /** An upsell category */
  UpsellCategory = 'UPSELL_CATEGORY',
}

/** Admin view of one restaurant for Restaurant Config */
export type AdminRestaurant = {
  readonly __typename?: 'AdminRestaurant';
  readonly id: Scalars['ID']['output'];
  /** Outposts use their parent restaurant's print order, so templates can't be applied */
  readonly isOutpost: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** The restaurant's current chit print order, including later edits made in Gravy Admin. An outpost shows its parent's order, which its chits use. */
  readonly printOrder: ReadonlyArray<AdminPrintOrderZone>;
  readonly printTemplate: Maybe<AdminAppliedPrintTemplate>;
};

/** One entry in a restaurant's Gravy audit log */
export type AdminRestaurantAudit = {
  readonly __typename?: 'AdminRestaurantAudit';
  /** create, update or destroy */
  readonly action: Scalars['String']['output'];
  /** Who made the change: the SG Admin or Gravy Admin user, or menu-svc for its jobs; null when unknown */
  readonly changedBy: Maybe<Scalars['String']['output']>;
  readonly changes: ReadonlyArray<AdminRestaurantAuditChange>;
  /** Comment saved with the change, such as the reason an item was 86’d */
  readonly comment: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  /** Id of the changed record */
  readonly recordId: Scalars['ID']['output'];
  /** The restaurant, ingredient or product name; null when the record no longer exists */
  readonly recordName: Maybe<Scalars['String']['output']>;
  readonly recordType: AdminRestaurantAuditRecordType;
};

/** One changed field of an audit entry */
export type AdminRestaurantAuditChange = {
  readonly __typename?: 'AdminRestaurantAuditChange';
  /** JSON-encoded value after the change; null when there is none */
  readonly after: Maybe<Scalars['String']['output']>;
  /** JSON-encoded value before the change; null when there was none */
  readonly before: Maybe<Scalars['String']['output']>;
  /** Column name; a changed key inside a hash column is named column.key, e.g. settings.lead_minutes */
  readonly field: Scalars['String']['output'];
};

/** A page of a restaurant's audit log, newest first */
export type AdminRestaurantAuditPage = {
  readonly __typename?: 'AdminRestaurantAuditPage';
  readonly entries: ReadonlyArray<AdminRestaurantAudit>;
  /** Pass as `after` for the next, older page; null on the last page */
  readonly nextCursor: Maybe<Scalars['String']['output']>;
  /** The restaurant's IANA time zone, to show entry times as the store sees them; null when Gravy has none */
  readonly timeZone: Maybe<Scalars['String']['output']>;
};

/** Kind of Gravy record an audit entry changed */
export enum AdminRestaurantAuditRecordType {
  /** A product at the restaurant (86s and restocks) */
  Product = 'PRODUCT',
  /** The restaurant's own settings */
  Restaurant = 'RESTAURANT',
  /** An ingredient's stock at the restaurant (86s and restocks) */
  Stock = 'STOCK',
}

export type AdminRestaurantAuditsInput = {
  /** The previous page's nextCursor */
  readonly after?: InputMaybe<Scalars['String']['input']>;
  /** Page size, 50 by default and at most 200 */
  readonly first?: InputMaybe<Scalars['Int']['input']>;
  /** Only these kinds of record. Defaults to all. */
  readonly recordTypes?: InputMaybe<ReadonlyArray<AdminRestaurantAuditRecordType>>;
  readonly restaurantId: Scalars['ID']['input'];
  /** Case-insensitive match on who made the change, the record name or the comment */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Only changes at or after this time. Defaults to 30 days ago. */
  readonly since?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A restaurant's menu products and ingredients with their stock, as Gravy Admin's Menu and Ingredients pages showed them */
export type AdminRestaurantAvailability = {
  readonly __typename?: 'AdminRestaurantAvailability';
  /** Whether you can change stock and dates here: you have write access and the restaurant is not an outpost */
  readonly canEdit: Scalars['Boolean']['output'];
  /** Ingredients in the restaurant's stock, grouped by lineage */
  readonly ingredients: ReadonlyArray<AdminRestaurantIngredient>;
  /** Products on the restaurant's menu, grouped by lineage */
  readonly menuProducts: ReadonlyArray<AdminRestaurantMenuProduct>;
  /** The restaurant's IANA time zone, which decides what is sold today; null when Gravy has none */
  readonly timeZone: Maybe<Scalars['String']['output']>;
};

/** An ingredient in the restaurant's stock as operators see it: the Gravy ingredients sharing a lineage */
export type AdminRestaurantIngredient = {
  readonly __typename?: 'AdminRestaurantIngredient';
  /** When it goes back in stock; null when not scheduled */
  readonly autoRestockAt: Maybe<Scalars['DateTime']['output']>;
  /** YYYY-MM-DD; null when unbounded */
  readonly availableDate: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD, the first day it is no longer offered; null when unbounded */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  /** ingredient-lineage:<key> or ingredient:<id> */
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Maybe<Scalars['String']['output']>;
  readonly kind: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  /** True when any of its ingredients is 86'd */
  readonly outOfStock: Scalars['Boolean']['output'];
  /** Who 86'd it, from Gravy's audit log */
  readonly outOfStockBy: Maybe<Scalars['String']['output']>;
  /** When it was 86'd: its latest audited 86, or else the row's last update, which can be later than the 86. Null when it isn't 86'd or Gravy has nothing to date it by */
  readonly outOfStockSince: Maybe<Scalars['DateTime']['output']>;
  /** True when outOfStockSince is the row's last update: it was 86'd at or before then */
  readonly outOfStockSinceApproximate: Scalars['Boolean']['output'];
  readonly records: ReadonlyArray<AdminRestaurantIngredientRecord>;
};

/** One Gravy ingredient behind a restaurant ingredient */
export type AdminRestaurantIngredientRecord = {
  readonly __typename?: 'AdminRestaurantIngredientRecord';
  /** Gravy ingredient id */
  readonly ingredientId: Scalars['Int']['output'];
  readonly kind: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  /** While 86'd, the adminOutOfStockReasons key it was 86'd with; null when in stock or unrecorded */
  readonly outOfStockReasonKey: Maybe<Scalars['String']['output']>;
};

/** A product on the restaurant's menu as operators see it: the Gravy product rows sharing a lineage */
export type AdminRestaurantMenuProduct = {
  readonly __typename?: 'AdminRestaurantMenuProduct';
  /** When it goes back in stock; null when not scheduled */
  readonly autoRestockAt: Maybe<Scalars['DateTime']['output']>;
  /** YYYY-MM-DD; null when unbounded */
  readonly availableDate: Maybe<Scalars['String']['output']>;
  readonly category: Maybe<Scalars['String']['output']>;
  /** Channels any of its rows is sold on */
  readonly channels: ReadonlyArray<Scalars['String']['output']>;
  /** YYYY-MM-DD, the first day it is no longer sold; null when unbounded */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  /** product-lineage:<key> or master-product:<id> */
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  /** True when a row sold today is 86'd */
  readonly outOfStock: Scalars['Boolean']['output'];
  /** Who 86'd it, from Gravy's audit log */
  readonly outOfStockBy: Maybe<Scalars['String']['output']>;
  /** When it was 86'd, from its latest audited 86. Null when it isn't 86'd or Gravy has no audit of the 86 (a product's last update can't date it: Gravy touches products when stock changes) */
  readonly outOfStockSince: Maybe<Scalars['DateTime']['output']>;
  /** Always false for products, which are dated by audits only */
  readonly outOfStockSinceApproximate: Scalars['Boolean']['output'];
  readonly records: ReadonlyArray<AdminRestaurantMenuProductRecord>;
  /** False when no row is sold today; stock changes need one */
  readonly soldToday: Scalars['Boolean']['output'];
};

/** One Gravy product row behind a menu product */
export type AdminRestaurantMenuProductRecord = {
  readonly __typename?: 'AdminRestaurantMenuProductRecord';
  readonly category: Maybe<Scalars['String']['output']>;
  /** Channels this row is sold on */
  readonly channels: ReadonlyArray<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  /** Gravy product id */
  readonly productId: Scalars['Int']['output'];
  /** Inside its available and expiration dates today */
  readonly soldToday: Scalars['Boolean']['output'];
};

/** A restaurant's ordering status */
export type AdminRestaurantOrdering = {
  readonly __typename?: 'AdminRestaurantOrdering';
  /** Whether the restaurant accepts digital orders */
  readonly acceptingOrders: Scalars['Boolean']['output'];
  /** Whether the restaurant is enabled */
  readonly enabled: Scalars['Boolean']['output'];
  /** Hidden from restaurant and location search */
  readonly hidden: Scalars['Boolean']['output'];
  /** Why ordering is off */
  readonly notAcceptingOrdersReason: Maybe<Scalars['String']['output']>;
};

/** A restaurant's customer-facing details */
export type AdminRestaurantProfile = {
  readonly __typename?: 'AdminRestaurantProfile';
  readonly crossStreet: Maybe<Scalars['String']['output']>;
  readonly description: Maybe<Scalars['String']['output']>;
  /** Message on the restaurant card */
  readonly flexMessage: Maybe<Scalars['String']['output']>;
  readonly pickupInstructions: Maybe<Scalars['String']['output']>;
};

/** A restaurant's settings and what you can change */
export type AdminRestaurantSettings = {
  readonly __typename?: 'AdminRestaurantSettings';
  /** Whether you can update enabled */
  readonly canEditEnabled: Scalars['Boolean']['output'];
  /** Whether you can update ordering */
  readonly canEditOrdering: Scalars['Boolean']['output'];
  /** Whether you can update the profile */
  readonly canEditProfile: Scalars['Boolean']['output'];
  readonly isOutpost: Scalars['Boolean']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly ordering: AdminRestaurantOrdering;
  /** An outpost's parent restaurant */
  readonly parentRestaurantId: Maybe<Scalars['ID']['output']>;
  readonly profile: AdminRestaurantProfile;
  readonly restaurantId: Scalars['ID']['output'];
};

/** What to do to an item's stock */
export enum AdminRestaurantStockAction {
  /** Keep an 86'd item out of stock until it is restocked */
  AutoRestockOff = 'AUTO_RESTOCK_OFF',
  /** Put an 86'd item back in stock at the next midnight in the restaurant's time zone */
  AutoRestockOn = 'AUTO_RESTOCK_ON',
  /** Mark it out of stock, with a reason */
  EightySix = 'EIGHTY_SIX',
  /** Put it back in stock and clear any scheduled auto-restock */
  Restock = 'RESTOCK',
}

/** A global upsell category and its master products */
export type AdminUpsellCategory = {
  readonly __typename?: 'AdminUpsellCategory';
  /** Position among categories, 1 first; null ranks last */
  readonly categoryRanking: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  /** Products in category order */
  readonly products: ReadonlyArray<AdminUpsellMasterProduct>;
};

export type AdminUpsellCategoryArrangementInput = {
  readonly id: Scalars['ID']['input'];
  /** The category's products, in rank order */
  readonly masterProductIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** A master product as the global upsell tools see it. Upsells are set per master product, so they apply to every restaurant that sells it. */
export type AdminUpsellMasterProduct = {
  readonly __typename?: 'AdminUpsellMasterProduct';
  /** Date (YYYY-MM-DD) the product becomes available; upsells skip it before then */
  readonly availableDate: Maybe<Scalars['String']['output']>;
  /** Date (YYYY-MM-DD) the product expires; upsells skip it from then on */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Cloudinary URL of the product's newest image; null when it has none */
  readonly imageUrl: Maybe<Scalars['String']['output']>;
  /** Offered in the ranked upsell list */
  readonly isUpsell: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** The upsell category it is shown in */
  readonly upsellCategoryId: Maybe<Scalars['ID']['output']>;
  /** Position within its upsell category, 1 first; null ranks last */
  readonly upsellCategoryRanking: Maybe<Scalars['Int']['output']>;
  /** Position in the ranked upsell list, 1 first; null ranks last */
  readonly upsellRanking: Maybe<Scalars['Int']['output']>;
};

export enum Allergen {
  CrustaceanShellfish = 'CRUSTACEAN_SHELLFISH',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Meat = 'MEAT',
  Milk = 'MILK',
  Peanuts = 'PEANUTS',
  Sesame = 'SESAME',
  Soybeans = 'SOYBEANS',
  TreeNuts = 'TREE_NUTS',
  Wheat = 'WHEAT',
}

export type AllergenProperty = {
  readonly __typename?: 'AllergenProperty';
  readonly id: Scalars['ID']['output'];
  readonly name: AllergenPropertyKind;
};

export enum AllergenPropertyKind {
  CrustaceanShellfish = 'CRUSTACEAN_SHELLFISH',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Meat = 'MEAT',
  Milk = 'MILK',
  Peanuts = 'PEANUTS',
  Sesame = 'SESAME',
  Soybeans = 'SOYBEANS',
  TreeNuts = 'TREE_NUTS',
  Wheat = 'WHEAT',
}

export type AnonymizeCustomerInput = {
  readonly authToken: Scalars['String']['input'];
  readonly email: Scalars['String']['input'];
};

export type ApplyAdminPrintPriorityTemplateInput = {
  readonly restaurantId: Scalars['Int']['input'];
  readonly templateId: Scalars['Int']['input'];
};

export type ApplyRewardByLoyaltyIdInput = {
  /** The loyalty ID of the customer. */
  readonly loyaltyId: Scalars['ID']['input'];
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export enum ApplyRewardFailureCode {
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  RestaurantNotAcceptingOrders = 'RESTAURANT_NOT_ACCEPTING_ORDERS',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
  RewardNotFound = 'REWARD_NOT_FOUND',
}

/** Validate and preview rewards success response */
export type ApplyRewardFailureMetadata = {
  readonly __typename?: 'ApplyRewardFailureMetadata';
  readonly requiredChannel: Maybe<Scalars['String']['output']>;
  readonly requiredDays: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
};

export type ApplyRewardInput = {
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export type ApplyRewardResponseUnion =
  | ApplyRewardSuccess
  | CartNotFound
  | LoyaltyScanTokenExpired
  | OrderLocked
  | RewardNotApplied
  | UnauthorizedOrderModification
  | ValidationError;

export type ApplyRewardSuccess = {
  readonly __typename?: 'ApplyRewardSuccess';
  readonly order: Order;
};

export type ApplyRewardWithLoyaltyInput = {
  /** The customer token of the customer. */
  readonly customerToken: Scalars['String']['input'];
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export type Asset = {
  readonly __typename?: 'Asset';
  readonly url: Scalars['String']['output'];
};

/** Async cancelation failed */
export type AsyncCancelFailed = UserError & {
  readonly __typename?: 'AsyncCancelFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** The error response for available customer support points. */
export type AvailableCustomerSupportPointsError = UserError & {
  readonly __typename?: 'AvailableCustomerSupportPointsError';
  /** The error message. */
  readonly errorMessage: Scalars['String']['output'];
};

export type AvailableCustomerSupportPointsResponseUnion =
  | AvailableCustomerSupportPointsError
  | AvailableCustomerSupportPointsSuccess;

/** The response for available customer support points. */
export type AvailableCustomerSupportPointsSuccess = {
  readonly __typename?: 'AvailableCustomerSupportPointsSuccess';
  /** The available customer support points. */
  readonly points: ReadonlyArray<CustomerSupportPoint>;
};

/** Failed fetch of available promotions with a typed reason */
export type AvailablePromotionFailure = UserError & {
  readonly __typename?: 'AvailablePromotionFailure';
  readonly errorMessage: Scalars['String']['output'];
  readonly reason: AvailablePromotionFailureReason;
};

/** Typed failure reasons returned by the availablePromotions query */
export enum AvailablePromotionFailureReason {
  UnableToProcess = 'UNABLE_TO_PROCESS',
}

export type AvailablePromotionsResponseUnion =
  | AvailablePromotionFailure
  | AvailablePromotionsSuccess;

/** Promotions the customer is currently eligible to claim */
export type AvailablePromotionsSuccess = {
  readonly __typename?: 'AvailablePromotionsSuccess';
  readonly promotions: ReadonlyArray<Reward>;
};

export type AvailableWantedTime = {
  readonly __typename?: 'AvailableWantedTime';
  readonly deliveryOffset: Scalars['Int']['output'];
  readonly time: Scalars['String']['output'];
};

export type BaseProduct = {
  readonly __typename?: 'BaseProduct';
  readonly asset: Asset;
  readonly calories: Maybe<Scalars['Float']['output']>;
  readonly caloriesFromFat: Maybe<Scalars['Float']['output']>;
  readonly cholesterolMg: Maybe<Scalars['Float']['output']>;
  readonly contains: Maybe<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly dietaryFiberG: Maybe<Scalars['Float']['output']>;
  readonly heading: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isDeepLinkingEnabled: Scalars['Boolean']['output'];
  readonly isSeasonal: Scalars['Boolean']['output'];
  readonly lineageKey: Maybe<Scalars['String']['output']>;
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly proteinG: Maybe<Scalars['Float']['output']>;
  readonly saturatedFatG: Maybe<Scalars['Float']['output']>;
  readonly slug: Scalars['String']['output'];
  readonly sodiumMg: Maybe<Scalars['Float']['output']>;
  readonly subheading: Scalars['String']['output'];
  readonly sugarsG: Maybe<Scalars['Float']['output']>;
  readonly totalCarbsG: Maybe<Scalars['Float']['output']>;
  readonly totalFatG: Maybe<Scalars['Float']['output']>;
  readonly transFatG: Maybe<Scalars['Float']['output']>;
};

export type BillingAccount = {
  readonly __typename?: 'BillingAccount';
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Scalars['String']['output'];
  readonly expirationState: ExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export enum BraintreeCardType {
  AmEx = 'AmEx',
  CarteBlanche = 'CarteBlanche',
  ChinaUnionPay = 'ChinaUnionPay',
  DinersClubInternational = 'DinersClubInternational',
  Discover = 'Discover',
  Elo = 'Elo',
  Jcb = 'JCB',
  Laser = 'Laser',
  Maestro = 'Maestro',
  MasterCard = 'MasterCard',
  Solo = 'Solo',
  Switch = 'Switch',
  UkMaestro = 'UKMaestro',
  Unknown = 'Unknown',
  Visa = 'Visa',
}

/** CX Credit */
export type CxCredit = {
  readonly __typename?: 'CXCredit';
  /** Display name of offer */
  readonly displayName: Scalars['String']['output'];
  /** ID of offer from loyalty vendor */
  readonly id: Scalars['ID']['output'];
};

/** Version of calories calculation method */
export enum CaloriesVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export type CanCancel = {
  readonly __typename?: 'CanCancel';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  /** Order ID validating on */
  readonly orderId: Scalars['ID']['output'];
  /**
   * Time in minutes before the order can no longer be canceled (sent to store)
   * @deprecated no longer supported.
   */
  readonly timeToFire: Scalars['Float']['output'];
};

/** Cannot find order to check if cancelation is allowed */
export type CanCancelAlreadySent = UserError & {
  readonly __typename?: 'CanCancelAlreadySent';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Generic Error for a failed can cancel query */
export type CanCancelFailed = UserError & {
  readonly __typename?: 'CanCancelFailed';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanCancelInput = {
  /** Gravy customer ID parent to the order being canceled. */
  readonly customerId: Scalars['String']['input'];
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Gravy restaurant ID parent to the order being canceled. */
  readonly restaurantId: Scalars['String']['input'];
  /** Watned time of order in ISO format. */
  readonly wantedTime: Scalars['DateTime']['input'];
};

/** Cannot find order to check if cancelation is allowed */
export type CanCancelNotFound = UserError & {
  readonly __typename?: 'CanCancelNotFound';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanCancelResponseUnion =
  | CanCancel
  | CanCancelAlreadySent
  | CanCancelFailed
  | CanCancelNotFound
  | CanCancelUnauthorized
  | CantCancelAlreadyCanceled
  | CantCancelLimitExcceeded
  | CantCancelOldOrders;

/** Unauthorized */
export type CanCancelUnauthorized = UserError & {
  readonly __typename?: 'CanCancelUnauthorized';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanNotReorder = {
  readonly __typename?: 'CanNotReorder';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type CancelExternalOrderInput = {
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
};

export type CancelOrderExternalResponseUnion =
  | AsyncCancelFailed
  | CancelOrderFailed
  | CancelOrderSuccess
  | CancelOrderSuccessAsync
  | CancelSuccessRefundFailed
  | CancellationFailedWithDelivery
  | OrderAlreadyCanceled
  | OrderAlreadySentToKitchen
  | OrderNotFound;

/** Generic Error for a failed cancellation */
export type CancelOrderFailed = UserError & {
  readonly __typename?: 'CancelOrderFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderInput = {
  /** Gravy customer ID parent to the order being canceled. */
  readonly customerId: Scalars['String']['input'];
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Description for why the order is being canceled. */
  readonly reason: Scalars['String']['input'];
  /** Refund the order if cancel succeeds?. */
  readonly refund: Scalars['Boolean']['input'];
  /** Gravy restaurant ID parent to the order being canceled. */
  readonly restaurantId: Scalars['String']['input'];
};

export type CancelOrderPaymentIntentInput = {
  readonly paymentIntentId: Scalars['String']['input'];
};

export type CancelOrderPaymentIntentResponse = {
  readonly __typename?: 'CancelOrderPaymentIntentResponse';
  readonly paymentIntentId: Scalars['ID']['output'];
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderResponseUnion =
  | AsyncCancelFailed
  | CancelOrderFailed
  | CancelOrderSuccess
  | CancelOrderSuccessAsync
  | CancelSuccessRefundFailed
  | CancellationFailedWithDelivery
  | CancellationLimitExceeded
  | OrderAlreadyCanceled
  | OrderAlreadySentToKitchen
  | OrderNotFound;

export type CancelOrderSuccess = {
  readonly __typename?: 'CancelOrderSuccess';
  readonly orderId: Scalars['ID']['output'];
  /** Reason for a failed order or a success string. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderSuccessAsync = {
  readonly __typename?: 'CancelOrderSuccessAsync';
  readonly orderId: Scalars['ID']['output'];
  /** Async order successfully canceled. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the async order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cancel succeeded but refund failed. */
export type CancelSuccessRefundFailed = UserError & {
  readonly __typename?: 'CancelSuccessRefundFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cancellation failed with delivery service */
export type CancellationFailedWithDelivery = UserError & {
  readonly __typename?: 'CancellationFailedWithDelivery';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cannot cancel more then one order per user per day */
export type CancellationLimitExceeded = UserError & {
  readonly __typename?: 'CancellationLimitExceeded';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Order has already been canceled */
export type CantCancelAlreadyCanceled = UserError & {
  readonly __typename?: 'CantCancelAlreadyCanceled';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Cannot cancel more then one order per user per day */
export type CantCancelLimitExcceeded = UserError & {
  readonly __typename?: 'CantCancelLimitExcceeded';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Order is greater then 2 days old */
export type CantCancelOldOrders = UserError & {
  readonly __typename?: 'CantCancelOldOrders';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export enum CardExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Unsupported = 'UNSUPPORTED',
  Visa = 'VISA',
}

export type CartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type CartNotFound = UserError & {
  readonly __typename?: 'CartNotFound';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type CateringCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type CateringCustomer = {
  readonly __typename?: 'CateringCustomer';
  /** Customer first name */
  readonly first: Scalars['String']['output'];
  /** Customer last name */
  readonly last: Scalars['String']['output'];
};

/** Delivery type as recorded in Monkey DB — used to determine whether to submit as cateringPickup or cateringDelivery. */
export enum CateringDeliveryType {
  /** Order is delivered to the customer */
  Delivery = 'DELIVERY',
  /** Order is picked up at the store */
  Pickup = 'PICKUP',
}

export type CateringIngredient = {
  readonly __typename?: 'CateringIngredient';
  /** Whether the ingredient is eighty-sixed (out of stock) */
  readonly eightySixed: Scalars['Boolean']['output'];
  /** Per-portion weight in grams, sourced from gravy_ingredients.serving_measure. May be null. */
  readonly gramsPerPortion: Maybe<Scalars['Float']['output']>;
  /** Ingredient ID */
  readonly id: Scalars['Int']['output'];
  /** Ingredient kind (e.g. "base", "premium", "protein", "dressing"). Sourced from IngredientEntity.kind; may be null for legacy rows. */
  readonly kind: Maybe<Scalars['String']['output']>;
  /** Ingredient name */
  readonly name: Scalars['String']['output'];
  /** Portion size for this ingredient */
  readonly portion: Maybe<Scalars['Float']['output']>;
  /** Raw Monkey subitem quantity — for SG Bar, the slot allocation count (1..maxSlots per modifier group). Unset for non-SG-Bar items. */
  readonly quantity: Maybe<Scalars['Int']['output']>;
  /** SG Bar (SALAD_BAR) additions only. Large-format ingredients are separate gravy_ingredients rows ("roasted chicken (lf) jan 2024") that no prep catalog knows; these are the regular ingredients sharing their lineage_key that are active at the restaurant on the order date. Usually one. Kids and dip variants share a lineage too, so there can be several: narrow them by your own catalog rather than taking the first. Empty when no sibling is active; null when not resolved (not an SG Bar addition, no lineage key, or the lookup failed). */
  readonly regularCounterparts: Maybe<ReadonlyArray<CateringRegularIngredient>>;
  /** Computed total grams for this subitem: quantity * gramsPerPortion. Null when either input is missing. */
  readonly totalGrams: Maybe<Scalars['Float']['output']>;
};

export type CateringLineItem = {
  readonly __typename?: 'CateringLineItem';
  /** Total cost in cents (quantity * perItemCost). Only present for submitted orders. */
  readonly cost: Maybe<Scalars['Int']['output']>;
  /** Whether the product is eighty-sixed (out of stock at this restaurant) */
  readonly eightySixed: Scalars['Boolean']['output'];
  /** List of ingredient additions */
  readonly ingredientAdditions: ReadonlyArray<CateringIngredient>;
  /** List of ingredients included in this line item */
  readonly ingredients: ReadonlyArray<CateringIngredient>;
  /** Per-item cost in cents. Only present for submitted orders. */
  readonly perItemCost: Maybe<Scalars['Int']['output']>;
  /** Product ID */
  readonly productId: Scalars['Int']['output'];
  /** Product name */
  readonly productName: Scalars['String']['output'];
  /** Quantity of this line item */
  readonly quantity: Scalars['Int']['output'];
  /** Ingredients removed from this line item (either eighty-sixed/out of stock or removed via special instructions). Only populated for submitted orders sourced from Gravy; empty for unsubmitted orders. */
  readonly removedIngredients: ReadonlyArray<CateringIngredient>;
  /** Special instructions for this line item */
  readonly specialInstructions: Maybe<Scalars['String']['output']>;
  /** Type of the item (e.g., SALAD, PLATE, WARM_BOWL, SIDES_AND_BEVERAGES, CATERING_BUNDLES) */
  readonly type: CateringProductType;
};

export type CateringOrder = {
  readonly __typename?: 'CateringOrder';
  /** Client (organization) name */
  readonly clientName: Maybe<Scalars['String']['output']>;
  /** Client phone number */
  readonly clientPhone: Maybe<Scalars['String']['output']>;
  /** Customer information */
  readonly customer: CateringCustomer;
  /** Delivery address line 1 */
  readonly deliveryAddress1: Maybe<Scalars['String']['output']>;
  /** Delivery address line 2 */
  readonly deliveryAddress2: Maybe<Scalars['String']['output']>;
  /** Delivery city */
  readonly deliveryCity: Maybe<Scalars['String']['output']>;
  /** Delivery fee in cents */
  readonly deliveryFee: Maybe<Scalars['Int']['output']>;
  /** Delivery postal code */
  readonly deliveryPostal: Maybe<Scalars['String']['output']>;
  /** Delivery state */
  readonly deliveryState: Maybe<Scalars['String']['output']>;
  /** Delivery type from Monkey DB — drives whether submission uses cateringPickup or cateringDelivery order type. */
  readonly deliveryType: Maybe<CateringDeliveryType>;
  /** Order-level discount in cents */
  readonly discount: Maybe<Scalars['Int']['output']>;
  /** External reference ID (monkey order ID) */
  readonly externalReferenceId: Scalars['Int']['output'];
  /** Gravy order ID (only present for submitted orders) */
  readonly gravyOrderId: Maybe<Scalars['Int']['output']>;
  /** Whether the order has been submitted */
  readonly isSubmitted: Scalars['Boolean']['output'];
  /** Whether the order is tax exempt */
  readonly isTaxExempt: Scalars['Boolean']['output'];
  /** Line items in the order */
  readonly lineItems: ReadonlyArray<CateringLineItem>;
  /** Number of guests */
  readonly numberOfGuests: Maybe<Scalars['Int']['output']>;
  /** Company name of the order acceptor */
  readonly orderAcceptorCompany: Scalars['String']['output'];
  /** Phone number of the order acceptor */
  readonly orderAcceptorPhone: Maybe<Scalars['String']['output']>;
  /** Order source (marketplace, private_store, or null) */
  readonly orderSource: Maybe<CateringOrderSource>;
  readonly orderValidation: Maybe<CateringOrderValidation>;
  /** Monkey payment_method (e.g. 'Paid by ezCater', 'House Account', 'Credit card') — drives the catering Brink tender on submit. */
  readonly paymentMethod: Maybe<Scalars['String']['output']>;
  /** Restaurant ID (Gravy restaurant ID) */
  readonly restaurantID: Scalars['Int']['output'];
  /** Special instructions for the order */
  readonly specialInstructions: Maybe<Scalars['String']['output']>;
  /** Submission window close time (ISO string with timezone, same as wantedTimeAtStore) */
  readonly submissionWindowCloseAt: Scalars['String']['output'];
  /** Submission window open time (ISO string with timezone, calculated as wantedTimeAtStore - 14 hours) */
  readonly submissionWindowOpenAt: Scalars['String']['output'];
  /** Raw time_requested from Monkey DB in HHMM integer format (e.g., 1745 = 17:45) */
  readonly timeReqd: Scalars['Int']['output'];
  /** Tip/gratuity in cents */
  readonly tip: Maybe<Scalars['Int']['output']>;
  /** Wanted time at store (ISO string with timezone, e.g., "2025-12-12T17:00:00-07:00") */
  readonly wantedTimeAtStore: Scalars['String']['output'];
};

/** Source of the catering order */
export enum CateringOrderSource {
  /** Order placed through the ezcater marketplace */
  Marketplace = 'MARKETPLACE',
  /** Order placed through a private store (ezOrdering) */
  PrivateStore = 'PRIVATE_STORE',
}

export type CateringOrderValidation = {
  readonly __typename?: 'CateringOrderValidation';
  readonly subtotal: Maybe<Scalars['Int']['output']>;
  readonly tax: Maybe<Scalars['Int']['output']>;
  readonly total: Maybe<Scalars['Int']['output']>;
};

export type CateringOrderValidationInput = {
  readonly subtotal?: InputMaybe<Scalars['Int']['input']>;
  readonly tax?: InputMaybe<Scalars['Int']['input']>;
  readonly total?: InputMaybe<Scalars['Int']['input']>;
};

export type CateringOrdersInput = {
  /** Optional date in YYYY-MM-DD format. Defaults to today in restaurant timezone if not provided. */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The restaurant ID (Gravy restaurant ID) to fetch catering orders for */
  readonly restaurantId: Scalars['Int']['input'];
};

export type CateringOrdersResponse = {
  readonly __typename?: 'CateringOrdersResponse';
  /** List of catering orders */
  readonly orders: ReadonlyArray<CateringOrder>;
};

/** Type of the catering product item */
export enum CateringProductType {
  CateringBundles = 'CATERING_BUNDLES',
  Extras = 'EXTRAS',
  Plate = 'PLATE',
  Salad = 'SALAD',
  SaladBar = 'SALAD_BAR',
  SidesAndBeverages = 'SIDES_AND_BEVERAGES',
  Unknown = 'UNKNOWN',
  WarmBowl = 'WARM_BOWL',
}

export type CateringRegularIngredient = {
  readonly __typename?: 'CateringRegularIngredient';
  /** Grams in one regular serving, from gravy_ingredients.serving_measure. Divide a large-format totalGrams by it to get servings. May be null. */
  readonly gramsPerPortion: Maybe<Scalars['Float']['output']>;
  /** Gravy ingredient id of the regular-menu ingredient */
  readonly id: Scalars['Int']['output'];
  /** Ingredient name */
  readonly name: Scalars['String']['output'];
};

/** A Challenge is a configured SessionM Campaign with the "is_challenge: true" flag set in the campaign custom payload */
export type Challenge = {
  readonly __typename?: 'Challenge';
  /** Field is integer representation of the total amount of times the challenge behavior was completed by the customer. */
  readonly achieved: Scalars['Float']['output'];
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  /** Field originates from SessionM Activity feed configuration message description. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Field originates from SessionM Activity feed configuration message subheader. */
  readonly descriptiveTitle: Scalars['String']['output'];
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field is a number representation of the challenge goal. Ex. A two STEP challenge would have a goal of `2.` A SPEND $20 challenge would have a goal of `2000` */
  readonly goal: Scalars['Float']['output'];
  /** Field is the SessionM campaign id */
  readonly id: Scalars['ID']['output'];
  readonly legalTerms: Scalars['String']['output'];
  /** Holds additional details (if needed) depending on the type of challenge (hurdle). */
  readonly multipleBehaviorDetails: Maybe<MultipleBehaviorDetailsUnion>;
  /** Field is `progress` divided by `goal` times 100. To be used to render progress bar. */
  readonly percentageCompleted: Scalars['Float']['output'];
  readonly permalink: Scalars['String']['output'];
  /** Field indicates the current count completed toward challenge goal. */
  readonly progress: Scalars['Float']['output'];
  /** Field is copy to show on the challenge card to indicate progress. Determined by challenge status and progress fields. */
  readonly progressCopy: Scalars['String']['output'];
  /** Field is the progress type of the challenge */
  readonly progressType: ChallengeProgressType;
  readonly status: ChallengeStatus;
  /**
   * Field represents the type of challenge, e.g. FLASH. Defaults to DEFAULT
   * @deprecated Deprecated in favor of "themeV2" field
   */
  readonly theme: ChallengeTheme;
  /** Field represents the type of challenge, e.g. FLASH. Defaults to DEFAULT */
  readonly themeV2: ChallengeThemeV2;
  /** Field originates from SessionM Activity feed configuration message header. */
  readonly title: Scalars['String']['output'];
};

/** Challenge celebration data originating from campaign information on SessionM. To be used to render challenge celebration messaging. */
export type ChallengeCelebration = {
  readonly __typename?: 'ChallengeCelebration';
  /** Field originates from SessionM Activity feed configuration message description. When a user has multiple rewards to be "celebrated" this field is hardcoded. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Completed challenges ids */
  readonly challengesIds: ReadonlyArray<Scalars['String']['output']>;
  /** Expiration date for reward. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field is hardcoded in challenges-svc */
  readonly rewardUsageDisclaimer: Scalars['String']['output'];
  /** Field originates from SessionM Activity Feed configuration message header. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly title: Maybe<Scalars['String']['output']>;
};

/** Challenge celebration data originating from campaign information on SessionM. To be used to render challenge celebration messaging. */
export type ChallengeCelebrationV2 = {
  readonly __typename?: 'ChallengeCelebrationV2';
  /** Field originates from SessionM Activity feed configuration message description. When a user has multiple rewards to be "celebrated" this field is hardcoded. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Completed challenges ids */
  readonly challengesIds: ReadonlyArray<Scalars['String']['output']>;
  /** Expiration date for reward. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field originates from SessionM Activity Feed configuration message header. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly title: Scalars['String']['output'];
};

export type ChallengeOptInResultUnion = Challenge | LoyaltyOptInFailed;

/** Step = step challenge, Spend = spend challenge */
export enum ChallengeProgressType {
  Spend = 'Spend',
  Step = 'Step',
}

/** Reward available to the customer */
export type ChallengeReward = {
  readonly __typename?: 'ChallengeReward';
  /** @deprecated Duplicate of Reward type. Use Reward instead */
  readonly expiresAt: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  /** @deprecated Duplicate of Reward type. Use Reward instead */
  readonly name: Scalars['String']['output'];
  /**
   * The Premium reward is only available to a customer 1x every twelve hours. The redeemable field allows the UI to indicate whether the reward is currently available to be used.
   * @deprecated Duplicate of Reward type. Use Reward instead
   */
  readonly redeemable: Maybe<Scalars['Boolean']['output']>;
  /**
   * The Premium reward is only available to a customer 1x every twelve hours. The redeemableAt will populate if reward is not redeemable with the next available date.
   * @deprecated Duplicate of Reward type. Use Reward instead
   */
  readonly redeemableAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * The channel(s) in which the reward can be redeemed
   * @deprecated Duplicate of Reward type. Use Reward instead
   */
  readonly redemptionChannel: RedemptionChannel;
  /**
   * Type PREMIUM refers to Premium Subscription Reward, NON_PREMIUM rewards not associated with loyalty program
   * @deprecated Duplicate of Reward type. Use Reward instead
   */
  readonly rewardType: RewardType;
  /**
   * Field references the offer terms and conditions configured in SessionM. If that field is not configured, returns the default SG terms url.
   * @deprecated Duplicate of Reward type. Use Reward instead
   */
  readonly terms: Scalars['String']['output'];
};

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export enum ChallengeStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
}

export enum ChallengeTheme {
  Default = 'DEFAULT',
  Flash = 'FLASH',
}

export enum ChallengeThemeV2 {
  Default = 'DEFAULT',
  Flash = 'FLASH',
  Hurdle = 'HURDLE',
  Unlimited = 'UNLIMITED',
}

export type ChangeDetail = {
  readonly __typename?: 'ChangeDetail';
  /** The field path that changed */
  readonly field: Scalars['String']['output'];
  /** The new value (null if removed) */
  readonly newValue: Maybe<Scalars['JSON']['output']>;
  /** The previous value (null if not present) */
  readonly oldValue: Maybe<Scalars['JSON']['output']>;
};

/** JWT token used to login a user in a chat app. */
export type ChatToken = {
  readonly __typename?: 'ChatToken';
  readonly token: Scalars['String']['output'];
};

export type ChildSyncResult = {
  readonly __typename?: 'ChildSyncResult';
  /** Error message if sync failed */
  readonly error: Maybe<Scalars['String']['output']>;
  /** The Salesforce ID of the child outpost */
  readonly salesforceId: Scalars['String']['output'];
  /** Whether the child sync succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Failed claim of a loyalty promotion with a typed reason */
export type ClaimLoyaltyPromotionFailure = UserError & {
  readonly __typename?: 'ClaimLoyaltyPromotionFailure';
  readonly errorMessage: Scalars['String']['output'];
  readonly reason: ClaimLoyaltyPromotionFailureReason;
};

/** Typed failure reasons returned by the claimLoyaltyPromotion mutation */
export enum ClaimLoyaltyPromotionFailureReason {
  CustomerIneligibleNewUserGate = 'CUSTOMER_INELIGIBLE_NEW_USER_GATE',
  CustomerIneligibleSegmentGate = 'CUSTOMER_INELIGIBLE_SEGMENT_GATE',
  ExpiredOffer = 'EXPIRED_OFFER',
  OfferNotFound = 'OFFER_NOT_FOUND',
  PreviouslyIssued = 'PREVIOUSLY_ISSUED',
  UnableToProcess = 'UNABLE_TO_PROCESS',
}

/** Reward discount */
export type ClaimLoyaltyPromotionInput = {
  readonly offerId: Scalars['String']['input'];
};

export type ClaimLoyaltyPromotionResponseUnion = ClaimLoyaltyPromotionFailure | Reward;

export type ClosedLoyaltyTransactionDetailsInput = {
  readonly createdAt: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly isGroupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isInFlight: Scalars['Boolean']['input'];
  readonly isInFlightDelivery: Scalars['Boolean']['input'];
  readonly lineItems: ReadonlyArray<OrderLineItemInput>;
  readonly orderType: Scalars['String']['input'];
  readonly payments: ReadonlyArray<OrderPaymentInput>;
  readonly restaurantEntityId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantParentId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantUtcOffset?: InputMaybe<Scalars['Float']['input']>;
  readonly selectedRewards?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** The selected reward with root offer id */
  readonly selectedRewardsWithDetails?: InputMaybe<ReadonlyArray<SelectedRewardsWithDetails>>;
  readonly subtotal: Scalars['Float']['input'];
  readonly tax: Scalars['Float']['input'];
  readonly updatedAt?: InputMaybe<Scalars['String']['input']>;
  readonly wantedTime?: InputMaybe<Scalars['String']['input']>;
};

export enum ConflictType {
  DeliveryIneligible = 'DELIVERY_INELIGIBLE',
  IngredientUnavailable = 'INGREDIENT_UNAVAILABLE',
  NoConflict = 'NO_CONFLICT',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',
}

export type ConsolidatedIngredient = {
  readonly __typename?: 'ConsolidatedIngredient';
  /** The sweetgreen ingredient id. */
  readonly id: Scalars['ID']['output'];
  /** Whether the ingredient's kind is a dressing. */
  readonly isDressing: Scalars['Boolean']['output'];
  /** The ingredient's Salesforce/MDM id (Ingredient__c id), when populated. */
  readonly mdmId: Maybe<Scalars['String']['output']>;
  /** How many times this ingredient appears in the line item's net ingredients. */
  readonly quantity: Scalars['Int']['output'];
};

export type ConvertToMultipartyOrderInput = {
  readonly multipartyOrderDetails: MultipartyDetailInput;
};

export type ConvertToMultipartyOrderResponseUnion =
  | CartNotFound
  | ConvertToMultipartyOrderSuccess
  | MultipartyOrderNotEnabled
  | OrderLocked
  | UnauthorizedOrderModification;

export type ConvertToMultipartyOrderSuccess = {
  readonly __typename?: 'ConvertToMultipartyOrderSuccess';
  readonly order: Order;
};

/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export enum CostChannel {
  DefaultCostChannel = 'DEFAULT_COST_CHANNEL',
  DeliveryCostChannel = 'DELIVERY_COST_CHANNEL',
  PickupCostChannel = 'PICKUP_COST_CHANNEL',
}

export type CourierDetails = {
  readonly __typename?: 'CourierDetails';
  readonly latitude: Maybe<Scalars['Float']['output']>;
  readonly longitude: Maybe<Scalars['Float']['output']>;
  readonly name: Maybe<Scalars['String']['output']>;
  readonly phone: Maybe<Scalars['String']['output']>;
};

export type CreateAccountInput = {
  /** Must be in YYYY-MM-DD format. */
  readonly birthday?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  /** Must be a valid US phone number, exactly 10 digits with no formatting. */
  readonly phoneNumber: Scalars['String']['input'];
  /** Stripe Radar Session ID captured on the registration screen, used for fraud evaluation. */
  readonly radarSession?: InputMaybe<Scalars['String']['input']>;
  /** Required for personalization use cases. */
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountResponseUnion = CreateAccountSuccess | ValidationError;

export type CreateAccountSuccess = {
  readonly __typename?: 'CreateAccountSuccess';
  readonly customer: Customer;
};

export type CreateAdminPrintPriorityTemplateInput = {
  /** Template name */
  readonly name: Scalars['String']['input'];
  /** All zones in template print order */
  readonly zones: ReadonlyArray<AdminPrintPriorityTemplateZoneInput>;
};

export type CreateAdminUpsellCategoryInput = {
  readonly name: Scalars['String']['input'];
};

export type CreateAndSubmitOrderInput = {
  /** Delivery fee in cents */
  readonly deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  /** Order-level discount amount in cents */
  readonly discount?: InputMaybe<Scalars['Int']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** If the client has their own identifier for this order, they should provide it here for potential correlation on sweetgreen's end. For example, delivery marketplaces should provide their order id. */
  readonly externalReferenceId?: InputMaybe<Scalars['ID']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the order is tax exempt. Defaults to false. */
  readonly isTaxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lineItems?: InputMaybe<ReadonlyArray<CateringCartInput>>;
  /** The order source for this catering order. Defaults to ezOrdering behavior if not provided. */
  readonly orderSource?: InputMaybe<CateringOrderSource>;
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly orderValidation?: InputMaybe<CateringOrderValidationInput>;
  /** The order's Monkey payment_method (e.g. 'Paid by ezCater', 'House Account', 'Credit card'), used to pick the catering Brink tender. */
  readonly paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** The restaurant ID for this order */
  readonly restaurantId: Scalars['Int']['input'];
  /** Order-level special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Override for throttle wanted time, used for late catering submissions. When provided, gravy uses this instead of computing wanted_time - 30min. */
  readonly throttleWantedTimeOverride?: InputMaybe<Scalars['String']['input']>;
  /** Tip amount in cents */
  readonly tip?: InputMaybe<Scalars['Int']['input']>;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

/** Successful connection token response */
export type CreateConnectionTokenResponse = {
  readonly __typename?: 'CreateConnectionTokenResponse';
  /** A token to pass token to the Stripe Terminal SDK */
  readonly secret: Scalars['String']['output'];
};

export type CreateFlexOnboardingSessionInput = {
  readonly cancelUrl: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly phoneNumber: Scalars['String']['input'];
  readonly successUrl: Scalars['String']['input'];
};

export type CreateGiftCardPaymentIntentInput = {
  readonly assetId: Scalars['String']['input'];
  readonly balance: Scalars['Float']['input'];
  readonly deliveryDateTime?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryMethods: ReadonlyArray<Scalars['String']['input']>;
  readonly isAsap: Scalars['Boolean']['input'];
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly paymentMethodId: Scalars['String']['input'];
  readonly quantity: Scalars['Float']['input'];
  readonly recipientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly recipientName: Scalars['String']['input'];
  readonly senderName: Scalars['String']['input'];
  readonly shouldSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly utcOffset: Scalars['Float']['input'];
};

/** Successful location creation response */
export type CreateKioskReaderLocationIdResponse = {
  readonly __typename?: 'CreateKioskReaderLocationIdResponse';
  readonly id: Scalars['String']['output'];
};

export type CreateLoyaltyProfileError = UserError & {
  readonly __typename?: 'CreateLoyaltyProfileError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CreateLoyaltyProfileResponseUnion =
  | CreateLoyaltyProfileError
  | CreateLoyaltyProfileSuccess;

export type CreateLoyaltyProfileSuccess = {
  readonly __typename?: 'CreateLoyaltyProfileSuccess';
  readonly loyaltyProfile: LoyaltyProfile;
};

export type CreateOrderInput = {
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  readonly multipartyOrderDetails?: InputMaybe<MultipartyDetailInput>;
  /** The restaurant ID for this order */
  readonly restaurantId: Scalars['Int']['input'];
};

export type CreateOrderPaymentIntentInput = {
  readonly amount: Scalars['Float']['input'];
  readonly deliveryOrderDetail?: InputMaybe<PaymentIntentDeliveryOrderDetail>;
  readonly dropoffLocationId?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType: Scalars['String']['input'];
  readonly orderId: Scalars['String']['input'];
  readonly orderType: Scalars['String']['input'];
  readonly paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantEntityId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantSlug?: InputMaybe<Scalars['String']['input']>;
  readonly shouldSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useCredit?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useHsa?: InputMaybe<Scalars['Boolean']['input']>;
  readonly wantedTime: Scalars['String']['input'];
};

export type CreateOrderResponseUnion =
  | CreateOrderSuccess
  | MultipartyOrderNotEnabled
  | UnauthorizedOrderModification
  | ValidationError;

export type CreateOrderSuccess = {
  readonly __typename?: 'CreateOrderSuccess';
  readonly order: Order;
};

export type CreateSetupIntent = {
  readonly __typename?: 'CreateSetupIntent';
  /** The Stripe created setup intent secret, required for the client to confirm its creation */
  readonly clientSecret: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type Credit = {
  readonly __typename?: 'Credit';
  readonly amount: Scalars['Float']['output'];
  readonly createdAt: Scalars['String']['output'];
  /** The type of credit */
  readonly creditType: CreditType;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expiresAt: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly remainingAmount: Scalars['Float']['output'];
  readonly storefrontEligibilityTitle: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export enum CreditType {
  AllNativeStorefronts = 'ALL_NATIVE_STOREFRONTS',
  InStoreOnly = 'IN_STORE_ONLY',
  OnlineOnly = 'ONLINE_ONLY',
}

export enum CustomProductType {
  Bowl = 'BOWL',
  Plate = 'PLATE',
}

/** Customer details including available credits */
export type Customer = {
  readonly __typename?: 'Customer';
  readonly addresses: ReadonlyArray<Address>;
  /** The amount of credit available to the customer. Credit is applied after tax. */
  readonly availableCredit: Scalars['Int']['output'];
  /** @deprecated Deprecated in favor of `paymentMethodCards` query. */
  readonly billingAccounts: ReadonlyArray<BillingAccount>;
  readonly birthday: Maybe<Scalars['String']['output']>;
  /** A detail list of available credits to the customer. */
  readonly credits: ReadonlyArray<Credit>;
  /**
   * Is this user marked for deletion.
   * @deprecated Clients have no use for this field.
   */
  readonly deletionInProgress: Maybe<Scalars['Boolean']['output']>;
  readonly email: Maybe<Scalars['String']['output']>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
  readonly phoneNumber: Maybe<Scalars['String']['output']>;
  /** Level Up / Paytronix Payment Token for the customer, used to generate QR codes. */
  readonly qrCode: Scalars['String']['output'];
  /** Level Up Share URL to be used when sharing by email. */
  readonly referralShareUrlEmail: Scalars['String']['output'];
  /** Gravy-generated UUID used for analytics purposes */
  readonly trackingUuid: Maybe<Scalars['String']['output']>;
  /** Whether or not the customer will use any available credit on their next transaction. */
  readonly useCredit: Scalars['Boolean']['output'];
  readonly zipCode: Maybe<Scalars['String']['output']>;
};

export type CustomerExistsInput = {
  readonly authToken: Scalars['String']['input'];
  readonly email: Scalars['String']['input'];
};

export type CustomerNotFound = UserError & {
  readonly __typename?: 'CustomerNotFound';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Customer not onboarded" user error — HSA/FSA (Flex) was requested but the customer has not onboarded. */
export type CustomerNotOnboardedError = UserError & {
  readonly __typename?: 'CustomerNotOnboardedError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerPass = {
  readonly __typename?: 'CustomerPass';
  readonly authenticationToken: Maybe<Scalars['String']['output']>;
  readonly url: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInfo = {
  readonly __typename?: 'CustomerPaymentInfo';
  readonly id: Scalars['ID']['output'];
  /** Stripe ephemeral key used to configure the payment element on the client. */
  readonly paymentEphemeralKey: Scalars['String']['output'];
  /** Stripe customer session id used to configure the payment element on the client. */
  readonly paymentSessionId: Scalars['String']['output'];
};

export type CustomerPointsForCustomerSupportFailureError = UserError & {
  readonly __typename?: 'CustomerPointsForCustomerSupportFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerPointsForCustomerSupportResponseUnion =
  | CustomerPointsForCustomerSupportFailureError
  | CustomerPointsForCustomerSupportSuccessResponse;

/** Successful response for customer points for customer support. */
export type CustomerPointsForCustomerSupportSuccessResponse = {
  readonly __typename?: 'CustomerPointsForCustomerSupportSuccessResponse';
  readonly points: Scalars['Int']['output'];
};

/** Customer Preference */
export type CustomerPreference = {
  readonly __typename?: 'CustomerPreference';
  readonly allergens: ReadonlyArray<Allergen>;
  readonly dietaryRestrictions: ReadonlyArray<DietaryRestriction>;
  readonly hasSyncedRestrictions: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
};

export type CustomerPreferencesInput = {
  readonly allergens?: InputMaybe<ReadonlyArray<Allergen>>;
  readonly dietaryRestrictions?: InputMaybe<ReadonlyArray<DietaryRestriction>>;
};

/** Failure to fetch Customer Support Credits */
export type CustomerSupportCreditsFailureError = UserError & {
  readonly __typename?: 'CustomerSupportCreditsFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerSupportCreditsResponseUnion =
  | CustomerSupportCreditsFailureError
  | CustomerSupportCreditsSuccessResponse;

/** Customer Support Credits Result */
export type CustomerSupportCreditsSuccessResponse = {
  readonly __typename?: 'CustomerSupportCreditsSuccessResponse';
  /** Credits allocated for customer support team to issue to customers */
  readonly credits: ReadonlyArray<CxCredit>;
};

/** A customer support point. */
export type CustomerSupportPoint = {
  readonly __typename?: 'CustomerSupportPoint';
  /** The display value of the points available. */
  readonly displayValue: Scalars['String']['output'];
  /** The number of points available for customer support to issue. */
  readonly value: Scalars['Float']['output'];
};

export type CustomerTokenError = UserError & {
  readonly __typename?: 'CustomerTokenError';
  readonly code: Scalars['String']['output'];
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerTokenResponseUnion = CustomerTokenError | LoyaltyAccessToken;

export type DeclinedPaymentMethod = UserError & {
  readonly __typename?: 'DeclinedPaymentMethod';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type DeleteAddressResponseUnion = DeleteAddressSuccess | InvalidAddress | ValidationError;

export type DeleteAddressSuccess = {
  readonly __typename?: 'DeleteAddressSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type DeleteAdminPrintPriorityTemplateInput = {
  /** Template id */
  readonly id: Scalars['ID']['input'];
};

export type DeleteAdminPrintPriorityTemplateResponse = {
  readonly __typename?: 'DeleteAdminPrintPriorityTemplateResponse';
  readonly message: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

export type DeleteAdminUpsellCategoryInput = {
  readonly id: Scalars['ID']['input'];
};

export type DeleteAdminUpsellCategoryResponse = {
  readonly __typename?: 'DeleteAdminUpsellCategoryResponse';
  readonly message: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

export type DeletePaymentMethodCardInput = {
  /** Id of card to delete */
  readonly id: Scalars['String']['input'];
};

export type DeleteSubscriptionPaymentMethodResponseUnion =
  | ActivePaymentMethodError
  | DeleteSubscriptionPaymentMethodSuccess
  | UnknownUserError;

/** The result of deleting a payment method from a subscription */
export type DeleteSubscriptionPaymentMethodSuccess = {
  readonly __typename?: 'DeleteSubscriptionPaymentMethodSuccess';
  /** Payment Methods */
  readonly creditCards: ReadonlyArray<SubscriptionCreditCard>;
};

export type DeliveryAlreadyInFlight = UserError & {
  readonly __typename?: 'DeliveryAlreadyInFlight';
  readonly errorMessage: Scalars['String']['output'];
};

export type DeliveryOrderDetail = {
  readonly __typename?: 'DeliveryOrderDetail';
  readonly address: Maybe<Address>;
  /** Delivery Fee in cents */
  readonly deliveryFee: Scalars['Float']['output'];
  /** Estimated delivery time for an delivery order, usually used as a range with +- 15mins offset. For outpost orders this is represented by the order "wantedTime". */
  readonly estimatedDeliveryTime: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Courier tip in cents */
  readonly tip: Scalars['Float']['output'];
  readonly vendor: Scalars['String']['output'];
  readonly vendorRestaurantId: Scalars['String']['output'];
};

export type DeliveryOrderDetailInput = {
  readonly addressId: Scalars['ID']['input'];
  readonly deliveryFee: Scalars['Float']['input'];
  readonly tip: Scalars['Float']['input'];
  readonly vendor: Scalars['String']['input'];
  readonly vendorRestaurantId: Scalars['String']['input'];
};

export enum DeliveryPreferenceType {
  Curbside = 'CURBSIDE',
  Door = 'DOOR',
  LeaveAtDoor = 'LEAVE_AT_DOOR',
}

export type DeliverySpecifyAddress = UserError & {
  readonly __typename?: 'DeliverySpecifyAddress';
  readonly errorMessage: Scalars['String']['output'];
};

export type DietaryProperty = {
  readonly __typename?: 'DietaryProperty';
  readonly id: Scalars['ID']['output'];
  readonly name: DietaryPropertyKind;
};

export enum DietaryPropertyKind {
  Dairy = 'DAIRY',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Meat = 'MEAT',
  Nuts = 'NUTS',
  Soy = 'SOY',
}

export enum DietaryRestriction {
  Dairy = 'DAIRY',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Meat = 'MEAT',
  Nuts = 'NUTS',
  Soy = 'SOY',
}

/** Discount on payment plan */
export type Discount = {
  readonly __typename?: 'Discount';
  /** The quantity of the discount */
  readonly amount: Maybe<Scalars['String']['output']>;
  /** The description of the discount */
  readonly description: Maybe<Scalars['String']['output']>;
  /** Discount identifier */
  readonly id: Scalars['ID']['output'];
  /** The name of the discount */
  readonly name: Scalars['ID']['output'];
};

export enum DressingMode {
  Mixed = 'MIXED',
  NotDressable = 'NOT_DRESSABLE',
  OnTheSide = 'ON_THE_SIDE',
  Removed = 'REMOVED',
}

export enum DressingWeight {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
}

export type DropOffLocation = {
  readonly __typename?: 'DropOffLocation';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

/** Unit used for handling duration types. */
export enum DurationUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type EditAddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type EditAddressV2Input = {
  readonly city: Scalars['String']['input'];
  /** 2 letter country code */
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly id: Scalars['ID']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter state code */
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type EditLineItemInCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type EditLineItemInCartResponseUnion =
  | CartNotFound
  | EditLineItemInCartSuccess
  | LineItemModificationsInvalidException
  | LocationClosed
  | LoyaltyScanTokenExpired
  | MaxEntreeReached
  | MaxModificationsExceeded
  | OrderLocked
  | ProductOutOfStock
  | RestaurantHoursMissing
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | UnauthorizedLineItemModification
  | UnauthorizedOrderModification
  | ValidationError;

export type EditLineItemInCartSuccess = {
  readonly __typename?: 'EditLineItemInCartSuccess';
  readonly cart: Order;
};

export type EditLineItemInCartWithLoyaltyInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  /** @deprecated Use customerToken instead */
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type EightySixIngredientInput = {
  readonly inStock: Scalars['Boolean']['input'];
  readonly ingredientId: Scalars['String']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId: Scalars['String']['input'];
};

export type EightySixProductInput = {
  readonly inStock: Scalars['Boolean']['input'];
  readonly productId: Scalars['String']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId: Scalars['String']['input'];
};

export type EightySixResponse = {
  readonly __typename?: 'EightySixResponse';
  readonly message: Scalars['String']['output'];
  readonly success: Scalars['Boolean']['output'];
};

export type EstimateRange = {
  readonly __typename?: 'EstimateRange';
  readonly end: Scalars['Int']['output'];
  readonly start: Scalars['Int']['output'];
};

export enum ExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export type ExpiredReceipt = UserError & {
  readonly __typename?: 'ExpiredReceipt';
  readonly errorMessage: Scalars['String']['output'];
};

export type FailedToFetchPaymentIntent = UserError & {
  readonly __typename?: 'FailedToFetchPaymentIntent';
  readonly errorMessage: Scalars['String']['output'];
};

export type FavoriteLineItemInput = {
  readonly favorited: Scalars['Boolean']['input'];
  readonly lineItemId: Scalars['ID']['input'];
  readonly productId: Scalars['ID']['input'];
};

export type FavoritedLineItemsInput = {
  readonly page: Scalars['Int']['input'];
};

export type FeedbackInput = {
  readonly id: Scalars['ID']['input'];
  readonly isFeedbackComplete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderType?: InputMaybe<FeedbackOrderType>;
  readonly questionId: Scalars['ID']['input'];
  readonly responseIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Order type used in FeedbackInput type */
export enum FeedbackOrderType {
  Delivery = 'Delivery',
  InStore = 'InStore',
  Pickup = 'Pickup',
}

export type FeedbackQuestion = {
  readonly __typename?: 'FeedbackQuestion';
  readonly id: Scalars['ID']['output'];
  readonly responses: Maybe<ReadonlyArray<FeedbackResponse>>;
  readonly slug: Maybe<Scalars['String']['output']>;
  readonly text: Maybe<Scalars['String']['output']>;
};

export type FeedbackResponse = {
  readonly __typename?: 'FeedbackResponse';
  readonly id: Scalars['ID']['output'];
  readonly text: Scalars['String']['output'];
};

export type FeedbackSuccess = {
  readonly __typename?: 'FeedbackSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type FieldValidationError = {
  readonly __typename?: 'FieldValidationError';
  readonly field: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
};

export enum FlattenedOrderStatuses {
  Completed = 'completed',
  Delivering = 'delivering',
  Failed = 'failed',
  Preparing = 'preparing',
  ReadyForCourier = 'readyForCourier',
  Received = 'received',
}

/** "Flex customer already exists" user error — the customer is already onboarded. */
export type FlexCustomerAlreadyExistsError = UserError & {
  readonly __typename?: 'FlexCustomerAlreadyExistsError';
  readonly errorMessage: Scalars['String']['output'];
};

export type FlexCustomerData = {
  readonly __typename?: 'FlexCustomerData';
  /** Cards banked with Flex for this customer. Empty when none are on file. */
  readonly flexPaymentMethods: ReadonlyArray<FlexPaymentMethod>;
};

export type FlexCustomerDataResponseUnion = FlexCustomerData | UnableToGetFlexCustomerDataError;

export type FlexOnboardingSession = {
  readonly __typename?: 'FlexOnboardingSession';
  /** Session expiry as unix epoch seconds. */
  readonly expiresAt: Scalars['Int']['output'];
  /** Flex-hosted onboarding page URL to redirect the customer to. */
  readonly redirectUrl: Scalars['String']['output'];
  /** Session status: open | complete | expired | canceled. */
  readonly status: Scalars['String']['output'];
};

export type FlexOnboardingSessionResponseUnion =
  | FlexCustomerAlreadyExistsError
  | FlexOnboardingSession;

export type FlexPaymentMethod = {
  readonly __typename?: 'FlexPaymentMethod';
  /** Card brand, e.g. "visa". */
  readonly brand: Maybe<Scalars['String']['output']>;
  readonly expMonth: Maybe<Scalars['Int']['output']>;
  readonly expYear: Maybe<Scalars['Int']['output']>;
  /** Last four digits of the card. */
  readonly last4: Maybe<Scalars['String']['output']>;
};

/** Forbidden error - insufficient permissions or scopes */
export type ForbiddenError = {
  readonly __typename?: 'ForbiddenError';
  readonly code: Scalars['String']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type GenerateTransactionPlanInput = {
  /** The payment method card to use. */
  readonly paymentMethodCardId?: InputMaybe<Scalars['String']['input']>;
  /** Tip, in cents. Added on top of the order total for the amount to plan. */
  readonly tip?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to apply stored-value credit. */
  readonly useCredit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to apply HSA/FSA (Flex). */
  readonly useHsa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetKioskPaymentsForCurrentDateInput = {
  readonly restaurantEntityId: Scalars['Float']['input'];
  readonly utcOffset: Scalars['Float']['input'];
};

/** Payments for current day */
export type GetKioskPaymentsForCurrentDateResponse = {
  readonly __typename?: 'GetKioskPaymentsForCurrentDateResponse';
  readonly id: Scalars['ID']['output'];
  readonly payments: ReadonlyArray<KioskPayment>;
};

/** Successful kiosk reader location fetch */
export type GetKioskReaderLocationIdResponse = {
  readonly __typename?: 'GetKioskReaderLocationIdResponse';
  readonly id: Scalars['String']['output'];
};

/** "Gift card associated with another account" user error */
export type GiftCardAssociatedWithAnotherAccountError = UserError & {
  readonly __typename?: 'GiftCardAssociatedWithAnotherAccountError';
  readonly errorMessage: Scalars['String']['output'];
};

/** The customer's gift card balance result */
export type GiftCardBalance = {
  readonly __typename?: 'GiftCardBalance';
  /** Customer's ID. NOTE: It can be useful for client-side caching. */
  readonly customerId: Scalars['String']['output'];
  /** Customer's gift card balance in cents */
  readonly giftCardBalance: Scalars['Float']['output'];
};

export type GiftCardBalanceResponseUnion = GiftCardBalance | UnableToGetGiftCardBalanceError;

/** The gift card order's delivery details */
export type GiftCardDeliveryDetail = {
  readonly __typename?: 'GiftCardDeliveryDetail';
  readonly deliveryDateTime: Maybe<Scalars['DateTime']['output']>;
  readonly deliveryMethods: ReadonlyArray<Scalars['String']['output']>;
  readonly isAsap: Scalars['Boolean']['output'];
};

/** Gift card was not found */
export type GiftCardNotFoundError = UserError & {
  readonly __typename?: 'GiftCardNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Successful gift card order details */
export type GiftCardOrderDetail = {
  readonly __typename?: 'GiftCardOrderDetail';
  /** Delivery options for the gift card order. */
  readonly deliveryDetail: GiftCardDeliveryDetail;
  /** Gift card order ID. */
  readonly id: Scalars['String']['output'];
  /** Gift card order purchase time. */
  readonly purchasedAt: Scalars['DateTime']['output'];
  /** Purchased gift cards. */
  readonly userGiftCards: ReadonlyArray<UserGiftCard>;
};

export type GiftCardOrderDetailResponseUnion = GiftCardOrderDetail | GiftCardOrderNotFoundError;

/** Gift card order was not found */
export type GiftCardOrderNotFoundError = UserError & {
  readonly __typename?: 'GiftCardOrderNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Successful gift card purchase history */
export type GiftCardPurchaseHistory = {
  readonly __typename?: 'GiftCardPurchaseHistory';
  /** Customer's ID. It can be useful for client-side caching. */
  readonly customerId: Scalars['String']['output'];
  /** A list of gift card orders for this user. */
  readonly giftCardOrders: ReadonlyArray<GiftCardOrderDetail>;
};

export type GiftCardRedemptionDetailResponseUnion =
  | GiftCardNotFoundError
  | GiftCardRedemptionDetailSuccess;

/** Successful gift card redemption details */
export type GiftCardRedemptionDetailSuccess = {
  readonly __typename?: 'GiftCardRedemptionDetailSuccess';
  /** Gift card asset id. */
  readonly assetId: Maybe<Scalars['String']['output']>;
  /** Gift card balance. */
  readonly balance: Scalars['Float']['output'];
  /** Gift card number. */
  readonly cardNumber: Scalars['String']['output'];
  /** Gift card reg code. */
  readonly cardRegCode: Scalars['String']['output'];
  /** Message for gift card recipient. */
  readonly recipientMessage: Maybe<Scalars['String']['output']>;
  /** Gift card recipient's name. */
  readonly recipientName: Scalars['String']['output'];
  /** Gift card redemption id. */
  readonly redeemId: Scalars['String']['output'];
  /** Gift card sender's name. */
  readonly senderName: Scalars['String']['output'];
};

export enum GravyStatusType {
  ArrivedAtDropoff = 'ARRIVED_AT_DROPOFF',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryFailed = 'DELIVERY_FAILED',
  KitchenCompleted = 'KITCHEN_COMPLETED',
  OrderCreated = 'ORDER_CREATED',
  OrderStatusFailed = 'ORDER_STATUS_FAILED',
  OrderStatusPreorderFailed = 'ORDER_STATUS_PREORDER_FAILED',
  OrderSubmitted = 'ORDER_SUBMITTED',
  SubmitFailed = 'SUBMIT_FAILED',
  Unknown = 'UNKNOWN',
}

export type Guest = {
  readonly __typename?: 'Guest';
  readonly email: Maybe<Scalars['String']['output']>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
};

/** Used to determine if the user has unseen challenges, meaning they haven't yet queried for the challenge. */
export type HasUnseenChallenges = {
  readonly __typename?: 'HasUnseenChallenges';
  readonly hasUnseenChallenges: Scalars['Boolean']['output'];
};

export type HurdleBehavior = {
  readonly __typename?: 'HurdleBehavior';
  readonly achieved: Scalars['Float']['output'];
  readonly goal: Scalars['Float']['output'];
  readonly outcome: Scalars['Int']['output'];
  readonly progress: Scalars['Float']['output'];
};

export type HurdleBehaviorDetails = {
  readonly __typename?: 'HurdleBehaviorDetails';
  readonly hurdleBehaviors: ReadonlyArray<HurdleBehavior>;
};

export type IdentifyAndClaimInStoreOrderInput = {
  /** ISO Format, e.g. 2024-01-15T10:30:00Z */
  readonly date: Scalars['String']['input'];
  /** POS if alphanumeric, Kiosk otherwise */
  readonly orderId: Scalars['ID']['input'];
  /** Only numbers, may begin with 0 */
  readonly restaurantZip: Scalars['String']['input'];
  /** Total in cents */
  readonly total: Scalars['Int']['input'];
};

export type IdentifyAndClaimInStoreOrderResponseUnion =
  | IdentifyAndClaimInStoreOrderSuccess
  | ReceiptAlreadyClaimedError
  | TimeRestrictionError
  | TransactionNotFoundError;

export type IdentifyAndClaimInStoreOrderSuccess = {
  readonly __typename?: 'IdentifyAndClaimInStoreOrderSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type InStoreOrder = {
  readonly __typename?: 'InStoreOrder';
  readonly id: Scalars['ID']['output'];
  readonly isPendingFeedback: Scalars['Boolean']['output'];
  readonly ledger: InStoreOrderLedger;
  readonly lineItems: ReadonlyArray<InStoreOrderLineItem>;
  readonly orderStatus: Scalars['String']['output'];
  readonly restaurant: InStoreOrderRestaurant;
  readonly vendorId: Scalars['String']['output'];
  readonly wantedTime: Scalars['String']['output'];
};

export type InStoreOrderDiscount = {
  readonly __typename?: 'InStoreOrderDiscount';
  readonly amount: Scalars['Float']['output'];
  readonly isLoyalty: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type InStoreOrderInput = {
  readonly id: Scalars['ID']['input'];
};

export type InStoreOrderLedger = {
  readonly __typename?: 'InStoreOrderLedger';
  readonly discounts: ReadonlyArray<InStoreOrderDiscount>;
  readonly payments: ReadonlyArray<InStoreOrderPayment>;
  readonly subtotal: Scalars['Float']['output'];
  readonly tax: Scalars['Float']['output'];
  readonly tip: Scalars['Float']['output'];
  readonly total: Scalars['Float']['output'];
};

export type InStoreOrderLineItem = {
  readonly __typename?: 'InStoreOrderLineItem';
  readonly asset: InStoreOrderLineItemAsset;
  readonly brinkId: Scalars['String']['output'];
  readonly isCustom: Scalars['Boolean']['output'];
  readonly isCustomProduct: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly price: Scalars['Float']['output'];
  readonly quantity: Scalars['Float']['output'];
};

export type InStoreOrderLineItemAsset = {
  readonly __typename?: 'InStoreOrderLineItemAsset';
  readonly url: Scalars['String']['output'];
};

export type InStoreOrderPayment = {
  readonly __typename?: 'InStoreOrderPayment';
  readonly amount: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
};

export type InStoreOrderRestaurant = {
  readonly __typename?: 'InStoreOrderRestaurant';
  readonly address: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly entityId: Scalars['ID']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly zipCode: Scalars['String']['output'];
};

export type InStoreOrdersInput = {
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type InStoreOrdersResponse = {
  readonly __typename?: 'InStoreOrdersResponse';
  readonly inStoreOrders: ReadonlyArray<InStoreOrder>;
  readonly pagination: Pagination;
};

export type IncorrectPaymentMethod = UserError & {
  readonly __typename?: 'IncorrectPaymentMethod';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Ingredient = {
  readonly __typename?: 'Ingredient';
  readonly allergenProperties: ReadonlyArray<AllergenProperty>;
  readonly asset: Asset;
  readonly availableDate: Maybe<Scalars['DateTime']['output']>;
  readonly calories: Maybe<Scalars['Float']['output']>;
  readonly caloriesFromFat: Maybe<Scalars['Float']['output']>;
  readonly cholesterolMg: Maybe<Scalars['Float']['output']>;
  readonly co2eKg: Maybe<Scalars['Float']['output']>;
  readonly dietaryFiberG: Maybe<Scalars['Float']['output']>;
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isGrain: Maybe<Scalars['Boolean']['output']>;
  readonly isMixable: Maybe<Scalars['Boolean']['output']>;
  readonly isWarmBase: Maybe<Scalars['Boolean']['output']>;
  readonly kind: Maybe<IngredientKind>;
  readonly lineageKey: Maybe<Scalars['String']['output']>;
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly proteinG: Maybe<Scalars['Float']['output']>;
  readonly saturatedFatG: Maybe<Scalars['Float']['output']>;
  readonly servingMeasure: Maybe<Scalars['Float']['output']>;
  readonly servingUnitOfMeasure: Maybe<Scalars['String']['output']>;
  readonly sodiumMg: Maybe<Scalars['Float']['output']>;
  readonly sugarsG: Maybe<Scalars['Float']['output']>;
  readonly totalCarbsG: Maybe<Scalars['Float']['output']>;
  readonly totalFatG: Maybe<Scalars['Float']['output']>;
  readonly transFatG: Maybe<Scalars['Float']['output']>;
};

export type IngredientAssetArgs = {
  version?: InputMaybe<IngredientAssetVersion>;
};

export type IngredientCaloriesArgs = {
  version?: InputMaybe<CaloriesVersion>;
};

/** Ingredient asset version */
export enum IngredientAssetVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum IngredientKind {
  Base = 'BASE',
  Dressing = 'DRESSING',
  Premium = 'PREMIUM',
  Topping = 'TOPPING',
}

export type IngredientModification = {
  readonly __typename?: 'IngredientModification';
  readonly additionCost: Scalars['Float']['output'];
  readonly calories: Scalars['Float']['output'];
  readonly ingredient: Ingredient;
  /** Asserts whether the ingredient modification is a "grain" type (like "rice," "quinoa," etc.) */
  readonly isGrain: Scalars['Boolean']['output'];
  readonly kind: Maybe<Scalars['String']['output']>;
  /** Is the modification able to be mixed-in to the salad, primarily used for dressings */
  readonly mixable: Scalars['Boolean']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  readonly removalCost: Scalars['Float']['output'];
  readonly subKind: Maybe<Scalars['String']['output']>;
  readonly substitutionCost: Scalars['Float']['output'];
};

export type IngredientModificationInput = {
  readonly ingredientId: Scalars['ID']['input'];
};

export type IngredientModificationKind = {
  readonly __typename?: 'IngredientModificationKind';
  /** The kind allows multiple quantity selections for a modification. */
  readonly allowMultipleQuantity: Scalars['Boolean']['output'];
  /** The number of free ingredient modifications that can be added of this kind. */
  readonly freeAggregateQuantity: Scalars['Int']['output'];
  /** The maximum number of ingredient modifications that can be of this kind. */
  readonly maxAggregateQuantity: Scalars['Int']['output'];
  /** The minimum number of ingredient modifications that can be of this kind. */
  readonly minAggregateQuantity: Scalars['Int']['output'];
  readonly modifications: ReadonlyArray<IngredientModification>;
};

export type IngredientModifications = {
  readonly __typename?: 'IngredientModifications';
  readonly bases: IngredientModificationKind;
  readonly bread: IngredientModificationKind;
  readonly dressings: IngredientModificationKind;
  readonly premiums: IngredientModificationKind;
  readonly toppings: IngredientModificationKind;
};

export type IngredientModifier = {
  readonly __typename?: 'IngredientModifier';
  readonly additionCost: Scalars['Float']['output'];
  readonly brinkPlu: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ingredient: Maybe<Ingredient>;
  /** Raw ingredient ID without modifier group encoding. Use this to join the same ingredient across included and extras modifier groups. */
  readonly ingredientId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Maybe<Scalars['Boolean']['output']>;
  readonly removalCost: Scalars['Float']['output'];
  readonly subKind: Maybe<Scalars['String']['output']>;
  readonly substitutionCost: Scalars['Float']['output'];
};

export type IngredientSubstitutionModificationInput = {
  readonly addedIngredientId: Scalars['ID']['input'];
  readonly removedIngredientId: Scalars['ID']['input'];
};

export type InvalidAddress = {
  readonly __typename?: 'InvalidAddress';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidBillingAccount = UserError & {
  readonly __typename?: 'InvalidBillingAccount';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidCreditCard = UserError & {
  readonly __typename?: 'InvalidCreditCard';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidCustomerPhone = UserError & {
  readonly __typename?: 'InvalidCustomerPhone';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Invalid gift card" user error */
export type InvalidGiftCardError = UserError & {
  readonly __typename?: 'InvalidGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

export type InvalidInput = {
  readonly __typename?: 'InvalidInput';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidOrder = UserError & {
  readonly __typename?: 'InvalidOrder';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidPromoCode = {
  readonly __typename?: 'InvalidPromoCode';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidRefundAmount = UserError & {
  readonly __typename?: 'InvalidRefundAmount';
  readonly errorMessage: Scalars['String']['output'];
};

export type InvalidTip = UserError & {
  readonly __typename?: 'InvalidTip';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type IssueCustomerSupportCreditResult = {
  readonly __typename?: 'IssueCustomerSupportCreditResult';
  readonly success: Scalars['Boolean']['output'];
};

export type IssueCustomerSupportPointsFailureError = UserError & {
  readonly __typename?: 'IssueCustomerSupportPointsFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Response for issuing customer support points */
export type IssueCustomerSupportPointsResponse =
  | IssueCustomerSupportPointsFailureError
  | IssueCustomerSupportPointsSuccessResponse;

/** Success response for issuing customer support points */
export type IssueCustomerSupportPointsSuccessResponse = {
  readonly __typename?: 'IssueCustomerSupportPointsSuccessResponse';
  readonly credits: Scalars['Int']['output'];
};

export type JoinMultipartyOrderInput = {
  readonly customerName: Scalars['String']['input'];
  readonly joinCode: Scalars['String']['input'];
};

export type JoinMultipartyOrderResponseUnion =
  | JoinMultipartyOrderSuccess
  | MultipartyOrderNotFound
  | OrderLocked
  | ValidationError;

export type JoinMultipartyOrderSuccess = {
  readonly __typename?: 'JoinMultipartyOrderSuccess';
  readonly order: Order;
};

export type KioskCustomerProfile = {
  readonly __typename?: 'KioskCustomerProfile';
  readonly firstName: Maybe<Scalars['String']['output']>;
  /** Gravy customer ID */
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
  /** Vendor Loyalty ID of the current customer */
  readonly loyaltyId: Maybe<Scalars['String']['output']>;
};

export type KioskCustomerScanPaymentInfo = {
  readonly __typename?: 'KioskCustomerScanPaymentInfo';
  readonly cardBrand: Maybe<Scalars['String']['output']>;
  readonly cardLast4: Maybe<Scalars['String']['output']>;
  readonly creditBalance: Maybe<Scalars['Int']['output']>;
};

export type KioskCustomerScanPaymentInfoError = UserError & {
  readonly __typename?: 'KioskCustomerScanPaymentInfoError';
  readonly errorMessage: Scalars['String']['output'];
};

export type KioskCustomerScanPaymentInfoResponse =
  | KioskCustomerScanPaymentInfoError
  | KioskCustomerScanPaymentInfoSuccess;

export type KioskCustomerScanPaymentInfoSuccess = {
  readonly __typename?: 'KioskCustomerScanPaymentInfoSuccess';
  readonly payment: Maybe<KioskCustomerScanPaymentInfo>;
  readonly purpose: LoyaltyAccessTokenPurpose;
};

export type KioskPayment = {
  readonly __typename?: 'KioskPayment';
  readonly amount: Scalars['Int']['output'];
  readonly cardBrand: Maybe<Scalars['String']['output']>;
  readonly cardholderName: Maybe<Scalars['String']['output']>;
  readonly created: Scalars['String']['output'];
  /** payment id */
  readonly id: Scalars['ID']['output'];
  readonly last4: Maybe<Scalars['String']['output']>;
  readonly orderId: Scalars['String']['output'];
  readonly receiptUrl: Maybe<Scalars['String']['output']>;
  readonly refunded: Scalars['Boolean']['output'];
  readonly refundedAmount: Scalars['Int']['output'];
  readonly status: Scalars['String']['output'];
};

export type KioskRefundInput = {
  /** Full name of administrator who is refunding */
  readonly administratorName: Scalars['String']['input'];
  readonly amount: Scalars['Int']['input'];
  readonly orderId: Scalars['String']['input'];
  readonly reason: Scalars['String']['input'];
};

export type KioskRefundReceiptInput = {
  readonly email: Scalars['String']['input'];
  readonly orderId: Scalars['String']['input'];
};

/** JWT token used to login a user in Kustomer */
export type Kustomer = {
  readonly __typename?: 'Kustomer';
  readonly token: Scalars['String']['output'];
};

export type LeaveMultipartyOrderResponseUnion =
  | LeaveOrderSuccess
  | MultipartyOrderNotFound
  | OrderLocked
  | ValidationError;

export type LeaveOrderSuccess = {
  readonly __typename?: 'LeaveOrderSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type Ledger = {
  readonly __typename?: 'Ledger';
  /** Items that reduce the post-tax cost (i.e. total) of the order. */
  readonly credits: ReadonlyArray<LedgerItem>;
  /** Sum of all credits */
  readonly creditsTotal: Scalars['Int']['output'];
  /** Items that reduce the pre-tax cost of the order, usually the result of applying offers. */
  readonly discounts: ReadonlyArray<LedgerItem>;
  /** Sum of all discounts */
  readonly discountsTotal: Scalars['Int']['output'];
  readonly fees: ReadonlyArray<LedgerItem>;
  /** Sum of all fees */
  readonly feesTotal: Scalars['Int']['output'];
  /** Loyalty vendor IDs of the selected discounts */
  readonly selectedRewards: ReadonlyArray<Scalars['String']['output']>;
  /** Sum of the cost of all line items. */
  readonly subtotal: Scalars['Int']['output'];
  readonly tax: Scalars['Int']['output'];
  /** Tip applied to order in cents */
  readonly tip: Scalars['Int']['output'];
};

export type LedgerItem = {
  readonly __typename?: 'LedgerItem';
  readonly amount: Scalars['Int']['output'];
  /** May be shown as a tooltip or flyout in clients */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};

export type LineItem = {
  readonly __typename?: 'LineItem';
  /** The ingredients that have been added on to the line item when compared to the product's default ingredients. */
  readonly addedIngredients: ReadonlyArray<Ingredient>;
  /** The total number of calories in the line item */
  readonly calories: Scalars['Int']['output'];
  /** Whether the line item can be edited. */
  readonly canEdit: Scalars['Boolean']['output'];
  /** Whether the line item can be reordered at the selected restaurant. */
  readonly canReorderAtRestaurant: Scalars['Boolean']['output'];
  /**
   * The raw ingredient ids of the line item's net ingredients (default minus removals, plus added/subbed). Duplicates are preserved so each ingredient occurrence is represented.
   * @deprecated Use consolidatedIngredients
   */
  readonly consolidatedIngredientIds: ReadonlyArray<Scalars['ID']['output']>;
  /** The line item's net ingredients grouped by id, with an occurrence count and a dressing flag. */
  readonly consolidatedIngredients: ReadonlyArray<ConsolidatedIngredient>;
  /** The per item cost multiplied by the quantity, in cents. */
  readonly cost: Scalars['Int']['output'];
  /** The custom name for the line item that has been specified by the user. */
  readonly customName: Maybe<Scalars['String']['output']>;
  /** Name of the customer who ordered this lineItem */
  readonly customerName: Scalars['String']['output'];
  /** Dressing status, if the product is dressable. Otherwise NOT_DRESSABLE. */
  readonly dressingMode: DressingMode;
  /** Whether the line item is marked as favorite. */
  readonly favorited: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** The ingredients that make up the line item. These ingredients include any added or removed ingredients compared to the product's default ingredients. */
  readonly ingredients: ReadonlyArray<Ingredient>;
  /** Whether the line item has been customized. */
  readonly isCustom: Scalars['Boolean']['output'];
  /** Information outlining which dressings are mixed into the line item and their associated weights. */
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetails>;
  /** The order participant associated with the line item. */
  readonly orderParticipant: Maybe<OrderParticipant>;
  /** The per item cost of the product as configured, in cents. */
  readonly perItemCost: Scalars['Int']['output'];
  /** The product associated with a line item. */
  readonly product: Product;
  /** The number of products in the line item. */
  readonly quantity: Scalars['Int']['output'];
  /** The ingredients that have been removed from the line item when compared to the product's default ingredients. */
  readonly removedIngredients: ReadonlyArray<Ingredient>;
  /** Line item selected modifiers with ingredient and cost details. */
  readonly selectedModifiers: ReadonlyArray<SelectedModifier>;
  readonly slug: Scalars['ID']['output'];
};

export type LineItemCanReorderAtRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
};

export type LineItemBySlugInput = {
  readonly slug: Scalars['ID']['input'];
};

export type LineItemInput = {
  readonly id: Scalars['ID']['input'];
};

export type LineItemModificationsInvalidException = UserError & {
  readonly __typename?: 'LineItemModificationsInvalidException';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LineItemNotFound = {
  readonly __typename?: 'LineItemNotFound';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LineItemRecommendation = {
  readonly __typename?: 'LineItemRecommendation';
  /** The date and time the recommendation was created. */
  readonly createdAt: Scalars['String']['output'];
  /** The description of the recommendation - commonly the list of ingredients. */
  readonly description: Scalars['String']['output'];
  /** The identifier for the complete item provided by this recommendation. */
  readonly id: Scalars['String']['output'];
  /** The ingredients that make up this recommendation. */
  readonly ingredientIds: ReadonlyArray<Scalars['String']['output']>;
  readonly ingredients: ReadonlyArray<Ingredient>;
  /** The name of the recommendation. */
  readonly name: Scalars['String']['output'];
  /** Whether the recommendation is based on a previous ordered item or is a new item */
  readonly recommendationType: RecommendationType;
};

export type LineItemResponseUnion = LineItemNotFound | LineItemSuccess | ValidationError;

export type LineItemSuccess = {
  readonly __typename?: 'LineItemSuccess';
  readonly lineItem: LineItem;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly estimateRange: EstimateRange;
  readonly restaurant: Restaurant;
  readonly status: LocationStatus;
  readonly vendor: Vendor;
};

export type LocationByAddressIdInput = {
  /** id for an address present in the current session. */
  readonly addressId: Scalars['ID']['input'];
  readonly useCartRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationByAddressInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  /** id for an address present in the current session. */
  readonly addressId?: InputMaybe<Scalars['ID']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly lat?: InputMaybe<Scalars['Float']['input']>;
  readonly lon?: InputMaybe<Scalars['Float']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly useCartRestaurant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly zipcode?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationByAddressResponseUnion =
  | InvalidInput
  | Location
  | NoValidRestaurants
  | ValidationError;

export type LocationByAddressV2Input = {
  readonly address1: Scalars['String']['input'];
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly city: Scalars['String']['input'];
  readonly lat: Scalars['Float']['input'];
  readonly lon: Scalars['Float']['input'];
  readonly state: Scalars['String']['input'];
  readonly zipcode: Scalars['Int']['input'];
};

export type LocationClosed = UserError & {
  readonly __typename?: 'LocationClosed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export enum LocationStatus {
  Closed = 'CLOSED',
  Invalid = 'INVALID',
  Open = 'OPEN',
}

export type LockOrderFailed = UserError & {
  readonly __typename?: 'LockOrderFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LockOrderInput = {
  readonly reason: LockOrderReason;
};

/** The reason why the order is being locked */
export enum LockOrderReason {
  ChangeLocation = 'CHANGE_LOCATION',
  Checkout = 'CHECKOUT',
}

export type LockOrderResponseUnion =
  | CartNotFound
  | LockOrderFailed
  | LockOrderSuccess
  | OrderLocked;

export type LockOrderSuccess = {
  readonly __typename?: 'LockOrderSuccess';
  readonly order: Order;
};

export type LogoutInput = {
  readonly customerId: Scalars['ID']['input'];
};

export type LogoutResponseUnion = LogoutSuccess | ValidationError;

export type LogoutSuccess = {
  readonly __typename?: 'LogoutSuccess';
  readonly csrf: Scalars['String']['output'];
};

/** User's loyalty access token to display in the QR code for scanning in store */
export type LoyaltyAccessToken = {
  readonly __typename?: 'LoyaltyAccessToken';
  /** The ISO 8601 timestamp when the token will expire. */
  readonly expiresAt: Scalars['DateTime']['output'];
  /** The JWT to be encoded into the QR code. */
  readonly token: Scalars['String']['output'];
};

/** The purpose of the customer access token. */
export enum LoyaltyAccessTokenPurpose {
  Identify = 'IDENTIFY',
  Payment = 'PAYMENT',
}

/** Error thrown when a user fails to opt into a challenge */
export type LoyaltyOptInFailed = UserError & {
  readonly __typename?: 'LoyaltyOptInFailed';
  readonly errorMessage: Scalars['String']['output'];
};

/** User's loyalty payment metadata to store in the QR code for scanning in store */
export type LoyaltyPaymentMetadata = {
  /** The payment method (credit card) used for the transaction. */
  readonly paymentMethodId: Scalars['String']['input'];
  /** Whether to use credit for the transaction. */
  readonly useCredit: Scalars['Boolean']['input'];
};

/** Customer Loyalty Profile */
export type LoyaltyProfile = {
  readonly __typename?: 'LoyaltyProfile';
  /** External user id */
  readonly customerId: Scalars['ID']['output'];
  readonly customerToken: Maybe<CustomerTokenResponseUnion>;
  /**
   * Customer has subscribed before
   * @deprecated sunsetting sweetpass+
   */
  readonly hasPaidTierHistory: Scalars['Boolean']['output'];
  /** Date the loyalty profile was created */
  readonly joinDate: Scalars['DateTime']['output'];
  /** Loyalty ID (SessionM Profile ID) of the current customer */
  readonly loyaltyId: Maybe<Scalars['String']['output']>;
  readonly points: Maybe<UserPointsStatus>;
  readonly pointsRewards: Maybe<ReadonlyArray<PointsReward>>;
  readonly rewards: Maybe<ReadonlyArray<Reward>>;
  readonly rewardsPremiumStatus: Maybe<RewardsPremiumStatus>;
  /** Customer Tier */
  readonly tier: Maybe<Tier>;
  /** Customer Tier */
  readonly tierStatus: Maybe<TierStatus>;
  /**
   * User trial eligibility. If empty then the user is not eligible
   * @deprecated Free trials are no longer supported
   */
  readonly trialEligible: Maybe<ReadonlyArray<TrialEligibility>>;
};

/** Customer Loyalty Profile */
export type LoyaltyProfileCustomerTokenArgs = {
  paymentMetadata?: InputMaybe<LoyaltyPaymentMetadata>;
  purpose: LoyaltyAccessTokenPurpose;
};

export type LoyaltyScanPaymentTokenInvalid = UserError & {
  readonly __typename?: 'LoyaltyScanPaymentTokenInvalid';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LoyaltyScanTokenExpired = UserError & {
  readonly __typename?: 'LoyaltyScanTokenExpired';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MaxEntreeReached = UserError & {
  readonly __typename?: 'MaxEntreeReached';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MaxModificationsExceeded = UserError & {
  readonly __typename?: 'MaxModificationsExceeded';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Menu = {
  readonly __typename?: 'Menu';
  readonly categories: ReadonlyArray<MenuCategory>;
  readonly id: Scalars['String']['output'];
};

export type MenuCategory = {
  readonly __typename?: 'MenuCategory';
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isCustom: Scalars['Boolean']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly products: ReadonlyArray<Product>;
};

export type MenuCollection = {
  readonly __typename?: 'MenuCollection';
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly primaryDescription: Scalars['String']['output'];
  readonly primaryImageUrl: Scalars['String']['output'];
  readonly primaryTitle: Scalars['String']['output'];
  readonly products: ReadonlyArray<Product>;
  readonly secondaryDescription: Maybe<Scalars['String']['output']>;
  readonly secondaryTitle: Maybe<Scalars['String']['output']>;
};

export type MenuNotFound = UserError & {
  readonly __typename?: 'MenuNotFound';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MinimumDeliverySubtotalNotMet = UserError & {
  readonly __typename?: 'MinimumDeliverySubtotalNotMet';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MixedDressingDetails = {
  readonly __typename?: 'MixedDressingDetails';
  readonly ingredientId: Scalars['ID']['output'];
  readonly weight: DressingWeight;
};

export type MixedDressingDetailsInput = {
  readonly ingredientId: Scalars['ID']['input'];
  readonly weight: DressingWeight;
};

export type ModifierGroup = {
  readonly __typename?: 'ModifierGroup';
  readonly allowMultipleQuantity: Scalars['Boolean']['output'];
  readonly displayName: Scalars['String']['output'];
  /** Prompt user to select above the minimum quantity for this modifier group */
  readonly encourageAboveMinSelection: Scalars['Boolean']['output'];
  /** Prompt user to select the maximum quantity for this modifier group */
  readonly encourageMaxSelection: Scalars['Boolean']['output'];
  readonly freeAggregateQuantity: Scalars['Float']['output'];
  /** Role of this modifier group for included pricing. Null treated as CORE for backward compatibility. */
  readonly groupRole: Maybe<ModifierGroupRole>;
  /** When true, maxAggregateQuantity is dynamically computed from the product recipe ingredient count in this group. */
  readonly hasDynamicMax: Maybe<Scalars['Boolean']['output']>;
  /** Helper text displayed to users for this modifier group */
  readonly helperText: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly maxAggregateQuantity: Scalars['Float']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly minAggregateQuantity: Scalars['Float']['output'];
  readonly modifications: ReadonlyArray<IngredientModifier>;
  readonly name: Scalars['String']['output'];
  /** ID of the paired modifier group. Extras groups reference their included group so the frontend can merge them into a single visual section. */
  readonly pairedGroupId: Maybe<Scalars['String']['output']>;
  readonly restaurantId: Scalars['String']['output'];
  /** The variation type for this modifier group */
  readonly variation: ModifierGroupVariation;
};

/** Role of a modifier group for included pricing. Null treated as CORE for backward compatibility. */
export enum ModifierGroupRole {
  /** Always-visible groups (e.g., dressings, bread) */
  Core = 'CORE',
  /** Paired add-on groups for items beyond the included set */
  Extras = 'EXTRAS',
  /** Groups whose items are part of the product recipe */
  Included = 'INCLUDED',
  /** Old-style groups replaced by INCLUDED+EXTRAS pairs */
  Legacy = 'LEGACY',
}

/** The variation type for a modifier group */
export enum ModifierGroupVariation {
  PortionStepper = 'PORTION_STEPPER',
  SplitPortion = 'SPLIT_PORTION',
  Standard = 'STANDARD',
}

/** The version of modifier group structure to return. v1 returns legacy flat groups, v2 returns included pricing split groups. */
export enum ModifierGroupVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum ModifierType {
  Addition = 'ADDITION',
  Included = 'INCLUDED',
  MixedDressing = 'MIXED_DRESSING',
  Removal = 'REMOVAL',
  Substitution = 'SUBSTITUTION',
}

export type MultipartyDetail = {
  readonly __typename?: 'MultipartyDetail';
  readonly displayName: Scalars['String']['output'];
  /** Code that hosts share with invitees to join multiparty order */
  readonly joinCode: Scalars['String']['output'];
};

export type MultipartyDetailInput = {
  readonly hostName: Scalars['String']['input'];
};

export type MultipartyOrderAlreadyJoined = {
  readonly __typename?: 'MultipartyOrderAlreadyJoined';
  readonly order: Order;
};

export type MultipartyOrderNotEnabled = UserError & {
  readonly __typename?: 'MultipartyOrderNotEnabled';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MultipartyOrderNotFound = UserError & {
  readonly __typename?: 'MultipartyOrderNotFound';
  readonly errorMessage: Scalars['String']['output'];
};

export type MultipartyOrderPreviewResponseUnion =
  | MultipartyOrderAlreadyJoined
  | MultipartyOrderNotFound
  | MultipartyOrderPreviewSuccess
  | OrderLocked;

export type MultipartyOrderPreviewSuccess = {
  readonly __typename?: 'MultipartyOrderPreviewSuccess';
  /** Delivery address summary. Null if order is for pickup */
  readonly deliveryAddressSummary: Maybe<Scalars['String']['output']>;
  readonly hostDisplayName: Scalars['String']['output'];
  readonly orderDisplayName: Scalars['String']['output'];
  readonly restaurant: Restaurant;
};

export type MultipleBehaviorDetailsUnion = HurdleBehaviorDetails;

export type Mutation = {
  readonly __typename?: 'Mutation';
  /**
   * Adds an address to the customer's list of addresses.
   * @deprecated Migrating away from google place id. Use addAddressV2
   */
  readonly addAddress: AddAddressResponseUnion;
  /** Adds an address to the customer's list of addresses. */
  readonly addAddressV2: AddAddressResponseUnion;
  readonly addLineItemBatchToCart: AddLineItemToCartResponseUnion;
  readonly addLineItemToCart: AddLineItemToCartResponseUnion;
  /** Adds a line item to the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly addLineItemToCartWithLoyalty: AddLineItemToCartResponseUnion;
  readonly anonymizeCustomer: Scalars['Boolean']['output'];
  /** Apply a snapshot of a global chit template to one accessible restaurant. */
  readonly applyAdminPrintPriorityTemplate: AdminPrintPriorityTemplate;
  readonly applyReward: ApplyRewardResponseUnion;
  /** @deprecated Use applyRewardWithLoyalty instead */
  readonly applyRewardByLoyaltyId: ApplyRewardResponseUnion;
  readonly applyRewardWithLoyalty: ApplyRewardResponseUnion;
  /**
   * Attempts to cancel and refund an order.
   * @deprecated Use cancelOrderV2 instead.
   */
  readonly cancelOrder: CancelOrderResponseUnion;
  /** Attempts to cancel an order from an external source. */
  readonly cancelOrderExternal: CancelOrderExternalResponseUnion;
  readonly cancelOrderPaymentIntent: CancelOrderPaymentIntentResponse;
  /** Attempts to cancel and refund an order. */
  readonly cancelOrderV2: CancelOrderResponseUnion;
  /**
   * Takes a challenge ID (a.k.a. SessionM campaign ID) as an argument and opts customer into the identified challenge.  Returns the challenge details upon success. If an error occurs, the error field will be populated in the response: errors[0].message = modal title, errors[0].extension.detailedMessage = modal description/friendly message detailing what went wrong
   * @deprecated Use challengeOptInV2
   */
  readonly challengeOptIn: Challenge;
  /** Takes a challenge ID (a.k.a. SessionM campaign ID) as an argument and opts customer into the identified challenge.  Returns the challenge details upon success. If an error occurs, LoyaltyOptInFailed will be returned with the error details in the error field. */
  readonly challengeOptInV2: ChallengeOptInResultUnion;
  readonly claimLoyaltyPromotion: ClaimLoyaltyPromotionResponseUnion;
  readonly convertToMultipartyOrder: ConvertToMultipartyOrderResponseUnion;
  /** Creates a new account for the customer. */
  readonly createAccount: CreateAccountResponseUnion;
  readonly createAdminPrintPriorityTemplate: AdminPrintPriorityTemplate;
  /** Create an empty upsell category, ranked last. Audited. */
  readonly createAdminUpsellCategory: AdminUpsellCategory;
  /** Creates and submits an order for a guest customer in a single operation. */
  readonly createAndSubmitPrepaidOrder: SubmitOrderWithPaymentMethodResponseUnion;
  /** Creates a new connection token to pass to the Stripe Terminal SDK */
  readonly createConnectionToken: CreateConnectionTokenResponse;
  readonly createFlexOnboardingSession: FlexOnboardingSessionResponseUnion;
  readonly createGiftCardPaymentIntent: PaymentIntent;
  /**
   * Creates a new location in Stripe
   * @deprecated No longer supported
   */
  readonly createKioskReaderLocation: CreateKioskReaderLocationIdResponse;
  /** Creates a new location in Stripe with restaurant ID and restaurant entity ID */
  readonly createKioskReaderLocationWithIds: CreateKioskReaderLocationIdResponse;
  readonly createOrder: CreateOrderResponseUnion;
  readonly createOrderPaymentIntent: PaymentIntent;
  readonly createPaymentIntent: Scalars['String']['output'];
  /** @deprecated Sunsetting sweetpass+ loyalty program */
  readonly createPaymentSubscriptionProfile: PaymentSubscriptionProfile;
  readonly createSetupPaymentIntent: CreateSetupIntent;
  /** Removes an address from the customer's list of addresses. */
  readonly deleteAddress: DeleteAddressResponseUnion;
  readonly deleteAdminPrintPriorityTemplate: DeleteAdminPrintPriorityTemplateResponse;
  /** Delete an upsell category; its products leave it but stay on menus. Each change is audited. */
  readonly deleteAdminUpsellCategory: DeleteAdminUpsellCategoryResponse;
  readonly deletePaymentMethodCard: PaymentMethodCard;
  readonly editLineItemInCart: EditLineItemInCartResponseUnion;
  /** Edits a line item in the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly editLineItemInCartWithLoyalty: EditLineItemInCartResponseUnion;
  readonly eightySixIngredient: EightySixResponse;
  readonly eightySixProduct: EightySixResponse;
  /** Favorites a Line Item. */
  readonly favoriteLineItem: LineItem;
  readonly handoffCart: ReorderResponseUnion;
  readonly identifyAndClaimInStoreOrder: IdentifyAndClaimInStoreOrderResponseUnion;
  /** Issue credit (aka sessionm offers) as sweet touches within the Kustomer platform. */
  readonly issueCustomerSupportCredit: IssueCustomerSupportCreditResult;
  /** Issues a points to a user. */
  readonly issueCustomerSupportPoints: IssueCustomerSupportPointsResponse;
  readonly joinMultipartyOrder: JoinMultipartyOrderResponseUnion;
  readonly leaveMultipartyOrder: LeaveMultipartyOrderResponseUnion;
  readonly lockOrder: LockOrderResponseUnion;
  /** Logs the user out. */
  readonly logout: LogoutResponseUnion;
  /** Opts into the free tier. */
  readonly optInFreeTierV2: Maybe<LoyaltyProfile>;
  /** Opts into the sg rewards loyalty program. */
  readonly optInLoyalty: Maybe<LoyaltyProfile>;
  /** Opts out of loyalty program. */
  readonly optOutLoyalty: OptOutLoyaltyResponseUnion;
  /** Opts a user out of loyalty. Requires a bearer auth token instead of relying on the user session */
  readonly optOutLoyaltyForCustomer: OptOutLoyaltyForCustomerResponseUnion;
  /** Redemption of a gift card */
  readonly redeemGiftCard: RedeemGiftCardResponseUnion;
  /**
   * Refunds a kiosk payment
   * @deprecated No longer supported
   */
  readonly refundKioskPayment: RefundKioskPaymentResponse;
  /** Refunds a kiosk payment. Requires the allow_refunding scope */
  readonly refundKioskPaymentV2: RefundKioskPaymentResponseUnion;
  readonly registerGuest: Maybe<RegisterGuestResponseUnion>;
  readonly removeFromCart: RemoveFromCartResponseUnion;
  /** Removes a line item from the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly removeFromCartWithLoyalty: RemoveFromCartResponseUnion;
  readonly removeReward: RemoveRewardResponseUnion;
  /** @deprecated Use removeRewardWithLoyalty instead */
  readonly removeRewardByLoyaltyId: RemoveRewardResponseUnion;
  readonly removeRewardWithLoyalty: RemoveRewardResponseUnion;
  /**
   * Remove a payment method from a subscription
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly removeSubscriptionPaymentMethod: DeleteSubscriptionPaymentMethodResponseUnion;
  /** Rename an upsell category. Audited. */
  readonly renameAdminUpsellCategory: AdminUpsellCategory;
  readonly reorderLineItem: ReorderResponseUnion;
  readonly reorderOrder: ReorderResponseUnion;
  readonly requestAccountDeletion: Maybe<RequestAccountDeletionResponseUnion>;
  readonly saveFeedbackCase: FeedbackSuccess;
  /** Sends an refund receipt email */
  readonly sendKioskRefundReceipt: Scalars['Boolean']['output'];
  readonly setDefaultPaymentMethod: PaymentProfile;
  readonly setUserNotificationPreferences: UserNotificationPreferencesUnion;
  /** Signs the user in. */
  readonly signIn: SignInResponseUnion;
  readonly submitFeedback: FeedbackSuccess;
  /** Order a gift card */
  readonly submitGiftCardOrderUsingPaymentMethod: SubmitGiftCardOrderUsingPaymentMethodResponseUnion;
  readonly submitInStoreFeedback: FeedbackSuccess;
  /** Submits an order paid for via a separate workflow i.e. marketplace without a wanted time */
  readonly submitOrderAsPayInStoreASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /**
   * Submits an order paid for via a separate workflow i.e. marketplace without a wanted time
   * @deprecated Use submitZeroTotalOrderWithLoyaltyASAP for $0 orders and submitOrderUsingPaymentIntentASAP for card orders.
   */
  readonly submitOrderAsPrepaidASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits a Kiosk card order using an authorized PaymentIntent, with optional loyalty support. */
  readonly submitOrderUsingPaymentIntentASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order, paid for using one of the customer's existing payment methods. */
  readonly submitOrderUsingPaymentMethod: SubmitOrderUsingPaymentMethodResponseUnion;
  /**
   * Submits an order paid for via a separate workflow without a wanted time with Loyalty ID-based loyalty support, for kiosks.
   * @deprecated Use submitZeroTotalOrderWithLoyaltyASAP for $0 orders and submitOrderUsingPaymentIntentASAP for card orders.
   */
  readonly submitOrderWithLoyaltyAsPrepaidASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid in-store without a wanted time with Loyalty ID-based loyalty support, for kiosks. */
  readonly submitOrderWithLoyaltyAsPrepaidInStoreASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for with the scan to pay QRCode token, for kiosks. */
  readonly submitOrderWithLoyaltyUsingPaymentMethodASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /**
   * Submits an order paid for via a separate workflow i.e. marketplace.
   * @deprecated Use submitOrderUsingPaymentMethod instead.
   */
  readonly submitOrderWithPaymentMethod: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits code to SessionM. */
  readonly submitPromoCode: SubmitPromoCodeResponseUnion;
  /**
   * Submits code to SessionM. If unsuccessful, code is submitted to LevelUp.
   * @deprecated Deprecated in favor of submitPromoCode
   */
  readonly submitPromoOrGiftCardCode: SubmitPromoCodeOrGiftCardResponseUnion;
  /** Submits a kiosk order whose total is $0 because of loyalty rewards or discounts, without a wanted time. */
  readonly submitZeroTotalOrderWithLoyaltyASAP: SubmitZeroTotalOrderWithLoyaltyResponseUnion;
  readonly syncLocation: SyncLocationResult;
  readonly unlockOrder: UnlockOrderResponseUnion;
  /**
   * Updates an address form the customer's list of addresses.
   * @deprecated Migrating away from google place id. Use updateAddressV2
   */
  readonly updateAddress: UpdateAddressResponseUnion;
  /** Updates an address form the customer's list of addresses. */
  readonly updateAddressV2: UpdateAddressResponseUnion;
  /** Update the group order max entree limit */
  readonly updateAdminGroupOrderSettings: AdminGroupOrderSettings;
  readonly updateAdminPrintPriorityTemplate: AdminPrintPriorityTemplate;
  /** Replace the ranked upsell list. Every restaurant serves the new list; each changed product is audited. */
  readonly updateAdminProductUpsells: ReadonlyArray<AdminUpsellMasterProduct>;
  /** Enable or disable a restaurant */
  readonly updateAdminRestaurantEnabled: AdminRestaurantSettings;
  /** Set or clear the restaurant's available and expiration dates on ingredients' stock at accessible restaurants. All or nothing. */
  readonly updateAdminRestaurantIngredientDates: UpdateAdminRestaurantAvailabilityResponse;
  /** 86, restock, or turn auto-restock on or off for ingredients at accessible restaurants, with the dip, lineage and outpost fan-out Gravy Admin applies. All or nothing. */
  readonly updateAdminRestaurantIngredientStock: UpdateAdminRestaurantAvailabilityResponse;
  /** Set or clear the restaurant's available and expiration dates on every row of menu products at accessible restaurants. All or nothing. */
  readonly updateAdminRestaurantMenuProductDates: UpdateAdminRestaurantAvailabilityResponse;
  /** 86, restock, or turn auto-restock on or off for menu products at accessible restaurants, with the lineage and outpost fan-out Gravy Admin applies. All or nothing. */
  readonly updateAdminRestaurantMenuProductStock: UpdateAdminRestaurantAvailabilityResponse;
  /** Update a restaurant's accepting orders, reason or hidden. Accepting orders changes are copied to its outposts. */
  readonly updateAdminRestaurantOrdering: AdminRestaurantSettings;
  /** Update a restaurant's pickup instructions, description, flex message or cross street */
  readonly updateAdminRestaurantProfile: AdminRestaurantSettings;
  /** Save the order of every upsell category and of the products in each. Each changed category and product is audited. */
  readonly updateAdminUpsellCategoryArrangement: ReadonlyArray<AdminUpsellCategory>;
  readonly updateCustomer: Maybe<UpdateCustomerResponse>;
  readonly updateKioskCustomer: Maybe<UpdateKioskCustomerResponse>;
  readonly updatePaymentMethod: PaymentMethodCard;
  readonly updatePreferences: UpdateCustomerPreferencesUnion;
  readonly updateRestaurantDeliveryChannels: RestaurantDeliveryChannels;
  readonly updateRestaurantThrottleLevers: RestaurantThrottleLevers;
  /** Sets whether to use credit on next purchase. */
  readonly updateUseCredit: UpdateUseCreditResponse;
  /** Returns whether a redemption token is valid and generates a new token */
  readonly validateAndRefreshGiftCardRedemptionTokenForCustomer: ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse;
};

export type MutationAddAddressArgs = {
  input: AddAddressInput;
};

export type MutationAddAddressV2Args = {
  input: AddAddressV2Input;
};

export type MutationAddLineItemBatchToCartArgs = {
  input: AddLineItemBatchToCartInput;
};

export type MutationAddLineItemToCartArgs = {
  input: AddLineItemToCartInput;
};

export type MutationAddLineItemToCartWithLoyaltyArgs = {
  input: AddLineItemToCartWithLoyaltyInput;
};

export type MutationAnonymizeCustomerArgs = {
  input: AnonymizeCustomerInput;
};

export type MutationApplyAdminPrintPriorityTemplateArgs = {
  input: ApplyAdminPrintPriorityTemplateInput;
};

export type MutationApplyRewardArgs = {
  input: ApplyRewardInput;
};

export type MutationApplyRewardByLoyaltyIdArgs = {
  input: ApplyRewardByLoyaltyIdInput;
};

export type MutationApplyRewardWithLoyaltyArgs = {
  input: ApplyRewardWithLoyaltyInput;
};

export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};

export type MutationCancelOrderExternalArgs = {
  input: CancelExternalOrderInput;
};

export type MutationCancelOrderPaymentIntentArgs = {
  input: CancelOrderPaymentIntentInput;
};

export type MutationCancelOrderV2Args = {
  input: CancelOrderInput;
};

export type MutationChallengeOptInArgs = {
  challengeId: Scalars['String']['input'];
};

export type MutationChallengeOptInV2Args = {
  challengeId: Scalars['String']['input'];
};

export type MutationClaimLoyaltyPromotionArgs = {
  input: ClaimLoyaltyPromotionInput;
};

export type MutationConvertToMultipartyOrderArgs = {
  input: ConvertToMultipartyOrderInput;
};

export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};

export type MutationCreateAdminPrintPriorityTemplateArgs = {
  input: CreateAdminPrintPriorityTemplateInput;
};

export type MutationCreateAdminUpsellCategoryArgs = {
  input: CreateAdminUpsellCategoryInput;
};

export type MutationCreateAndSubmitPrepaidOrderArgs = {
  input: CreateAndSubmitOrderInput;
};

export type MutationCreateFlexOnboardingSessionArgs = {
  input: CreateFlexOnboardingSessionInput;
};

export type MutationCreateGiftCardPaymentIntentArgs = {
  input: CreateGiftCardPaymentIntentInput;
};

export type MutationCreateKioskReaderLocationArgs = {
  restaurantInfo: RestaurantLocationInfoInputDto;
};

export type MutationCreateKioskReaderLocationWithIdsArgs = {
  restaurantInfo: RestaurantLocationInfoWithIdsInput;
};

export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

export type MutationCreateOrderPaymentIntentArgs = {
  input: CreateOrderPaymentIntentInput;
};

export type MutationDeleteAddressArgs = {
  addressId: Scalars['ID']['input'];
};

export type MutationDeleteAdminPrintPriorityTemplateArgs = {
  input: DeleteAdminPrintPriorityTemplateInput;
};

export type MutationDeleteAdminUpsellCategoryArgs = {
  input: DeleteAdminUpsellCategoryInput;
};

export type MutationDeletePaymentMethodCardArgs = {
  input: DeletePaymentMethodCardInput;
};

export type MutationEditLineItemInCartArgs = {
  input: EditLineItemInCartInput;
};

export type MutationEditLineItemInCartWithLoyaltyArgs = {
  input: EditLineItemInCartWithLoyaltyInput;
};

export type MutationEightySixIngredientArgs = {
  input: EightySixIngredientInput;
};

export type MutationEightySixProductArgs = {
  input: EightySixProductInput;
};

export type MutationFavoriteLineItemArgs = {
  input: FavoriteLineItemInput;
};

export type MutationHandoffCartArgs = {
  ignoreConflicts: Scalars['Boolean']['input'];
  orderToken: Scalars['String']['input'];
};

export type MutationIdentifyAndClaimInStoreOrderArgs = {
  input: IdentifyAndClaimInStoreOrderInput;
};

export type MutationIssueCustomerSupportCreditArgs = {
  creditId: Scalars['String']['input'];
  legacyInternalId: Scalars['String']['input'];
};

export type MutationIssueCustomerSupportPointsArgs = {
  legacyInternalId: Scalars['ID']['input'];
  numberOfPoints: Scalars['Int']['input'];
};

export type MutationJoinMultipartyOrderArgs = {
  input: JoinMultipartyOrderInput;
};

export type MutationLockOrderArgs = {
  input: LockOrderInput;
};

export type MutationLogoutArgs = {
  input: LogoutInput;
};

export type MutationOptOutLoyaltyForCustomerArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  legacyInternalId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRedeemGiftCardArgs = {
  code: Scalars['String']['input'];
  regCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefundKioskPaymentArgs = {
  refundParameters: KioskRefundInput;
};

export type MutationRefundKioskPaymentV2Args = {
  refundParameters: KioskRefundInput;
};

export type MutationRegisterGuestArgs = {
  input: RegisterGuestInput;
};

export type MutationRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};

export type MutationRemoveFromCartWithLoyaltyArgs = {
  input: RemoveFromCartWithLoyaltyInput;
};

export type MutationRemoveRewardArgs = {
  input: RemoveRewardInput;
};

export type MutationRemoveRewardByLoyaltyIdArgs = {
  input: RemoveRewardByLoyaltyIdInput;
};

export type MutationRemoveRewardWithLoyaltyArgs = {
  input: RemoveRewardWithLoyaltyInput;
};

export type MutationRemoveSubscriptionPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};

export type MutationRenameAdminUpsellCategoryArgs = {
  input: RenameAdminUpsellCategoryInput;
};

export type MutationReorderLineItemArgs = {
  input: ReorderInput;
};

export type MutationReorderOrderArgs = {
  input: ReorderInput;
};

export type MutationSaveFeedbackCaseArgs = {
  input: SaveFeedbackCaseInput;
};

export type MutationSendKioskRefundReceiptArgs = {
  refundReceiptParameters: KioskRefundReceiptInput;
};

export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};

export type MutationSetUserNotificationPreferencesArgs = {
  input: NotificationPreferencesInput;
};

export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitGiftCardOrderUsingPaymentMethodArgs = {
  input: SubmitGiftCardOrderUsingPaymentMethodInput;
};

export type MutationSubmitInStoreFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitOrderAsPayInStoreAsapArgs = {
  input: SubmitOrderAsapInput;
};

export type MutationSubmitOrderAsPrepaidAsapArgs = {
  input: SubmitOrderAsapInput;
};

export type MutationSubmitOrderUsingPaymentIntentAsapArgs = {
  input: SubmitOrderUsingPaymentIntentAsapInput;
};

export type MutationSubmitOrderUsingPaymentMethodArgs = {
  input: SubmitOrderUsingPaymentMethodInput;
};

export type MutationSubmitOrderWithLoyaltyAsPrepaidAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithLoyaltyAsPrepaidInStoreAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithLoyaltyUsingPaymentMethodAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithPaymentMethodArgs = {
  input: SubmitOrderWithPaymentMethodInput;
};

export type MutationSubmitPromoCodeArgs = {
  input: SubmitPromoCodeInput;
};

export type MutationSubmitPromoOrGiftCardCodeArgs = {
  input: SubmitPromoOrGiftCardCodeInput;
};

export type MutationSubmitZeroTotalOrderWithLoyaltyAsapArgs = {
  input: SubmitZeroTotalOrderWithLoyaltyInput;
};

export type MutationSyncLocationArgs = {
  input: SyncLocationInput;
};

export type MutationUpdateAddressArgs = {
  input: EditAddressInput;
};

export type MutationUpdateAddressV2Args = {
  input: EditAddressV2Input;
};

export type MutationUpdateAdminGroupOrderSettingsArgs = {
  input: UpdateAdminGroupOrderSettingsInput;
};

export type MutationUpdateAdminPrintPriorityTemplateArgs = {
  input: UpdateAdminPrintPriorityTemplateInput;
};

export type MutationUpdateAdminProductUpsellsArgs = {
  input: UpdateAdminProductUpsellsInput;
};

export type MutationUpdateAdminRestaurantEnabledArgs = {
  input: UpdateAdminRestaurantEnabledInput;
};

export type MutationUpdateAdminRestaurantIngredientDatesArgs = {
  input: UpdateAdminRestaurantIngredientDatesInput;
};

export type MutationUpdateAdminRestaurantIngredientStockArgs = {
  input: UpdateAdminRestaurantIngredientStockInput;
};

export type MutationUpdateAdminRestaurantMenuProductDatesArgs = {
  input: UpdateAdminRestaurantMenuProductDatesInput;
};

export type MutationUpdateAdminRestaurantMenuProductStockArgs = {
  input: UpdateAdminRestaurantMenuProductStockInput;
};

export type MutationUpdateAdminRestaurantOrderingArgs = {
  input: UpdateAdminRestaurantOrderingInput;
};

export type MutationUpdateAdminRestaurantProfileArgs = {
  input: UpdateAdminRestaurantProfileInput;
};

export type MutationUpdateAdminUpsellCategoryArrangementArgs = {
  input: UpdateAdminUpsellCategoryArrangementInput;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

export type MutationUpdateKioskCustomerArgs = {
  input: UpdateKioskCustomerInput;
};

export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};

export type MutationUpdatePreferencesArgs = {
  input: CustomerPreferencesInput;
};

export type MutationUpdateRestaurantDeliveryChannelsArgs = {
  input: UpdateRestaurantDeliveryChannelsInput;
};

export type MutationUpdateRestaurantThrottleLeversArgs = {
  input: UpdateRestaurantThrottleLeversInput;
};

export type MutationUpdateUseCreditArgs = {
  useCredit: Scalars['Boolean']['input'];
};

export type MutationValidateAndRefreshGiftCardRedemptionTokenForCustomerArgs = {
  input: ValidateAndRefreshGiftCardRedemptionTokenForCustomerInput;
};

/** "No Balance Gift card" user error */
export type NoBalanceGiftCardError = UserError & {
  readonly __typename?: 'NoBalanceGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

export type NoValidRestaurants = {
  readonly __typename?: 'NoValidRestaurants';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Notification Category */
export type NotificationCategory = {
  readonly __typename?: 'NotificationCategory';
  readonly displayName: Scalars['String']['output'];
  readonly emailSubscribe: Scalars['Boolean']['output'];
  readonly hasResolved: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  readonly pushSubscribe: Scalars['Boolean']['output'];
};

export type NotificationCategoryInput = {
  readonly emailSubscribe: Scalars['Boolean']['input'];
  readonly id: Scalars['String']['input'];
  readonly pushSubscribe: Scalars['Boolean']['input'];
};

export type NotificationPreferencesError = UserError & {
  readonly __typename?: 'NotificationPreferencesError';
  readonly errorMessage: Scalars['String']['output'];
};

export type NotificationPreferencesInput = {
  readonly notificationCategories: ReadonlyArray<NotificationCategoryInput>;
};

export enum NotificationType {
  LiveActivity = 'LIVE_ACTIVITY',
  Push = 'PUSH',
  Sms = 'SMS',
}

export type OpenLoyaltyTransactionDetailsInput = {
  readonly createdAt: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly isGroupOrder?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isInFlight: Scalars['Boolean']['input'];
  readonly isInFlightDelivery: Scalars['Boolean']['input'];
  readonly lineItems: ReadonlyArray<OrderLineItemInput>;
  readonly orderType: Scalars['String']['input'];
  readonly restaurantEntityId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantParentId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantUtcOffset?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use selectedRewardsWithDetails instead */
  readonly selectedRewards?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subtotal: Scalars['Float']['input'];
  readonly tax: Scalars['Float']['input'];
  readonly updatedAt?: InputMaybe<Scalars['String']['input']>;
  readonly wantedTime?: InputMaybe<Scalars['String']['input']>;
};

export type OptOutLoyaltyForCustomerResponseUnion =
  | OptOutLoyaltyForCustomerSuccessResponse
  | UnknownUserError;

/** Opt Out Loyalty For Customer Result */
export type OptOutLoyaltyForCustomerSuccessResponse = {
  readonly __typename?: 'OptOutLoyaltyForCustomerSuccessResponse';
  /** Indicates if the user has successfully been opted out */
  readonly success: Scalars['Boolean']['output'];
};

export type OptOutLoyaltyResponseUnion = OptOutLoyaltySuccessResponse | UnknownUserError;

/** Opt Out Loyalty Result */
export type OptOutLoyaltySuccessResponse = {
  readonly __typename?: 'OptOutLoyaltySuccessResponse';
  /** Indicates if the user has successfully been opted out */
  readonly success: Scalars['Boolean']['output'];
};

/** Order */
export type Order = {
  readonly __typename?: 'Order';
  readonly asset: Asset;
  /** All non-points rewards that are issued to this customer, regardless of eligibility to this order. */
  readonly availableRewards: Maybe<ReadonlyArray<Reward>>;
  /** All non-points rewards that are issued to this customer (looked up by their loyalty ID), regardless of eligibility to this order. */
  readonly availableRewardsByLoyaltyId: Maybe<ReadonlyArray<Reward>>;
  /** All non-points rewards that are issued to this customer (looked up by their customer token), regardless of eligibility to this order. */
  readonly availableRewardsWithLoyalty: Maybe<ReadonlyArray<Reward>>;
  readonly availableWantedTimes: ReadonlyArray<AvailableWantedTime>;
  /** Checks if this order is in the received state, but only if the wanted time is recent (12hrs). */
  readonly canCancel: Scalars['Boolean']['output'];
  /** Whether or not this order belongs to a restaurant with support for tracking the orders with a QSR system. This is always true for delivery orders, for pickup or outpost, it checks the tracking status of the restaurant. This flag affects what we should the customer in the order status feature. */
  readonly canTrackOrderStatus: Scalars['Boolean']['output'];
  readonly currentUserOrderPermissions: UserOrderPermission;
  readonly deliveryOrderDetail: Maybe<DeliveryOrderDetail>;
  readonly description: Scalars['String']['output'];
  readonly dropoffLocation: Maybe<Scalars['String']['output']>;
  /** All points rewards that are issued to this customer and are eligible to this order. */
  readonly eligiblePointRewards: Maybe<ReadonlyArray<PointsReward>>;
  /** All points rewards that are issued to this customer (lookup by loyalty ID) and are eligible to this order. */
  readonly eligiblePointRewardsByLoyaltyId: Maybe<ReadonlyArray<PointsReward>>;
  /** All points rewards that are issued to this customer (lookup by their customer token) and are eligible to this order. */
  readonly eligiblePointRewardsWithLoyalty: Maybe<ReadonlyArray<PointsReward>>;
  /** Whether the customer has earned loyalty points for this order */
  readonly hasEarnedLoyaltyPoints: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly includeUtensils: Scalars['Boolean']['output'];
  /** Indicates whether the order was canceled. */
  readonly isCanceled: Scalars['Boolean']['output'];
  /** Whether or not this order is an inflight order, this is done by checking the session.inFlightOrderId on a field resolver. */
  readonly isInFlight: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not this order is an inflight delivery order, this is done by checking the session.inFlightDeliveryOrderId on a field resolver. */
  readonly isInFlightDelivery: Scalars['Boolean']['output'];
  /** Whether or not this order is pending the feedback from "rate your order". */
  readonly isPendingFeedback: Scalars['Boolean']['output'];
  readonly ledger: Ledger;
  readonly lineItems: ReadonlyArray<LineItem>;
  readonly multipartyDetails: Maybe<MultipartyDetail>;
  readonly orderSource: Maybe<OrderSource>;
  /** State of the order */
  readonly orderState: OrderState;
  readonly orderType: OrderType;
  readonly payments: Maybe<ReadonlyArray<Payment>>;
  readonly restaurant: Restaurant;
  readonly total: Maybe<Scalars['Int']['output']>;
  readonly transactionPlan: Maybe<TransactionPlanResponseUnion>;
  /** Used by customers to reference the order when speaking to our support team. */
  readonly vendorId: Scalars['String']['output'];
  readonly wantedTime: Scalars['DateTime']['output'];
};

/** Order */
export type OrderAvailableRewardsByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

/** Order */
export type OrderAvailableRewardsWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

/** Order */
export type OrderEligiblePointRewardsByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

/** Order */
export type OrderEligiblePointRewardsWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

/** Order */
export type OrderTransactionPlanArgs = {
  input: GenerateTransactionPlanInput;
};

/** Order has already been canceled */
export type OrderAlreadyCanceled = UserError & {
  readonly __typename?: 'OrderAlreadyCanceled';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Order sent to kitchen */
export type OrderAlreadySentToKitchen = UserError & {
  readonly __typename?: 'OrderAlreadySentToKitchen';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type OrderConflict = {
  readonly __typename?: 'OrderConflict';
  readonly product: Product;
  /** Reorder conflict type */
  readonly type: ConflictType;
  readonly unavailableIngredients: ReadonlyArray<Ingredient>;
};

export type OrderLineItemInput = {
  readonly brinkPlu: Scalars['Float']['input'];
  readonly cost: Scalars['Float']['input'];
  readonly id?: InputMaybe<Scalars['Float']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly parentLineItemId?: InputMaybe<Scalars['Float']['input']>;
  readonly perItemCost: Scalars['Float']['input'];
  readonly quantity: Scalars['Float']['input'];
};

export type OrderLocked = UserError & {
  readonly __typename?: 'OrderLocked';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly reason: LockOrderReason;
  readonly status: Scalars['Int']['output'];
};

/** "Order missing total" user error — the order has no total to plan against. */
export type OrderMissingTotalError = UserError & {
  readonly __typename?: 'OrderMissingTotalError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Order not found */
export type OrderNotFound = UserError & {
  readonly __typename?: 'OrderNotFound';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type OrderParticipant = {
  readonly __typename?: 'OrderParticipant';
  readonly displayName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** True if this participant is the current user */
  readonly isMe: Scalars['Boolean']['output'];
};

export type OrderPaymentInput = {
  readonly amountEligibleForPointsInCents?: InputMaybe<Scalars['Float']['input']>;
  readonly amountInCents: Scalars['Float']['input'];
  readonly id: Scalars['String']['input'];
  readonly paymentTime: Scalars['String']['input'];
  readonly processor: Scalars['String']['input'];
};

export type OrderPaymentState = {
  readonly __typename?: 'OrderPaymentState';
  readonly createdAt: Scalars['String']['output'];
  readonly error: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly paymentIntentId: Scalars['String']['output'];
  readonly paymentIntentSecret: Scalars['String']['output'];
  readonly status: OrderPaymentStatus;
  readonly updatedAt: Scalars['String']['output'];
};

export enum OrderPaymentStatus {
  Approved = 'Approved',
  Created = 'Created',
  Failed = 'Failed',
  Fulfilled = 'Fulfilled',
  Released = 'Released',
}

export enum OrderSource {
  DoordashMarketplace = 'DOORDASH_MARKETPLACE',
  EzcaterB2BMarketplace = 'EZCATER_B2B_MARKETPLACE',
  EzcaterMarketplace = 'EZCATER_MARKETPLACE',
  EzOrdering = 'EZ_ORDERING',
  FoodaMarketplace = 'FOODA_MARKETPLACE',
  GenericMarketplace = 'GENERIC_MARKETPLACE',
  GrubhubMarketplace = 'GRUBHUB_MARKETPLACE',
  Kiosk = 'KIOSK',
  MealpalMarketplace = 'MEALPAL_MARKETPLACE',
  Native = 'NATIVE',
  SharebiteMarketplace = 'SHAREBITE_MARKETPLACE',
  UberEatsMarketplace = 'UBER_EATS_MARKETPLACE',
}

export enum OrderState {
  Active = 'Active',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Discarded = 'Discarded',
  LockedChangeLocation = 'LockedChangeLocation',
  LockedCheckout = 'LockedCheckout',
}

export type OrderStatus = {
  readonly __typename?: 'OrderStatus';
  readonly canceledStatus: Maybe<Scalars['String']['output']>;
  readonly courierDetails: Maybe<CourierDetails>;
  readonly customerId: Scalars['ID']['output'];
  readonly deliveryAddressName: Maybe<Scalars['String']['output']>;
  /** Flattened list of order statuses, which collapses the different per order type order statuses into a standard list. */
  readonly flattenedOrderStatus: FlattenedOrderStatuses;
  readonly gravyStatus: GravyStatusType;
  readonly gravyUpdatedAt: Scalars['String']['output'];
  readonly order: Order;
  readonly orderId: Maybe<Scalars['ID']['output']>;
  readonly orderOccasion: Scalars['String']['output'];
  /** Raw list of order statuses, each status comes with the order type and there are multiple variants per each step. */
  readonly orderStatus: Scalars['String']['output'];
  readonly orderWantedTime: Maybe<Scalars['String']['output']>;
  readonly restaurantName: Maybe<Scalars['String']['output']>;
};

export type OrderStatusResponseUnion = InvalidOrder | OrderStatus;

export type OrderTotalNotZero = UserError & {
  readonly __typename?: 'OrderTotalNotZero';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export enum OrderType {
  Catering = 'CATERING',
  CateringDelivery = 'CATERING_DELIVERY',
  CateringPickup = 'CATERING_PICKUP',
  Delivery = 'DELIVERY',
  InStore = 'IN_STORE',
  Pickup = 'PICKUP',
}

export type OrdersInput = {
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type OrdersInputV2 = {
  readonly includeCanceledOrders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly includePlacedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type OrdersResponseSuccess = {
  readonly __typename?: 'OrdersResponseSuccess';
  readonly orders: ReadonlyArray<Order>;
  readonly pagination: Pagination;
};

export type OrdersResponseUnion = OrdersResponseSuccess | ValidationError;

export type Pagination = {
  readonly __typename?: 'Pagination';
  /** Last available page. */
  readonly last: Scalars['Int']['output'];
  /** The page requested. */
  readonly page: Scalars['Int']['output'];
  /** Items per page. */
  readonly take: Scalars['Int']['output'];
  /** Total number of items available. */
  readonly total: Scalars['Int']['output'];
};

/** Payment entity */
export type Payment = {
  readonly __typename?: 'Payment';
  /** How much of this payment is eligible for points */
  readonly amountEligibleForPoints: Scalars['Float']['output'];
  readonly amountInCents: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  /** Credit card last4 */
  readonly last4: Maybe<Scalars['String']['output']>;
  readonly paymentTime: Scalars['DateTime']['output'];
  readonly processor: Scalars['String']['output'];
  /** Is payment fully refunded */
  readonly refunded: Maybe<Scalars['Boolean']['output']>;
  /** Amount refunded in cents */
  readonly refundedAmount: Maybe<Scalars['Float']['output']>;
  /** Credit card type */
  readonly type: Maybe<Scalars['String']['output']>;
};

export type PaymentAlreadyRefunded = UserError & {
  readonly __typename?: 'PaymentAlreadyRefunded';
  readonly errorMessage: Scalars['String']['output'];
};

export type PaymentIntent = {
  readonly __typename?: 'PaymentIntent';
  readonly id: Scalars['ID']['output'];
  /** Order ID associated with the payment intent. */
  readonly orderId: Scalars['String']['output'];
  readonly secret: Scalars['String']['output'];
};

export type PaymentIntentDeliveryOrderDetail = {
  readonly addressId: Scalars['ID']['input'];
  readonly deliveryFee: Scalars['Float']['input'];
  readonly tip: Scalars['Float']['input'];
  readonly vendor: Scalars['String']['input'];
  readonly vendorRestaurantId: Scalars['String']['input'];
};

export type PaymentMethodBillingAccount = {
  readonly __typename?: 'PaymentMethodBillingAccount';
  /** The type of card */
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCard = {
  readonly __typename?: 'PaymentMethodCard';
  /** The type of card */
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCardUnion = PaymentMethodBillingAccount | PaymentMethodCard;

export enum PaymentMethods {
  MarketplaceCatering = 'MARKETPLACE_CATERING',
  NativeCc = 'NATIVE_CC',
  NativePaidOnAccount = 'NATIVE_PAID_ON_ACCOUNT',
  PaidBy_3P = 'PAID_BY_3P',
  PaymentIntent = 'PAYMENT_INTENT',
  PaymentMethodCard = 'PAYMENT_METHOD_CARD',
  PayInStore = 'PAY_IN_STORE',
  Prepaid = 'PREPAID',
}

/** Payment Plan */
export type PaymentPlan = {
  readonly __typename?: 'PaymentPlan';
  /** ID of plan from Braintree */
  readonly braintreePlanId: Scalars['ID']['output'];
  /** Tier plan belongs to */
  readonly tier: Tier;
};

/** Customer Payment Profile */
export type PaymentProfile = {
  readonly __typename?: 'PaymentProfile';
  readonly defaultCardId: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
};

/** Customer Subscription object */
export type PaymentSubscription = {
  readonly __typename?: 'PaymentSubscription';
  readonly balance: Scalars['String']['output'];
  /**
   * The frequency in which subscription payments should be made.
   * @deprecated Deprecated in favor of `billingRecurrence`
   */
  readonly billingFrequencyUnit: Maybe<DurationUnit>;
  readonly billingHistory: ReadonlyArray<SubscriptionTransactions>;
  readonly billingPeriodEndDate: Maybe<Scalars['String']['output']>;
  readonly billingPeriodStartDate: Maybe<Scalars['String']['output']>;
  /** The recurrence in which subscription payments should be made. */
  readonly billingRecurrence: Maybe<DurationUnit>;
  readonly createdAt: Scalars['String']['output'];
  /** The first billing date of this subscription. */
  readonly firstBillingDate: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if the subscription has a free trial associated with it. */
  readonly hasFreeTrial: Scalars['Boolean']['output'];
  /** The ID of the subscription */
  readonly id: Scalars['ID']['output'];
  /** Indicates if the subscription is currently on a free trial (was not paid for yet). */
  readonly isTrialActive: Scalars['Boolean']['output'];
  readonly nextBillingDate: Scalars['String']['output'];
  readonly nextBillingPeriodAmount: Scalars['String']['output'];
  readonly paidThroughDate: Maybe<Scalars['DateTime']['output']>;
  readonly planId: Scalars['String']['output'];
  readonly price: Maybe<Scalars['String']['output']>;
  readonly status: PaymentSubscriptionStatus;
};

/** Braintree Customer Payment Subscription Profile (deprecated) */
export type PaymentSubscriptionProfile = {
  readonly __typename?: 'PaymentSubscriptionProfile';
  readonly creditCards: Maybe<ReadonlyArray<SubscriptionCreditCard>>;
  readonly id: Scalars['ID']['output'];
  readonly transactionHistory: ReadonlyArray<SubscriptionTransactions>;
};

export enum PaymentSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Expired = 'Expired',
  PastDue = 'PastDue',
  Pending = 'Pending',
}

export type PersonalizedUpsell = {
  readonly __typename?: 'PersonalizedUpsell';
  readonly customerId: Maybe<Scalars['ID']['output']>;
  readonly products: ReadonlyArray<UpsellCategoryProduct>;
  readonly restaurantId: Scalars['String']['output'];
};

export type PersonalizedUpsellsResponseUnion = MenuNotFound | PersonalizedUpsell;

/** Point expiration information */
export type PointExpirationEntry = {
  readonly __typename?: 'PointExpirationEntry';
  readonly amountExpiring: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly numOfDaysUntilExpiration: Scalars['Int']['output'];
};

/** Point History Entry */
export type PointHistoryEntry = {
  readonly __typename?: 'PointHistoryEntry';
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['String']['output'];
  readonly source: Maybe<PointIssuanceSource>;
  readonly type: Maybe<PointHistoryEntryType>;
  readonly value: Scalars['Int']['output'];
};

/** The type of the point history entry */
export enum PointHistoryEntryType {
  Earned = 'EARNED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED',
  Removed = 'REMOVED',
}

/** Point History For User Error */
export type PointHistoryForUserError = {
  readonly __typename?: 'PointHistoryForUserError';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type PointHistoryForUserResponseUnion =
  | PointHistoryForUserError
  | PointHistoryForUserSuccess;

/** Point History For User Success */
export type PointHistoryForUserSuccess = {
  readonly __typename?: 'PointHistoryForUserSuccess';
  readonly pagination: Pagination;
  readonly pointExpirationEntries: ReadonlyArray<PointExpirationEntry>;
  /** Point history entries. Can contain null values as a result of serialization failures. */
  readonly pointHistoryEntries: ReadonlyArray<Maybe<PointHistoryEntry>>;
};

/** The source of the points issuance */
export enum PointIssuanceSource {
  BonusPoints = 'BONUS_POINTS',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  MultipleSources = 'MULTIPLE_SOURCES',
  OfferCompletion = 'OFFER_COMPLETION',
  Order = 'ORDER',
  Sweetgreen = 'SWEETGREEN',
  VoidedOrder = 'VOIDED_ORDER',
}

export type PointsReward = {
  readonly __typename?: 'PointsReward';
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly points: Scalars['Float']['output'];
  readonly redeemable: Scalars['Boolean']['output'];
};

export type Product = {
  readonly __typename?: 'Product';
  readonly allergenProperties: ReadonlyArray<AllergenProperty>;
  readonly asset: Asset;
  /** Date that product will be available */
  readonly availableDate: Maybe<Scalars['String']['output']>;
  readonly baseProduct: BaseProduct;
  /** Override text for calorie display, used for products that have optional ingredients in their recipe build where a fixed calorie count cannot be displayed. */
  readonly calorieOverrideText: Maybe<Scalars['String']['output']>;
  readonly calories: Scalars['Int']['output'];
  /** @deprecated Not being used anymore by the client. */
  readonly categoryId: Scalars['String']['output'];
  /** @deprecated Not being used anymore by the client. */
  readonly categoryName: Scalars['String']['output'];
  /** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are is implicit based on the request and restaurant. */
  readonly channelCost: Scalars['Int']['output'];
  /** Base cost, in cents */
  readonly cost: Scalars['Int']['output'];
  /** If a product is custom, this field provides the type of that product, otherwise the field will be null. Clients must only use this field for cosmetic purposes; for example, displaying a custom product card on the menu page. */
  readonly customType: Maybe<CustomProductType>;
  readonly description: Scalars['String']['output'];
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  /** Indicates whether dressing details should be displayed for this product */
  readonly enableDressingDetails: Scalars['Boolean']['output'];
  /** Date that product will no longer be valid */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ingredientModifications: IngredientModifications;
  readonly ingredients: ReadonlyArray<Ingredient>;
  readonly isCustom: Scalars['Boolean']['output'];
  readonly isMixable: Maybe<Scalars['Boolean']['output']>;
  readonly isModifiable: Scalars['Boolean']['output'];
  readonly isSalad: Scalars['Boolean']['output'];
  readonly label: Maybe<ProductLabel>;
  /** Master product ID from gravy database */
  readonly masterProductId: Maybe<Scalars['Int']['output']>;
  /** The total number of additions, removals, and substitutions that are allowed to be modified for this product */
  readonly maxModifications: Scalars['Int']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly modifierGroups: ReadonlyArray<ModifierGroup>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  readonly restaurant: Restaurant;
  readonly restaurantId: Scalars['ID']['output'];
  readonly slug: Scalars['String']['output'];
  readonly throttleItem: Scalars['Boolean']['output'];
};

export type ProductChannelCostArgs = {
  costChannel?: InputMaybe<CostChannel>;
};

export type ProductIngredientsArgs = {
  version?: InputMaybe<ModifierGroupVersion>;
};

export type ProductModifierGroupsArgs = {
  version?: InputMaybe<ModifierGroupVersion>;
};

export type ProductLabel = {
  readonly __typename?: 'ProductLabel';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ProductOutOfStock = UserError & {
  readonly __typename?: 'ProductOutOfStock';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type ProductUnavailable = UserError & {
  readonly __typename?: 'ProductUnavailable';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Promo code has already been applied */
export type PromoCodeAlreadyApplied = UserError & {
  readonly __typename?: 'PromoCodeAlreadyApplied';
  readonly errorMessage: Scalars['String']['output'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly addons: Addons;
  readonly address: Maybe<Address>;
  /** Group ordering settings */
  readonly adminGroupOrderSettings: AdminGroupOrderSettings;
  /** Global chit print zones in default print order. Admin tooling. */
  readonly adminMasterZones: ReadonlyArray<AdminMasterZone>;
  readonly adminOrder: Maybe<AdminOrder>;
  readonly adminOrders: AdminOrderPage;
  /** Gravy's active reasons for 86ing an item, by label. */
  readonly adminOutOfStockReasons: ReadonlyArray<AdminOutOfStockReason>;
  /** Every ingredient row for the print priority template builder, unfiltered. Admin tooling. */
  readonly adminPrintPriorityIngredients: ReadonlyArray<AdminPrintPriorityIngredient>;
  /** All chit print priority templates, ordered by name. Admin tooling. */
  readonly adminPrintPriorityTemplates: ReadonlyArray<AdminPrintPriorityTemplate>;
  /** Newest-first Gravy audit history of the product upsells and upsell categories changed from SG Admin. Admin tooling. */
  readonly adminProductUpsellAudits: ReadonlyArray<AdminProductUpsellAudit>;
  /** The ranked upsell list shared by every restaurant, in rank order. Admin tooling. */
  readonly adminProductUpsells: ReadonlyArray<AdminUpsellMasterProduct>;
  /** One restaurant for Restaurant Config, or null if it does not exist or is outside your locations. */
  readonly adminRestaurant: Maybe<AdminRestaurant>;
  /** A restaurant's Gravy audit log, newest first: its settings and its stock and product 86s and restocks. Null if the restaurant does not exist or is outside your locations. */
  readonly adminRestaurantAudits: Maybe<AdminRestaurantAuditPage>;
  /** A restaurant's menu products and ingredients with their stock, including scheduled and ended ones. Null if the restaurant does not exist or is outside your locations. */
  readonly adminRestaurantAvailability: Maybe<AdminRestaurantAvailability>;
  /** A restaurant's settings. Null if it doesn't exist or is outside your locations. */
  readonly adminRestaurantSettings: Maybe<AdminRestaurantSettings>;
  /** Global upsell categories in rank order, with their products. Admin tooling. */
  readonly adminUpsellCategories: ReadonlyArray<AdminUpsellCategory>;
  /** Master products whose name contains `search`, by name, for adding to upsells. At most 25. Admin tooling. */
  readonly adminUpsellMasterProducts: ReadonlyArray<AdminUpsellMasterProduct>;
  /** Returns available loyalty point options */
  readonly availableCustomerSupportPoints: AvailableCustomerSupportPointsResponseUnion;
  readonly availablePromotions: AvailablePromotionsResponseUnion;
  readonly baseProduct: Maybe<BaseProduct>;
  /**
   * Returns if an order can be canceled and the amount of minutes before the order cannot be canceled.
   * @deprecated Use canCancelV2 instead.
   */
  readonly canCancel: ReadonlyArray<CanCancelResponseUnion>;
  /** Returns if an order can be canceled and the amount of minutes before the order cannot be canceled. */
  readonly canCancelV2: ReadonlyArray<CanCancelResponseUnion>;
  readonly cart: Maybe<Order>;
  readonly categoryUpsells: ReadonlyArray<UpsellCategory>;
  /** Fetch catering orders for a restaurant */
  readonly cateringOrders: CateringOrdersResponse;
  /**
   * Returns the challenge celebration details available for a customer from newly completed challenges. If multiple challenges have been newly completed, returns hardcoded description and disclaimer with no title or expirationDate. Returns null if customer has already viewed celebration messaging.
   * @deprecated Deprecated in favor of the "challengeCelebrationModal" query.
   */
  readonly challengeCelebration: Maybe<ChallengeCelebration>;
  /** Returns the challenge celebration details available for a customer from newly completed challenges. Returns null if customer has already viewed celebration messaging. */
  readonly challengeCelebrationV2: Maybe<ChallengeCelebrationV2>;
  /**
   * Returns all eligible rewards available to the customer
   * @deprecated Fetching rewards for user should be done through loyaltyProfile
   */
  readonly challengeRewards: ReadonlyArray<ChallengeReward>;
  /** Returns customers eligible challenges */
  readonly challenges: ReadonlyArray<Challenge>;
  /** JWT token used to login the user in a chat app. */
  readonly chatToken: Maybe<ChatToken>;
  readonly currentCustomer: Maybe<Customer>;
  readonly customerExists: Scalars['Boolean']['output'];
  /** Pass card for scan to pay, usually for adding to apple wallet */
  readonly customerPass: Maybe<CustomerPass>;
  readonly customerPaymentInfo: CustomerPaymentInfo;
  /** Returns the loyalty points for a user. */
  readonly customerPointsForCustomerSupport: CustomerPointsForCustomerSupportResponseUnion;
  /** Returns available credits allocated for customer support team to issue. Requires a bearer auth token. */
  readonly customerSupportCredits: CustomerSupportCreditsResponseUnion;
  readonly favoritedLineItems: ReadonlyArray<LineItem>;
  readonly feedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  /**
   * Returns all plans associated to tierId
   * @deprecated Sunsetting sweetpass+
   */
  readonly fetchPlansByTierId: Maybe<ReadonlyArray<PaymentPlan>>;
  readonly flexCustomerData: Maybe<FlexCustomerDataResponseUnion>;
  /** Get all payments for specified date and restaurant */
  readonly getKioskPaymentsForCurrentDate: GetKioskPaymentsForCurrentDateResponse;
  /**
   * Get the Kiosk Reader Location ID
   * @deprecated No longer supported
   */
  readonly getKioskReaderLocationId: Maybe<GetKioskReaderLocationIdResponse>;
  /** Get the Kiosk Reader Location ID by Restaurant ID */
  readonly getKioskReaderLocationIdByEntityId: Maybe<GetKioskReaderLocationIdResponse>;
  /** Get the Kiosk Reader Location ID by Restaurant ID */
  readonly getKioskReaderLocationIdByRestaurantId: Maybe<GetKioskReaderLocationIdResponse>;
  /** @deprecated Use orderPaymentState instead */
  readonly getOrderPaymentState: Maybe<OrderPaymentState>;
  readonly getOrderStatusNotificationPreferences: NotificationCategory;
  readonly getPreferences: CustomerPreference;
  /** @deprecated Sunsetting sweetpass+ loyalty program */
  readonly getSubscriptions: ReadonlyArray<PaymentSubscription>;
  readonly getUserNotificationPreferences: UserNotificationPreferencesUnion;
  /** Customer's gift card balance */
  readonly giftCardBalance: GiftCardBalanceResponseUnion;
  /** Customer's gift card order detail */
  readonly giftCardOrderDetail: GiftCardOrderDetailResponseUnion;
  /** Customer's gift card purchase history */
  readonly giftCardPurchaseHistory: GiftCardPurchaseHistory;
  /** Gift card redepmtion details */
  readonly giftCardRedemptionDetail: GiftCardRedemptionDetailResponseUnion;
  /** Returns a boolean indicating if user has any unseen challenges */
  readonly hasUnseenChallenges: HasUnseenChallenges;
  readonly inFlightDeliveryOrder: Maybe<Order>;
  readonly inStoreFeedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  /** Returns the specified in store order for this customer */
  readonly inStoreLoyaltyOrder: Maybe<InStoreOrder>;
  /** Returns all in store orders for this customer */
  readonly inStoreLoyaltyOrders: InStoreOrdersResponse;
  /** @deprecated LU scan-to-pay is no longer supported. */
  readonly inStoreOrderLastPendingFeedback: Maybe<InStoreOrder>;
  readonly inStorePaymentMethods: ReadonlyArray<Credit>;
  /** Returns customer's profile by loyalty ID (aka SessionM customer ID) */
  readonly kioskCustomerProfile: Maybe<KioskCustomerProfile>;
  /** Resolves default payment card info and credit balance for scan-to-pay customers */
  readonly kioskCustomerScanPaymentInfo: KioskCustomerScanPaymentInfoResponse;
  /** Kustomer JWT token used to login the user in Kustomer */
  readonly kustomerToken: Maybe<Kustomer>;
  readonly lineItem: Maybe<LineItemResponseUnion>;
  readonly lineItemBySlug: Maybe<LineItemResponseUnion>;
  readonly lineItemRecommendations: ReadonlyArray<LineItemRecommendation>;
  /** @deprecated Migrating away from google place id. Use either locationByAddressV2 or locationByAddressId. */
  readonly locationByAddress: LocationByAddressResponseUnion;
  readonly locationByAddressId: LocationByAddressResponseUnion;
  readonly locationByAddressV2: LocationByAddressResponseUnion;
  /** Returns existing loyalty profile, otherwise creates one */
  readonly loyaltyProfile: Maybe<LoyaltyProfile>;
  /**
   * Returns existing loyalty profile based on the provided `loyaltyId`
   * @deprecated Use loyaltyProfileWithLoyalty instead
   */
  readonly loyaltyProfileByLoyaltyId: LoyaltyProfile;
  /** Returns existing loyalty profile based on the provided `loyaltyId` */
  readonly loyaltyProfileWithLoyalty: LoyaltyProfile;
  readonly menuCollection: MenuCollection;
  readonly menuCollections: ReadonlyArray<MenuCollection>;
  readonly multipartyOrderPreview: MultipartyOrderPreviewResponseUnion;
  readonly order: Order;
  readonly orderLastPendingFeedback: Maybe<Order>;
  readonly orderPaymentState: Maybe<OrderPaymentState>;
  readonly orderStatus: Maybe<OrderStatusResponseUnion>;
  readonly orders: OrdersResponseUnion;
  readonly ordersV2: OrdersResponseUnion;
  readonly paymentMethodCards: ReadonlyArray<PaymentMethodCardUnion>;
  /** Returns a payment profile entry matching the customer customerId provided */
  readonly paymentProfile: Maybe<PaymentProfile>;
  /**
   * Returns a payment subscription profile matching the customer customerId provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly paymentSubscriptionProfile: Maybe<PaymentSubscriptionProfile>;
  readonly personalizedUpsells: PersonalizedUpsellsResponseUnion;
  /** Returns the point history for a user. */
  readonly pointHistoryForUser: PointHistoryForUserResponseUnion;
  readonly product: Product;
  readonly productForRestaurant: Maybe<Product>;
  readonly productForRestaurantByLineageKey: Maybe<Product>;
  readonly receipt: Maybe<ReceiptResponse>;
  readonly restaurant: Maybe<Restaurant>;
  readonly restaurantCapacity: RestaurantCapacity;
  readonly restaurantDeliveryChannels: RestaurantDeliveryChannels;
  /** Returns the entity ids of all restaurants that are not outposts. */
  readonly restaurantEntityIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Returns the restaurantID of entityIds with valid menus */
  readonly restaurantIdByEntityId: Maybe<Scalars['ID']['output']>;
  readonly restaurantThrottle: RestaurantThrottle;
  /** Find restaurants within a radius of given coordinates */
  readonly restaurantsByLocation: ReadonlyArray<Restaurant>;
  /** Find restaurants within a geographical bounding box */
  readonly restaurantsByRegion: ReadonlyArray<Restaurant>;
  /** Returns enabled restaurants accessible to an admin user based on their location permissions, without outposts unless includeOutposts is set. Supports pagination, search, and lookup by Salesforce id (mdmIds). */
  readonly restaurantsForAdmin: ReadonlyArray<Restaurant>;
  readonly rewards: ReadonlyArray<Reward>;
  /** Search for restaurants by name */
  readonly searchRestaurants: ReadonlyArray<Restaurant>;
  readonly session: Session;
  /**
   * Returns a subscription plan matching the planId provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly subscriptionPlanById: Maybe<SubscriptionPlan>;
  /**
   * Returns an array of subscription plans matching the planIds provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly subscriptionPlansByIds: Maybe<ReadonlyArray<SubscriptionPlan>>;
};

export type QueryAddressArgs = {
  addressId: Scalars['ID']['input'];
};

export type QueryAdminOrderArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminOrdersArgs = {
  input: AdminOrdersInput;
};

export type QueryAdminProductUpsellAuditsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAdminRestaurantArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminRestaurantAuditsArgs = {
  input: AdminRestaurantAuditsInput;
};

export type QueryAdminRestaurantAvailabilityArgs = {
  restaurantId: Scalars['ID']['input'];
};

export type QueryAdminRestaurantSettingsArgs = {
  restaurantId: Scalars['ID']['input'];
};

export type QueryAdminUpsellMasterProductsArgs = {
  search: Scalars['String']['input'];
};

export type QueryBaseProductArgs = {
  slug: Scalars['String']['input'];
};

export type QueryCanCancelArgs = {
  input: ReadonlyArray<CanCancelInput>;
};

export type QueryCanCancelV2Args = {
  input: ReadonlyArray<CanCancelInput>;
};

export type QueryCategoryUpsellsArgs = {
  restaurantId: Scalars['String']['input'];
};

export type QueryCateringOrdersArgs = {
  input: CateringOrdersInput;
};

export type QueryCustomerExistsArgs = {
  input: CustomerExistsInput;
};

export type QueryCustomerPointsForCustomerSupportArgs = {
  legacyInternalId: Scalars['ID']['input'];
};

export type QueryFavoritedLineItemsArgs = {
  input: FavoritedLineItemsInput;
};

export type QueryFeedbackQuestionsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryFetchPlansByTierIdArgs = {
  tierId: Scalars['ID']['input'];
};

export type QueryGetKioskPaymentsForCurrentDateArgs = {
  restaurantInfo: GetKioskPaymentsForCurrentDateInput;
};

export type QueryGetKioskReaderLocationIdArgs = {
  restaurantSlug: Scalars['String']['input'];
};

export type QueryGetKioskReaderLocationIdByEntityIdArgs = {
  restaurantEntityId: Scalars['String']['input'];
};

export type QueryGetKioskReaderLocationIdByRestaurantIdArgs = {
  restaurantId: Scalars['String']['input'];
};

export type QueryGetOrderPaymentStateArgs = {
  orderId: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
};

export type QueryGetSubscriptionsArgs = {
  status?: InputMaybe<ReadonlyArray<SubscriptionStatus>>;
};

export type QueryGiftCardOrderDetailArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryGiftCardRedemptionDetailArgs = {
  id: Scalars['String']['input'];
};

export type QueryInStoreFeedbackQuestionsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryInStoreLoyaltyOrderArgs = {
  input: InStoreOrderInput;
};

export type QueryInStoreLoyaltyOrdersArgs = {
  input: InStoreOrdersInput;
};

export type QueryKioskCustomerProfileArgs = {
  customerToken?: InputMaybe<Scalars['String']['input']>;
  loyaltyID?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryKioskCustomerScanPaymentInfoArgs = {
  customerToken: Scalars['String']['input'];
};

export type QueryLineItemArgs = {
  input: LineItemInput;
};

export type QueryLineItemBySlugArgs = {
  input: LineItemBySlugInput;
};

export type QueryLocationByAddressArgs = {
  input: LocationByAddressInput;
};

export type QueryLocationByAddressIdArgs = {
  input: LocationByAddressIdInput;
};

export type QueryLocationByAddressV2Args = {
  input: LocationByAddressV2Input;
};

export type QueryLoyaltyProfileByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

export type QueryLoyaltyProfileWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

export type QueryMenuCollectionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMenuCollectionsArgs = {
  menuId: Scalars['ID']['input'];
};

export type QueryMultipartyOrderPreviewArgs = {
  joinCode: Scalars['String']['input'];
};

export type QueryOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryOrderPaymentStateArgs = {
  orderId: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
};

export type QueryOrderStatusArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryOrdersArgs = {
  input: OrdersInput;
};

export type QueryOrdersV2Args = {
  input: OrdersInputV2;
};

export type QueryPersonalizedUpsellsArgs = {
  restaurantId: Scalars['String']['input'];
};

export type QueryPointHistoryForUserArgs = {
  page: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProductForRestaurantArgs = {
  baseProductSlug: Scalars['String']['input'];
  restaurantId: Scalars['String']['input'];
};

export type QueryProductForRestaurantByLineageKeyArgs = {
  lineageKey: Scalars['String']['input'];
  restaurantId: Scalars['String']['input'];
};

export type QueryReceiptArgs = {
  id: Scalars['String']['input'];
};

export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRestaurantCapacityArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  minimumLineItemCapacity?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRestaurantDeliveryChannelsArgs = {
  input: RestaurantDeliveryChannelsInput;
};

export type QueryRestaurantIdByEntityIdArgs = {
  entityId: Scalars['ID']['input'];
};

export type QueryRestaurantThrottleArgs = {
  input: RestaurantThrottleInput;
};

export type QueryRestaurantsByLocationArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius?: Scalars['Float']['input'];
  type?: RestaurantSearchType;
};

export type QueryRestaurantsByRegionArgs = {
  bottomRightLat: Scalars['Float']['input'];
  bottomRightLng: Scalars['Float']['input'];
  sortByLat?: InputMaybe<Scalars['Float']['input']>;
  sortByLng?: InputMaybe<Scalars['Float']['input']>;
  topLeftLat: Scalars['Float']['input'];
  topLeftLng: Scalars['Float']['input'];
  type?: RestaurantSearchType;
};

export type QueryRestaurantsForAdminArgs = {
  input?: InputMaybe<RestaurantsForAdminInput>;
};

export type QuerySearchRestaurantsArgs = {
  query: Scalars['String']['input'];
  type?: RestaurantSearchType;
};

export type QuerySubscriptionPlanByIdArgs = {
  planId: Scalars['ID']['input'];
};

export type QuerySubscriptionPlansByIdsArgs = {
  planIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type Receipt = {
  readonly __typename?: 'Receipt';
  readonly id: Scalars['ID']['output'];
  readonly isClaimed: Scalars['Boolean']['output'];
  readonly order: Order;
  readonly restaurant: Restaurant;
};

export type ReceiptAlreadyClaimed = UserError & {
  readonly __typename?: 'ReceiptAlreadyClaimed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type ReceiptAlreadyClaimedError = UserError & {
  readonly __typename?: 'ReceiptAlreadyClaimedError';
  readonly errorMessage: Scalars['String']['output'];
};

export type ReceiptNotFound = UserError & {
  readonly __typename?: 'ReceiptNotFound';
  readonly errorMessage: Scalars['String']['output'];
};

export type ReceiptResponse = ExpiredReceipt | Receipt | ReceiptAlreadyClaimed | ReceiptNotFound;

export enum RecommendationType {
  Historical = 'HISTORICAL',
  New = 'NEW',
}

export type RedeemGiftCardResponseUnion =
  | GiftCardAssociatedWithAnotherAccountError
  | GiftCardBalance
  | InvalidGiftCardError
  | NoBalanceGiftCardError
  | UnableToRedeemGiftCardError;

/** InStore = Reward can be redeemed in store, Delivery = Reward can be redeemed in delivery, Pickup = Reward can be redeemed in pickup, All = Reward can be redeemed in all channels */
export enum RedemptionChannel {
  All = 'All',
  Delivery = 'Delivery',
  InStore = 'InStore',
  Kiosk = 'Kiosk',
  Outpost = 'Outpost',
  Pickup = 'Pickup',
}

/** Kiosk refund response */
export type RefundKioskPaymentResponse = {
  readonly __typename?: 'RefundKioskPaymentResponse';
  readonly failureReason: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type RefundKioskPaymentResponseUnion =
  | FailedToFetchPaymentIntent
  | ForbiddenError
  | InvalidRefundAmount
  | PaymentAlreadyRefunded
  | RefundKioskPaymentResponse
  | StripeRefundErrorResponse;

export type RefundOrderInput = {
  /** Person making the adjustment to the order payment. */
  readonly adjuster: Scalars['String']['input'];
  /** Array of Gravy IDs to be refunded. */
  readonly order_ids: ReadonlyArray<Scalars['String']['input']>;
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Description for why the order is being refunded. */
  readonly reason: Scalars['String']['input'];
};

export type RefundOrderSuccess = {
  readonly __typename?: 'RefundOrderSuccess';
  /** Array of refund results for each refunded order. */
  readonly refundResults: ReadonlyArray<RefundResult>;
};

export type RefundResult = {
  readonly __typename?: 'RefundResult';
  /** Gravy order ID being refunded. */
  readonly id: Scalars['String']['output'];
  /** Reason for a failed order or a success string. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the order successfully refunded or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type RegisterGuestFailed = {
  readonly __typename?: 'RegisterGuestFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RegisterGuestInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterGuestResponseUnion =
  | RegisterGuestFailed
  | RegisterGuestSuccess
  | ValidationError;

export type RegisterGuestSuccess = {
  readonly __typename?: 'RegisterGuestSuccess';
  readonly csrf: Scalars['String']['output'];
  /** Guest details. */
  readonly guest: Guest;
};

export type RemoveFromCartInput = {
  readonly lineItemId: Scalars['ID']['input'];
};

export type RemoveFromCartResponseUnion =
  | CartNotFound
  | LocationClosed
  | LoyaltyScanTokenExpired
  | OrderLocked
  | RemoveFromCartSuccess
  | UnauthorizedLineItemModification
  | UnauthorizedOrderModification
  | ValidationError;

export type RemoveFromCartSuccess = {
  readonly __typename?: 'RemoveFromCartSuccess';
  readonly cart: Order;
  readonly success: Scalars['Boolean']['output'];
};

export type RemoveFromCartWithLoyaltyInput = {
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  /** @deprecated Use customerToken instead */
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveRewardByLoyaltyIdInput = {
  /** The loyalty ID of the customer. */
  readonly loyaltyId: Scalars['ID']['input'];
};

export type RemoveRewardInput = {
  /**
   * The ID of the order the reward is being removed from
   * @deprecated No longer needed with rewardsV2
   */
  readonly orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveRewardResponseUnion =
  | CartNotFound
  | LoyaltyScanTokenExpired
  | OrderLocked
  | RemoveRewardSuccess
  | RewardNotRemoved
  | UnauthorizedOrderModification
  | ValidationError;

export type RemoveRewardSuccess = {
  readonly __typename?: 'RemoveRewardSuccess';
  readonly order: Order;
};

export type RemoveRewardWithLoyaltyInput = {
  /** The customer token of the customer. */
  readonly customerToken: Scalars['String']['input'];
};

export type RenameAdminUpsellCategoryInput = {
  readonly id: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
};

export type ReorderConflict = {
  readonly __typename?: 'ReorderConflict';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  /** Indicates if all products in the order are unavailable */
  readonly isNothingAvailable: Scalars['Boolean']['output'];
};

export type ReorderInput = {
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly destinationRestaurantId: Scalars['ID']['input'];
  readonly id: Scalars['ID']['input'];
  /** Ignore order conflicts and submit reorder */
  readonly ignoreConflicts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReorderResponseUnion =
  | CanNotReorder
  | OrderLocked
  | ReorderConflict
  | ReorderSuccess
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | UnauthorizedOrderModification
  | ValidationError;

export type ReorderSuccess = {
  readonly __typename?: 'ReorderSuccess';
  readonly cart: Order;
  /** Indicates if the reorder supports mixing */
  readonly isMixingSupported: Scalars['Boolean']['output'];
};

export type RequestAccountDeletionFailed = {
  readonly __typename?: 'RequestAccountDeletionFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RequestAccountDeletionResponseUnion =
  | RequestAccountDeletionFailed
  | RequestAccountDeletionSuccess;

export type RequestAccountDeletionSuccess = {
  readonly __typename?: 'RequestAccountDeletionSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type Restaurant = {
  readonly __typename?: 'Restaurant';
  readonly address: Scalars['String']['output'];
  readonly asset: Asset;
  /** Some outposts have multiple shelves within them (say, on different floors), and allow customers to select one */
  readonly availableDropOffLocations: ReadonlyArray<DropOffLocation>;
  readonly city: Scalars['String']['output'];
  readonly deliveryFee: Scalars['Int']['output'];
  readonly deliveryMinSubtotal: Scalars['Float']['output'];
  readonly entityId: Maybe<Scalars['Int']['output']>;
  readonly flexMessage: Maybe<Scalars['String']['output']>;
  readonly hours: RestaurantHours;
  readonly id: Scalars['ID']['output'];
  readonly isAcceptingOrders: Scalars['Boolean']['output'];
  readonly isOutpost: Scalars['Boolean']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly menu: Menu;
  readonly name: Scalars['String']['output'];
  readonly notAcceptingOrdersReason: Scalars['String']['output'];
  readonly parentId: Maybe<Scalars['Int']['output']>;
  readonly phone: Scalars['String']['output'];
  readonly sanitaryGradeDisplayText: Maybe<Scalars['String']['output']>;
  readonly sanitaryGradeUrl: Maybe<Scalars['String']['output']>;
  readonly showDeliveryFeeDisclosure: Scalars['Boolean']['output'];
  readonly showDeliveryPriceDifferenciationDisclosure: Scalars['Boolean']['output'];
  readonly showOutpostPriceDifferenciationDisclosure: Scalars['Boolean']['output'];
  readonly showWarningDialog: Maybe<Scalars['Boolean']['output']>;
  readonly slug: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly utcOffset: Maybe<Scalars['Int']['output']>;
  readonly warningDialogDescription: Maybe<Scalars['String']['output']>;
  readonly warningDialogTimeout: Maybe<Scalars['Int']['output']>;
  readonly warningDialogTitle: Maybe<Scalars['String']['output']>;
  readonly zipCode: Scalars['String']['output'];
};

export type RestaurantCapacity = {
  readonly __typename?: 'RestaurantCapacity';
  /** available capacity slots */
  readonly availableWantedTimes: ReadonlyArray<RestaurantCapacitySlot>;
  readonly restaurantAddress: Scalars['String']['output'];
  readonly restaurantHours: Scalars['String']['output'];
  readonly restaurantId: Scalars['ID']['output'];
};

export type RestaurantCapacitySlot = {
  readonly __typename?: 'RestaurantCapacitySlot';
  readonly availableLineItems: Scalars['Float']['output'];
  /** A timeslot in Day, HH:MM format using timezone of the store's location */
  readonly formatted: Scalars['String']['output'];
  readonly maxLineItems: Scalars['Float']['output'];
  /** A timeslot in ISO8601 date time format using timezone of the store's location */
  readonly original: Scalars['String']['output'];
};

export type RestaurantDeliveryChannels = {
  readonly __typename?: 'RestaurantDeliveryChannels';
  /** UI shows the toggles editable only when true; the mutation enforces the same permission. */
  readonly canEdit: Scalars['Boolean']['output'];
  /** DoorDash marketplace: settings.dd_marketplace_delivery_enabled */
  readonly doorDashMarketplaceEnabled: Scalars['Boolean']['output'];
  /** Fooda marketplace: settings.fa_marketplace_delivery_enabled */
  readonly foodaMarketplaceEnabled: Scalars['Boolean']['output'];
  /** Grubhub marketplace: settings.marketplace_delivery_enabled (the unprefixed key predates the other marketplaces) */
  readonly grubhubMarketplaceEnabled: Scalars['Boolean']['output'];
  /** MealPal marketplace: settings.mp_marketplace_delivery_enabled */
  readonly mealPalMarketplaceEnabled: Scalars['Boolean']['output'];
  /** Native (first-party) delivery: settings.ue_native_delivery_enabled */
  readonly nativeDeliveryEnabled: Scalars['Boolean']['output'];
  /** The restaurant these flags belong to */
  readonly restaurantId: Scalars['ID']['output'];
  /** Sharebite marketplace: settings.sb_marketplace_delivery_enabled */
  readonly sharebiteMarketplaceEnabled: Scalars['Boolean']['output'];
  /** UberEats marketplace: settings.ue_marketplace_delivery_enabled */
  readonly uberEatsMarketplaceEnabled: Scalars['Boolean']['output'];
};

export type RestaurantDeliveryChannelsInput = {
  /** Restaurant id. Must be a cooking store, not an outpost. */
  readonly restaurantId: Scalars['ID']['input'];
};

export type RestaurantHours = {
  readonly __typename?: 'RestaurantHours';
  readonly formatted: Maybe<Scalars['String']['output']>;
  readonly permanent: ReadonlyArray<RestaurantStoreHours>;
  readonly store: ReadonlyArray<RestaurantStoreHours>;
};

/** Deprecated: This is deprecated in favor of LocationClosed. This is still kept around for some old native apps out in the wild. */
export type RestaurantHoursMissing = UserError & {
  readonly __typename?: 'RestaurantHoursMissing';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantIsNotAcceptingOrders = UserError & {
  readonly __typename?: 'RestaurantIsNotAcceptingOrders';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantLocationInfoInputDto = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly display_name: Scalars['String']['input'];
  readonly line1: Scalars['String']['input'];
  readonly line2?: InputMaybe<Scalars['String']['input']>;
  readonly postal_code: Scalars['String']['input'];
  /** @deprecated No longer supported */
  readonly restaurant_entity_id?: InputMaybe<Scalars['String']['input']>;
  readonly restaurant_slug: Scalars['String']['input'];
  readonly state: Scalars['String']['input'];
};

export type RestaurantLocationInfoWithIdsInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly displayName: Scalars['String']['input'];
  readonly line1: Scalars['String']['input'];
  readonly line2?: InputMaybe<Scalars['String']['input']>;
  readonly postalCode: Scalars['String']['input'];
  readonly restaurantEntityId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantSlug?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
};

export type RestaurantMaxDeliveryQuantityExceeded = UserError & {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantMaxQuantityExceeded = UserError & {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Type of restaurant to search for */
export enum RestaurantSearchType {
  /** Search all restaurants and outposts */
  All = 'ALL',
  /** Search only outposts (restaurants with parent_id) */
  Outpost = 'OUTPOST',
  /** Search only regular restaurants (no parent_id) */
  Restaurant = 'RESTAURANT',
}

export type RestaurantStoreHours = {
  readonly __typename?: 'RestaurantStoreHours';
  /** Day of the week */
  readonly day: Scalars['String']['output'];
  /** Time formatted as hh:mm (ex. 10:00). Will show as "CLOSED" if the store is closed for the day */
  readonly end: Scalars['String']['output'];
  /** Time formatted as hh:mm (ex. 10:00). Will show as "CLOSED" if the store is closed for the day */
  readonly start: Scalars['String']['output'];
};

export type RestaurantThrottle = {
  readonly __typename?: 'RestaurantThrottle';
  readonly address: Maybe<Scalars['String']['output']>;
  readonly brinkLocationToken: Maybe<Scalars['String']['output']>;
  /** Whether the caller may change the levers; mirrors the mutation guard */
  readonly canEditLevers: Scalars['Boolean']['output'];
  readonly city: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['String']['output'];
  readonly kioskThrottlePercentage: Scalars['Int']['output'];
  readonly kitchenSiteUid: Maybe<Scalars['String']['output']>;
  readonly latitude: Maybe<Scalars['Float']['output']>;
  readonly levers: RestaurantThrottleLevers;
  readonly longitude: Maybe<Scalars['Float']['output']>;
  readonly outpostCount: Scalars['Int']['output'];
  readonly parentId: Maybe<Scalars['ID']['output']>;
  readonly phone: Maybe<Scalars['String']['output']>;
  readonly restaurantId: Scalars['ID']['output'];
  readonly restaurantName: Scalars['String']['output'];
  readonly slots: ReadonlyArray<RestaurantThrottleSlot>;
  readonly state: Maybe<Scalars['String']['output']>;
  readonly throttleDefaultSize: Scalars['Int']['output'];
  readonly throttleGridEnabled: Scalars['Boolean']['output'];
  readonly timeZone: Scalars['String']['output'];
  readonly zipCode: Maybe<Scalars['String']['output']>;
};

export type RestaurantThrottleInput = {
  /** Date in YYYY-MM-DD format */
  readonly date: Scalars['String']['input'];
  /** Restaurant id */
  readonly restaurantId: Scalars['ID']['input'];
};

export type RestaurantThrottleLevers = {
  readonly __typename?: 'RestaurantThrottleLevers';
  /** Order types allowed to place large orders */
  readonly channels: ReadonlyArray<Scalars['String']['output']>;
  /** What counts as large, as a percent of one window of capacity (1 to 100) */
  readonly largeOrderThresholdPercent: Scalars['Int']['output'];
  /** How many earlier windows a large order may spread into */
  readonly maxBuildAheadWindows: Scalars['Int']['output'];
  /** Hard ceiling on one order regardless of available room */
  readonly maxOrderSize: Scalars['Int']['output'];
  /** Percent of each window kept for normal orders; large orders may not use it */
  readonly reservePercent: Scalars['Int']['output'];
  /** The store these levers were read from; differs from the outpost being viewed */
  readonly resolvedFromRestaurantId: Scalars['Int']['output'];
};

export type RestaurantThrottleSlot = {
  readonly __typename?: 'RestaurantThrottleSlot';
  readonly availableCount: Scalars['Int']['output'];
  readonly breakdown: ReadonlyArray<ThrottleSlotBreakdown>;
  readonly defaultCapacity: Scalars['Int']['output'];
  readonly defaultFilledCount: Scalars['Int']['output'];
  readonly filledCount: Scalars['Int']['output'];
  readonly kioskCapacity: Scalars['Int']['output'];
  readonly kioskFilledCount: Scalars['Int']['output'];
  /** ISO8601 local time */
  readonly time: Scalars['String']['output'];
  /** Formatted time HH:mm */
  readonly timeFormatted: Scalars['String']['output'];
  readonly totalCapacity: Scalars['Int']['output'];
};

export type RestaurantsForAdminInput = {
  /** Include outposts, which the list leaves out by default */
  readonly includeOutposts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of restaurants to return (max: 50) */
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  /** Only the restaurants with these Salesforce ids (Restaurant.mdmId) */
  readonly mdmIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Number of restaurants to skip for pagination */
  readonly offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive search term for restaurant name (minimum 2 characters) */
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

/** Entity contributes to the Rewards entity in Monograph with fields provided by Challenges SVC */
export type Reward = {
  readonly __typename?: 'Reward';
  /** URL for the reward image */
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  /** Date the reward expires */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  /** SessionM Offer ID - Not direct match to ID in Reward entity in Monograph but included in the serialized value */
  readonly id: Scalars['ID']['output'];
  /** If true, reward is a hero offer and should be featured in the UI */
  readonly isFeatured: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** If true, reward can be used and UI should allow it to be selected on the bag */
  readonly redeemable: Scalars['Boolean']['output'];
  /** If redeemable is false, this will populate with the next timestamp in UTC when the offer can be used. */
  readonly redeemableAt: Maybe<Scalars['DateTime']['output']>;
  /** The channel(s) in which the reward can be redeemed */
  readonly redemptionChannel: RedemptionChannel;
  readonly rewardType: RewardType;
  /** Field references the offer terms and conditions configured in SessionM. If that field is not configured, returns the default SG terms url. */
  readonly terms: Scalars['String']['output'];
};

/** Indicates that adding, removing, or validating a reward failed and that an error should be shown to the customer. The end result is always that the cart's current reward is cleared; clients should update their internal state to reflect this. */
export type RewardNotApplied = {
  readonly __typename?: 'RewardNotApplied';
  /**
   * Provides more detail about the reason reward application failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value.
   * @deprecated Use failureReasons and failureMetadata instead
   */
  readonly failureCode: ApplyRewardFailureCode;
  /** Provides even more detail about the reason reward application failed. Clients use these for more refined messaging. */
  readonly failureMetadata: ApplyRewardFailureMetadata;
  /** Provides more detail about the reason reward application failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureReasons: ReadonlyArray<Scalars['String']['output']>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RewardNotRemoved = {
  readonly __typename?: 'RewardNotRemoved';
  /** Provides more detail about the reason reward removal failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureCode: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RewardNotValidated = UserError & {
  readonly __typename?: 'RewardNotValidated';
  readonly errorMessage: Scalars['String']['output'];
  readonly failureCode: ValidateRewardFailureCode;
  readonly failureMetadata: Maybe<ValidateRewardFailureMetadata>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export enum RewardType {
  NonPremium = 'NON_PREMIUM',
  Premium = 'PREMIUM',
}

/** Validation error response */
export type RewardValidationGeneralError = {
  readonly __typename?: 'RewardValidationGeneralError';
  readonly errorMessage: Scalars['String']['output'];
};

export type RewardsPremiumStatus = {
  readonly __typename?: 'RewardsPremiumStatus';
  readonly expirationDate: Scalars['String']['output'];
  readonly isActive: Scalars['Boolean']['output'];
};

export type RewardsValidateAndPreviewUnion = RewardValidationGeneralError;

export type RewardsValidateAndReserveUnion = RewardValidationGeneralError;

export type SaveFeedbackCaseInput = {
  readonly isFeedbackComplete: Scalars['Boolean']['input'];
  readonly orderId: Scalars['ID']['input'];
  readonly orderType: FeedbackOrderType;
};

export type SelectedModifier = {
  readonly __typename?: 'SelectedModifier';
  /** The cost of the modification, in cents. */
  readonly cost: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  /** The modified ingredient. */
  readonly ingredient: Maybe<Ingredient>;
  /** The type of modification. */
  readonly modifierType: Maybe<ModifierType>;
  /** The parent modifier ID. */
  readonly parentId: Maybe<Scalars['Int']['output']>;
};

export type SelectedRewardsWithDetails = {
  readonly id: Scalars['String']['input'];
  readonly offerId?: InputMaybe<Scalars['String']['input']>;
};

export type Session = {
  readonly __typename?: 'Session';
  readonly cart: Maybe<Order>;
  readonly csrf: Scalars['String']['output'];
  /** ID of the order currently in-flight, restricted to delivery orders. */
  readonly inFlightDeliveryOrderId: Maybe<Scalars['ID']['output']>;
  /** ID of the order currently in-flight. */
  readonly inFlightOrderId: Maybe<Scalars['ID']['output']>;
  readonly isLoggedIn: Scalars['Boolean']['output'];
};

export type SignInFailed = {
  readonly __typename?: 'SignInFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type SignInResponseUnion = CustomerNotFound | SignInFailed | SignInSuccess | ValidationError;

export type SignInSuccess = {
  readonly __typename?: 'SignInSuccess';
  readonly customer: Customer;
};

export type StoreOffline = UserError & {
  readonly __typename?: 'StoreOffline';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type StripeRefundErrorResponse = UserError & {
  readonly __typename?: 'StripeRefundErrorResponse';
  readonly errorMessage: Scalars['String']['output'];
};

export type SubmitGiftCardCodeSuccess = {
  readonly __typename?: 'SubmitGiftCardCodeSuccess';
  /** Total credit after applying gift card */
  readonly totalCredit: Scalars['Float']['output'];
};

/** "Unable to purchase gift card" user error */
export type SubmitGiftCardOrderError = UserError & {
  readonly __typename?: 'SubmitGiftCardOrderError';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Payment failed" user error */
export type SubmitGiftCardOrderPaymentError = UserError & {
  readonly __typename?: 'SubmitGiftCardOrderPaymentError';
  readonly errorMessage: Scalars['String']['output'];
};

export type SubmitGiftCardOrderUsingPaymentMethodInput = {
  readonly assetId: Scalars['String']['input'];
  readonly balance: Scalars['Float']['input'];
  readonly deliveryDateTime?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryMethods: ReadonlyArray<Scalars['String']['input']>;
  readonly isAsap: Scalars['Boolean']['input'];
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly paymentMethodId: Scalars['String']['input'];
  readonly quantity: Scalars['Float']['input'];
  readonly recipientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly recipientName: Scalars['String']['input'];
  readonly senderName: Scalars['String']['input'];
  readonly utcOffset: Scalars['Float']['input'];
};

export type SubmitGiftCardOrderUsingPaymentMethodResponseUnion =
  | GiftCardOrderDetail
  | SubmitGiftCardOrderError
  | SubmitGiftCardOrderPaymentError;

export type SubmitOrderAsapInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitOrderAsapWithLoyaltyInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use customerToken instead */
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly paymentId?: InputMaybe<Scalars['String']['input']>;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitOrderUsingPaymentIntentAsapInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly paymentIntentId: Scalars['String']['input'];
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitOrderUsingPaymentMethodInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: InputMaybe<Scalars['ID']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** Customer's saved Payment Method */
  readonly paymentMethodId: Scalars['ID']['input'];
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  readonly shouldTrackPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: Scalars['Boolean']['input'];
  /** Whether or not to apply HSA/FSA (Flex) funds towards eligible items */
  readonly useHsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderUsingPaymentMethodResponseUnion =
  | DeclinedPaymentMethod
  | DeliveryAlreadyInFlight
  | DeliverySpecifyAddress
  | IncorrectPaymentMethod
  | InvalidCustomerPhone
  | InvalidTip
  | MinimumDeliverySubtotalNotMet
  | ProductOutOfStock
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderUsingPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderUsingPaymentMethodSuccess = {
  readonly __typename?: 'SubmitOrderUsingPaymentMethodSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderWithPaymentMethodInput = {
  /** If the client has their own identifier for this order, they should provide it here for potential correlation on sweetgreen's end. For example, delivery marketplaces should provide their order id. */
  readonly externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: Scalars['String']['input'];
  /** the order payment method, ie: prepaid or cash */
  readonly paymentMethod: PaymentMethods;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderWithPaymentMethodResponseUnion =
  | DeclinedPaymentMethod
  | InvalidBillingAccount
  | InvalidCreditCard
  | LoyaltyScanPaymentTokenInvalid
  | LoyaltyScanTokenExpired
  | MinimumDeliverySubtotalNotMet
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderWithPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderWithPaymentMethodSuccess = {
  readonly __typename?: 'SubmitOrderWithPaymentMethodSuccess';
  readonly order: Order;
};

export type SubmitPromoCodeInput = {
  /** Promotion code */
  readonly code: Scalars['String']['input'];
};

export type SubmitPromoCodeOrGiftCardResponseUnion =
  | InvalidPromoCode
  | PromoCodeAlreadyApplied
  | SubmitGiftCardCodeSuccess
  | SubmitPromoCodeSuccessV2
  | ValidationError;

export type SubmitPromoCodeResponseUnion =
  | InvalidPromoCode
  | PromoCodeAlreadyApplied
  | SubmitPromoCodeSuccessV2
  | ValidationError;

export type SubmitPromoCodeSuccessV2 = {
  readonly __typename?: 'SubmitPromoCodeSuccessV2';
  /** Placeholder value that always returns true. Use `__typename` to identify success */
  readonly placeholder: Scalars['Boolean']['output'];
};

export type SubmitPromoOrGiftCardCodeInput = {
  /** Promotion or gift card code */
  readonly code: Scalars['String']['input'];
};

export type SubmitZeroTotalOrderWithLoyaltyInput = {
  /** Contact number for SMS order updates */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** The customer's scanned loyalty token */
  readonly customerToken: Scalars['String']['input'];
  /** The order being submitted, used to recognize a retry of an already placed order */
  readonly orderId: Scalars['ID']['input'];
};

export type SubmitZeroTotalOrderWithLoyaltyResponseUnion =
  | DeclinedPaymentMethod
  | InvalidBillingAccount
  | InvalidCreditCard
  | LoyaltyScanPaymentTokenInvalid
  | LoyaltyScanTokenExpired
  | MinimumDeliverySubtotalNotMet
  | OrderTotalNotZero
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderWithPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubscriptionCreditCard = {
  readonly __typename?: 'SubscriptionCreditCard';
  readonly cardType: BraintreeCardType;
  readonly expirationMonth: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly expirationYear: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly lastFour: Scalars['String']['output'];
};

/** Customer Subscription Plan (deprecated) */
export type SubscriptionPlan = {
  readonly __typename?: 'SubscriptionPlan';
  /** The value that specifies the day of the month that the Braintree gateway will charge the subscription each billing cycle */
  readonly billingDayOfMonth: Maybe<Scalars['String']['output']>;
  /** Specifies the billing interval of the plan in months */
  readonly billingFrequency: Scalars['String']['output'];
  /**
   * The frequency in which subscription payments should be made.
   * @deprecated Deprecated in favor of `billingRecurrence`
   */
  readonly billingFrequencyUnit: Maybe<DurationUnit>;
  /** The recurrence in which subscription payments should be made. */
  readonly billingRecurrence: Maybe<DurationUnit>;
  /** The date/time the plan was created in UTC format */
  readonly createdAt: Scalars['String']['output'];
  /** The currency for the transaction */
  readonly currencyIsoCode: Scalars['String']['output'];
  /** The description of the plan */
  readonly description: Maybe<Scalars['String']['output']>;
  /** The plan identifier */
  readonly discounts: Maybe<ReadonlyArray<Discount>>;
  /** Whether this plan supports a free trial */
  readonly hasFreeTrial: Scalars['Boolean']['output'];
  /** The plan identifier */
  readonly id: Scalars['String']['output'];
  /** The name of the plan */
  readonly name: Scalars['String']['output'];
  /** The base price for the plan */
  readonly price: Scalars['String']['output'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  PastDue = 'PAST_DUE',
  Pending = 'PENDING',
}

export type SubscriptionTransactions = {
  readonly __typename?: 'SubscriptionTransactions';
  readonly amount: Scalars['String']['output'];
  readonly creditCard: SubscriptionCreditCard;
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly refund: Scalars['Boolean']['output'];
  readonly transactionCreditCard: TransactionCreditCard;
};

export type SyncChanges = {
  readonly __typename?: 'SyncChanges';
  /** Fields added on initial insert (empty for updates) */
  readonly additions: ReadonlyArray<Scalars['String']['output']>;
  /** Fields removed during sync (with before values) */
  readonly deletions: ReadonlyArray<ChangeDetail>;
  /** Fields updated during sync with before/after values */
  readonly updates: ReadonlyArray<ChangeDetail>;
};

export type SyncLocationInput = {
  /** When true, includes the raw Salesforce payload in the response for debugging. */
  readonly isDebug?: Scalars['Boolean']['input'];
  /** When true, performs a dry-run and returns the computed changes without persisting to the database. */
  readonly isPreview?: Scalars['Boolean']['input'];
  readonly salesforceId: Scalars['String']['input'];
};

export type SyncLocationResult = {
  readonly __typename?: 'SyncLocationResult';
  /** Detailed change information. For preview mode, this reflects what would change. */
  readonly changes: Maybe<SyncChanges>;
  /** Results of child outpost syncs triggered when parent restaurant Outpost_Price_Differentiation changes */
  readonly childSyncResults: Maybe<ReadonlyArray<ChildSyncResult>>;
  /** Raw Salesforce payload for debugging (only set when isDebug=true) */
  readonly data: Maybe<Scalars['JSON']['output']>;
  /** Array of error messages (only present when success is false) */
  readonly errors: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** When true, the sync ran in preview mode (no database writes were performed). */
  readonly isPreview: Scalars['Boolean']['output'];
  /** The Salesforce Account ID that was queried */
  readonly salesforceId: Scalars['String']['output'];
  /** Indicates whether the sync operation succeeded */
  readonly success: Scalars['Boolean']['output'];
  /** Timestamp when the sync was performed (null on failure) */
  readonly syncedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ThrottleSlotBreakdown = {
  readonly __typename?: 'ThrottleSlotBreakdown';
  readonly categoryName: Scalars['String']['output'];
  readonly count: Scalars['Int']['output'];
  readonly orderSource: Scalars['String']['output'];
  readonly orderType: Scalars['String']['output'];
};

/** Loyalty Tier */
export type Tier = {
  readonly __typename?: 'Tier';
  /** Loyalty Tier Display Name */
  readonly displayName: Scalars['String']['output'];
  /** Tier ID */
  readonly id: Scalars['ID']['output'];
  /**
   * Loyalty Tier Name
   * @deprecated Use nameV2 field instead. This field will be removed in the future.
   */
  readonly name: TierName;
  /** Loyalty Tier Name */
  readonly nameV2: TierName;
  /** Next tier */
  readonly nextTier: Maybe<Tier>;
  /** Tier Group */
  readonly tierGroup: TierGroup;
};

/** Tier Group */
export type TierGroup = {
  readonly __typename?: 'TierGroup';
  /** Tier Group ID */
  readonly id: Scalars['ID']['output'];
  /** Tier Group Name */
  readonly name: Scalars['ID']['output'];
};

export enum TierName {
  OptedOut = 'OPTED_OUT',
  RewardsBase = 'REWARDS_BASE',
  RewardsOptedOut = 'REWARDS_OPTED_OUT',
  Sweetpass = 'SWEETPASS',
  SweetpassPlus = 'SWEETPASS_PLUS',
}

/** Loyalty Tier */
export type TierStatus = {
  readonly __typename?: 'TierStatus';
  /** Tier ID */
  readonly id: Scalars['ID']['output'];
  /** Tier Status Name */
  readonly name: TierStatusName;
};

export enum TierStatusName {
  Active = 'ACTIVE',
  CancellationPending = 'CANCELLATION_PENDING',
  FreeTrial = 'FREE_TRIAL',
  PastDue = 'PAST_DUE',
  Processing = 'PROCESSING',
}

export type TimeRestrictionError = UserError & {
  readonly __typename?: 'TimeRestrictionError';
  readonly errorMessage: Scalars['String']['output'];
};

export type TimeslotUnavailable = UserError & {
  readonly __typename?: 'TimeslotUnavailable';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type TransactionCreditCard = {
  readonly __typename?: 'TransactionCreditCard';
  readonly cardType: BraintreeCardType;
  /** Credit card ID, if the Credit Card was removed Transaction ID */
  readonly id: Scalars['ID']['output'];
  readonly lastFour: Scalars['String']['output'];
};

export type TransactionNotFoundError = UserError & {
  readonly __typename?: 'TransactionNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** A single planned tender in the payment waterfall. */
export type TransactionPlan = {
  readonly __typename?: 'TransactionPlan';
  /** Amount planned for this tender, in cents. */
  readonly amountInCents: Scalars['Int']['output'];
  /** Whether this tender is captured automatically. */
  readonly automaticCapture: Maybe<Scalars['Boolean']['output']>;
  /** The payment processor for this tender (e.g. stripe, flex, stipend, paytronix-gift-card). */
  readonly processor: Scalars['String']['output'];
};

export type TransactionPlanResponseUnion =
  | CustomerNotOnboardedError
  | OrderMissingTotalError
  | TransactionPlanResult;

/** A successfully transaction plan for an order. */
export type TransactionPlanResult = {
  readonly __typename?: 'TransactionPlanResult';
  /** The planned tenders, in execution order. */
  readonly transactionPlan: ReadonlyArray<TransactionPlan>;
};

/** Trial Eligibility */
export type TrialEligibility = {
  readonly __typename?: 'TrialEligibility';
  /** The trial duration length */
  readonly duration: Scalars['Int']['output'];
  /** The trial duration unit */
  readonly durationUnit: DurationUnit;
};

/** "Unable to get Flex customer data" user error. */
export type UnableToGetFlexCustomerDataError = UserError & {
  readonly __typename?: 'UnableToGetFlexCustomerDataError';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Unable to get gift card balance" user error */
export type UnableToGetGiftCardBalanceError = UserError & {
  readonly __typename?: 'UnableToGetGiftCardBalanceError';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Unable to redeem gift card" user error */
export type UnableToRedeemGiftCardError = UserError & {
  readonly __typename?: 'UnableToRedeemGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

export type UnauthorizedLineItemModification = UserError & {
  readonly __typename?: 'UnauthorizedLineItemModification';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type UnauthorizedOrderModification = UserError & {
  readonly __typename?: 'UnauthorizedOrderModification';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Generic user error */
export type UnknownUserError = UserError & {
  readonly __typename?: 'UnknownUserError';
  readonly errorMessage: Scalars['String']['output'];
};

export type UnlockOrderFailed = UserError & {
  readonly __typename?: 'UnlockOrderFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type UnlockOrderResponseUnion = CartNotFound | UnlockOrderFailed | UnlockOrderSuccess;

export type UnlockOrderSuccess = {
  readonly __typename?: 'UnlockOrderSuccess';
  readonly order: Order;
};

export type UpdateAddressResponseUnion = InvalidAddress | UpdateAddressSuccess | ValidationError;

export type UpdateAddressSuccess = {
  readonly __typename?: 'UpdateAddressSuccess';
  readonly address: Address;
};

export type UpdateAdminGroupOrderSettingsInput = {
  /** A positive whole number */
  readonly maxEntreeLimit: Scalars['Int']['input'];
};

export type UpdateAdminPrintPriorityTemplateInput = {
  /** Template id */
  readonly id: Scalars['ID']['input'];
  /** New template name; omit to keep the current name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** All zones in template print order */
  readonly zones: ReadonlyArray<AdminPrintPriorityTemplateZoneInput>;
};

export type UpdateAdminProductUpsellsInput = {
  /** Every upsell, in rank order. Listed products become upsells ranked 1, 2, 3…; upsells left out stop being upsells. */
  readonly masterProductIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type UpdateAdminRestaurantAvailabilityResponse = {
  readonly __typename?: 'UpdateAdminRestaurantAvailabilityResponse';
  readonly message: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
  /** Gravy product and stock rows changed, including lineage, dip and outpost rows; 0 when all were already in that state */
  readonly updatedCount: Scalars['Int']['output'];
};

export type UpdateAdminRestaurantEnabledInput = {
  readonly enabled: Scalars['Boolean']['input'];
  /** Restaurant or outpost id */
  readonly restaurantId: Scalars['ID']['input'];
};

export type UpdateAdminRestaurantIngredientDatesInput = {
  /** YYYY-MM-DD, or null to clear the restaurant date; omit to keep each current one */
  readonly availableDate?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, the first day it is no longer sold, or null to clear; omit to keep each current one */
  readonly expirationDate?: InputMaybe<Scalars['String']['input']>;
  /** adminRestaurantAvailability ingredient ids, at most 100 */
  readonly ingredientIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Restaurants to change, at most 50; none may be an outpost */
  readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type UpdateAdminRestaurantIngredientStockInput = {
  readonly action: AdminRestaurantStockAction;
  /** When 86ing, put it back in stock at the next midnight in the restaurant's time zone */
  readonly autoRestock?: Scalars['Boolean']['input'];
  /** adminRestaurantAvailability ingredient ids, at most 100 */
  readonly ingredientIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Free text saved with the reason; required when the reason is other */
  readonly reasonComment?: InputMaybe<Scalars['String']['input']>;
  /** Required to 86: a key from adminOutOfStockReasons. Ignored otherwise. */
  readonly reasonKey?: InputMaybe<Scalars['String']['input']>;
  /** Restaurants to change, at most 50; none may be an outpost */
  readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type UpdateAdminRestaurantMenuProductDatesInput = {
  /** YYYY-MM-DD, or null to clear the restaurant date; omit to keep each current one */
  readonly availableDate?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, the first day it is no longer sold, or null to clear; omit to keep each current one */
  readonly expirationDate?: InputMaybe<Scalars['String']['input']>;
  /** adminRestaurantAvailability menu product ids, at most 100 */
  readonly menuProductIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Restaurants to change, at most 50; none may be an outpost */
  readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type UpdateAdminRestaurantMenuProductStockInput = {
  readonly action: AdminRestaurantStockAction;
  /** When 86ing, put it back in stock at the next midnight in the restaurant's time zone */
  readonly autoRestock?: Scalars['Boolean']['input'];
  /** adminRestaurantAvailability menu product ids, at most 100 */
  readonly menuProductIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Free text saved with the reason; required when the reason is other */
  readonly reasonComment?: InputMaybe<Scalars['String']['input']>;
  /** Required to 86: a key from adminOutOfStockReasons. Ignored otherwise. */
  readonly reasonKey?: InputMaybe<Scalars['String']['input']>;
  /** Restaurants to change, at most 50; none may be an outpost */
  readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type UpdateAdminRestaurantOrderingInput = {
  readonly acceptingOrders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Why ordering is off. Empty clears it. */
  readonly notAcceptingOrdersReason?: InputMaybe<Scalars['String']['input']>;
  /** Restaurant or outpost id */
  readonly restaurantId: Scalars['ID']['input'];
};

export type UpdateAdminRestaurantProfileInput = {
  readonly crossStreet?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly flexMessage?: InputMaybe<Scalars['String']['input']>;
  readonly pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Restaurant or outpost id */
  readonly restaurantId: Scalars['ID']['input'];
};

export type UpdateAdminUpsellCategoryArrangementInput = {
  /** Every upsell category exactly once, in rank order, each with its products in rank order. A product can be in one category; products left out leave their category. */
  readonly categories: ReadonlyArray<AdminUpsellCategoryArrangementInput>;
};

export type UpdateCustomerInput = {
  readonly birthday?: InputMaybe<Scalars['String']['input']>;
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated The password field will not be used with the new password-less flow. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerPreferencesError = UserError & {
  readonly __typename?: 'UpdateCustomerPreferencesError';
  readonly errorMessage: Scalars['String']['output'];
};

export type UpdateCustomerPreferencesUnion = CustomerPreference | UpdateCustomerPreferencesError;

export type UpdateCustomerResponse = {
  readonly __typename?: 'UpdateCustomerResponse';
  readonly customer: Customer;
};

export type UpdateKioskCustomerInput = {
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKioskCustomerResponse = {
  readonly __typename?: 'UpdateKioskCustomerResponse';
  readonly customer: Customer;
};

export type UpdatePaymentMethodInput = {
  /** Id of card to update */
  readonly id: Scalars['String']['input'];
  /** New default flag value of card to update */
  readonly isDefault: Scalars['Boolean']['input'];
  /** New nickname of card to update */
  readonly nickname: Scalars['String']['input'];
};

export type UpdateRestaurantDeliveryChannelsInput = {
  readonly doorDashMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly foodaMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly grubhubMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mealPalMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restaurant id. Must be a cooking store, not an outpost. */
  readonly restaurantId: Scalars['ID']['input'];
  readonly sharebiteMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly uberEatsMarketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRestaurantThrottleLeversInput = {
  readonly channels?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly largeOrderThresholdPercent?: InputMaybe<Scalars['Int']['input']>;
  readonly maxBuildAheadWindows?: InputMaybe<Scalars['Int']['input']>;
  readonly maxOrderSize?: InputMaybe<Scalars['Int']['input']>;
  readonly reservePercent?: InputMaybe<Scalars['Int']['input']>;
  /** Restaurant id. Must be a cooking store, not an outpost. */
  readonly restaurantId: Scalars['ID']['input'];
};

export type UpdateUseCreditResponse = {
  readonly __typename?: 'UpdateUseCreditResponse';
  readonly customer: Customer;
};

export type UpsellCategory = {
  readonly __typename?: 'UpsellCategory';
  readonly categoryRanking: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly products: ReadonlyArray<UpsellCategoryProduct>;
  readonly restaurantId: Scalars['String']['output'];
};

export type UpsellCategoryProduct = {
  readonly __typename?: 'UpsellCategoryProduct';
  /** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
  readonly channelCost: Scalars['Int']['output'];
  readonly cost: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Scalars['String']['output'];
  readonly menuId: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
};

export type UpsellCategoryProductChannelCostArgs = {
  costChannel?: InputMaybe<CostChannel>;
};

export type UserError = {
  readonly errorMessage: Scalars['String']['output'];
};

/** The purchased gift card details */
export type UserGiftCard = {
  readonly __typename?: 'UserGiftCard';
  /** Gift card asset id. */
  readonly assetId: Maybe<Scalars['String']['output']>;
  /** Gift card balance. */
  readonly balance: Scalars['Float']['output'];
  /** Gift card id. */
  readonly id: Scalars['String']['output'];
  /** User provided message sent to the gift card recipient. */
  readonly message: Maybe<Scalars['String']['output']>;
  /** User provided email of the gift card recipient. */
  readonly recipientEmail: Maybe<Scalars['String']['output']>;
  /** User provided name of the gift card recipient. */
  readonly recipientName: Scalars['String']['output'];
  /** Gift card redemption token. */
  readonly redemptionToken: Maybe<Scalars['String']['output']>;
};

/** User Notification Preferences */
export type UserNotificationPreferences = {
  readonly __typename?: 'UserNotificationPreferences';
  readonly notificationCategories: ReadonlyArray<NotificationCategory>;
};

export type UserNotificationPreferencesUnion =
  | NotificationPreferencesError
  | UserNotificationPreferences;

export type UserOrderPermission = {
  readonly __typename?: 'UserOrderPermission';
  readonly canApplyRewards: Scalars['Boolean']['output'];
  readonly canSubmitOrder: Scalars['Boolean']['output'];
  readonly canUpdateOrderDetails: Scalars['Boolean']['output'];
  readonly isHost: Scalars['Boolean']['output'];
};

export type UserPointsStatus = {
  readonly __typename?: 'UserPointsStatus';
  readonly available: Scalars['Float']['output'];
  readonly pending: Scalars['Float']['output'];
  readonly total: Scalars['Float']['output'];
};

export type ValidateAndRefreshGiftCardRedemptionTokenForCustomerInput = {
  readonly recipientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly redemptionToken: Scalars['String']['input'];
};

export type ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse = {
  readonly __typename?: 'ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse';
  /** A valid redemption token generated with the new secret. */
  readonly redemptionToken: Maybe<Scalars['String']['output']>;
  /** Whether the redemption token is valid. */
  readonly valid: Scalars['Boolean']['output'];
};

export enum ValidateRewardFailureCode {
  CartNotFound = 'CART_NOT_FOUND',
  ChannelRestriction = 'CHANNEL_RESTRICTION',
  DayRestriction = 'DAY_RESTRICTION',
  LoyaltyLocationNotFound = 'LOYALTY_LOCATION_NOT_FOUND',
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  MissingSku = 'MISSING_SKU',
  PriceMaximum = 'PRICE_MAXIMUM',
  PriceMinimum = 'PRICE_MINIMUM',
  RestaurantNotAcceptingOrders = 'RESTAURANT_NOT_ACCEPTING_ORDERS',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
  RewardNotFound = 'REWARD_NOT_FOUND',
  TimeRestriction = 'TIME_RESTRICTION',
}

/** Reward Validation Metadata */
export type ValidateRewardFailureMetadata = {
  readonly __typename?: 'ValidateRewardFailureMetadata';
  readonly requiredChannel: Maybe<Scalars['String']['output']>;
  readonly requiredDays: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
};

export type ValidationError = {
  readonly __typename?: 'ValidationError';
  readonly fieldErrors: ReadonlyArray<FieldValidationError>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Vendor = {
  readonly __typename?: 'Vendor';
  readonly name: Scalars['String']['output'];
  readonly restaurantId: Scalars['String']['output'];
};

export type WithTypename<T extends { __typename?: any }> = Partial<T> & {
  __typename: NonNullable<T['__typename']>;
};

export type GraphCacheKeysConfig = {
  ActivePaymentMethodError?: (data: WithTypename<ActivePaymentMethodError>) => null | string;
  AddAddressSuccess?: (data: WithTypename<AddAddressSuccess>) => null | string;
  AddLineItemToCartSuccess?: (data: WithTypename<AddLineItemToCartSuccess>) => null | string;
  Addons?: (data: WithTypename<Addons>) => null | string;
  Address?: (data: WithTypename<Address>) => null | string;
  AdminAppliedPrintTemplate?: (data: WithTypename<AdminAppliedPrintTemplate>) => null | string;
  AdminGroupOrderSettingAudit?: (data: WithTypename<AdminGroupOrderSettingAudit>) => null | string;
  AdminGroupOrderSettings?: (data: WithTypename<AdminGroupOrderSettings>) => null | string;
  AdminMasterZone?: (data: WithTypename<AdminMasterZone>) => null | string;
  AdminOrder?: (data: WithTypename<AdminOrder>) => null | string;
  AdminOrderAddress?: (data: WithTypename<AdminOrderAddress>) => null | string;
  AdminOrderCustomer?: (data: WithTypename<AdminOrderCustomer>) => null | string;
  AdminOrderCustomerSummary?: (data: WithTypename<AdminOrderCustomerSummary>) => null | string;
  AdminOrderDelivery?: (data: WithTypename<AdminOrderDelivery>) => null | string;
  AdminOrderDiscount?: (data: WithTypename<AdminOrderDiscount>) => null | string;
  AdminOrderFee?: (data: WithTypename<AdminOrderFee>) => null | string;
  AdminOrderLineItem?: (data: WithTypename<AdminOrderLineItem>) => null | string;
  AdminOrderPage?: (data: WithTypename<AdminOrderPage>) => null | string;
  AdminOrderRestaurant?: (data: WithTypename<AdminOrderRestaurant>) => null | string;
  AdminOrderSummary?: (data: WithTypename<AdminOrderSummary>) => null | string;
  AdminOutOfStockReason?: (data: WithTypename<AdminOutOfStockReason>) => null | string;
  AdminPrintOrderIngredient?: (data: WithTypename<AdminPrintOrderIngredient>) => null | string;
  AdminPrintOrderZone?: (data: WithTypename<AdminPrintOrderZone>) => null | string;
  AdminPrintPriorityIngredient?: (
    data: WithTypename<AdminPrintPriorityIngredient>,
  ) => null | string;
  AdminPrintPriorityTemplate?: (data: WithTypename<AdminPrintPriorityTemplate>) => null | string;
  AdminPrintPriorityTemplateZone?: (
    data: WithTypename<AdminPrintPriorityTemplateZone>,
  ) => null | string;
  AdminProductUpsellAudit?: (data: WithTypename<AdminProductUpsellAudit>) => null | string;
  AdminProductUpsellAuditChange?: (
    data: WithTypename<AdminProductUpsellAuditChange>,
  ) => null | string;
  AdminRestaurant?: (data: WithTypename<AdminRestaurant>) => null | string;
  AdminRestaurantAudit?: (data: WithTypename<AdminRestaurantAudit>) => null | string;
  AdminRestaurantAuditChange?: (data: WithTypename<AdminRestaurantAuditChange>) => null | string;
  AdminRestaurantAuditPage?: (data: WithTypename<AdminRestaurantAuditPage>) => null | string;
  AdminRestaurantAvailability?: (data: WithTypename<AdminRestaurantAvailability>) => null | string;
  AdminRestaurantIngredient?: (data: WithTypename<AdminRestaurantIngredient>) => null | string;
  AdminRestaurantIngredientRecord?: (
    data: WithTypename<AdminRestaurantIngredientRecord>,
  ) => null | string;
  AdminRestaurantMenuProduct?: (data: WithTypename<AdminRestaurantMenuProduct>) => null | string;
  AdminRestaurantMenuProductRecord?: (
    data: WithTypename<AdminRestaurantMenuProductRecord>,
  ) => null | string;
  AdminRestaurantOrdering?: (data: WithTypename<AdminRestaurantOrdering>) => null | string;
  AdminRestaurantProfile?: (data: WithTypename<AdminRestaurantProfile>) => null | string;
  AdminRestaurantSettings?: (data: WithTypename<AdminRestaurantSettings>) => null | string;
  AdminUpsellCategory?: (data: WithTypename<AdminUpsellCategory>) => null | string;
  AdminUpsellMasterProduct?: (data: WithTypename<AdminUpsellMasterProduct>) => null | string;
  AllergenProperty?: (data: WithTypename<AllergenProperty>) => null | string;
  ApplyRewardFailureMetadata?: (data: WithTypename<ApplyRewardFailureMetadata>) => null | string;
  ApplyRewardSuccess?: (data: WithTypename<ApplyRewardSuccess>) => null | string;
  Asset?: (data: WithTypename<Asset>) => null | string;
  AsyncCancelFailed?: (data: WithTypename<AsyncCancelFailed>) => null | string;
  AvailableCustomerSupportPointsError?: (
    data: WithTypename<AvailableCustomerSupportPointsError>,
  ) => null | string;
  AvailableCustomerSupportPointsSuccess?: (
    data: WithTypename<AvailableCustomerSupportPointsSuccess>,
  ) => null | string;
  AvailablePromotionFailure?: (data: WithTypename<AvailablePromotionFailure>) => null | string;
  AvailablePromotionsSuccess?: (data: WithTypename<AvailablePromotionsSuccess>) => null | string;
  AvailableWantedTime?: (data: WithTypename<AvailableWantedTime>) => null | string;
  BaseProduct?: (data: WithTypename<BaseProduct>) => null | string;
  BillingAccount?: (data: WithTypename<BillingAccount>) => null | string;
  CXCredit?: (data: WithTypename<CxCredit>) => null | string;
  CanCancel?: (data: WithTypename<CanCancel>) => null | string;
  CanCancelAlreadySent?: (data: WithTypename<CanCancelAlreadySent>) => null | string;
  CanCancelFailed?: (data: WithTypename<CanCancelFailed>) => null | string;
  CanCancelNotFound?: (data: WithTypename<CanCancelNotFound>) => null | string;
  CanCancelUnauthorized?: (data: WithTypename<CanCancelUnauthorized>) => null | string;
  CanNotReorder?: (data: WithTypename<CanNotReorder>) => null | string;
  CancelOrderFailed?: (data: WithTypename<CancelOrderFailed>) => null | string;
  CancelOrderPaymentIntentResponse?: (
    data: WithTypename<CancelOrderPaymentIntentResponse>,
  ) => null | string;
  CancelOrderSuccess?: (data: WithTypename<CancelOrderSuccess>) => null | string;
  CancelOrderSuccessAsync?: (data: WithTypename<CancelOrderSuccessAsync>) => null | string;
  CancelSuccessRefundFailed?: (data: WithTypename<CancelSuccessRefundFailed>) => null | string;
  CancellationFailedWithDelivery?: (
    data: WithTypename<CancellationFailedWithDelivery>,
  ) => null | string;
  CancellationLimitExceeded?: (data: WithTypename<CancellationLimitExceeded>) => null | string;
  CantCancelAlreadyCanceled?: (data: WithTypename<CantCancelAlreadyCanceled>) => null | string;
  CantCancelLimitExcceeded?: (data: WithTypename<CantCancelLimitExcceeded>) => null | string;
  CantCancelOldOrders?: (data: WithTypename<CantCancelOldOrders>) => null | string;
  CartNotFound?: (data: WithTypename<CartNotFound>) => null | string;
  CateringCustomer?: (data: WithTypename<CateringCustomer>) => null | string;
  CateringIngredient?: (data: WithTypename<CateringIngredient>) => null | string;
  CateringLineItem?: (data: WithTypename<CateringLineItem>) => null | string;
  CateringOrder?: (data: WithTypename<CateringOrder>) => null | string;
  CateringOrderValidation?: (data: WithTypename<CateringOrderValidation>) => null | string;
  CateringOrdersResponse?: (data: WithTypename<CateringOrdersResponse>) => null | string;
  CateringRegularIngredient?: (data: WithTypename<CateringRegularIngredient>) => null | string;
  Challenge?: (data: WithTypename<Challenge>) => null | string;
  ChallengeCelebration?: (data: WithTypename<ChallengeCelebration>) => null | string;
  ChallengeCelebrationV2?: (data: WithTypename<ChallengeCelebrationV2>) => null | string;
  ChallengeReward?: (data: WithTypename<ChallengeReward>) => null | string;
  ChangeDetail?: (data: WithTypename<ChangeDetail>) => null | string;
  ChatToken?: (data: WithTypename<ChatToken>) => null | string;
  ChildSyncResult?: (data: WithTypename<ChildSyncResult>) => null | string;
  ClaimLoyaltyPromotionFailure?: (
    data: WithTypename<ClaimLoyaltyPromotionFailure>,
  ) => null | string;
  ConsolidatedIngredient?: (data: WithTypename<ConsolidatedIngredient>) => null | string;
  ConvertToMultipartyOrderSuccess?: (
    data: WithTypename<ConvertToMultipartyOrderSuccess>,
  ) => null | string;
  CourierDetails?: (data: WithTypename<CourierDetails>) => null | string;
  CreateAccountSuccess?: (data: WithTypename<CreateAccountSuccess>) => null | string;
  CreateConnectionTokenResponse?: (
    data: WithTypename<CreateConnectionTokenResponse>,
  ) => null | string;
  CreateKioskReaderLocationIdResponse?: (
    data: WithTypename<CreateKioskReaderLocationIdResponse>,
  ) => null | string;
  CreateLoyaltyProfileError?: (data: WithTypename<CreateLoyaltyProfileError>) => null | string;
  CreateLoyaltyProfileSuccess?: (data: WithTypename<CreateLoyaltyProfileSuccess>) => null | string;
  CreateOrderSuccess?: (data: WithTypename<CreateOrderSuccess>) => null | string;
  CreateSetupIntent?: (data: WithTypename<CreateSetupIntent>) => null | string;
  Credit?: (data: WithTypename<Credit>) => null | string;
  Customer?: (data: WithTypename<Customer>) => null | string;
  CustomerNotFound?: (data: WithTypename<CustomerNotFound>) => null | string;
  CustomerNotOnboardedError?: (data: WithTypename<CustomerNotOnboardedError>) => null | string;
  CustomerPass?: (data: WithTypename<CustomerPass>) => null | string;
  CustomerPaymentInfo?: (data: WithTypename<CustomerPaymentInfo>) => null | string;
  CustomerPointsForCustomerSupportFailureError?: (
    data: WithTypename<CustomerPointsForCustomerSupportFailureError>,
  ) => null | string;
  CustomerPointsForCustomerSupportSuccessResponse?: (
    data: WithTypename<CustomerPointsForCustomerSupportSuccessResponse>,
  ) => null | string;
  CustomerPreference?: (data: WithTypename<CustomerPreference>) => null | string;
  CustomerSupportCreditsFailureError?: (
    data: WithTypename<CustomerSupportCreditsFailureError>,
  ) => null | string;
  CustomerSupportCreditsSuccessResponse?: (
    data: WithTypename<CustomerSupportCreditsSuccessResponse>,
  ) => null | string;
  CustomerSupportPoint?: (data: WithTypename<CustomerSupportPoint>) => null | string;
  CustomerTokenError?: (data: WithTypename<CustomerTokenError>) => null | string;
  DeclinedPaymentMethod?: (data: WithTypename<DeclinedPaymentMethod>) => null | string;
  DeleteAddressSuccess?: (data: WithTypename<DeleteAddressSuccess>) => null | string;
  DeleteAdminPrintPriorityTemplateResponse?: (
    data: WithTypename<DeleteAdminPrintPriorityTemplateResponse>,
  ) => null | string;
  DeleteAdminUpsellCategoryResponse?: (
    data: WithTypename<DeleteAdminUpsellCategoryResponse>,
  ) => null | string;
  DeleteSubscriptionPaymentMethodSuccess?: (
    data: WithTypename<DeleteSubscriptionPaymentMethodSuccess>,
  ) => null | string;
  DeliveryAlreadyInFlight?: (data: WithTypename<DeliveryAlreadyInFlight>) => null | string;
  DeliveryOrderDetail?: (data: WithTypename<DeliveryOrderDetail>) => null | string;
  DeliverySpecifyAddress?: (data: WithTypename<DeliverySpecifyAddress>) => null | string;
  DietaryProperty?: (data: WithTypename<DietaryProperty>) => null | string;
  Discount?: (data: WithTypename<Discount>) => null | string;
  DropOffLocation?: (data: WithTypename<DropOffLocation>) => null | string;
  EditLineItemInCartSuccess?: (data: WithTypename<EditLineItemInCartSuccess>) => null | string;
  EightySixResponse?: (data: WithTypename<EightySixResponse>) => null | string;
  EstimateRange?: (data: WithTypename<EstimateRange>) => null | string;
  ExpiredReceipt?: (data: WithTypename<ExpiredReceipt>) => null | string;
  FailedToFetchPaymentIntent?: (data: WithTypename<FailedToFetchPaymentIntent>) => null | string;
  FeedbackQuestion?: (data: WithTypename<FeedbackQuestion>) => null | string;
  FeedbackResponse?: (data: WithTypename<FeedbackResponse>) => null | string;
  FeedbackSuccess?: (data: WithTypename<FeedbackSuccess>) => null | string;
  FieldValidationError?: (data: WithTypename<FieldValidationError>) => null | string;
  FlexCustomerAlreadyExistsError?: (
    data: WithTypename<FlexCustomerAlreadyExistsError>,
  ) => null | string;
  FlexCustomerData?: (data: WithTypename<FlexCustomerData>) => null | string;
  FlexOnboardingSession?: (data: WithTypename<FlexOnboardingSession>) => null | string;
  FlexPaymentMethod?: (data: WithTypename<FlexPaymentMethod>) => null | string;
  ForbiddenError?: (data: WithTypename<ForbiddenError>) => null | string;
  GetKioskPaymentsForCurrentDateResponse?: (
    data: WithTypename<GetKioskPaymentsForCurrentDateResponse>,
  ) => null | string;
  GetKioskReaderLocationIdResponse?: (
    data: WithTypename<GetKioskReaderLocationIdResponse>,
  ) => null | string;
  GiftCardAssociatedWithAnotherAccountError?: (
    data: WithTypename<GiftCardAssociatedWithAnotherAccountError>,
  ) => null | string;
  GiftCardBalance?: (data: WithTypename<GiftCardBalance>) => null | string;
  GiftCardDeliveryDetail?: (data: WithTypename<GiftCardDeliveryDetail>) => null | string;
  GiftCardNotFoundError?: (data: WithTypename<GiftCardNotFoundError>) => null | string;
  GiftCardOrderDetail?: (data: WithTypename<GiftCardOrderDetail>) => null | string;
  GiftCardOrderNotFoundError?: (data: WithTypename<GiftCardOrderNotFoundError>) => null | string;
  GiftCardPurchaseHistory?: (data: WithTypename<GiftCardPurchaseHistory>) => null | string;
  GiftCardRedemptionDetailSuccess?: (
    data: WithTypename<GiftCardRedemptionDetailSuccess>,
  ) => null | string;
  Guest?: (data: WithTypename<Guest>) => null | string;
  HasUnseenChallenges?: (data: WithTypename<HasUnseenChallenges>) => null | string;
  HurdleBehavior?: (data: WithTypename<HurdleBehavior>) => null | string;
  HurdleBehaviorDetails?: (data: WithTypename<HurdleBehaviorDetails>) => null | string;
  IdentifyAndClaimInStoreOrderSuccess?: (
    data: WithTypename<IdentifyAndClaimInStoreOrderSuccess>,
  ) => null | string;
  InStoreOrder?: (data: WithTypename<InStoreOrder>) => null | string;
  InStoreOrderDiscount?: (data: WithTypename<InStoreOrderDiscount>) => null | string;
  InStoreOrderLedger?: (data: WithTypename<InStoreOrderLedger>) => null | string;
  InStoreOrderLineItem?: (data: WithTypename<InStoreOrderLineItem>) => null | string;
  InStoreOrderLineItemAsset?: (data: WithTypename<InStoreOrderLineItemAsset>) => null | string;
  InStoreOrderPayment?: (data: WithTypename<InStoreOrderPayment>) => null | string;
  InStoreOrderRestaurant?: (data: WithTypename<InStoreOrderRestaurant>) => null | string;
  InStoreOrdersResponse?: (data: WithTypename<InStoreOrdersResponse>) => null | string;
  IncorrectPaymentMethod?: (data: WithTypename<IncorrectPaymentMethod>) => null | string;
  Ingredient?: (data: WithTypename<Ingredient>) => null | string;
  IngredientModification?: (data: WithTypename<IngredientModification>) => null | string;
  IngredientModificationKind?: (data: WithTypename<IngredientModificationKind>) => null | string;
  IngredientModifications?: (data: WithTypename<IngredientModifications>) => null | string;
  IngredientModifier?: (data: WithTypename<IngredientModifier>) => null | string;
  InvalidAddress?: (data: WithTypename<InvalidAddress>) => null | string;
  InvalidBillingAccount?: (data: WithTypename<InvalidBillingAccount>) => null | string;
  InvalidCreditCard?: (data: WithTypename<InvalidCreditCard>) => null | string;
  InvalidCustomerPhone?: (data: WithTypename<InvalidCustomerPhone>) => null | string;
  InvalidGiftCardError?: (data: WithTypename<InvalidGiftCardError>) => null | string;
  InvalidInput?: (data: WithTypename<InvalidInput>) => null | string;
  InvalidOrder?: (data: WithTypename<InvalidOrder>) => null | string;
  InvalidPromoCode?: (data: WithTypename<InvalidPromoCode>) => null | string;
  InvalidRefundAmount?: (data: WithTypename<InvalidRefundAmount>) => null | string;
  InvalidTip?: (data: WithTypename<InvalidTip>) => null | string;
  IssueCustomerSupportCreditResult?: (
    data: WithTypename<IssueCustomerSupportCreditResult>,
  ) => null | string;
  IssueCustomerSupportPointsFailureError?: (
    data: WithTypename<IssueCustomerSupportPointsFailureError>,
  ) => null | string;
  IssueCustomerSupportPointsSuccessResponse?: (
    data: WithTypename<IssueCustomerSupportPointsSuccessResponse>,
  ) => null | string;
  JoinMultipartyOrderSuccess?: (data: WithTypename<JoinMultipartyOrderSuccess>) => null | string;
  KioskCustomerProfile?: (data: WithTypename<KioskCustomerProfile>) => null | string;
  KioskCustomerScanPaymentInfo?: (
    data: WithTypename<KioskCustomerScanPaymentInfo>,
  ) => null | string;
  KioskCustomerScanPaymentInfoError?: (
    data: WithTypename<KioskCustomerScanPaymentInfoError>,
  ) => null | string;
  KioskCustomerScanPaymentInfoSuccess?: (
    data: WithTypename<KioskCustomerScanPaymentInfoSuccess>,
  ) => null | string;
  KioskPayment?: (data: WithTypename<KioskPayment>) => null | string;
  Kustomer?: (data: WithTypename<Kustomer>) => null | string;
  LeaveOrderSuccess?: (data: WithTypename<LeaveOrderSuccess>) => null | string;
  Ledger?: (data: WithTypename<Ledger>) => null | string;
  LedgerItem?: (data: WithTypename<LedgerItem>) => null | string;
  LineItem?: (data: WithTypename<LineItem>) => null | string;
  LineItemModificationsInvalidException?: (
    data: WithTypename<LineItemModificationsInvalidException>,
  ) => null | string;
  LineItemNotFound?: (data: WithTypename<LineItemNotFound>) => null | string;
  LineItemRecommendation?: (data: WithTypename<LineItemRecommendation>) => null | string;
  LineItemSuccess?: (data: WithTypename<LineItemSuccess>) => null | string;
  Location?: (data: WithTypename<Location>) => null | string;
  LocationClosed?: (data: WithTypename<LocationClosed>) => null | string;
  LockOrderFailed?: (data: WithTypename<LockOrderFailed>) => null | string;
  LockOrderSuccess?: (data: WithTypename<LockOrderSuccess>) => null | string;
  LogoutSuccess?: (data: WithTypename<LogoutSuccess>) => null | string;
  LoyaltyAccessToken?: (data: WithTypename<LoyaltyAccessToken>) => null | string;
  LoyaltyOptInFailed?: (data: WithTypename<LoyaltyOptInFailed>) => null | string;
  LoyaltyProfile?: (data: WithTypename<LoyaltyProfile>) => null | string;
  LoyaltyScanPaymentTokenInvalid?: (
    data: WithTypename<LoyaltyScanPaymentTokenInvalid>,
  ) => null | string;
  LoyaltyScanTokenExpired?: (data: WithTypename<LoyaltyScanTokenExpired>) => null | string;
  MaxEntreeReached?: (data: WithTypename<MaxEntreeReached>) => null | string;
  MaxModificationsExceeded?: (data: WithTypename<MaxModificationsExceeded>) => null | string;
  Menu?: (data: WithTypename<Menu>) => null | string;
  MenuCategory?: (data: WithTypename<MenuCategory>) => null | string;
  MenuCollection?: (data: WithTypename<MenuCollection>) => null | string;
  MenuNotFound?: (data: WithTypename<MenuNotFound>) => null | string;
  MinimumDeliverySubtotalNotMet?: (
    data: WithTypename<MinimumDeliverySubtotalNotMet>,
  ) => null | string;
  MixedDressingDetails?: (data: WithTypename<MixedDressingDetails>) => null | string;
  ModifierGroup?: (data: WithTypename<ModifierGroup>) => null | string;
  MultipartyDetail?: (data: WithTypename<MultipartyDetail>) => null | string;
  MultipartyOrderAlreadyJoined?: (
    data: WithTypename<MultipartyOrderAlreadyJoined>,
  ) => null | string;
  MultipartyOrderNotEnabled?: (data: WithTypename<MultipartyOrderNotEnabled>) => null | string;
  MultipartyOrderNotFound?: (data: WithTypename<MultipartyOrderNotFound>) => null | string;
  MultipartyOrderPreviewSuccess?: (
    data: WithTypename<MultipartyOrderPreviewSuccess>,
  ) => null | string;
  NoBalanceGiftCardError?: (data: WithTypename<NoBalanceGiftCardError>) => null | string;
  NoValidRestaurants?: (data: WithTypename<NoValidRestaurants>) => null | string;
  NotificationCategory?: (data: WithTypename<NotificationCategory>) => null | string;
  NotificationPreferencesError?: (
    data: WithTypename<NotificationPreferencesError>,
  ) => null | string;
  OptOutLoyaltyForCustomerSuccessResponse?: (
    data: WithTypename<OptOutLoyaltyForCustomerSuccessResponse>,
  ) => null | string;
  OptOutLoyaltySuccessResponse?: (
    data: WithTypename<OptOutLoyaltySuccessResponse>,
  ) => null | string;
  Order?: (data: WithTypename<Order>) => null | string;
  OrderAlreadyCanceled?: (data: WithTypename<OrderAlreadyCanceled>) => null | string;
  OrderAlreadySentToKitchen?: (data: WithTypename<OrderAlreadySentToKitchen>) => null | string;
  OrderConflict?: (data: WithTypename<OrderConflict>) => null | string;
  OrderLocked?: (data: WithTypename<OrderLocked>) => null | string;
  OrderMissingTotalError?: (data: WithTypename<OrderMissingTotalError>) => null | string;
  OrderNotFound?: (data: WithTypename<OrderNotFound>) => null | string;
  OrderParticipant?: (data: WithTypename<OrderParticipant>) => null | string;
  OrderPaymentState?: (data: WithTypename<OrderPaymentState>) => null | string;
  OrderStatus?: (data: WithTypename<OrderStatus>) => null | string;
  OrderTotalNotZero?: (data: WithTypename<OrderTotalNotZero>) => null | string;
  OrdersResponseSuccess?: (data: WithTypename<OrdersResponseSuccess>) => null | string;
  Pagination?: (data: WithTypename<Pagination>) => null | string;
  Payment?: (data: WithTypename<Payment>) => null | string;
  PaymentAlreadyRefunded?: (data: WithTypename<PaymentAlreadyRefunded>) => null | string;
  PaymentIntent?: (data: WithTypename<PaymentIntent>) => null | string;
  PaymentMethodBillingAccount?: (data: WithTypename<PaymentMethodBillingAccount>) => null | string;
  PaymentMethodCard?: (data: WithTypename<PaymentMethodCard>) => null | string;
  PaymentPlan?: (data: WithTypename<PaymentPlan>) => null | string;
  PaymentProfile?: (data: WithTypename<PaymentProfile>) => null | string;
  PaymentSubscription?: (data: WithTypename<PaymentSubscription>) => null | string;
  PaymentSubscriptionProfile?: (data: WithTypename<PaymentSubscriptionProfile>) => null | string;
  PersonalizedUpsell?: (data: WithTypename<PersonalizedUpsell>) => null | string;
  PointExpirationEntry?: (data: WithTypename<PointExpirationEntry>) => null | string;
  PointHistoryEntry?: (data: WithTypename<PointHistoryEntry>) => null | string;
  PointHistoryForUserError?: (data: WithTypename<PointHistoryForUserError>) => null | string;
  PointHistoryForUserSuccess?: (data: WithTypename<PointHistoryForUserSuccess>) => null | string;
  PointsReward?: (data: WithTypename<PointsReward>) => null | string;
  Product?: (data: WithTypename<Product>) => null | string;
  ProductLabel?: (data: WithTypename<ProductLabel>) => null | string;
  ProductOutOfStock?: (data: WithTypename<ProductOutOfStock>) => null | string;
  ProductUnavailable?: (data: WithTypename<ProductUnavailable>) => null | string;
  PromoCodeAlreadyApplied?: (data: WithTypename<PromoCodeAlreadyApplied>) => null | string;
  Receipt?: (data: WithTypename<Receipt>) => null | string;
  ReceiptAlreadyClaimed?: (data: WithTypename<ReceiptAlreadyClaimed>) => null | string;
  ReceiptAlreadyClaimedError?: (data: WithTypename<ReceiptAlreadyClaimedError>) => null | string;
  ReceiptNotFound?: (data: WithTypename<ReceiptNotFound>) => null | string;
  RefundKioskPaymentResponse?: (data: WithTypename<RefundKioskPaymentResponse>) => null | string;
  RefundOrderSuccess?: (data: WithTypename<RefundOrderSuccess>) => null | string;
  RefundResult?: (data: WithTypename<RefundResult>) => null | string;
  RegisterGuestFailed?: (data: WithTypename<RegisterGuestFailed>) => null | string;
  RegisterGuestSuccess?: (data: WithTypename<RegisterGuestSuccess>) => null | string;
  RemoveFromCartSuccess?: (data: WithTypename<RemoveFromCartSuccess>) => null | string;
  RemoveRewardSuccess?: (data: WithTypename<RemoveRewardSuccess>) => null | string;
  ReorderConflict?: (data: WithTypename<ReorderConflict>) => null | string;
  ReorderSuccess?: (data: WithTypename<ReorderSuccess>) => null | string;
  RequestAccountDeletionFailed?: (
    data: WithTypename<RequestAccountDeletionFailed>,
  ) => null | string;
  RequestAccountDeletionSuccess?: (
    data: WithTypename<RequestAccountDeletionSuccess>,
  ) => null | string;
  Restaurant?: (data: WithTypename<Restaurant>) => null | string;
  RestaurantCapacity?: (data: WithTypename<RestaurantCapacity>) => null | string;
  RestaurantCapacitySlot?: (data: WithTypename<RestaurantCapacitySlot>) => null | string;
  RestaurantDeliveryChannels?: (data: WithTypename<RestaurantDeliveryChannels>) => null | string;
  RestaurantHours?: (data: WithTypename<RestaurantHours>) => null | string;
  RestaurantHoursMissing?: (data: WithTypename<RestaurantHoursMissing>) => null | string;
  RestaurantIsNotAcceptingOrders?: (
    data: WithTypename<RestaurantIsNotAcceptingOrders>,
  ) => null | string;
  RestaurantMaxDeliveryQuantityExceeded?: (
    data: WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
  ) => null | string;
  RestaurantMaxQuantityExceeded?: (
    data: WithTypename<RestaurantMaxQuantityExceeded>,
  ) => null | string;
  RestaurantStoreHours?: (data: WithTypename<RestaurantStoreHours>) => null | string;
  RestaurantThrottle?: (data: WithTypename<RestaurantThrottle>) => null | string;
  RestaurantThrottleLevers?: (data: WithTypename<RestaurantThrottleLevers>) => null | string;
  RestaurantThrottleSlot?: (data: WithTypename<RestaurantThrottleSlot>) => null | string;
  Reward?: (data: WithTypename<Reward>) => null | string;
  RewardNotApplied?: (data: WithTypename<RewardNotApplied>) => null | string;
  RewardNotRemoved?: (data: WithTypename<RewardNotRemoved>) => null | string;
  RewardNotValidated?: (data: WithTypename<RewardNotValidated>) => null | string;
  RewardValidationGeneralError?: (
    data: WithTypename<RewardValidationGeneralError>,
  ) => null | string;
  RewardsPremiumStatus?: (data: WithTypename<RewardsPremiumStatus>) => null | string;
  SelectedModifier?: (data: WithTypename<SelectedModifier>) => null | string;
  Session?: (data: WithTypename<Session>) => null | string;
  SignInFailed?: (data: WithTypename<SignInFailed>) => null | string;
  SignInSuccess?: (data: WithTypename<SignInSuccess>) => null | string;
  StoreOffline?: (data: WithTypename<StoreOffline>) => null | string;
  StripeRefundErrorResponse?: (data: WithTypename<StripeRefundErrorResponse>) => null | string;
  SubmitGiftCardCodeSuccess?: (data: WithTypename<SubmitGiftCardCodeSuccess>) => null | string;
  SubmitGiftCardOrderError?: (data: WithTypename<SubmitGiftCardOrderError>) => null | string;
  SubmitGiftCardOrderPaymentError?: (
    data: WithTypename<SubmitGiftCardOrderPaymentError>,
  ) => null | string;
  SubmitOrderUsingPaymentMethodSuccess?: (
    data: WithTypename<SubmitOrderUsingPaymentMethodSuccess>,
  ) => null | string;
  SubmitOrderWithPaymentMethodSuccess?: (
    data: WithTypename<SubmitOrderWithPaymentMethodSuccess>,
  ) => null | string;
  SubmitPromoCodeSuccessV2?: (data: WithTypename<SubmitPromoCodeSuccessV2>) => null | string;
  SubscriptionCreditCard?: (data: WithTypename<SubscriptionCreditCard>) => null | string;
  SubscriptionPlan?: (data: WithTypename<SubscriptionPlan>) => null | string;
  SubscriptionTransactions?: (data: WithTypename<SubscriptionTransactions>) => null | string;
  SyncChanges?: (data: WithTypename<SyncChanges>) => null | string;
  SyncLocationResult?: (data: WithTypename<SyncLocationResult>) => null | string;
  ThrottleSlotBreakdown?: (data: WithTypename<ThrottleSlotBreakdown>) => null | string;
  Tier?: (data: WithTypename<Tier>) => null | string;
  TierGroup?: (data: WithTypename<TierGroup>) => null | string;
  TierStatus?: (data: WithTypename<TierStatus>) => null | string;
  TimeRestrictionError?: (data: WithTypename<TimeRestrictionError>) => null | string;
  TimeslotUnavailable?: (data: WithTypename<TimeslotUnavailable>) => null | string;
  TransactionCreditCard?: (data: WithTypename<TransactionCreditCard>) => null | string;
  TransactionNotFoundError?: (data: WithTypename<TransactionNotFoundError>) => null | string;
  TransactionPlan?: (data: WithTypename<TransactionPlan>) => null | string;
  TransactionPlanResult?: (data: WithTypename<TransactionPlanResult>) => null | string;
  TrialEligibility?: (data: WithTypename<TrialEligibility>) => null | string;
  UnableToGetFlexCustomerDataError?: (
    data: WithTypename<UnableToGetFlexCustomerDataError>,
  ) => null | string;
  UnableToGetGiftCardBalanceError?: (
    data: WithTypename<UnableToGetGiftCardBalanceError>,
  ) => null | string;
  UnableToRedeemGiftCardError?: (data: WithTypename<UnableToRedeemGiftCardError>) => null | string;
  UnauthorizedLineItemModification?: (
    data: WithTypename<UnauthorizedLineItemModification>,
  ) => null | string;
  UnauthorizedOrderModification?: (
    data: WithTypename<UnauthorizedOrderModification>,
  ) => null | string;
  UnknownUserError?: (data: WithTypename<UnknownUserError>) => null | string;
  UnlockOrderFailed?: (data: WithTypename<UnlockOrderFailed>) => null | string;
  UnlockOrderSuccess?: (data: WithTypename<UnlockOrderSuccess>) => null | string;
  UpdateAddressSuccess?: (data: WithTypename<UpdateAddressSuccess>) => null | string;
  UpdateAdminRestaurantAvailabilityResponse?: (
    data: WithTypename<UpdateAdminRestaurantAvailabilityResponse>,
  ) => null | string;
  UpdateCustomerPreferencesError?: (
    data: WithTypename<UpdateCustomerPreferencesError>,
  ) => null | string;
  UpdateCustomerResponse?: (data: WithTypename<UpdateCustomerResponse>) => null | string;
  UpdateKioskCustomerResponse?: (data: WithTypename<UpdateKioskCustomerResponse>) => null | string;
  UpdateUseCreditResponse?: (data: WithTypename<UpdateUseCreditResponse>) => null | string;
  UpsellCategory?: (data: WithTypename<UpsellCategory>) => null | string;
  UpsellCategoryProduct?: (data: WithTypename<UpsellCategoryProduct>) => null | string;
  UserGiftCard?: (data: WithTypename<UserGiftCard>) => null | string;
  UserNotificationPreferences?: (data: WithTypename<UserNotificationPreferences>) => null | string;
  UserOrderPermission?: (data: WithTypename<UserOrderPermission>) => null | string;
  UserPointsStatus?: (data: WithTypename<UserPointsStatus>) => null | string;
  ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse?: (
    data: WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>,
  ) => null | string;
  ValidateRewardFailureMetadata?: (
    data: WithTypename<ValidateRewardFailureMetadata>,
  ) => null | string;
  ValidationError?: (data: WithTypename<ValidationError>) => null | string;
  Vendor?: (data: WithTypename<Vendor>) => null | string;
};

export type GraphCacheResolvers = {
  Query?: {
    addons?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Addons> | string
    >;
    address?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAddressArgs,
      WithTypename<Address> | string
    >;
    adminGroupOrderSettings?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<AdminGroupOrderSettings> | string
    >;
    adminMasterZones?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminMasterZone> | string>
    >;
    adminOrder?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminOrderArgs,
      WithTypename<AdminOrder> | string
    >;
    adminOrders?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminOrdersArgs,
      WithTypename<AdminOrderPage> | string
    >;
    adminOutOfStockReasons?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminOutOfStockReason> | string>
    >;
    adminPrintPriorityIngredients?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminPrintPriorityIngredient> | string>
    >;
    adminPrintPriorityTemplates?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminPrintPriorityTemplate> | string>
    >;
    adminProductUpsellAudits?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminProductUpsellAuditsArgs,
      Array<WithTypename<AdminProductUpsellAudit> | string>
    >;
    adminProductUpsells?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminUpsellMasterProduct> | string>
    >;
    adminRestaurant?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminRestaurantArgs,
      WithTypename<AdminRestaurant> | string
    >;
    adminRestaurantAudits?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminRestaurantAuditsArgs,
      WithTypename<AdminRestaurantAuditPage> | string
    >;
    adminRestaurantAvailability?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminRestaurantAvailabilityArgs,
      WithTypename<AdminRestaurantAvailability> | string
    >;
    adminRestaurantSettings?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminRestaurantSettingsArgs,
      WithTypename<AdminRestaurantSettings> | string
    >;
    adminUpsellCategories?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<AdminUpsellCategory> | string>
    >;
    adminUpsellMasterProducts?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAdminUpsellMasterProductsArgs,
      Array<WithTypename<AdminUpsellMasterProduct> | string>
    >;
    availableCustomerSupportPoints?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<AvailableCustomerSupportPointsResponseUnion> | string
    >;
    availablePromotions?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<AvailablePromotionsResponseUnion> | string
    >;
    baseProduct?: GraphCacheResolver<
      WithTypename<Query>,
      QueryBaseProductArgs,
      WithTypename<BaseProduct> | string
    >;
    canCancel?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCanCancelArgs,
      Array<WithTypename<CanCancelResponseUnion> | string>
    >;
    canCancelV2?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCanCancelV2Args,
      Array<WithTypename<CanCancelResponseUnion> | string>
    >;
    cart?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    categoryUpsells?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCategoryUpsellsArgs,
      Array<WithTypename<UpsellCategory> | string>
    >;
    cateringOrders?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCateringOrdersArgs,
      WithTypename<CateringOrdersResponse> | string
    >;
    challengeCelebration?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<ChallengeCelebration> | string
    >;
    challengeCelebrationV2?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<ChallengeCelebrationV2> | string
    >;
    challengeRewards?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<ChallengeReward> | string>
    >;
    challenges?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<Challenge> | string>
    >;
    chatToken?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<ChatToken> | string
    >;
    currentCustomer?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
    customerExists?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCustomerExistsArgs,
      Scalars['Boolean']['output'] | string
    >;
    customerPass?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<CustomerPass> | string
    >;
    customerPaymentInfo?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<CustomerPaymentInfo> | string
    >;
    customerPointsForCustomerSupport?: GraphCacheResolver<
      WithTypename<Query>,
      QueryCustomerPointsForCustomerSupportArgs,
      WithTypename<CustomerPointsForCustomerSupportResponseUnion> | string
    >;
    customerSupportCredits?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<CustomerSupportCreditsResponseUnion> | string
    >;
    favoritedLineItems?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFavoritedLineItemsArgs,
      Array<WithTypename<LineItem> | string>
    >;
    feedbackQuestions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFeedbackQuestionsArgs,
      Array<WithTypename<FeedbackQuestion> | string>
    >;
    fetchPlansByTierId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFetchPlansByTierIdArgs,
      Array<WithTypename<PaymentPlan> | string>
    >;
    flexCustomerData?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<FlexCustomerDataResponseUnion> | string
    >;
    getKioskPaymentsForCurrentDate?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetKioskPaymentsForCurrentDateArgs,
      WithTypename<GetKioskPaymentsForCurrentDateResponse> | string
    >;
    getKioskReaderLocationId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetKioskReaderLocationIdArgs,
      WithTypename<GetKioskReaderLocationIdResponse> | string
    >;
    getKioskReaderLocationIdByEntityId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetKioskReaderLocationIdByEntityIdArgs,
      WithTypename<GetKioskReaderLocationIdResponse> | string
    >;
    getKioskReaderLocationIdByRestaurantId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetKioskReaderLocationIdByRestaurantIdArgs,
      WithTypename<GetKioskReaderLocationIdResponse> | string
    >;
    getOrderPaymentState?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetOrderPaymentStateArgs,
      WithTypename<OrderPaymentState> | string
    >;
    getOrderStatusNotificationPreferences?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<NotificationCategory> | string
    >;
    getPreferences?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<CustomerPreference> | string
    >;
    getSubscriptions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetSubscriptionsArgs,
      Array<WithTypename<PaymentSubscription> | string>
    >;
    getUserNotificationPreferences?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<UserNotificationPreferencesUnion> | string
    >;
    giftCardBalance?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<GiftCardBalanceResponseUnion> | string
    >;
    giftCardOrderDetail?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGiftCardOrderDetailArgs,
      WithTypename<GiftCardOrderDetailResponseUnion> | string
    >;
    giftCardPurchaseHistory?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<GiftCardPurchaseHistory> | string
    >;
    giftCardRedemptionDetail?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGiftCardRedemptionDetailArgs,
      WithTypename<GiftCardRedemptionDetailResponseUnion> | string
    >;
    hasUnseenChallenges?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<HasUnseenChallenges> | string
    >;
    inFlightDeliveryOrder?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    inStoreFeedbackQuestions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryInStoreFeedbackQuestionsArgs,
      Array<WithTypename<FeedbackQuestion> | string>
    >;
    inStoreLoyaltyOrder?: GraphCacheResolver<
      WithTypename<Query>,
      QueryInStoreLoyaltyOrderArgs,
      WithTypename<InStoreOrder> | string
    >;
    inStoreLoyaltyOrders?: GraphCacheResolver<
      WithTypename<Query>,
      QueryInStoreLoyaltyOrdersArgs,
      WithTypename<InStoreOrdersResponse> | string
    >;
    inStoreOrderLastPendingFeedback?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<InStoreOrder> | string
    >;
    inStorePaymentMethods?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<Credit> | string>
    >;
    kioskCustomerProfile?: GraphCacheResolver<
      WithTypename<Query>,
      QueryKioskCustomerProfileArgs,
      WithTypename<KioskCustomerProfile> | string
    >;
    kioskCustomerScanPaymentInfo?: GraphCacheResolver<
      WithTypename<Query>,
      QueryKioskCustomerScanPaymentInfoArgs,
      WithTypename<KioskCustomerScanPaymentInfoResponse> | string
    >;
    kustomerToken?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Kustomer> | string
    >;
    lineItem?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLineItemArgs,
      WithTypename<LineItemResponseUnion> | string
    >;
    lineItemBySlug?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLineItemBySlugArgs,
      WithTypename<LineItemResponseUnion> | string
    >;
    lineItemRecommendations?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<LineItemRecommendation> | string>
    >;
    locationByAddress?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLocationByAddressArgs,
      WithTypename<LocationByAddressResponseUnion> | string
    >;
    locationByAddressId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLocationByAddressIdArgs,
      WithTypename<LocationByAddressResponseUnion> | string
    >;
    locationByAddressV2?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLocationByAddressV2Args,
      WithTypename<LocationByAddressResponseUnion> | string
    >;
    loyaltyProfile?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<LoyaltyProfile> | string
    >;
    loyaltyProfileByLoyaltyId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLoyaltyProfileByLoyaltyIdArgs,
      WithTypename<LoyaltyProfile> | string
    >;
    loyaltyProfileWithLoyalty?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLoyaltyProfileWithLoyaltyArgs,
      WithTypename<LoyaltyProfile> | string
    >;
    menuCollection?: GraphCacheResolver<
      WithTypename<Query>,
      QueryMenuCollectionArgs,
      WithTypename<MenuCollection> | string
    >;
    menuCollections?: GraphCacheResolver<
      WithTypename<Query>,
      QueryMenuCollectionsArgs,
      Array<WithTypename<MenuCollection> | string>
    >;
    multipartyOrderPreview?: GraphCacheResolver<
      WithTypename<Query>,
      QueryMultipartyOrderPreviewArgs,
      WithTypename<MultipartyOrderPreviewResponseUnion> | string
    >;
    order?: GraphCacheResolver<WithTypename<Query>, QueryOrderArgs, WithTypename<Order> | string>;
    orderLastPendingFeedback?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    orderPaymentState?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrderPaymentStateArgs,
      WithTypename<OrderPaymentState> | string
    >;
    orderStatus?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrderStatusArgs,
      WithTypename<OrderStatusResponseUnion> | string
    >;
    orders?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrdersArgs,
      WithTypename<OrdersResponseUnion> | string
    >;
    ordersV2?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrdersV2Args,
      WithTypename<OrdersResponseUnion> | string
    >;
    paymentMethodCards?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<PaymentMethodCardUnion> | string>
    >;
    paymentProfile?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<PaymentProfile> | string
    >;
    paymentSubscriptionProfile?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<PaymentSubscriptionProfile> | string
    >;
    personalizedUpsells?: GraphCacheResolver<
      WithTypename<Query>,
      QueryPersonalizedUpsellsArgs,
      WithTypename<PersonalizedUpsellsResponseUnion> | string
    >;
    pointHistoryForUser?: GraphCacheResolver<
      WithTypename<Query>,
      QueryPointHistoryForUserArgs,
      WithTypename<PointHistoryForUserResponseUnion> | string
    >;
    product?: GraphCacheResolver<
      WithTypename<Query>,
      QueryProductArgs,
      WithTypename<Product> | string
    >;
    productForRestaurant?: GraphCacheResolver<
      WithTypename<Query>,
      QueryProductForRestaurantArgs,
      WithTypename<Product> | string
    >;
    productForRestaurantByLineageKey?: GraphCacheResolver<
      WithTypename<Query>,
      QueryProductForRestaurantByLineageKeyArgs,
      WithTypename<Product> | string
    >;
    receipt?: GraphCacheResolver<
      WithTypename<Query>,
      QueryReceiptArgs,
      WithTypename<ReceiptResponse> | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantArgs,
      WithTypename<Restaurant> | string
    >;
    restaurantCapacity?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantCapacityArgs,
      WithTypename<RestaurantCapacity> | string
    >;
    restaurantDeliveryChannels?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantDeliveryChannelsArgs,
      WithTypename<RestaurantDeliveryChannels> | string
    >;
    restaurantEntityIds?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<Scalars['ID']['output'] | string>
    >;
    restaurantIdByEntityId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantIdByEntityIdArgs,
      Scalars['ID']['output'] | string
    >;
    restaurantThrottle?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantThrottleArgs,
      WithTypename<RestaurantThrottle> | string
    >;
    restaurantsByLocation?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantsByLocationArgs,
      Array<WithTypename<Restaurant> | string>
    >;
    restaurantsByRegion?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantsByRegionArgs,
      Array<WithTypename<Restaurant> | string>
    >;
    restaurantsForAdmin?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantsForAdminArgs,
      Array<WithTypename<Restaurant> | string>
    >;
    rewards?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<Reward> | string>
    >;
    searchRestaurants?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchRestaurantsArgs,
      Array<WithTypename<Restaurant> | string>
    >;
    session?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Session> | string
    >;
    subscriptionPlanById?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySubscriptionPlanByIdArgs,
      WithTypename<SubscriptionPlan> | string
    >;
    subscriptionPlansByIds?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySubscriptionPlansByIdsArgs,
      Array<WithTypename<SubscriptionPlan> | string>
    >;
  };
  ActivePaymentMethodError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ActivePaymentMethodError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AddAddressSuccess?: {
    address?: GraphCacheResolver<
      WithTypename<AddAddressSuccess>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
  };
  AddLineItemToCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<AddLineItemToCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  Addons?: {
    products?: GraphCacheResolver<
      WithTypename<Addons>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
  };
  Address?: {
    city?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    country?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryPreference?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      DeliveryPreferenceType | string
    >;
    googlePlaceId?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    notes?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    secondaryStreet?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    street?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminAppliedPrintTemplate?: {
    appliedAt?: GraphCacheResolver<
      WithTypename<AdminAppliedPrintTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    appliedBy?: GraphCacheResolver<
      WithTypename<AdminAppliedPrintTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    templateId?: GraphCacheResolver<
      WithTypename<AdminAppliedPrintTemplate>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    templateName?: GraphCacheResolver<
      WithTypename<AdminAppliedPrintTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminGroupOrderSettingAudit?: {
    action?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    after?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    before?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    changedBy?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettingAudit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  AdminGroupOrderSettings?: {
    history?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettings>,
      AdminGroupOrderSettingsHistoryArgs,
      Array<WithTypename<AdminGroupOrderSettingAudit> | string>
    >;
    maxEntreeLimit?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettings>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxEntreeLimitIsDefault?: GraphCacheResolver<
      WithTypename<AdminGroupOrderSettings>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  AdminMasterZone?: {
    id?: GraphCacheResolver<
      WithTypename<AdminMasterZone>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    index?: GraphCacheResolver<
      WithTypename<AdminMasterZone>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminMasterZone>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrder?: {
    couponDiscountCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    creditAppliedCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    customer?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      WithTypename<AdminOrderCustomer> | string
    >;
    delivery?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      WithTypename<AdminOrderDelivery> | string
    >;
    discounts?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Array<WithTypename<AdminOrderDiscount> | string>
    >;
    externalReferenceId?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fees?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Array<WithTypename<AdminOrderFee> | string>
    >;
    fulfillmentRestaurantId?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    lineItems?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Array<WithTypename<AdminOrderLineItem> | string>
    >;
    orderSource?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderType?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      AdminOrderType | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      WithTypename<AdminOrderRestaurant> | string
    >;
    specialInstructions?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    state?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    subtotalCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    taxCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    timeZone?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    tipCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    totalCents?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tracking?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<AdminOrder>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
  };
  AdminOrderAddress?: {
    city?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    notes?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    secondaryStreet?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    street?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<AdminOrderAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderCustomer?: {
    email?: GraphCacheResolver<
      WithTypename<AdminOrderCustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminOrderCustomer>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminOrderCustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<AdminOrderCustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderCustomerSummary?: {
    email?: GraphCacheResolver<
      WithTypename<AdminOrderCustomerSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminOrderCustomerSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderDelivery?: {
    address?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      WithTypename<AdminOrderAddress> | string
    >;
    courierTipCents?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    deliveredAt?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    deliveryFeeCents?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    estimatedDeliveryTime?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    terminalStatus?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vendor?: GraphCacheResolver<
      WithTypename<AdminOrderDelivery>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderDiscount?: {
    amountCents?: GraphCacheResolver<
      WithTypename<AdminOrderDiscount>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<AdminOrderDiscount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderFee?: {
    amountCents?: GraphCacheResolver<
      WithTypename<AdminOrderFee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<AdminOrderFee>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderLineItem?: {
    costCents?: GraphCacheResolver<
      WithTypename<AdminOrderLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminOrderLineItem>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    modifiers?: GraphCacheResolver<
      WithTypename<AdminOrderLineItem>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminOrderLineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<AdminOrderLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  AdminOrderPage?: {
    nextCursor?: GraphCacheResolver<
      WithTypename<AdminOrderPage>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orders?: GraphCacheResolver<
      WithTypename<AdminOrderPage>,
      Record<string, never>,
      Array<WithTypename<AdminOrderSummary> | string>
    >;
  };
  AdminOrderRestaurant?: {
    id?: GraphCacheResolver<
      WithTypename<AdminOrderRestaurant>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminOrderSummary?: {
    createdAt?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    customer?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      WithTypename<AdminOrderCustomerSummary> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    orderSource?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderType?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      AdminOrderType | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      WithTypename<AdminOrderRestaurant> | string
    >;
    state?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timeZone?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    totalCents?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tracking?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<AdminOrderSummary>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
  };
  AdminOutOfStockReason?: {
    key?: GraphCacheResolver<
      WithTypename<AdminOutOfStockReason>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<AdminOutOfStockReason>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminPrintOrderIngredient?: {
    id?: GraphCacheResolver<
      WithTypename<AdminPrintOrderIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminPrintOrderIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    printName?: GraphCacheResolver<
      WithTypename<AdminPrintOrderIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminPrintOrderZone?: {
    id?: GraphCacheResolver<
      WithTypename<AdminPrintOrderZone>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<AdminPrintOrderZone>,
      Record<string, never>,
      Array<WithTypename<AdminPrintOrderIngredient> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminPrintOrderZone>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminPrintPriorityIngredient?: {
    active?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityIngredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminPrintPriorityTemplate?: {
    id?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplate>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    updatedAt?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zones?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplate>,
      Record<string, never>,
      Array<WithTypename<AdminPrintPriorityTemplateZone> | string>
    >;
  };
  AdminPrintPriorityTemplateZone?: {
    id?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplateZone>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ingredientIds?: GraphCacheResolver<
      WithTypename<AdminPrintPriorityTemplateZone>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
  };
  AdminProductUpsellAudit?: {
    action?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    changedBy?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    changes?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Array<WithTypename<AdminProductUpsellAuditChange> | string>
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    recordId?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    recordName?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recordType?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAudit>,
      Record<string, never>,
      AdminProductUpsellAuditRecordType | string
    >;
  };
  AdminProductUpsellAuditChange?: {
    after?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    before?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    field?: GraphCacheResolver<
      WithTypename<AdminProductUpsellAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurant?: {
    id?: GraphCacheResolver<
      WithTypename<AdminRestaurant>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isOutpost?: GraphCacheResolver<
      WithTypename<AdminRestaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    printOrder?: GraphCacheResolver<
      WithTypename<AdminRestaurant>,
      Record<string, never>,
      Array<WithTypename<AdminPrintOrderZone> | string>
    >;
    printTemplate?: GraphCacheResolver<
      WithTypename<AdminRestaurant>,
      Record<string, never>,
      WithTypename<AdminAppliedPrintTemplate> | string
    >;
  };
  AdminRestaurantAudit?: {
    action?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    changedBy?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    changes?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantAuditChange> | string>
    >;
    comment?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    recordId?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    recordName?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recordType?: GraphCacheResolver<
      WithTypename<AdminRestaurantAudit>,
      Record<string, never>,
      AdminRestaurantAuditRecordType | string
    >;
  };
  AdminRestaurantAuditChange?: {
    after?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    before?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    field?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantAuditPage?: {
    entries?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditPage>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantAudit> | string>
    >;
    nextCursor?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditPage>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timeZone?: GraphCacheResolver<
      WithTypename<AdminRestaurantAuditPage>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantAvailability?: {
    canEdit?: GraphCacheResolver<
      WithTypename<AdminRestaurantAvailability>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<AdminRestaurantAvailability>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantIngredient> | string>
    >;
    menuProducts?: GraphCacheResolver<
      WithTypename<AdminRestaurantAvailability>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantMenuProduct> | string>
    >;
    timeZone?: GraphCacheResolver<
      WithTypename<AdminRestaurantAvailability>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantIngredient?: {
    autoRestockAt?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    availableDate?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    imageUrl?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    outOfStockBy?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStockSince?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    outOfStockSinceApproximate?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    records?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredient>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantIngredientRecord> | string>
    >;
  };
  AdminRestaurantIngredientRecord?: {
    ingredientId?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredientRecord>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredientRecord>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredientRecord>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredientRecord>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    outOfStockReasonKey?: GraphCacheResolver<
      WithTypename<AdminRestaurantIngredientRecord>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantMenuProduct?: {
    autoRestockAt?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    availableDate?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    category?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    channels?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    imageUrl?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    outOfStockBy?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStockSince?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    outOfStockSinceApproximate?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    records?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Array<WithTypename<AdminRestaurantMenuProductRecord> | string>
    >;
    soldToday?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  AdminRestaurantMenuProductRecord?: {
    category?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    channels?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    productId?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    soldToday?: GraphCacheResolver<
      WithTypename<AdminRestaurantMenuProductRecord>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  AdminRestaurantOrdering?: {
    acceptingOrders?: GraphCacheResolver<
      WithTypename<AdminRestaurantOrdering>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    enabled?: GraphCacheResolver<
      WithTypename<AdminRestaurantOrdering>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    hidden?: GraphCacheResolver<
      WithTypename<AdminRestaurantOrdering>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    notAcceptingOrdersReason?: GraphCacheResolver<
      WithTypename<AdminRestaurantOrdering>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantProfile?: {
    crossStreet?: GraphCacheResolver<
      WithTypename<AdminRestaurantProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<AdminRestaurantProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    flexMessage?: GraphCacheResolver<
      WithTypename<AdminRestaurantProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    pickupInstructions?: GraphCacheResolver<
      WithTypename<AdminRestaurantProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AdminRestaurantSettings?: {
    canEditEnabled?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canEditOrdering?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canEditProfile?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isOutpost?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ordering?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      WithTypename<AdminRestaurantOrdering> | string
    >;
    parentRestaurantId?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    profile?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      WithTypename<AdminRestaurantProfile> | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<AdminRestaurantSettings>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  AdminUpsellCategory?: {
    categoryRanking?: GraphCacheResolver<
      WithTypename<AdminUpsellCategory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminUpsellCategory>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminUpsellCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<AdminUpsellCategory>,
      Record<string, never>,
      Array<WithTypename<AdminUpsellMasterProduct> | string>
    >;
  };
  AdminUpsellMasterProduct?: {
    availableDate?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    imageUrl?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    isUpsell?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    upsellCategoryId?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    upsellCategoryRanking?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    upsellRanking?: GraphCacheResolver<
      WithTypename<AdminUpsellMasterProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  AllergenProperty?: {
    id?: GraphCacheResolver<
      WithTypename<AllergenProperty>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<AllergenProperty>,
      Record<string, never>,
      AllergenPropertyKind | string
    >;
  };
  ApplyRewardFailureMetadata?: {
    requiredChannel?: GraphCacheResolver<
      WithTypename<ApplyRewardFailureMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    requiredDays?: GraphCacheResolver<
      WithTypename<ApplyRewardFailureMetadata>,
      Record<string, never>,
      Array<Scalars['Float']['output'] | string>
    >;
  };
  ApplyRewardSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<ApplyRewardSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  Asset?: {
    url?: GraphCacheResolver<
      WithTypename<Asset>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AsyncCancelFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<AsyncCancelFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<AsyncCancelFailed>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<AsyncCancelFailed>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  AvailableCustomerSupportPointsError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<AvailableCustomerSupportPointsError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AvailableCustomerSupportPointsSuccess?: {
    points?: GraphCacheResolver<
      WithTypename<AvailableCustomerSupportPointsSuccess>,
      Record<string, never>,
      Array<WithTypename<CustomerSupportPoint> | string>
    >;
  };
  AvailablePromotionFailure?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<AvailablePromotionFailure>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<AvailablePromotionFailure>,
      Record<string, never>,
      AvailablePromotionFailureReason | string
    >;
  };
  AvailablePromotionsSuccess?: {
    promotions?: GraphCacheResolver<
      WithTypename<AvailablePromotionsSuccess>,
      Record<string, never>,
      Array<WithTypename<Reward> | string>
    >;
  };
  AvailableWantedTime?: {
    deliveryOffset?: GraphCacheResolver<
      WithTypename<AvailableWantedTime>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    time?: GraphCacheResolver<
      WithTypename<AvailableWantedTime>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  BaseProduct?: {
    asset?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    caloriesFromFat?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    cholesterolMg?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    contains?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    dietaryFiberG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    heading?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isDeepLinkingEnabled?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isSeasonal?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    lineageKey?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    proteinG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    saturatedFatG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    sodiumMg?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    subheading?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    sugarsG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    totalCarbsG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    totalFatG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    transFatG?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  BillingAccount?: {
    cardType?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      CardType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationState?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      ExpirationState | string
    >;
    id?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isDefault?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    nickname?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CXCredit?: {
    displayName?: GraphCacheResolver<
      WithTypename<CxCredit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CxCredit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CanCancel?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CanCancel>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CanCancel>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    timeToFire?: GraphCacheResolver<
      WithTypename<CanCancel>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  CanCancelAlreadySent?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CanCancelAlreadySent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CanCancelAlreadySent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CanCancelAlreadySent>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CanCancelFailed?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CanCancelFailed>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CanCancelFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CanCancelFailed>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CanCancelNotFound?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CanCancelNotFound>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CanCancelNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CanCancelNotFound>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CanCancelUnauthorized?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CanCancelUnauthorized>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CanCancelUnauthorized>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CanCancelUnauthorized>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CanNotReorder?: {
    conflicts?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CancelOrderFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CancelOrderFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CancelOrderFailed>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancelOrderFailed>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancelOrderPaymentIntentResponse?: {
    paymentIntentId?: GraphCacheResolver<
      WithTypename<CancelOrderPaymentIntentResponse>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancelOrderPaymentIntentResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancelOrderSuccess?: {
    orderId?: GraphCacheResolver<
      WithTypename<CancelOrderSuccess>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<CancelOrderSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancelOrderSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancelOrderSuccessAsync?: {
    orderId?: GraphCacheResolver<
      WithTypename<CancelOrderSuccessAsync>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<CancelOrderSuccessAsync>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancelOrderSuccessAsync>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancelSuccessRefundFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CancelSuccessRefundFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CancelSuccessRefundFailed>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancelSuccessRefundFailed>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancellationFailedWithDelivery?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CancellationFailedWithDelivery>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CancellationFailedWithDelivery>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancellationFailedWithDelivery>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CancellationLimitExceeded?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CancellationLimitExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CancellationLimitExceeded>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<CancellationLimitExceeded>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  CantCancelAlreadyCanceled?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CantCancelAlreadyCanceled>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CantCancelAlreadyCanceled>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CantCancelAlreadyCanceled>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CantCancelLimitExcceeded?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CantCancelLimitExcceeded>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CantCancelLimitExcceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CantCancelLimitExcceeded>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CantCancelOldOrders?: {
    canCancel?: GraphCacheResolver<
      WithTypename<CantCancelOldOrders>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CantCancelOldOrders>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<CantCancelOldOrders>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CartNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CartNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<CartNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<CartNotFound>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CateringCustomer?: {
    first?: GraphCacheResolver<
      WithTypename<CateringCustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    last?: GraphCacheResolver<
      WithTypename<CateringCustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CateringIngredient?: {
    eightySixed?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    gramsPerPortion?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    portion?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    regularCounterparts?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Array<WithTypename<CateringRegularIngredient> | string>
    >;
    totalGrams?: GraphCacheResolver<
      WithTypename<CateringIngredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  CateringLineItem?: {
    cost?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eightySixed?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    ingredientAdditions?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Array<WithTypename<CateringIngredient> | string>
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Array<WithTypename<CateringIngredient> | string>
    >;
    perItemCost?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    productId?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    productName?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    removedIngredients?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Array<WithTypename<CateringIngredient> | string>
    >;
    specialInstructions?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<CateringLineItem>,
      Record<string, never>,
      CateringProductType | string
    >;
  };
  CateringOrder?: {
    clientName?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    clientPhone?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    customer?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      WithTypename<CateringCustomer> | string
    >;
    deliveryAddress1?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryAddress2?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryCity?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryFee?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    deliveryPostal?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryState?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryType?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      CateringDeliveryType | string
    >;
    discount?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    externalReferenceId?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    gravyOrderId?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    isSubmitted?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isTaxExempt?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    lineItems?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Array<WithTypename<CateringLineItem> | string>
    >;
    numberOfGuests?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    orderAcceptorCompany?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderAcceptorPhone?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderSource?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      CateringOrderSource | string
    >;
    orderValidation?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      WithTypename<CateringOrderValidation> | string
    >;
    paymentMethod?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantID?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    specialInstructions?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    submissionWindowCloseAt?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    submissionWindowOpenAt?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timeReqd?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    wantedTimeAtStore?: GraphCacheResolver<
      WithTypename<CateringOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CateringOrderValidation?: {
    subtotal?: GraphCacheResolver<
      WithTypename<CateringOrderValidation>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tax?: GraphCacheResolver<
      WithTypename<CateringOrderValidation>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<CateringOrderValidation>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CateringOrdersResponse?: {
    orders?: GraphCacheResolver<
      WithTypename<CateringOrdersResponse>,
      Record<string, never>,
      Array<WithTypename<CateringOrder> | string>
    >;
  };
  CateringRegularIngredient?: {
    gramsPerPortion?: GraphCacheResolver<
      WithTypename<CateringRegularIngredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CateringRegularIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<CateringRegularIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Challenge?: {
    achieved?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    assetUrl?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    celebrationCopy?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    descriptiveTitle?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    goal?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    legalTerms?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    multipleBehaviorDetails?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      WithTypename<MultipleBehaviorDetailsUnion> | string
    >;
    percentageCompleted?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    permalink?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    progress?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    progressCopy?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    progressType?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      ChallengeProgressType | string
    >;
    status?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      ChallengeStatus | string
    >;
    theme?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      ChallengeTheme | string
    >;
    themeV2?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      ChallengeThemeV2 | string
    >;
    title?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ChallengeCelebration?: {
    celebrationCopy?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    challengesIds?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    rewardUsageDisclaimer?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ChallengeCelebrationV2?: {
    celebrationCopy?: GraphCacheResolver<
      WithTypename<ChallengeCelebrationV2>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    challengesIds?: GraphCacheResolver<
      WithTypename<ChallengeCelebrationV2>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<ChallengeCelebrationV2>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<ChallengeCelebrationV2>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ChallengeReward?: {
    expiresAt?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    redeemable?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    redeemableAt?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    redemptionChannel?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      RedemptionChannel | string
    >;
    rewardType?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      RewardType | string
    >;
    terms?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ChangeDetail?: {
    field?: GraphCacheResolver<
      WithTypename<ChangeDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    newValue?: GraphCacheResolver<
      WithTypename<ChangeDetail>,
      Record<string, never>,
      Scalars['JSON']['output'] | string
    >;
    oldValue?: GraphCacheResolver<
      WithTypename<ChangeDetail>,
      Record<string, never>,
      Scalars['JSON']['output'] | string
    >;
  };
  ChatToken?: {
    token?: GraphCacheResolver<
      WithTypename<ChatToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ChildSyncResult?: {
    error?: GraphCacheResolver<
      WithTypename<ChildSyncResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    salesforceId?: GraphCacheResolver<
      WithTypename<ChildSyncResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<ChildSyncResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ClaimLoyaltyPromotionFailure?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ClaimLoyaltyPromotionFailure>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<ClaimLoyaltyPromotionFailure>,
      Record<string, never>,
      ClaimLoyaltyPromotionFailureReason | string
    >;
  };
  ConsolidatedIngredient?: {
    id?: GraphCacheResolver<
      WithTypename<ConsolidatedIngredient>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isDressing?: GraphCacheResolver<
      WithTypename<ConsolidatedIngredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<ConsolidatedIngredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<ConsolidatedIngredient>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ConvertToMultipartyOrderSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<ConvertToMultipartyOrderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  CourierDetails?: {
    latitude?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateAccountSuccess?: {
    customer?: GraphCacheResolver<
      WithTypename<CreateAccountSuccess>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  CreateConnectionTokenResponse?: {
    secret?: GraphCacheResolver<
      WithTypename<CreateConnectionTokenResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateKioskReaderLocationIdResponse?: {
    id?: GraphCacheResolver<
      WithTypename<CreateKioskReaderLocationIdResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateLoyaltyProfileError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CreateLoyaltyProfileError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateLoyaltyProfileSuccess?: {
    loyaltyProfile?: GraphCacheResolver<
      WithTypename<CreateLoyaltyProfileSuccess>,
      Record<string, never>,
      WithTypename<LoyaltyProfile> | string
    >;
  };
  CreateOrderSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<CreateOrderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  CreateSetupIntent?: {
    clientSecret?: GraphCacheResolver<
      WithTypename<CreateSetupIntent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CreateSetupIntent>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  Credit?: {
    amount?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    creditType?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      CreditType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expiresAt?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    remainingAmount?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    storefrontEligibilityTitle?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Customer?: {
    addresses?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<Address> | string>
    >;
    availableCredit?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    billingAccounts?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<BillingAccount> | string>
    >;
    birthday?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    credits?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<Credit> | string>
    >;
    deletionInProgress?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    email?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    firstName?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    phoneNumber?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    qrCode?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    referralShareUrlEmail?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    trackingUuid?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    useCredit?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CustomerNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerNotOnboardedError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CustomerNotOnboardedError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerPass?: {
    authenticationToken?: GraphCacheResolver<
      WithTypename<CustomerPass>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    url?: GraphCacheResolver<
      WithTypename<CustomerPass>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerPaymentInfo?: {
    id?: GraphCacheResolver<
      WithTypename<CustomerPaymentInfo>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    paymentEphemeralKey?: GraphCacheResolver<
      WithTypename<CustomerPaymentInfo>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    paymentSessionId?: GraphCacheResolver<
      WithTypename<CustomerPaymentInfo>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerPointsForCustomerSupportFailureError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CustomerPointsForCustomerSupportFailureError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerPointsForCustomerSupportSuccessResponse?: {
    points?: GraphCacheResolver<
      WithTypename<CustomerPointsForCustomerSupportSuccessResponse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CustomerPreference?: {
    allergens?: GraphCacheResolver<
      WithTypename<CustomerPreference>,
      Record<string, never>,
      Array<Allergen | string>
    >;
    dietaryRestrictions?: GraphCacheResolver<
      WithTypename<CustomerPreference>,
      Record<string, never>,
      Array<DietaryRestriction | string>
    >;
    hasSyncedRestrictions?: GraphCacheResolver<
      WithTypename<CustomerPreference>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CustomerPreference>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  CustomerSupportCreditsFailureError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<CustomerSupportCreditsFailureError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CustomerSupportCreditsSuccessResponse?: {
    credits?: GraphCacheResolver<
      WithTypename<CustomerSupportCreditsSuccessResponse>,
      Record<string, never>,
      Array<WithTypename<CxCredit> | string>
    >;
  };
  CustomerSupportPoint?: {
    displayValue?: GraphCacheResolver<
      WithTypename<CustomerSupportPoint>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    value?: GraphCacheResolver<
      WithTypename<CustomerSupportPoint>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  CustomerTokenError?: {
    code?: GraphCacheResolver<
      WithTypename<CustomerTokenError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<CustomerTokenError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DeclinedPaymentMethod?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<DeclinedPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<DeclinedPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<DeclinedPaymentMethod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  DeleteAddressSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<DeleteAddressSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  DeleteAdminPrintPriorityTemplateResponse?: {
    message?: GraphCacheResolver<
      WithTypename<DeleteAdminPrintPriorityTemplateResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<DeleteAdminPrintPriorityTemplateResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  DeleteAdminUpsellCategoryResponse?: {
    message?: GraphCacheResolver<
      WithTypename<DeleteAdminUpsellCategoryResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<DeleteAdminUpsellCategoryResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  DeleteSubscriptionPaymentMethodSuccess?: {
    creditCards?: GraphCacheResolver<
      WithTypename<DeleteSubscriptionPaymentMethodSuccess>,
      Record<string, never>,
      Array<WithTypename<SubscriptionCreditCard> | string>
    >;
  };
  DeliveryAlreadyInFlight?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<DeliveryAlreadyInFlight>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DeliveryOrderDetail?: {
    address?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
    deliveryFee?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    estimatedDeliveryTime?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    vendor?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vendorRestaurantId?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DeliverySpecifyAddress?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<DeliverySpecifyAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DietaryProperty?: {
    id?: GraphCacheResolver<
      WithTypename<DietaryProperty>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<DietaryProperty>,
      Record<string, never>,
      DietaryPropertyKind | string
    >;
  };
  Discount?: {
    amount?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  DropOffLocation?: {
    id?: GraphCacheResolver<
      WithTypename<DropOffLocation>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<DropOffLocation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  EditLineItemInCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<EditLineItemInCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  EightySixResponse?: {
    message?: GraphCacheResolver<
      WithTypename<EightySixResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<EightySixResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  EstimateRange?: {
    end?: GraphCacheResolver<
      WithTypename<EstimateRange>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    start?: GraphCacheResolver<
      WithTypename<EstimateRange>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ExpiredReceipt?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ExpiredReceipt>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FailedToFetchPaymentIntent?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<FailedToFetchPaymentIntent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FeedbackQuestion?: {
    id?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    responses?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Array<WithTypename<FeedbackResponse> | string>
    >;
    slug?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    text?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FeedbackResponse?: {
    id?: GraphCacheResolver<
      WithTypename<FeedbackResponse>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    text?: GraphCacheResolver<
      WithTypename<FeedbackResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FeedbackSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<FeedbackSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  FieldValidationError?: {
    field?: GraphCacheResolver<
      WithTypename<FieldValidationError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<FieldValidationError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FlexCustomerAlreadyExistsError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<FlexCustomerAlreadyExistsError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FlexCustomerData?: {
    flexPaymentMethods?: GraphCacheResolver<
      WithTypename<FlexCustomerData>,
      Record<string, never>,
      Array<WithTypename<FlexPaymentMethod> | string>
    >;
  };
  FlexOnboardingSession?: {
    expiresAt?: GraphCacheResolver<
      WithTypename<FlexOnboardingSession>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    redirectUrl?: GraphCacheResolver<
      WithTypename<FlexOnboardingSession>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<FlexOnboardingSession>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  FlexPaymentMethod?: {
    brand?: GraphCacheResolver<
      WithTypename<FlexPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expMonth?: GraphCacheResolver<
      WithTypename<FlexPaymentMethod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    expYear?: GraphCacheResolver<
      WithTypename<FlexPaymentMethod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    last4?: GraphCacheResolver<
      WithTypename<FlexPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ForbiddenError?: {
    code?: GraphCacheResolver<
      WithTypename<ForbiddenError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<ForbiddenError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ForbiddenError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GetKioskPaymentsForCurrentDateResponse?: {
    id?: GraphCacheResolver<
      WithTypename<GetKioskPaymentsForCurrentDateResponse>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    payments?: GraphCacheResolver<
      WithTypename<GetKioskPaymentsForCurrentDateResponse>,
      Record<string, never>,
      Array<WithTypename<KioskPayment> | string>
    >;
  };
  GetKioskReaderLocationIdResponse?: {
    id?: GraphCacheResolver<
      WithTypename<GetKioskReaderLocationIdResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GiftCardAssociatedWithAnotherAccountError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<GiftCardAssociatedWithAnotherAccountError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GiftCardBalance?: {
    customerId?: GraphCacheResolver<
      WithTypename<GiftCardBalance>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    giftCardBalance?: GraphCacheResolver<
      WithTypename<GiftCardBalance>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  GiftCardDeliveryDetail?: {
    deliveryDateTime?: GraphCacheResolver<
      WithTypename<GiftCardDeliveryDetail>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    deliveryMethods?: GraphCacheResolver<
      WithTypename<GiftCardDeliveryDetail>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    isAsap?: GraphCacheResolver<
      WithTypename<GiftCardDeliveryDetail>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  GiftCardNotFoundError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<GiftCardNotFoundError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GiftCardOrderDetail?: {
    deliveryDetail?: GraphCacheResolver<
      WithTypename<GiftCardOrderDetail>,
      Record<string, never>,
      WithTypename<GiftCardDeliveryDetail> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<GiftCardOrderDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    purchasedAt?: GraphCacheResolver<
      WithTypename<GiftCardOrderDetail>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    userGiftCards?: GraphCacheResolver<
      WithTypename<GiftCardOrderDetail>,
      Record<string, never>,
      Array<WithTypename<UserGiftCard> | string>
    >;
  };
  GiftCardOrderNotFoundError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<GiftCardOrderNotFoundError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GiftCardPurchaseHistory?: {
    customerId?: GraphCacheResolver<
      WithTypename<GiftCardPurchaseHistory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    giftCardOrders?: GraphCacheResolver<
      WithTypename<GiftCardPurchaseHistory>,
      Record<string, never>,
      Array<WithTypename<GiftCardOrderDetail> | string>
    >;
  };
  GiftCardRedemptionDetailSuccess?: {
    assetId?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    balance?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    cardNumber?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    cardRegCode?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recipientMessage?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recipientName?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    redeemId?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    senderName?: GraphCacheResolver<
      WithTypename<GiftCardRedemptionDetailSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Guest?: {
    email?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    firstName?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  HasUnseenChallenges?: {
    hasUnseenChallenges?: GraphCacheResolver<
      WithTypename<HasUnseenChallenges>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  HurdleBehavior?: {
    achieved?: GraphCacheResolver<
      WithTypename<HurdleBehavior>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    goal?: GraphCacheResolver<
      WithTypename<HurdleBehavior>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    outcome?: GraphCacheResolver<
      WithTypename<HurdleBehavior>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    progress?: GraphCacheResolver<
      WithTypename<HurdleBehavior>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  HurdleBehaviorDetails?: {
    hurdleBehaviors?: GraphCacheResolver<
      WithTypename<HurdleBehaviorDetails>,
      Record<string, never>,
      Array<WithTypename<HurdleBehavior> | string>
    >;
  };
  IdentifyAndClaimInStoreOrderSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<IdentifyAndClaimInStoreOrderSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  InStoreOrder?: {
    id?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isPendingFeedback?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    ledger?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      WithTypename<InStoreOrderLedger> | string
    >;
    lineItems?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Array<WithTypename<InStoreOrderLineItem> | string>
    >;
    orderStatus?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      WithTypename<InStoreOrderRestaurant> | string
    >;
    vendorId?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InStoreOrderDiscount?: {
    amount?: GraphCacheResolver<
      WithTypename<InStoreOrderDiscount>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    isLoyalty?: GraphCacheResolver<
      WithTypename<InStoreOrderDiscount>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<InStoreOrderDiscount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InStoreOrderLedger?: {
    discounts?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Array<WithTypename<InStoreOrderDiscount> | string>
    >;
    payments?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Array<WithTypename<InStoreOrderPayment> | string>
    >;
    subtotal?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    tax?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<InStoreOrderLedger>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  InStoreOrderLineItem?: {
    asset?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      WithTypename<InStoreOrderLineItemAsset> | string
    >;
    brinkId?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isCustomProduct?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    price?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItem>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  InStoreOrderLineItemAsset?: {
    url?: GraphCacheResolver<
      WithTypename<InStoreOrderLineItemAsset>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InStoreOrderPayment?: {
    amount?: GraphCacheResolver<
      WithTypename<InStoreOrderPayment>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<InStoreOrderPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InStoreOrderRestaurant?: {
    address?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    city?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    entityId?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<InStoreOrderRestaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InStoreOrdersResponse?: {
    inStoreOrders?: GraphCacheResolver<
      WithTypename<InStoreOrdersResponse>,
      Record<string, never>,
      Array<WithTypename<InStoreOrder> | string>
    >;
    pagination?: GraphCacheResolver<
      WithTypename<InStoreOrdersResponse>,
      Record<string, never>,
      WithTypename<Pagination> | string
    >;
  };
  IncorrectPaymentMethod?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<IncorrectPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<IncorrectPaymentMethod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IncorrectPaymentMethod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Ingredient?: {
    allergenProperties?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Array<WithTypename<AllergenProperty> | string>
    >;
    asset?: GraphCacheResolver<
      WithTypename<Ingredient>,
      IngredientAssetArgs,
      WithTypename<Asset> | string
    >;
    availableDate?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<Ingredient>,
      IngredientCaloriesArgs,
      Scalars['Float']['output'] | string
    >;
    caloriesFromFat?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    cholesterolMg?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    co2eKg?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    dietaryFiberG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    dietaryProperties?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Array<WithTypename<DietaryProperty> | string>
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isGrain?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isMixable?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isWarmBase?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      IngredientKind | string
    >;
    lineageKey?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    proteinG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    saturatedFatG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    servingMeasure?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    servingUnitOfMeasure?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    sodiumMg?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    sugarsG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    totalCarbsG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    totalFatG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    transFatG?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  IngredientModification?: {
    additionCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    ingredient?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      WithTypename<Ingredient> | string
    >;
    isGrain?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mixable?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    removalCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    subKind?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    substitutionCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  IngredientModificationKind?: {
    allowMultipleQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    freeAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    minAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modifications?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Array<WithTypename<IngredientModification> | string>
    >;
  };
  IngredientModifications?: {
    bases?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    bread?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    dressings?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    premiums?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    toppings?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
  };
  IngredientModifier?: {
    additionCost?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    brinkPlu?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    ingredient?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      WithTypename<Ingredient> | string
    >;
    ingredientId?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    removalCost?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    subKind?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    substitutionCost?: GraphCacheResolver<
      WithTypename<IngredientModifier>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  InvalidAddress?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidAddress>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidAddress>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidBillingAccount?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidCreditCard?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<InvalidCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidCreditCard>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidCustomerPhone?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidCustomerPhone>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InvalidGiftCardError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidGiftCardError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InvalidInput?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidInput>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidInput>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidOrder?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<InvalidOrder>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidOrder>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidPromoCode?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidPromoCode>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidPromoCode>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvalidRefundAmount?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidRefundAmount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  InvalidTip?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidTip>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<InvalidTip>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidTip>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  IssueCustomerSupportCreditResult?: {
    success?: GraphCacheResolver<
      WithTypename<IssueCustomerSupportCreditResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  IssueCustomerSupportPointsFailureError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<IssueCustomerSupportPointsFailureError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  IssueCustomerSupportPointsSuccessResponse?: {
    credits?: GraphCacheResolver<
      WithTypename<IssueCustomerSupportPointsSuccessResponse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  JoinMultipartyOrderSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<JoinMultipartyOrderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  KioskCustomerProfile?: {
    firstName?: GraphCacheResolver<
      WithTypename<KioskCustomerProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<KioskCustomerProfile>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<KioskCustomerProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    loyaltyId?: GraphCacheResolver<
      WithTypename<KioskCustomerProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  KioskCustomerScanPaymentInfo?: {
    cardBrand?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfo>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    cardLast4?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfo>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    creditBalance?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfo>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  KioskCustomerScanPaymentInfoError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfoError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  KioskCustomerScanPaymentInfoSuccess?: {
    payment?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfoSuccess>,
      Record<string, never>,
      WithTypename<KioskCustomerScanPaymentInfo> | string
    >;
    purpose?: GraphCacheResolver<
      WithTypename<KioskCustomerScanPaymentInfoSuccess>,
      Record<string, never>,
      LoyaltyAccessTokenPurpose | string
    >;
  };
  KioskPayment?: {
    amount?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    cardBrand?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    cardholderName?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    created?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    last4?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    receiptUrl?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    refunded?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    refundedAmount?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<KioskPayment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Kustomer?: {
    token?: GraphCacheResolver<
      WithTypename<Kustomer>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LeaveOrderSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<LeaveOrderSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  Ledger?: {
    credits?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    creditsTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    discounts?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    discountsTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    fees?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    feesTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    selectedRewards?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    subtotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tax?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LedgerItem?: {
    amount?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LineItem?: {
    addedIngredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    calories?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    canEdit?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canReorderAtRestaurant?: GraphCacheResolver<
      WithTypename<LineItem>,
      LineItemCanReorderAtRestaurantArgs,
      Scalars['Boolean']['output'] | string
    >;
    consolidatedIngredientIds?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<Scalars['ID']['output'] | string>
    >;
    consolidatedIngredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<ConsolidatedIngredient> | string>
    >;
    cost?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    customName?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    customerName?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    dressingMode?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      DressingMode | string
    >;
    favorited?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    mixedDressingDetails?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<MixedDressingDetails> | string>
    >;
    orderParticipant?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      WithTypename<OrderParticipant> | string
    >;
    perItemCost?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    product?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      WithTypename<Product> | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    removedIngredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    selectedModifiers?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<SelectedModifier> | string>
    >;
    slug?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  LineItemModificationsInvalidException?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LineItemModificationsInvalidException>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<LineItemModificationsInvalidException>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LineItemModificationsInvalidException>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LineItemNotFound?: {
    message?: GraphCacheResolver<
      WithTypename<LineItemNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LineItemNotFound>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LineItemRecommendation?: {
    createdAt?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ingredientIds?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recommendationType?: GraphCacheResolver<
      WithTypename<LineItemRecommendation>,
      Record<string, never>,
      RecommendationType | string
    >;
  };
  LineItemSuccess?: {
    lineItem?: GraphCacheResolver<
      WithTypename<LineItemSuccess>,
      Record<string, never>,
      WithTypename<LineItem> | string
    >;
  };
  Location?: {
    estimateRange?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<EstimateRange> | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    status?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      LocationStatus | string
    >;
    vendor?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<Vendor> | string
    >;
  };
  LocationClosed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LocationClosed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<LocationClosed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LocationClosed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LockOrderFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LockOrderFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<LockOrderFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LockOrderFailed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LockOrderSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<LockOrderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  LogoutSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<LogoutSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LoyaltyAccessToken?: {
    expiresAt?: GraphCacheResolver<
      WithTypename<LoyaltyAccessToken>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    token?: GraphCacheResolver<
      WithTypename<LoyaltyAccessToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LoyaltyOptInFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LoyaltyOptInFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LoyaltyProfile?: {
    customerId?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    customerToken?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      LoyaltyProfileCustomerTokenArgs,
      WithTypename<CustomerTokenResponseUnion> | string
    >;
    hasPaidTierHistory?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    joinDate?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    loyaltyId?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    points?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<UserPointsStatus> | string
    >;
    pointsRewards?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Array<WithTypename<PointsReward> | string>
    >;
    rewards?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Array<WithTypename<Reward> | string>
    >;
    rewardsPremiumStatus?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<RewardsPremiumStatus> | string
    >;
    tier?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
    tierStatus?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<TierStatus> | string
    >;
    trialEligible?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Array<WithTypename<TrialEligibility> | string>
    >;
  };
  LoyaltyScanPaymentTokenInvalid?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LoyaltyScanPaymentTokenInvalid>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<LoyaltyScanPaymentTokenInvalid>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LoyaltyScanPaymentTokenInvalid>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LoyaltyScanTokenExpired?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<LoyaltyScanTokenExpired>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<LoyaltyScanTokenExpired>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LoyaltyScanTokenExpired>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  MaxEntreeReached?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MaxEntreeReached>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MaxEntreeReached>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MaxEntreeReached>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  MaxModificationsExceeded?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MaxModificationsExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MaxModificationsExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MaxModificationsExceeded>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Menu?: {
    categories?: GraphCacheResolver<
      WithTypename<Menu>,
      Record<string, never>,
      Array<WithTypename<MenuCategory> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<Menu>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  MenuCategory?: {
    description?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
  };
  MenuCollection?: {
    color?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    primaryDescription?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    primaryImageUrl?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    primaryTitle?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
    secondaryDescription?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    secondaryTitle?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  MenuNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MenuNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MenuNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MenuNotFound>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  MinimumDeliverySubtotalNotMet?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  MixedDressingDetails?: {
    ingredientId?: GraphCacheResolver<
      WithTypename<MixedDressingDetails>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    weight?: GraphCacheResolver<
      WithTypename<MixedDressingDetails>,
      Record<string, never>,
      DressingWeight | string
    >;
  };
  ModifierGroup?: {
    allowMultipleQuantity?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    displayName?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    encourageAboveMinSelection?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    encourageMaxSelection?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    freeAggregateQuantity?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    groupRole?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      ModifierGroupRole | string
    >;
    hasDynamicMax?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    helperText?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    maxAggregateQuantity?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    minAggregateQuantity?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    modifications?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Array<WithTypename<IngredientModifier> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    pairedGroupId?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    variation?: GraphCacheResolver<
      WithTypename<ModifierGroup>,
      Record<string, never>,
      ModifierGroupVariation | string
    >;
  };
  MultipartyDetail?: {
    displayName?: GraphCacheResolver<
      WithTypename<MultipartyDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    joinCode?: GraphCacheResolver<
      WithTypename<MultipartyDetail>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  MultipartyOrderAlreadyJoined?: {
    order?: GraphCacheResolver<
      WithTypename<MultipartyOrderAlreadyJoined>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  MultipartyOrderNotEnabled?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MultipartyOrderNotEnabled>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MultipartyOrderNotEnabled>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MultipartyOrderNotEnabled>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  MultipartyOrderNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MultipartyOrderNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  MultipartyOrderPreviewSuccess?: {
    deliveryAddressSummary?: GraphCacheResolver<
      WithTypename<MultipartyOrderPreviewSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    hostDisplayName?: GraphCacheResolver<
      WithTypename<MultipartyOrderPreviewSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderDisplayName?: GraphCacheResolver<
      WithTypename<MultipartyOrderPreviewSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<MultipartyOrderPreviewSuccess>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
  };
  NoBalanceGiftCardError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<NoBalanceGiftCardError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  NoValidRestaurants?: {
    message?: GraphCacheResolver<
      WithTypename<NoValidRestaurants>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<NoValidRestaurants>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  NotificationCategory?: {
    displayName?: GraphCacheResolver<
      WithTypename<NotificationCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    emailSubscribe?: GraphCacheResolver<
      WithTypename<NotificationCategory>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    hasResolved?: GraphCacheResolver<
      WithTypename<NotificationCategory>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<NotificationCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    pushSubscribe?: GraphCacheResolver<
      WithTypename<NotificationCategory>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  NotificationPreferencesError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<NotificationPreferencesError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  OptOutLoyaltyForCustomerSuccessResponse?: {
    success?: GraphCacheResolver<
      WithTypename<OptOutLoyaltyForCustomerSuccessResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  OptOutLoyaltySuccessResponse?: {
    success?: GraphCacheResolver<
      WithTypename<OptOutLoyaltySuccessResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  Order?: {
    asset?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    availableRewards?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<Reward> | string>
    >;
    availableRewardsByLoyaltyId?: GraphCacheResolver<
      WithTypename<Order>,
      OrderAvailableRewardsByLoyaltyIdArgs,
      Array<WithTypename<Reward> | string>
    >;
    availableRewardsWithLoyalty?: GraphCacheResolver<
      WithTypename<Order>,
      OrderAvailableRewardsWithLoyaltyArgs,
      Array<WithTypename<Reward> | string>
    >;
    availableWantedTimes?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<AvailableWantedTime> | string>
    >;
    canCancel?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canTrackOrderStatus?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    currentUserOrderPermissions?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<UserOrderPermission> | string
    >;
    deliveryOrderDetail?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<DeliveryOrderDetail> | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    dropoffLocation?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eligiblePointRewards?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<PointsReward> | string>
    >;
    eligiblePointRewardsByLoyaltyId?: GraphCacheResolver<
      WithTypename<Order>,
      OrderEligiblePointRewardsByLoyaltyIdArgs,
      Array<WithTypename<PointsReward> | string>
    >;
    eligiblePointRewardsWithLoyalty?: GraphCacheResolver<
      WithTypename<Order>,
      OrderEligiblePointRewardsWithLoyaltyArgs,
      Array<WithTypename<PointsReward> | string>
    >;
    hasEarnedLoyaltyPoints?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    includeUtensils?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isCanceled?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isInFlight?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isInFlightDelivery?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isPendingFeedback?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    ledger?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Ledger> | string
    >;
    lineItems?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<LineItem> | string>
    >;
    multipartyDetails?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<MultipartyDetail> | string
    >;
    orderSource?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      OrderSource | string
    >;
    orderState?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      OrderState | string
    >;
    orderType?: GraphCacheResolver<WithTypename<Order>, Record<string, never>, OrderType | string>;
    payments?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<Payment> | string>
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    total?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    transactionPlan?: GraphCacheResolver<
      WithTypename<Order>,
      OrderTransactionPlanArgs,
      WithTypename<TransactionPlanResponseUnion> | string
    >;
    vendorId?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
  };
  OrderAlreadyCanceled?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderAlreadyCanceled>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<OrderAlreadyCanceled>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<OrderAlreadyCanceled>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  OrderAlreadySentToKitchen?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderAlreadySentToKitchen>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<OrderAlreadySentToKitchen>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<OrderAlreadySentToKitchen>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  OrderConflict?: {
    product?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      WithTypename<Product> | string
    >;
    type?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      ConflictType | string
    >;
    unavailableIngredients?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
  };
  OrderLocked?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderLocked>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<OrderLocked>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<OrderLocked>,
      Record<string, never>,
      LockOrderReason | string
    >;
    status?: GraphCacheResolver<
      WithTypename<OrderLocked>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  OrderMissingTotalError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderMissingTotalError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  OrderNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<OrderNotFound>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<OrderNotFound>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  OrderParticipant?: {
    displayName?: GraphCacheResolver<
      WithTypename<OrderParticipant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<OrderParticipant>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isMe?: GraphCacheResolver<
      WithTypename<OrderParticipant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  OrderPaymentState?: {
    createdAt?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    paymentIntentId?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    paymentIntentSecret?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      OrderPaymentStatus | string
    >;
    updatedAt?: GraphCacheResolver<
      WithTypename<OrderPaymentState>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  OrderStatus?: {
    canceledStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    courierDetails?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      WithTypename<CourierDetails> | string
    >;
    customerId?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    deliveryAddressName?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    flattenedOrderStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      FlattenedOrderStatuses | string
    >;
    gravyStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      GravyStatusType | string
    >;
    gravyUpdatedAt?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    order?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    orderOccasion?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderWantedTime?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantName?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  OrderTotalNotZero?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<OrderTotalNotZero>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<OrderTotalNotZero>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<OrderTotalNotZero>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  OrdersResponseSuccess?: {
    orders?: GraphCacheResolver<
      WithTypename<OrdersResponseSuccess>,
      Record<string, never>,
      Array<WithTypename<Order> | string>
    >;
    pagination?: GraphCacheResolver<
      WithTypename<OrdersResponseSuccess>,
      Record<string, never>,
      WithTypename<Pagination> | string
    >;
  };
  Pagination?: {
    last?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    page?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    take?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Payment?: {
    amountEligibleForPoints?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    amountInCents?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    last4?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    paymentTime?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    processor?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    refunded?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    refundedAmount?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<Payment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PaymentAlreadyRefunded?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<PaymentAlreadyRefunded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PaymentIntent?: {
    id?: GraphCacheResolver<
      WithTypename<PaymentIntent>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<PaymentIntent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    secret?: GraphCacheResolver<
      WithTypename<PaymentIntent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PaymentMethodBillingAccount?: {
    cardType?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      CardType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationState?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      CardExpirationState | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isDefault?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    nickname?: GraphCacheResolver<
      WithTypename<PaymentMethodBillingAccount>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PaymentMethodCard?: {
    cardType?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      CardType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationState?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      CardExpirationState | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isDefault?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    nickname?: GraphCacheResolver<
      WithTypename<PaymentMethodCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PaymentPlan?: {
    braintreePlanId?: GraphCacheResolver<
      WithTypename<PaymentPlan>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    tier?: GraphCacheResolver<
      WithTypename<PaymentPlan>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
  };
  PaymentProfile?: {
    defaultCardId?: GraphCacheResolver<
      WithTypename<PaymentProfile>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentProfile>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  PaymentSubscription?: {
    balance?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    billingFrequencyUnit?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      DurationUnit | string
    >;
    billingHistory?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Array<WithTypename<SubscriptionTransactions> | string>
    >;
    billingPeriodEndDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    billingPeriodStartDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    billingRecurrence?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      DurationUnit | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    firstBillingDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    hasFreeTrial?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isTrialActive?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    nextBillingDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    nextBillingPeriodAmount?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    paidThroughDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    planId?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    price?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      PaymentSubscriptionStatus | string
    >;
  };
  PaymentSubscriptionProfile?: {
    creditCards?: GraphCacheResolver<
      WithTypename<PaymentSubscriptionProfile>,
      Record<string, never>,
      Array<WithTypename<SubscriptionCreditCard> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentSubscriptionProfile>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    transactionHistory?: GraphCacheResolver<
      WithTypename<PaymentSubscriptionProfile>,
      Record<string, never>,
      Array<WithTypename<SubscriptionTransactions> | string>
    >;
  };
  PersonalizedUpsell?: {
    customerId?: GraphCacheResolver<
      WithTypename<PersonalizedUpsell>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<PersonalizedUpsell>,
      Record<string, never>,
      Array<WithTypename<UpsellCategoryProduct> | string>
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<PersonalizedUpsell>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  PointExpirationEntry?: {
    amountExpiring?: GraphCacheResolver<
      WithTypename<PointExpirationEntry>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PointExpirationEntry>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    numOfDaysUntilExpiration?: GraphCacheResolver<
      WithTypename<PointExpirationEntry>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  PointHistoryEntry?: {
    date?: GraphCacheResolver<
      WithTypename<PointHistoryEntry>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PointHistoryEntry>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    source?: GraphCacheResolver<
      WithTypename<PointHistoryEntry>,
      Record<string, never>,
      PointIssuanceSource | string
    >;
    type?: GraphCacheResolver<
      WithTypename<PointHistoryEntry>,
      Record<string, never>,
      PointHistoryEntryType | string
    >;
    value?: GraphCacheResolver<
      WithTypename<PointHistoryEntry>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  PointHistoryForUserError?: {
    message?: GraphCacheResolver<
      WithTypename<PointHistoryForUserError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<PointHistoryForUserError>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  PointHistoryForUserSuccess?: {
    pagination?: GraphCacheResolver<
      WithTypename<PointHistoryForUserSuccess>,
      Record<string, never>,
      WithTypename<Pagination> | string
    >;
    pointExpirationEntries?: GraphCacheResolver<
      WithTypename<PointHistoryForUserSuccess>,
      Record<string, never>,
      Array<WithTypename<PointExpirationEntry> | string>
    >;
    pointHistoryEntries?: GraphCacheResolver<
      WithTypename<PointHistoryForUserSuccess>,
      Record<string, never>,
      Array<WithTypename<PointHistoryEntry> | string>
    >;
  };
  PointsReward?: {
    assetUrl?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    displayName?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    points?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    redeemable?: GraphCacheResolver<
      WithTypename<PointsReward>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  Product?: {
    allergenProperties?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Array<WithTypename<AllergenProperty> | string>
    >;
    asset?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    availableDate?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    baseProduct?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<BaseProduct> | string
    >;
    calorieOverrideText?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    categoryId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    categoryName?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    channelCost?: GraphCacheResolver<
      WithTypename<Product>,
      ProductChannelCostArgs,
      Scalars['Int']['output'] | string
    >;
    cost?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    customType?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      CustomProductType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    dietaryProperties?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Array<WithTypename<DietaryProperty> | string>
    >;
    enableDressingDetails?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    ingredientModifications?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<IngredientModifications> | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<Product>,
      ProductIngredientsArgs,
      Array<WithTypename<Ingredient> | string>
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isMixable?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isModifiable?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isSalad?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<ProductLabel> | string
    >;
    masterProductId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxModifications?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modifierGroups?: GraphCacheResolver<
      WithTypename<Product>,
      ProductModifierGroupsArgs,
      Array<WithTypename<ModifierGroup> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    throttleItem?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ProductLabel?: {
    id?: GraphCacheResolver<
      WithTypename<ProductLabel>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ProductLabel>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ProductOutOfStock?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ProductOutOfStock>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<ProductOutOfStock>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ProductOutOfStock>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ProductUnavailable?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  PromoCodeAlreadyApplied?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<PromoCodeAlreadyApplied>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Receipt?: {
    id?: GraphCacheResolver<
      WithTypename<Receipt>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isClaimed?: GraphCacheResolver<
      WithTypename<Receipt>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    order?: GraphCacheResolver<
      WithTypename<Receipt>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Receipt>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
  };
  ReceiptAlreadyClaimed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ReceiptAlreadyClaimed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<ReceiptAlreadyClaimed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ReceiptAlreadyClaimed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ReceiptAlreadyClaimedError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ReceiptAlreadyClaimedError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ReceiptNotFound?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ReceiptNotFound>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RefundKioskPaymentResponse?: {
    failureReason?: GraphCacheResolver<
      WithTypename<RefundKioskPaymentResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<RefundKioskPaymentResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RefundKioskPaymentResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RefundOrderSuccess?: {
    refundResults?: GraphCacheResolver<
      WithTypename<RefundOrderSuccess>,
      Record<string, never>,
      Array<WithTypename<RefundResult> | string>
    >;
  };
  RefundResult?: {
    id?: GraphCacheResolver<
      WithTypename<RefundResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<RefundResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<RefundResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  RegisterGuestFailed?: {
    message?: GraphCacheResolver<
      WithTypename<RegisterGuestFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RegisterGuestFailed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RegisterGuestSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<RegisterGuestSuccess>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    guest?: GraphCacheResolver<
      WithTypename<RegisterGuestSuccess>,
      Record<string, never>,
      WithTypename<Guest> | string
    >;
  };
  RemoveFromCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<RemoveFromCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    success?: GraphCacheResolver<
      WithTypename<RemoveFromCartSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  RemoveRewardSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<RemoveRewardSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  ReorderConflict?: {
    conflicts?: GraphCacheResolver<
      WithTypename<ReorderConflict>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    isNothingAvailable?: GraphCacheResolver<
      WithTypename<ReorderConflict>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ReorderSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<ReorderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    isMixingSupported?: GraphCacheResolver<
      WithTypename<ReorderSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  RequestAccountDeletionFailed?: {
    message?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionFailed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RequestAccountDeletionSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionSuccess>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  Restaurant?: {
    address?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    asset?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    availableDropOffLocations?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Array<WithTypename<DropOffLocation> | string>
    >;
    city?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    deliveryFee?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    deliveryMinSubtotal?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    entityId?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    flexMessage?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    hours?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<RestaurantHours> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isAcceptingOrders?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isOutpost?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    mdmId?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    menu?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<Menu> | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    notAcceptingOrdersReason?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    parentId?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    sanitaryGradeDisplayText?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    sanitaryGradeUrl?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    showDeliveryFeeDisclosure?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    showDeliveryPriceDifferenciationDisclosure?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    showOutpostPriceDifferenciationDisclosure?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    showWarningDialog?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    utcOffset?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    warningDialogDescription?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    warningDialogTimeout?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    warningDialogTitle?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RestaurantCapacity?: {
    availableWantedTimes?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Array<WithTypename<RestaurantCapacitySlot> | string>
    >;
    restaurantAddress?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantHours?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  RestaurantCapacitySlot?: {
    availableLineItems?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    formatted?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    maxLineItems?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    original?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RestaurantDeliveryChannels?: {
    canEdit?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    doorDashMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    foodaMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    grubhubMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    mealPalMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    nativeDeliveryEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    sharebiteMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    uberEatsMarketplaceEnabled?: GraphCacheResolver<
      WithTypename<RestaurantDeliveryChannels>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  RestaurantHours?: {
    formatted?: GraphCacheResolver<
      WithTypename<RestaurantHours>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    permanent?: GraphCacheResolver<
      WithTypename<RestaurantHours>,
      Record<string, never>,
      Array<WithTypename<RestaurantStoreHours> | string>
    >;
    store?: GraphCacheResolver<
      WithTypename<RestaurantHours>,
      Record<string, never>,
      Array<WithTypename<RestaurantStoreHours> | string>
    >;
  };
  RestaurantHoursMissing?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RestaurantHoursMissing>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantHoursMissing>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantHoursMissing>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RestaurantIsNotAcceptingOrders?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RestaurantMaxDeliveryQuantityExceeded?: {
    conflicts?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RestaurantMaxQuantityExceeded?: {
    conflicts?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    errorMessage?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RestaurantStoreHours?: {
    day?: GraphCacheResolver<
      WithTypename<RestaurantStoreHours>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    end?: GraphCacheResolver<
      WithTypename<RestaurantStoreHours>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    start?: GraphCacheResolver<
      WithTypename<RestaurantStoreHours>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RestaurantThrottle?: {
    address?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    brinkLocationToken?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    canEditLevers?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    city?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    date?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    kioskThrottlePercentage?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kitchenSiteUid?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    levers?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      WithTypename<RestaurantThrottleLevers> | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    outpostCount?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    parentId?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    restaurantName?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    slots?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Array<WithTypename<RestaurantThrottleSlot> | string>
    >;
    state?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    throttleDefaultSize?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    throttleGridEnabled?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    timeZone?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<RestaurantThrottle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RestaurantThrottleLevers?: {
    channels?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    largeOrderThresholdPercent?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxBuildAheadWindows?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxOrderSize?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    reservePercent?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    resolvedFromRestaurantId?: GraphCacheResolver<
      WithTypename<RestaurantThrottleLevers>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RestaurantThrottleSlot?: {
    availableCount?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    breakdown?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Array<WithTypename<ThrottleSlotBreakdown> | string>
    >;
    defaultCapacity?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    defaultFilledCount?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    filledCount?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kioskCapacity?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kioskFilledCount?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    time?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timeFormatted?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    totalCapacity?: GraphCacheResolver<
      WithTypename<RestaurantThrottleSlot>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Reward?: {
    assetUrl?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isFeatured?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    redeemable?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    redeemableAt?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    redemptionChannel?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      RedemptionChannel | string
    >;
    rewardType?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      RewardType | string
    >;
    terms?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RewardNotApplied?: {
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      ApplyRewardFailureCode | string
    >;
    failureMetadata?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      WithTypename<ApplyRewardFailureMetadata> | string
    >;
    failureReasons?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RewardNotRemoved?: {
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RewardNotValidated?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      ValidateRewardFailureCode | string
    >;
    failureMetadata?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      WithTypename<ValidateRewardFailureMetadata> | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  RewardValidationGeneralError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RewardValidationGeneralError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RewardsPremiumStatus?: {
    expirationDate?: GraphCacheResolver<
      WithTypename<RewardsPremiumStatus>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    isActive?: GraphCacheResolver<
      WithTypename<RewardsPremiumStatus>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  SelectedModifier?: {
    cost?: GraphCacheResolver<
      WithTypename<SelectedModifier>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SelectedModifier>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ingredient?: GraphCacheResolver<
      WithTypename<SelectedModifier>,
      Record<string, never>,
      WithTypename<Ingredient> | string
    >;
    modifierType?: GraphCacheResolver<
      WithTypename<SelectedModifier>,
      Record<string, never>,
      ModifierType | string
    >;
    parentId?: GraphCacheResolver<
      WithTypename<SelectedModifier>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Session?: {
    cart?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    csrf?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    inFlightDeliveryOrderId?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    inFlightOrderId?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isLoggedIn?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  SignInFailed?: {
    message?: GraphCacheResolver<
      WithTypename<SignInFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<SignInFailed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  SignInSuccess?: {
    customer?: GraphCacheResolver<
      WithTypename<SignInSuccess>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  StoreOffline?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<StoreOffline>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<StoreOffline>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<StoreOffline>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  StripeRefundErrorResponse?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<StripeRefundErrorResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  SubmitGiftCardCodeSuccess?: {
    totalCredit?: GraphCacheResolver<
      WithTypename<SubmitGiftCardCodeSuccess>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  SubmitGiftCardOrderError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<SubmitGiftCardOrderError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  SubmitGiftCardOrderPaymentError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<SubmitGiftCardOrderPaymentError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  SubmitOrderUsingPaymentMethodSuccess?: {
    customer?: GraphCacheResolver<
      WithTypename<SubmitOrderUsingPaymentMethodSuccess>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
    order?: GraphCacheResolver<
      WithTypename<SubmitOrderUsingPaymentMethodSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  SubmitOrderWithPaymentMethodSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<SubmitOrderWithPaymentMethodSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  SubmitPromoCodeSuccessV2?: {
    placeholder?: GraphCacheResolver<
      WithTypename<SubmitPromoCodeSuccessV2>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  SubscriptionCreditCard?: {
    cardType?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      BraintreeCardType | string
    >;
    expirationMonth?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expirationState?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      CardExpirationState | string
    >;
    expirationYear?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    isActive?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    lastFour?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  SubscriptionPlan?: {
    billingDayOfMonth?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    billingFrequency?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    billingFrequencyUnit?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      DurationUnit | string
    >;
    billingRecurrence?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      DurationUnit | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    currencyIsoCode?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    discounts?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Array<WithTypename<Discount> | string>
    >;
    hasFreeTrial?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    price?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  SubscriptionTransactions?: {
    amount?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    creditCard?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      WithTypename<SubscriptionCreditCard> | string
    >;
    date?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    refund?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    transactionCreditCard?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      WithTypename<TransactionCreditCard> | string
    >;
  };
  SyncChanges?: {
    additions?: GraphCacheResolver<
      WithTypename<SyncChanges>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    deletions?: GraphCacheResolver<
      WithTypename<SyncChanges>,
      Record<string, never>,
      Array<WithTypename<ChangeDetail> | string>
    >;
    updates?: GraphCacheResolver<
      WithTypename<SyncChanges>,
      Record<string, never>,
      Array<WithTypename<ChangeDetail> | string>
    >;
  };
  SyncLocationResult?: {
    changes?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      WithTypename<SyncChanges> | string
    >;
    childSyncResults?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Array<WithTypename<ChildSyncResult> | string>
    >;
    data?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Scalars['JSON']['output'] | string
    >;
    errors?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    isPreview?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    salesforceId?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    syncedAt?: GraphCacheResolver<
      WithTypename<SyncLocationResult>,
      Record<string, never>,
      Scalars['DateTime']['output'] | string
    >;
  };
  ThrottleSlotBreakdown?: {
    categoryName?: GraphCacheResolver<
      WithTypename<ThrottleSlotBreakdown>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    count?: GraphCacheResolver<
      WithTypename<ThrottleSlotBreakdown>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    orderSource?: GraphCacheResolver<
      WithTypename<ThrottleSlotBreakdown>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    orderType?: GraphCacheResolver<
      WithTypename<ThrottleSlotBreakdown>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Tier?: {
    displayName?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<WithTypename<Tier>, Record<string, never>, TierName | string>;
    nameV2?: GraphCacheResolver<WithTypename<Tier>, Record<string, never>, TierName | string>;
    nextTier?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
    tierGroup?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      WithTypename<TierGroup> | string
    >;
  };
  TierGroup?: {
    id?: GraphCacheResolver<
      WithTypename<TierGroup>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<TierGroup>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
  };
  TierStatus?: {
    id?: GraphCacheResolver<
      WithTypename<TierStatus>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<TierStatus>,
      Record<string, never>,
      TierStatusName | string
    >;
  };
  TimeRestrictionError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<TimeRestrictionError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  TimeslotUnavailable?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  TransactionCreditCard?: {
    cardType?: GraphCacheResolver<
      WithTypename<TransactionCreditCard>,
      Record<string, never>,
      BraintreeCardType | string
    >;
    id?: GraphCacheResolver<
      WithTypename<TransactionCreditCard>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    lastFour?: GraphCacheResolver<
      WithTypename<TransactionCreditCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  TransactionNotFoundError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<TransactionNotFoundError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  TransactionPlan?: {
    amountInCents?: GraphCacheResolver<
      WithTypename<TransactionPlan>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    automaticCapture?: GraphCacheResolver<
      WithTypename<TransactionPlan>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    processor?: GraphCacheResolver<
      WithTypename<TransactionPlan>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  TransactionPlanResult?: {
    transactionPlan?: GraphCacheResolver<
      WithTypename<TransactionPlanResult>,
      Record<string, never>,
      Array<WithTypename<TransactionPlan> | string>
    >;
  };
  TrialEligibility?: {
    duration?: GraphCacheResolver<
      WithTypename<TrialEligibility>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    durationUnit?: GraphCacheResolver<
      WithTypename<TrialEligibility>,
      Record<string, never>,
      DurationUnit | string
    >;
  };
  UnableToGetFlexCustomerDataError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnableToGetFlexCustomerDataError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UnableToGetGiftCardBalanceError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnableToGetGiftCardBalanceError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UnableToRedeemGiftCardError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnableToRedeemGiftCardError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UnauthorizedLineItemModification?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnauthorizedLineItemModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<UnauthorizedLineItemModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<UnauthorizedLineItemModification>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  UnauthorizedOrderModification?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnauthorizedOrderModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<UnauthorizedOrderModification>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<UnauthorizedOrderModification>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  UnknownUserError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnknownUserError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UnlockOrderFailed?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnlockOrderFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<UnlockOrderFailed>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<UnlockOrderFailed>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  UnlockOrderSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<UnlockOrderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  UpdateAddressSuccess?: {
    address?: GraphCacheResolver<
      WithTypename<UpdateAddressSuccess>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
  };
  UpdateAdminRestaurantAvailabilityResponse?: {
    message?: GraphCacheResolver<
      WithTypename<UpdateAdminRestaurantAvailabilityResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<UpdateAdminRestaurantAvailabilityResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    updatedCount?: GraphCacheResolver<
      WithTypename<UpdateAdminRestaurantAvailabilityResponse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  UpdateCustomerPreferencesError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UpdateCustomerPreferencesError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCustomerResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateCustomerResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  UpdateKioskCustomerResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateKioskCustomerResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  UpdateUseCreditResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateUseCreditResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  UpsellCategory?: {
    categoryRanking?: GraphCacheResolver<
      WithTypename<UpsellCategory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<UpsellCategory>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<UpsellCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<UpsellCategory>,
      Record<string, never>,
      Array<WithTypename<UpsellCategoryProduct> | string>
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<UpsellCategory>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpsellCategoryProduct?: {
    channelCost?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      UpsellCategoryProductChannelCostArgs,
      Scalars['Int']['output'] | string
    >;
    cost?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['ID']['output'] | string
    >;
    imageUrl?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    menuId?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<UpsellCategoryProduct>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  UserGiftCard?: {
    assetId?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    balance?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recipientEmail?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recipientName?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    redemptionToken?: GraphCacheResolver<
      WithTypename<UserGiftCard>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UserNotificationPreferences?: {
    notificationCategories?: GraphCacheResolver<
      WithTypename<UserNotificationPreferences>,
      Record<string, never>,
      Array<WithTypename<NotificationCategory> | string>
    >;
  };
  UserOrderPermission?: {
    canApplyRewards?: GraphCacheResolver<
      WithTypename<UserOrderPermission>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canSubmitOrder?: GraphCacheResolver<
      WithTypename<UserOrderPermission>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    canUpdateOrderDetails?: GraphCacheResolver<
      WithTypename<UserOrderPermission>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isHost?: GraphCacheResolver<
      WithTypename<UserOrderPermission>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  UserPointsStatus?: {
    available?: GraphCacheResolver<
      WithTypename<UserPointsStatus>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    pending?: GraphCacheResolver<
      WithTypename<UserPointsStatus>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<UserPointsStatus>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse?: {
    redemptionToken?: GraphCacheResolver<
      WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    valid?: GraphCacheResolver<
      WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ValidateRewardFailureMetadata?: {
    requiredChannel?: GraphCacheResolver<
      WithTypename<ValidateRewardFailureMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    requiredDays?: GraphCacheResolver<
      WithTypename<ValidateRewardFailureMetadata>,
      Record<string, never>,
      Array<Scalars['Float']['output'] | string>
    >;
  };
  ValidationError?: {
    fieldErrors?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Array<WithTypename<FieldValidationError> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Vendor?: {
    name?: GraphCacheResolver<
      WithTypename<Vendor>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<Vendor>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
};

export type GraphCacheOptimisticUpdaters = {
  addAddress?: GraphCacheOptimisticMutationResolver<
    MutationAddAddressArgs,
    WithTypename<AddAddressResponseUnion>
  >;
  addAddressV2?: GraphCacheOptimisticMutationResolver<
    MutationAddAddressV2Args,
    WithTypename<AddAddressResponseUnion>
  >;
  addLineItemBatchToCart?: GraphCacheOptimisticMutationResolver<
    MutationAddLineItemBatchToCartArgs,
    WithTypename<AddLineItemToCartResponseUnion>
  >;
  addLineItemToCart?: GraphCacheOptimisticMutationResolver<
    MutationAddLineItemToCartArgs,
    WithTypename<AddLineItemToCartResponseUnion>
  >;
  addLineItemToCartWithLoyalty?: GraphCacheOptimisticMutationResolver<
    MutationAddLineItemToCartWithLoyaltyArgs,
    WithTypename<AddLineItemToCartResponseUnion>
  >;
  anonymizeCustomer?: GraphCacheOptimisticMutationResolver<
    MutationAnonymizeCustomerArgs,
    Scalars['Boolean']['output']
  >;
  applyAdminPrintPriorityTemplate?: GraphCacheOptimisticMutationResolver<
    MutationApplyAdminPrintPriorityTemplateArgs,
    WithTypename<AdminPrintPriorityTemplate>
  >;
  applyReward?: GraphCacheOptimisticMutationResolver<
    MutationApplyRewardArgs,
    WithTypename<ApplyRewardResponseUnion>
  >;
  applyRewardByLoyaltyId?: GraphCacheOptimisticMutationResolver<
    MutationApplyRewardByLoyaltyIdArgs,
    WithTypename<ApplyRewardResponseUnion>
  >;
  applyRewardWithLoyalty?: GraphCacheOptimisticMutationResolver<
    MutationApplyRewardWithLoyaltyArgs,
    WithTypename<ApplyRewardResponseUnion>
  >;
  cancelOrder?: GraphCacheOptimisticMutationResolver<
    MutationCancelOrderArgs,
    WithTypename<CancelOrderResponseUnion>
  >;
  cancelOrderExternal?: GraphCacheOptimisticMutationResolver<
    MutationCancelOrderExternalArgs,
    WithTypename<CancelOrderExternalResponseUnion>
  >;
  cancelOrderPaymentIntent?: GraphCacheOptimisticMutationResolver<
    MutationCancelOrderPaymentIntentArgs,
    WithTypename<CancelOrderPaymentIntentResponse>
  >;
  cancelOrderV2?: GraphCacheOptimisticMutationResolver<
    MutationCancelOrderV2Args,
    WithTypename<CancelOrderResponseUnion>
  >;
  challengeOptIn?: GraphCacheOptimisticMutationResolver<
    MutationChallengeOptInArgs,
    WithTypename<Challenge>
  >;
  challengeOptInV2?: GraphCacheOptimisticMutationResolver<
    MutationChallengeOptInV2Args,
    WithTypename<ChallengeOptInResultUnion>
  >;
  claimLoyaltyPromotion?: GraphCacheOptimisticMutationResolver<
    MutationClaimLoyaltyPromotionArgs,
    WithTypename<ClaimLoyaltyPromotionResponseUnion>
  >;
  convertToMultipartyOrder?: GraphCacheOptimisticMutationResolver<
    MutationConvertToMultipartyOrderArgs,
    WithTypename<ConvertToMultipartyOrderResponseUnion>
  >;
  createAccount?: GraphCacheOptimisticMutationResolver<
    MutationCreateAccountArgs,
    WithTypename<CreateAccountResponseUnion>
  >;
  createAdminPrintPriorityTemplate?: GraphCacheOptimisticMutationResolver<
    MutationCreateAdminPrintPriorityTemplateArgs,
    WithTypename<AdminPrintPriorityTemplate>
  >;
  createAdminUpsellCategory?: GraphCacheOptimisticMutationResolver<
    MutationCreateAdminUpsellCategoryArgs,
    WithTypename<AdminUpsellCategory>
  >;
  createAndSubmitPrepaidOrder?: GraphCacheOptimisticMutationResolver<
    MutationCreateAndSubmitPrepaidOrderArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  createConnectionToken?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<CreateConnectionTokenResponse>
  >;
  createFlexOnboardingSession?: GraphCacheOptimisticMutationResolver<
    MutationCreateFlexOnboardingSessionArgs,
    WithTypename<FlexOnboardingSessionResponseUnion>
  >;
  createGiftCardPaymentIntent?: GraphCacheOptimisticMutationResolver<
    MutationCreateGiftCardPaymentIntentArgs,
    WithTypename<PaymentIntent>
  >;
  createKioskReaderLocation?: GraphCacheOptimisticMutationResolver<
    MutationCreateKioskReaderLocationArgs,
    WithTypename<CreateKioskReaderLocationIdResponse>
  >;
  createKioskReaderLocationWithIds?: GraphCacheOptimisticMutationResolver<
    MutationCreateKioskReaderLocationWithIdsArgs,
    WithTypename<CreateKioskReaderLocationIdResponse>
  >;
  createOrder?: GraphCacheOptimisticMutationResolver<
    MutationCreateOrderArgs,
    WithTypename<CreateOrderResponseUnion>
  >;
  createOrderPaymentIntent?: GraphCacheOptimisticMutationResolver<
    MutationCreateOrderPaymentIntentArgs,
    WithTypename<PaymentIntent>
  >;
  createPaymentIntent?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Scalars['String']['output']
  >;
  createPaymentSubscriptionProfile?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<PaymentSubscriptionProfile>
  >;
  createSetupPaymentIntent?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<CreateSetupIntent>
  >;
  deleteAddress?: GraphCacheOptimisticMutationResolver<
    MutationDeleteAddressArgs,
    WithTypename<DeleteAddressResponseUnion>
  >;
  deleteAdminPrintPriorityTemplate?: GraphCacheOptimisticMutationResolver<
    MutationDeleteAdminPrintPriorityTemplateArgs,
    WithTypename<DeleteAdminPrintPriorityTemplateResponse>
  >;
  deleteAdminUpsellCategory?: GraphCacheOptimisticMutationResolver<
    MutationDeleteAdminUpsellCategoryArgs,
    WithTypename<DeleteAdminUpsellCategoryResponse>
  >;
  deletePaymentMethodCard?: GraphCacheOptimisticMutationResolver<
    MutationDeletePaymentMethodCardArgs,
    WithTypename<PaymentMethodCard>
  >;
  editLineItemInCart?: GraphCacheOptimisticMutationResolver<
    MutationEditLineItemInCartArgs,
    WithTypename<EditLineItemInCartResponseUnion>
  >;
  editLineItemInCartWithLoyalty?: GraphCacheOptimisticMutationResolver<
    MutationEditLineItemInCartWithLoyaltyArgs,
    WithTypename<EditLineItemInCartResponseUnion>
  >;
  eightySixIngredient?: GraphCacheOptimisticMutationResolver<
    MutationEightySixIngredientArgs,
    WithTypename<EightySixResponse>
  >;
  eightySixProduct?: GraphCacheOptimisticMutationResolver<
    MutationEightySixProductArgs,
    WithTypename<EightySixResponse>
  >;
  favoriteLineItem?: GraphCacheOptimisticMutationResolver<
    MutationFavoriteLineItemArgs,
    WithTypename<LineItem>
  >;
  handoffCart?: GraphCacheOptimisticMutationResolver<
    MutationHandoffCartArgs,
    WithTypename<ReorderResponseUnion>
  >;
  identifyAndClaimInStoreOrder?: GraphCacheOptimisticMutationResolver<
    MutationIdentifyAndClaimInStoreOrderArgs,
    WithTypename<IdentifyAndClaimInStoreOrderResponseUnion>
  >;
  issueCustomerSupportCredit?: GraphCacheOptimisticMutationResolver<
    MutationIssueCustomerSupportCreditArgs,
    WithTypename<IssueCustomerSupportCreditResult>
  >;
  issueCustomerSupportPoints?: GraphCacheOptimisticMutationResolver<
    MutationIssueCustomerSupportPointsArgs,
    WithTypename<IssueCustomerSupportPointsResponse>
  >;
  joinMultipartyOrder?: GraphCacheOptimisticMutationResolver<
    MutationJoinMultipartyOrderArgs,
    WithTypename<JoinMultipartyOrderResponseUnion>
  >;
  leaveMultipartyOrder?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<LeaveMultipartyOrderResponseUnion>
  >;
  lockOrder?: GraphCacheOptimisticMutationResolver<
    MutationLockOrderArgs,
    WithTypename<LockOrderResponseUnion>
  >;
  logout?: GraphCacheOptimisticMutationResolver<
    MutationLogoutArgs,
    WithTypename<LogoutResponseUnion>
  >;
  optInFreeTierV2?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Maybe<WithTypename<LoyaltyProfile>>
  >;
  optInLoyalty?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Maybe<WithTypename<LoyaltyProfile>>
  >;
  optOutLoyalty?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<OptOutLoyaltyResponseUnion>
  >;
  optOutLoyaltyForCustomer?: GraphCacheOptimisticMutationResolver<
    MutationOptOutLoyaltyForCustomerArgs,
    WithTypename<OptOutLoyaltyForCustomerResponseUnion>
  >;
  redeemGiftCard?: GraphCacheOptimisticMutationResolver<
    MutationRedeemGiftCardArgs,
    WithTypename<RedeemGiftCardResponseUnion>
  >;
  refundKioskPayment?: GraphCacheOptimisticMutationResolver<
    MutationRefundKioskPaymentArgs,
    WithTypename<RefundKioskPaymentResponse>
  >;
  refundKioskPaymentV2?: GraphCacheOptimisticMutationResolver<
    MutationRefundKioskPaymentV2Args,
    WithTypename<RefundKioskPaymentResponseUnion>
  >;
  registerGuest?: GraphCacheOptimisticMutationResolver<
    MutationRegisterGuestArgs,
    Maybe<WithTypename<RegisterGuestResponseUnion>>
  >;
  removeFromCart?: GraphCacheOptimisticMutationResolver<
    MutationRemoveFromCartArgs,
    WithTypename<RemoveFromCartResponseUnion>
  >;
  removeFromCartWithLoyalty?: GraphCacheOptimisticMutationResolver<
    MutationRemoveFromCartWithLoyaltyArgs,
    WithTypename<RemoveFromCartResponseUnion>
  >;
  removeReward?: GraphCacheOptimisticMutationResolver<
    MutationRemoveRewardArgs,
    WithTypename<RemoveRewardResponseUnion>
  >;
  removeRewardByLoyaltyId?: GraphCacheOptimisticMutationResolver<
    MutationRemoveRewardByLoyaltyIdArgs,
    WithTypename<RemoveRewardResponseUnion>
  >;
  removeRewardWithLoyalty?: GraphCacheOptimisticMutationResolver<
    MutationRemoveRewardWithLoyaltyArgs,
    WithTypename<RemoveRewardResponseUnion>
  >;
  removeSubscriptionPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationRemoveSubscriptionPaymentMethodArgs,
    WithTypename<DeleteSubscriptionPaymentMethodResponseUnion>
  >;
  renameAdminUpsellCategory?: GraphCacheOptimisticMutationResolver<
    MutationRenameAdminUpsellCategoryArgs,
    WithTypename<AdminUpsellCategory>
  >;
  reorderLineItem?: GraphCacheOptimisticMutationResolver<
    MutationReorderLineItemArgs,
    WithTypename<ReorderResponseUnion>
  >;
  reorderOrder?: GraphCacheOptimisticMutationResolver<
    MutationReorderOrderArgs,
    WithTypename<ReorderResponseUnion>
  >;
  requestAccountDeletion?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Maybe<WithTypename<RequestAccountDeletionResponseUnion>>
  >;
  saveFeedbackCase?: GraphCacheOptimisticMutationResolver<
    MutationSaveFeedbackCaseArgs,
    WithTypename<FeedbackSuccess>
  >;
  sendKioskRefundReceipt?: GraphCacheOptimisticMutationResolver<
    MutationSendKioskRefundReceiptArgs,
    Scalars['Boolean']['output']
  >;
  setDefaultPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationSetDefaultPaymentMethodArgs,
    WithTypename<PaymentProfile>
  >;
  setUserNotificationPreferences?: GraphCacheOptimisticMutationResolver<
    MutationSetUserNotificationPreferencesArgs,
    WithTypename<UserNotificationPreferencesUnion>
  >;
  signIn?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<SignInResponseUnion>
  >;
  submitFeedback?: GraphCacheOptimisticMutationResolver<
    MutationSubmitFeedbackArgs,
    WithTypename<FeedbackSuccess>
  >;
  submitGiftCardOrderUsingPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationSubmitGiftCardOrderUsingPaymentMethodArgs,
    WithTypename<SubmitGiftCardOrderUsingPaymentMethodResponseUnion>
  >;
  submitInStoreFeedback?: GraphCacheOptimisticMutationResolver<
    MutationSubmitInStoreFeedbackArgs,
    WithTypename<FeedbackSuccess>
  >;
  submitOrderAsPayInStoreASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderAsPayInStoreAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderAsPrepaidASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderAsPrepaidAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderUsingPaymentIntentASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderUsingPaymentIntentAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderUsingPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderUsingPaymentMethodArgs,
    WithTypename<SubmitOrderUsingPaymentMethodResponseUnion>
  >;
  submitOrderWithLoyaltyAsPrepaidASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderWithLoyaltyAsPrepaidAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderWithLoyaltyAsPrepaidInStoreASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderWithLoyaltyAsPrepaidInStoreAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderWithLoyaltyUsingPaymentMethodASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderWithLoyaltyUsingPaymentMethodAsapArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitOrderWithPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderWithPaymentMethodArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitPromoCode?: GraphCacheOptimisticMutationResolver<
    MutationSubmitPromoCodeArgs,
    WithTypename<SubmitPromoCodeResponseUnion>
  >;
  submitPromoOrGiftCardCode?: GraphCacheOptimisticMutationResolver<
    MutationSubmitPromoOrGiftCardCodeArgs,
    WithTypename<SubmitPromoCodeOrGiftCardResponseUnion>
  >;
  submitZeroTotalOrderWithLoyaltyASAP?: GraphCacheOptimisticMutationResolver<
    MutationSubmitZeroTotalOrderWithLoyaltyAsapArgs,
    WithTypename<SubmitZeroTotalOrderWithLoyaltyResponseUnion>
  >;
  syncLocation?: GraphCacheOptimisticMutationResolver<
    MutationSyncLocationArgs,
    WithTypename<SyncLocationResult>
  >;
  unlockOrder?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<UnlockOrderResponseUnion>
  >;
  updateAddress?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAddressArgs,
    WithTypename<UpdateAddressResponseUnion>
  >;
  updateAddressV2?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAddressV2Args,
    WithTypename<UpdateAddressResponseUnion>
  >;
  updateAdminGroupOrderSettings?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminGroupOrderSettingsArgs,
    WithTypename<AdminGroupOrderSettings>
  >;
  updateAdminPrintPriorityTemplate?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminPrintPriorityTemplateArgs,
    WithTypename<AdminPrintPriorityTemplate>
  >;
  updateAdminProductUpsells?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminProductUpsellsArgs,
    Array<WithTypename<AdminUpsellMasterProduct>>
  >;
  updateAdminRestaurantEnabled?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantEnabledArgs,
    WithTypename<AdminRestaurantSettings>
  >;
  updateAdminRestaurantIngredientDates?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantIngredientDatesArgs,
    WithTypename<UpdateAdminRestaurantAvailabilityResponse>
  >;
  updateAdminRestaurantIngredientStock?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantIngredientStockArgs,
    WithTypename<UpdateAdminRestaurantAvailabilityResponse>
  >;
  updateAdminRestaurantMenuProductDates?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantMenuProductDatesArgs,
    WithTypename<UpdateAdminRestaurantAvailabilityResponse>
  >;
  updateAdminRestaurantMenuProductStock?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantMenuProductStockArgs,
    WithTypename<UpdateAdminRestaurantAvailabilityResponse>
  >;
  updateAdminRestaurantOrdering?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantOrderingArgs,
    WithTypename<AdminRestaurantSettings>
  >;
  updateAdminRestaurantProfile?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminRestaurantProfileArgs,
    WithTypename<AdminRestaurantSettings>
  >;
  updateAdminUpsellCategoryArrangement?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAdminUpsellCategoryArrangementArgs,
    Array<WithTypename<AdminUpsellCategory>>
  >;
  updateCustomer?: GraphCacheOptimisticMutationResolver<
    MutationUpdateCustomerArgs,
    Maybe<WithTypename<UpdateCustomerResponse>>
  >;
  updateKioskCustomer?: GraphCacheOptimisticMutationResolver<
    MutationUpdateKioskCustomerArgs,
    Maybe<WithTypename<UpdateKioskCustomerResponse>>
  >;
  updatePaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationUpdatePaymentMethodArgs,
    WithTypename<PaymentMethodCard>
  >;
  updatePreferences?: GraphCacheOptimisticMutationResolver<
    MutationUpdatePreferencesArgs,
    WithTypename<UpdateCustomerPreferencesUnion>
  >;
  updateRestaurantDeliveryChannels?: GraphCacheOptimisticMutationResolver<
    MutationUpdateRestaurantDeliveryChannelsArgs,
    WithTypename<RestaurantDeliveryChannels>
  >;
  updateRestaurantThrottleLevers?: GraphCacheOptimisticMutationResolver<
    MutationUpdateRestaurantThrottleLeversArgs,
    WithTypename<RestaurantThrottleLevers>
  >;
  updateUseCredit?: GraphCacheOptimisticMutationResolver<
    MutationUpdateUseCreditArgs,
    WithTypename<UpdateUseCreditResponse>
  >;
  validateAndRefreshGiftCardRedemptionTokenForCustomer?: GraphCacheOptimisticMutationResolver<
    MutationValidateAndRefreshGiftCardRedemptionTokenForCustomerArgs,
    WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>
  >;
};

export type GraphCacheUpdaters = {
  Query?: {
    addons?: GraphCacheUpdateResolver<{ addons: WithTypename<Addons> }, Record<string, never>>;
    address?: GraphCacheUpdateResolver<{ address: Maybe<WithTypename<Address>> }, QueryAddressArgs>;
    adminGroupOrderSettings?: GraphCacheUpdateResolver<
      { adminGroupOrderSettings: WithTypename<AdminGroupOrderSettings> },
      Record<string, never>
    >;
    adminMasterZones?: GraphCacheUpdateResolver<
      { adminMasterZones: Array<WithTypename<AdminMasterZone>> },
      Record<string, never>
    >;
    adminOrder?: GraphCacheUpdateResolver<
      { adminOrder: Maybe<WithTypename<AdminOrder>> },
      QueryAdminOrderArgs
    >;
    adminOrders?: GraphCacheUpdateResolver<
      { adminOrders: WithTypename<AdminOrderPage> },
      QueryAdminOrdersArgs
    >;
    adminOutOfStockReasons?: GraphCacheUpdateResolver<
      { adminOutOfStockReasons: Array<WithTypename<AdminOutOfStockReason>> },
      Record<string, never>
    >;
    adminPrintPriorityIngredients?: GraphCacheUpdateResolver<
      { adminPrintPriorityIngredients: Array<WithTypename<AdminPrintPriorityIngredient>> },
      Record<string, never>
    >;
    adminPrintPriorityTemplates?: GraphCacheUpdateResolver<
      { adminPrintPriorityTemplates: Array<WithTypename<AdminPrintPriorityTemplate>> },
      Record<string, never>
    >;
    adminProductUpsellAudits?: GraphCacheUpdateResolver<
      { adminProductUpsellAudits: Array<WithTypename<AdminProductUpsellAudit>> },
      QueryAdminProductUpsellAuditsArgs
    >;
    adminProductUpsells?: GraphCacheUpdateResolver<
      { adminProductUpsells: Array<WithTypename<AdminUpsellMasterProduct>> },
      Record<string, never>
    >;
    adminRestaurant?: GraphCacheUpdateResolver<
      { adminRestaurant: Maybe<WithTypename<AdminRestaurant>> },
      QueryAdminRestaurantArgs
    >;
    adminRestaurantAudits?: GraphCacheUpdateResolver<
      { adminRestaurantAudits: Maybe<WithTypename<AdminRestaurantAuditPage>> },
      QueryAdminRestaurantAuditsArgs
    >;
    adminRestaurantAvailability?: GraphCacheUpdateResolver<
      { adminRestaurantAvailability: Maybe<WithTypename<AdminRestaurantAvailability>> },
      QueryAdminRestaurantAvailabilityArgs
    >;
    adminRestaurantSettings?: GraphCacheUpdateResolver<
      { adminRestaurantSettings: Maybe<WithTypename<AdminRestaurantSettings>> },
      QueryAdminRestaurantSettingsArgs
    >;
    adminUpsellCategories?: GraphCacheUpdateResolver<
      { adminUpsellCategories: Array<WithTypename<AdminUpsellCategory>> },
      Record<string, never>
    >;
    adminUpsellMasterProducts?: GraphCacheUpdateResolver<
      { adminUpsellMasterProducts: Array<WithTypename<AdminUpsellMasterProduct>> },
      QueryAdminUpsellMasterProductsArgs
    >;
    availableCustomerSupportPoints?: GraphCacheUpdateResolver<
      { availableCustomerSupportPoints: WithTypename<AvailableCustomerSupportPointsResponseUnion> },
      Record<string, never>
    >;
    availablePromotions?: GraphCacheUpdateResolver<
      { availablePromotions: WithTypename<AvailablePromotionsResponseUnion> },
      Record<string, never>
    >;
    baseProduct?: GraphCacheUpdateResolver<
      { baseProduct: Maybe<WithTypename<BaseProduct>> },
      QueryBaseProductArgs
    >;
    canCancel?: GraphCacheUpdateResolver<
      { canCancel: Array<WithTypename<CanCancelResponseUnion>> },
      QueryCanCancelArgs
    >;
    canCancelV2?: GraphCacheUpdateResolver<
      { canCancelV2: Array<WithTypename<CanCancelResponseUnion>> },
      QueryCanCancelV2Args
    >;
    cart?: GraphCacheUpdateResolver<{ cart: Maybe<WithTypename<Order>> }, Record<string, never>>;
    categoryUpsells?: GraphCacheUpdateResolver<
      { categoryUpsells: Array<WithTypename<UpsellCategory>> },
      QueryCategoryUpsellsArgs
    >;
    cateringOrders?: GraphCacheUpdateResolver<
      { cateringOrders: WithTypename<CateringOrdersResponse> },
      QueryCateringOrdersArgs
    >;
    challengeCelebration?: GraphCacheUpdateResolver<
      { challengeCelebration: Maybe<WithTypename<ChallengeCelebration>> },
      Record<string, never>
    >;
    challengeCelebrationV2?: GraphCacheUpdateResolver<
      { challengeCelebrationV2: Maybe<WithTypename<ChallengeCelebrationV2>> },
      Record<string, never>
    >;
    challengeRewards?: GraphCacheUpdateResolver<
      { challengeRewards: Array<WithTypename<ChallengeReward>> },
      Record<string, never>
    >;
    challenges?: GraphCacheUpdateResolver<
      { challenges: Array<WithTypename<Challenge>> },
      Record<string, never>
    >;
    chatToken?: GraphCacheUpdateResolver<
      { chatToken: Maybe<WithTypename<ChatToken>> },
      Record<string, never>
    >;
    currentCustomer?: GraphCacheUpdateResolver<
      { currentCustomer: Maybe<WithTypename<Customer>> },
      Record<string, never>
    >;
    customerExists?: GraphCacheUpdateResolver<
      { customerExists: Scalars['Boolean']['output'] },
      QueryCustomerExistsArgs
    >;
    customerPass?: GraphCacheUpdateResolver<
      { customerPass: Maybe<WithTypename<CustomerPass>> },
      Record<string, never>
    >;
    customerPaymentInfo?: GraphCacheUpdateResolver<
      { customerPaymentInfo: WithTypename<CustomerPaymentInfo> },
      Record<string, never>
    >;
    customerPointsForCustomerSupport?: GraphCacheUpdateResolver<
      {
        customerPointsForCustomerSupport: WithTypename<CustomerPointsForCustomerSupportResponseUnion>;
      },
      QueryCustomerPointsForCustomerSupportArgs
    >;
    customerSupportCredits?: GraphCacheUpdateResolver<
      { customerSupportCredits: WithTypename<CustomerSupportCreditsResponseUnion> },
      Record<string, never>
    >;
    favoritedLineItems?: GraphCacheUpdateResolver<
      { favoritedLineItems: Array<WithTypename<LineItem>> },
      QueryFavoritedLineItemsArgs
    >;
    feedbackQuestions?: GraphCacheUpdateResolver<
      { feedbackQuestions: Array<WithTypename<FeedbackQuestion>> },
      QueryFeedbackQuestionsArgs
    >;
    fetchPlansByTierId?: GraphCacheUpdateResolver<
      { fetchPlansByTierId: Maybe<Array<WithTypename<PaymentPlan>>> },
      QueryFetchPlansByTierIdArgs
    >;
    flexCustomerData?: GraphCacheUpdateResolver<
      { flexCustomerData: Maybe<WithTypename<FlexCustomerDataResponseUnion>> },
      Record<string, never>
    >;
    getKioskPaymentsForCurrentDate?: GraphCacheUpdateResolver<
      { getKioskPaymentsForCurrentDate: WithTypename<GetKioskPaymentsForCurrentDateResponse> },
      QueryGetKioskPaymentsForCurrentDateArgs
    >;
    getKioskReaderLocationId?: GraphCacheUpdateResolver<
      { getKioskReaderLocationId: Maybe<WithTypename<GetKioskReaderLocationIdResponse>> },
      QueryGetKioskReaderLocationIdArgs
    >;
    getKioskReaderLocationIdByEntityId?: GraphCacheUpdateResolver<
      { getKioskReaderLocationIdByEntityId: Maybe<WithTypename<GetKioskReaderLocationIdResponse>> },
      QueryGetKioskReaderLocationIdByEntityIdArgs
    >;
    getKioskReaderLocationIdByRestaurantId?: GraphCacheUpdateResolver<
      {
        getKioskReaderLocationIdByRestaurantId: Maybe<
          WithTypename<GetKioskReaderLocationIdResponse>
        >;
      },
      QueryGetKioskReaderLocationIdByRestaurantIdArgs
    >;
    getOrderPaymentState?: GraphCacheUpdateResolver<
      { getOrderPaymentState: Maybe<WithTypename<OrderPaymentState>> },
      QueryGetOrderPaymentStateArgs
    >;
    getOrderStatusNotificationPreferences?: GraphCacheUpdateResolver<
      { getOrderStatusNotificationPreferences: WithTypename<NotificationCategory> },
      Record<string, never>
    >;
    getPreferences?: GraphCacheUpdateResolver<
      { getPreferences: WithTypename<CustomerPreference> },
      Record<string, never>
    >;
    getSubscriptions?: GraphCacheUpdateResolver<
      { getSubscriptions: Array<WithTypename<PaymentSubscription>> },
      QueryGetSubscriptionsArgs
    >;
    getUserNotificationPreferences?: GraphCacheUpdateResolver<
      { getUserNotificationPreferences: WithTypename<UserNotificationPreferencesUnion> },
      Record<string, never>
    >;
    giftCardBalance?: GraphCacheUpdateResolver<
      { giftCardBalance: WithTypename<GiftCardBalanceResponseUnion> },
      Record<string, never>
    >;
    giftCardOrderDetail?: GraphCacheUpdateResolver<
      { giftCardOrderDetail: WithTypename<GiftCardOrderDetailResponseUnion> },
      QueryGiftCardOrderDetailArgs
    >;
    giftCardPurchaseHistory?: GraphCacheUpdateResolver<
      { giftCardPurchaseHistory: WithTypename<GiftCardPurchaseHistory> },
      Record<string, never>
    >;
    giftCardRedemptionDetail?: GraphCacheUpdateResolver<
      { giftCardRedemptionDetail: WithTypename<GiftCardRedemptionDetailResponseUnion> },
      QueryGiftCardRedemptionDetailArgs
    >;
    hasUnseenChallenges?: GraphCacheUpdateResolver<
      { hasUnseenChallenges: WithTypename<HasUnseenChallenges> },
      Record<string, never>
    >;
    inFlightDeliveryOrder?: GraphCacheUpdateResolver<
      { inFlightDeliveryOrder: Maybe<WithTypename<Order>> },
      Record<string, never>
    >;
    inStoreFeedbackQuestions?: GraphCacheUpdateResolver<
      { inStoreFeedbackQuestions: Array<WithTypename<FeedbackQuestion>> },
      QueryInStoreFeedbackQuestionsArgs
    >;
    inStoreLoyaltyOrder?: GraphCacheUpdateResolver<
      { inStoreLoyaltyOrder: Maybe<WithTypename<InStoreOrder>> },
      QueryInStoreLoyaltyOrderArgs
    >;
    inStoreLoyaltyOrders?: GraphCacheUpdateResolver<
      { inStoreLoyaltyOrders: WithTypename<InStoreOrdersResponse> },
      QueryInStoreLoyaltyOrdersArgs
    >;
    inStoreOrderLastPendingFeedback?: GraphCacheUpdateResolver<
      { inStoreOrderLastPendingFeedback: Maybe<WithTypename<InStoreOrder>> },
      Record<string, never>
    >;
    inStorePaymentMethods?: GraphCacheUpdateResolver<
      { inStorePaymentMethods: Array<WithTypename<Credit>> },
      Record<string, never>
    >;
    kioskCustomerProfile?: GraphCacheUpdateResolver<
      { kioskCustomerProfile: Maybe<WithTypename<KioskCustomerProfile>> },
      QueryKioskCustomerProfileArgs
    >;
    kioskCustomerScanPaymentInfo?: GraphCacheUpdateResolver<
      { kioskCustomerScanPaymentInfo: WithTypename<KioskCustomerScanPaymentInfoResponse> },
      QueryKioskCustomerScanPaymentInfoArgs
    >;
    kustomerToken?: GraphCacheUpdateResolver<
      { kustomerToken: Maybe<WithTypename<Kustomer>> },
      Record<string, never>
    >;
    lineItem?: GraphCacheUpdateResolver<
      { lineItem: Maybe<WithTypename<LineItemResponseUnion>> },
      QueryLineItemArgs
    >;
    lineItemBySlug?: GraphCacheUpdateResolver<
      { lineItemBySlug: Maybe<WithTypename<LineItemResponseUnion>> },
      QueryLineItemBySlugArgs
    >;
    lineItemRecommendations?: GraphCacheUpdateResolver<
      { lineItemRecommendations: Array<WithTypename<LineItemRecommendation>> },
      Record<string, never>
    >;
    locationByAddress?: GraphCacheUpdateResolver<
      { locationByAddress: WithTypename<LocationByAddressResponseUnion> },
      QueryLocationByAddressArgs
    >;
    locationByAddressId?: GraphCacheUpdateResolver<
      { locationByAddressId: WithTypename<LocationByAddressResponseUnion> },
      QueryLocationByAddressIdArgs
    >;
    locationByAddressV2?: GraphCacheUpdateResolver<
      { locationByAddressV2: WithTypename<LocationByAddressResponseUnion> },
      QueryLocationByAddressV2Args
    >;
    loyaltyProfile?: GraphCacheUpdateResolver<
      { loyaltyProfile: Maybe<WithTypename<LoyaltyProfile>> },
      Record<string, never>
    >;
    loyaltyProfileByLoyaltyId?: GraphCacheUpdateResolver<
      { loyaltyProfileByLoyaltyId: WithTypename<LoyaltyProfile> },
      QueryLoyaltyProfileByLoyaltyIdArgs
    >;
    loyaltyProfileWithLoyalty?: GraphCacheUpdateResolver<
      { loyaltyProfileWithLoyalty: WithTypename<LoyaltyProfile> },
      QueryLoyaltyProfileWithLoyaltyArgs
    >;
    menuCollection?: GraphCacheUpdateResolver<
      { menuCollection: WithTypename<MenuCollection> },
      QueryMenuCollectionArgs
    >;
    menuCollections?: GraphCacheUpdateResolver<
      { menuCollections: Array<WithTypename<MenuCollection>> },
      QueryMenuCollectionsArgs
    >;
    multipartyOrderPreview?: GraphCacheUpdateResolver<
      { multipartyOrderPreview: WithTypename<MultipartyOrderPreviewResponseUnion> },
      QueryMultipartyOrderPreviewArgs
    >;
    order?: GraphCacheUpdateResolver<{ order: WithTypename<Order> }, QueryOrderArgs>;
    orderLastPendingFeedback?: GraphCacheUpdateResolver<
      { orderLastPendingFeedback: Maybe<WithTypename<Order>> },
      Record<string, never>
    >;
    orderPaymentState?: GraphCacheUpdateResolver<
      { orderPaymentState: Maybe<WithTypename<OrderPaymentState>> },
      QueryOrderPaymentStateArgs
    >;
    orderStatus?: GraphCacheUpdateResolver<
      { orderStatus: Maybe<WithTypename<OrderStatusResponseUnion>> },
      QueryOrderStatusArgs
    >;
    orders?: GraphCacheUpdateResolver<
      { orders: WithTypename<OrdersResponseUnion> },
      QueryOrdersArgs
    >;
    ordersV2?: GraphCacheUpdateResolver<
      { ordersV2: WithTypename<OrdersResponseUnion> },
      QueryOrdersV2Args
    >;
    paymentMethodCards?: GraphCacheUpdateResolver<
      { paymentMethodCards: Array<WithTypename<PaymentMethodCardUnion>> },
      Record<string, never>
    >;
    paymentProfile?: GraphCacheUpdateResolver<
      { paymentProfile: Maybe<WithTypename<PaymentProfile>> },
      Record<string, never>
    >;
    paymentSubscriptionProfile?: GraphCacheUpdateResolver<
      { paymentSubscriptionProfile: Maybe<WithTypename<PaymentSubscriptionProfile>> },
      Record<string, never>
    >;
    personalizedUpsells?: GraphCacheUpdateResolver<
      { personalizedUpsells: WithTypename<PersonalizedUpsellsResponseUnion> },
      QueryPersonalizedUpsellsArgs
    >;
    pointHistoryForUser?: GraphCacheUpdateResolver<
      { pointHistoryForUser: WithTypename<PointHistoryForUserResponseUnion> },
      QueryPointHistoryForUserArgs
    >;
    product?: GraphCacheUpdateResolver<{ product: WithTypename<Product> }, QueryProductArgs>;
    productForRestaurant?: GraphCacheUpdateResolver<
      { productForRestaurant: Maybe<WithTypename<Product>> },
      QueryProductForRestaurantArgs
    >;
    productForRestaurantByLineageKey?: GraphCacheUpdateResolver<
      { productForRestaurantByLineageKey: Maybe<WithTypename<Product>> },
      QueryProductForRestaurantByLineageKeyArgs
    >;
    receipt?: GraphCacheUpdateResolver<
      { receipt: Maybe<WithTypename<ReceiptResponse>> },
      QueryReceiptArgs
    >;
    restaurant?: GraphCacheUpdateResolver<
      { restaurant: Maybe<WithTypename<Restaurant>> },
      QueryRestaurantArgs
    >;
    restaurantCapacity?: GraphCacheUpdateResolver<
      { restaurantCapacity: WithTypename<RestaurantCapacity> },
      QueryRestaurantCapacityArgs
    >;
    restaurantDeliveryChannels?: GraphCacheUpdateResolver<
      { restaurantDeliveryChannels: WithTypename<RestaurantDeliveryChannels> },
      QueryRestaurantDeliveryChannelsArgs
    >;
    restaurantEntityIds?: GraphCacheUpdateResolver<
      { restaurantEntityIds: Array<Scalars['ID']['output']> },
      Record<string, never>
    >;
    restaurantIdByEntityId?: GraphCacheUpdateResolver<
      { restaurantIdByEntityId: Maybe<Scalars['ID']['output']> },
      QueryRestaurantIdByEntityIdArgs
    >;
    restaurantThrottle?: GraphCacheUpdateResolver<
      { restaurantThrottle: WithTypename<RestaurantThrottle> },
      QueryRestaurantThrottleArgs
    >;
    restaurantsByLocation?: GraphCacheUpdateResolver<
      { restaurantsByLocation: Array<WithTypename<Restaurant>> },
      QueryRestaurantsByLocationArgs
    >;
    restaurantsByRegion?: GraphCacheUpdateResolver<
      { restaurantsByRegion: Array<WithTypename<Restaurant>> },
      QueryRestaurantsByRegionArgs
    >;
    restaurantsForAdmin?: GraphCacheUpdateResolver<
      { restaurantsForAdmin: Array<WithTypename<Restaurant>> },
      QueryRestaurantsForAdminArgs
    >;
    rewards?: GraphCacheUpdateResolver<
      { rewards: Array<WithTypename<Reward>> },
      Record<string, never>
    >;
    searchRestaurants?: GraphCacheUpdateResolver<
      { searchRestaurants: Array<WithTypename<Restaurant>> },
      QuerySearchRestaurantsArgs
    >;
    session?: GraphCacheUpdateResolver<{ session: WithTypename<Session> }, Record<string, never>>;
    subscriptionPlanById?: GraphCacheUpdateResolver<
      { subscriptionPlanById: Maybe<WithTypename<SubscriptionPlan>> },
      QuerySubscriptionPlanByIdArgs
    >;
    subscriptionPlansByIds?: GraphCacheUpdateResolver<
      { subscriptionPlansByIds: Maybe<Array<WithTypename<SubscriptionPlan>>> },
      QuerySubscriptionPlansByIdsArgs
    >;
  };
  Mutation?: {
    addAddress?: GraphCacheUpdateResolver<
      { addAddress: WithTypename<AddAddressResponseUnion> },
      MutationAddAddressArgs
    >;
    addAddressV2?: GraphCacheUpdateResolver<
      { addAddressV2: WithTypename<AddAddressResponseUnion> },
      MutationAddAddressV2Args
    >;
    addLineItemBatchToCart?: GraphCacheUpdateResolver<
      { addLineItemBatchToCart: WithTypename<AddLineItemToCartResponseUnion> },
      MutationAddLineItemBatchToCartArgs
    >;
    addLineItemToCart?: GraphCacheUpdateResolver<
      { addLineItemToCart: WithTypename<AddLineItemToCartResponseUnion> },
      MutationAddLineItemToCartArgs
    >;
    addLineItemToCartWithLoyalty?: GraphCacheUpdateResolver<
      { addLineItemToCartWithLoyalty: WithTypename<AddLineItemToCartResponseUnion> },
      MutationAddLineItemToCartWithLoyaltyArgs
    >;
    anonymizeCustomer?: GraphCacheUpdateResolver<
      { anonymizeCustomer: Scalars['Boolean']['output'] },
      MutationAnonymizeCustomerArgs
    >;
    applyAdminPrintPriorityTemplate?: GraphCacheUpdateResolver<
      { applyAdminPrintPriorityTemplate: WithTypename<AdminPrintPriorityTemplate> },
      MutationApplyAdminPrintPriorityTemplateArgs
    >;
    applyReward?: GraphCacheUpdateResolver<
      { applyReward: WithTypename<ApplyRewardResponseUnion> },
      MutationApplyRewardArgs
    >;
    applyRewardByLoyaltyId?: GraphCacheUpdateResolver<
      { applyRewardByLoyaltyId: WithTypename<ApplyRewardResponseUnion> },
      MutationApplyRewardByLoyaltyIdArgs
    >;
    applyRewardWithLoyalty?: GraphCacheUpdateResolver<
      { applyRewardWithLoyalty: WithTypename<ApplyRewardResponseUnion> },
      MutationApplyRewardWithLoyaltyArgs
    >;
    cancelOrder?: GraphCacheUpdateResolver<
      { cancelOrder: WithTypename<CancelOrderResponseUnion> },
      MutationCancelOrderArgs
    >;
    cancelOrderExternal?: GraphCacheUpdateResolver<
      { cancelOrderExternal: WithTypename<CancelOrderExternalResponseUnion> },
      MutationCancelOrderExternalArgs
    >;
    cancelOrderPaymentIntent?: GraphCacheUpdateResolver<
      { cancelOrderPaymentIntent: WithTypename<CancelOrderPaymentIntentResponse> },
      MutationCancelOrderPaymentIntentArgs
    >;
    cancelOrderV2?: GraphCacheUpdateResolver<
      { cancelOrderV2: WithTypename<CancelOrderResponseUnion> },
      MutationCancelOrderV2Args
    >;
    challengeOptIn?: GraphCacheUpdateResolver<
      { challengeOptIn: WithTypename<Challenge> },
      MutationChallengeOptInArgs
    >;
    challengeOptInV2?: GraphCacheUpdateResolver<
      { challengeOptInV2: WithTypename<ChallengeOptInResultUnion> },
      MutationChallengeOptInV2Args
    >;
    claimLoyaltyPromotion?: GraphCacheUpdateResolver<
      { claimLoyaltyPromotion: WithTypename<ClaimLoyaltyPromotionResponseUnion> },
      MutationClaimLoyaltyPromotionArgs
    >;
    convertToMultipartyOrder?: GraphCacheUpdateResolver<
      { convertToMultipartyOrder: WithTypename<ConvertToMultipartyOrderResponseUnion> },
      MutationConvertToMultipartyOrderArgs
    >;
    createAccount?: GraphCacheUpdateResolver<
      { createAccount: WithTypename<CreateAccountResponseUnion> },
      MutationCreateAccountArgs
    >;
    createAdminPrintPriorityTemplate?: GraphCacheUpdateResolver<
      { createAdminPrintPriorityTemplate: WithTypename<AdminPrintPriorityTemplate> },
      MutationCreateAdminPrintPriorityTemplateArgs
    >;
    createAdminUpsellCategory?: GraphCacheUpdateResolver<
      { createAdminUpsellCategory: WithTypename<AdminUpsellCategory> },
      MutationCreateAdminUpsellCategoryArgs
    >;
    createAndSubmitPrepaidOrder?: GraphCacheUpdateResolver<
      { createAndSubmitPrepaidOrder: WithTypename<SubmitOrderWithPaymentMethodResponseUnion> },
      MutationCreateAndSubmitPrepaidOrderArgs
    >;
    createConnectionToken?: GraphCacheUpdateResolver<
      { createConnectionToken: WithTypename<CreateConnectionTokenResponse> },
      Record<string, never>
    >;
    createFlexOnboardingSession?: GraphCacheUpdateResolver<
      { createFlexOnboardingSession: WithTypename<FlexOnboardingSessionResponseUnion> },
      MutationCreateFlexOnboardingSessionArgs
    >;
    createGiftCardPaymentIntent?: GraphCacheUpdateResolver<
      { createGiftCardPaymentIntent: WithTypename<PaymentIntent> },
      MutationCreateGiftCardPaymentIntentArgs
    >;
    createKioskReaderLocation?: GraphCacheUpdateResolver<
      { createKioskReaderLocation: WithTypename<CreateKioskReaderLocationIdResponse> },
      MutationCreateKioskReaderLocationArgs
    >;
    createKioskReaderLocationWithIds?: GraphCacheUpdateResolver<
      { createKioskReaderLocationWithIds: WithTypename<CreateKioskReaderLocationIdResponse> },
      MutationCreateKioskReaderLocationWithIdsArgs
    >;
    createOrder?: GraphCacheUpdateResolver<
      { createOrder: WithTypename<CreateOrderResponseUnion> },
      MutationCreateOrderArgs
    >;
    createOrderPaymentIntent?: GraphCacheUpdateResolver<
      { createOrderPaymentIntent: WithTypename<PaymentIntent> },
      MutationCreateOrderPaymentIntentArgs
    >;
    createPaymentIntent?: GraphCacheUpdateResolver<
      { createPaymentIntent: Scalars['String']['output'] },
      Record<string, never>
    >;
    createPaymentSubscriptionProfile?: GraphCacheUpdateResolver<
      { createPaymentSubscriptionProfile: WithTypename<PaymentSubscriptionProfile> },
      Record<string, never>
    >;
    createSetupPaymentIntent?: GraphCacheUpdateResolver<
      { createSetupPaymentIntent: WithTypename<CreateSetupIntent> },
      Record<string, never>
    >;
    deleteAddress?: GraphCacheUpdateResolver<
      { deleteAddress: WithTypename<DeleteAddressResponseUnion> },
      MutationDeleteAddressArgs
    >;
    deleteAdminPrintPriorityTemplate?: GraphCacheUpdateResolver<
      { deleteAdminPrintPriorityTemplate: WithTypename<DeleteAdminPrintPriorityTemplateResponse> },
      MutationDeleteAdminPrintPriorityTemplateArgs
    >;
    deleteAdminUpsellCategory?: GraphCacheUpdateResolver<
      { deleteAdminUpsellCategory: WithTypename<DeleteAdminUpsellCategoryResponse> },
      MutationDeleteAdminUpsellCategoryArgs
    >;
    deletePaymentMethodCard?: GraphCacheUpdateResolver<
      { deletePaymentMethodCard: WithTypename<PaymentMethodCard> },
      MutationDeletePaymentMethodCardArgs
    >;
    editLineItemInCart?: GraphCacheUpdateResolver<
      { editLineItemInCart: WithTypename<EditLineItemInCartResponseUnion> },
      MutationEditLineItemInCartArgs
    >;
    editLineItemInCartWithLoyalty?: GraphCacheUpdateResolver<
      { editLineItemInCartWithLoyalty: WithTypename<EditLineItemInCartResponseUnion> },
      MutationEditLineItemInCartWithLoyaltyArgs
    >;
    eightySixIngredient?: GraphCacheUpdateResolver<
      { eightySixIngredient: WithTypename<EightySixResponse> },
      MutationEightySixIngredientArgs
    >;
    eightySixProduct?: GraphCacheUpdateResolver<
      { eightySixProduct: WithTypename<EightySixResponse> },
      MutationEightySixProductArgs
    >;
    favoriteLineItem?: GraphCacheUpdateResolver<
      { favoriteLineItem: WithTypename<LineItem> },
      MutationFavoriteLineItemArgs
    >;
    handoffCart?: GraphCacheUpdateResolver<
      { handoffCart: WithTypename<ReorderResponseUnion> },
      MutationHandoffCartArgs
    >;
    identifyAndClaimInStoreOrder?: GraphCacheUpdateResolver<
      { identifyAndClaimInStoreOrder: WithTypename<IdentifyAndClaimInStoreOrderResponseUnion> },
      MutationIdentifyAndClaimInStoreOrderArgs
    >;
    issueCustomerSupportCredit?: GraphCacheUpdateResolver<
      { issueCustomerSupportCredit: WithTypename<IssueCustomerSupportCreditResult> },
      MutationIssueCustomerSupportCreditArgs
    >;
    issueCustomerSupportPoints?: GraphCacheUpdateResolver<
      { issueCustomerSupportPoints: WithTypename<IssueCustomerSupportPointsResponse> },
      MutationIssueCustomerSupportPointsArgs
    >;
    joinMultipartyOrder?: GraphCacheUpdateResolver<
      { joinMultipartyOrder: WithTypename<JoinMultipartyOrderResponseUnion> },
      MutationJoinMultipartyOrderArgs
    >;
    leaveMultipartyOrder?: GraphCacheUpdateResolver<
      { leaveMultipartyOrder: WithTypename<LeaveMultipartyOrderResponseUnion> },
      Record<string, never>
    >;
    lockOrder?: GraphCacheUpdateResolver<
      { lockOrder: WithTypename<LockOrderResponseUnion> },
      MutationLockOrderArgs
    >;
    logout?: GraphCacheUpdateResolver<
      { logout: WithTypename<LogoutResponseUnion> },
      MutationLogoutArgs
    >;
    optInFreeTierV2?: GraphCacheUpdateResolver<
      { optInFreeTierV2: Maybe<WithTypename<LoyaltyProfile>> },
      Record<string, never>
    >;
    optInLoyalty?: GraphCacheUpdateResolver<
      { optInLoyalty: Maybe<WithTypename<LoyaltyProfile>> },
      Record<string, never>
    >;
    optOutLoyalty?: GraphCacheUpdateResolver<
      { optOutLoyalty: WithTypename<OptOutLoyaltyResponseUnion> },
      Record<string, never>
    >;
    optOutLoyaltyForCustomer?: GraphCacheUpdateResolver<
      { optOutLoyaltyForCustomer: WithTypename<OptOutLoyaltyForCustomerResponseUnion> },
      MutationOptOutLoyaltyForCustomerArgs
    >;
    redeemGiftCard?: GraphCacheUpdateResolver<
      { redeemGiftCard: WithTypename<RedeemGiftCardResponseUnion> },
      MutationRedeemGiftCardArgs
    >;
    refundKioskPayment?: GraphCacheUpdateResolver<
      { refundKioskPayment: WithTypename<RefundKioskPaymentResponse> },
      MutationRefundKioskPaymentArgs
    >;
    refundKioskPaymentV2?: GraphCacheUpdateResolver<
      { refundKioskPaymentV2: WithTypename<RefundKioskPaymentResponseUnion> },
      MutationRefundKioskPaymentV2Args
    >;
    registerGuest?: GraphCacheUpdateResolver<
      { registerGuest: Maybe<WithTypename<RegisterGuestResponseUnion>> },
      MutationRegisterGuestArgs
    >;
    removeFromCart?: GraphCacheUpdateResolver<
      { removeFromCart: WithTypename<RemoveFromCartResponseUnion> },
      MutationRemoveFromCartArgs
    >;
    removeFromCartWithLoyalty?: GraphCacheUpdateResolver<
      { removeFromCartWithLoyalty: WithTypename<RemoveFromCartResponseUnion> },
      MutationRemoveFromCartWithLoyaltyArgs
    >;
    removeReward?: GraphCacheUpdateResolver<
      { removeReward: WithTypename<RemoveRewardResponseUnion> },
      MutationRemoveRewardArgs
    >;
    removeRewardByLoyaltyId?: GraphCacheUpdateResolver<
      { removeRewardByLoyaltyId: WithTypename<RemoveRewardResponseUnion> },
      MutationRemoveRewardByLoyaltyIdArgs
    >;
    removeRewardWithLoyalty?: GraphCacheUpdateResolver<
      { removeRewardWithLoyalty: WithTypename<RemoveRewardResponseUnion> },
      MutationRemoveRewardWithLoyaltyArgs
    >;
    removeSubscriptionPaymentMethod?: GraphCacheUpdateResolver<
      {
        removeSubscriptionPaymentMethod: WithTypename<DeleteSubscriptionPaymentMethodResponseUnion>;
      },
      MutationRemoveSubscriptionPaymentMethodArgs
    >;
    renameAdminUpsellCategory?: GraphCacheUpdateResolver<
      { renameAdminUpsellCategory: WithTypename<AdminUpsellCategory> },
      MutationRenameAdminUpsellCategoryArgs
    >;
    reorderLineItem?: GraphCacheUpdateResolver<
      { reorderLineItem: WithTypename<ReorderResponseUnion> },
      MutationReorderLineItemArgs
    >;
    reorderOrder?: GraphCacheUpdateResolver<
      { reorderOrder: WithTypename<ReorderResponseUnion> },
      MutationReorderOrderArgs
    >;
    requestAccountDeletion?: GraphCacheUpdateResolver<
      { requestAccountDeletion: Maybe<WithTypename<RequestAccountDeletionResponseUnion>> },
      Record<string, never>
    >;
    saveFeedbackCase?: GraphCacheUpdateResolver<
      { saveFeedbackCase: WithTypename<FeedbackSuccess> },
      MutationSaveFeedbackCaseArgs
    >;
    sendKioskRefundReceipt?: GraphCacheUpdateResolver<
      { sendKioskRefundReceipt: Scalars['Boolean']['output'] },
      MutationSendKioskRefundReceiptArgs
    >;
    setDefaultPaymentMethod?: GraphCacheUpdateResolver<
      { setDefaultPaymentMethod: WithTypename<PaymentProfile> },
      MutationSetDefaultPaymentMethodArgs
    >;
    setUserNotificationPreferences?: GraphCacheUpdateResolver<
      { setUserNotificationPreferences: WithTypename<UserNotificationPreferencesUnion> },
      MutationSetUserNotificationPreferencesArgs
    >;
    signIn?: GraphCacheUpdateResolver<
      { signIn: WithTypename<SignInResponseUnion> },
      Record<string, never>
    >;
    submitFeedback?: GraphCacheUpdateResolver<
      { submitFeedback: WithTypename<FeedbackSuccess> },
      MutationSubmitFeedbackArgs
    >;
    submitGiftCardOrderUsingPaymentMethod?: GraphCacheUpdateResolver<
      {
        submitGiftCardOrderUsingPaymentMethod: WithTypename<SubmitGiftCardOrderUsingPaymentMethodResponseUnion>;
      },
      MutationSubmitGiftCardOrderUsingPaymentMethodArgs
    >;
    submitInStoreFeedback?: GraphCacheUpdateResolver<
      { submitInStoreFeedback: WithTypename<FeedbackSuccess> },
      MutationSubmitInStoreFeedbackArgs
    >;
    submitOrderAsPayInStoreASAP?: GraphCacheUpdateResolver<
      { submitOrderAsPayInStoreASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion> },
      MutationSubmitOrderAsPayInStoreAsapArgs
    >;
    submitOrderAsPrepaidASAP?: GraphCacheUpdateResolver<
      { submitOrderAsPrepaidASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion> },
      MutationSubmitOrderAsPrepaidAsapArgs
    >;
    submitOrderUsingPaymentIntentASAP?: GraphCacheUpdateResolver<
      {
        submitOrderUsingPaymentIntentASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion>;
      },
      MutationSubmitOrderUsingPaymentIntentAsapArgs
    >;
    submitOrderUsingPaymentMethod?: GraphCacheUpdateResolver<
      { submitOrderUsingPaymentMethod: WithTypename<SubmitOrderUsingPaymentMethodResponseUnion> },
      MutationSubmitOrderUsingPaymentMethodArgs
    >;
    submitOrderWithLoyaltyAsPrepaidASAP?: GraphCacheUpdateResolver<
      {
        submitOrderWithLoyaltyAsPrepaidASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion>;
      },
      MutationSubmitOrderWithLoyaltyAsPrepaidAsapArgs
    >;
    submitOrderWithLoyaltyAsPrepaidInStoreASAP?: GraphCacheUpdateResolver<
      {
        submitOrderWithLoyaltyAsPrepaidInStoreASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion>;
      },
      MutationSubmitOrderWithLoyaltyAsPrepaidInStoreAsapArgs
    >;
    submitOrderWithLoyaltyUsingPaymentMethodASAP?: GraphCacheUpdateResolver<
      {
        submitOrderWithLoyaltyUsingPaymentMethodASAP: WithTypename<SubmitOrderWithPaymentMethodResponseUnion>;
      },
      MutationSubmitOrderWithLoyaltyUsingPaymentMethodAsapArgs
    >;
    submitOrderWithPaymentMethod?: GraphCacheUpdateResolver<
      { submitOrderWithPaymentMethod: WithTypename<SubmitOrderWithPaymentMethodResponseUnion> },
      MutationSubmitOrderWithPaymentMethodArgs
    >;
    submitPromoCode?: GraphCacheUpdateResolver<
      { submitPromoCode: WithTypename<SubmitPromoCodeResponseUnion> },
      MutationSubmitPromoCodeArgs
    >;
    submitPromoOrGiftCardCode?: GraphCacheUpdateResolver<
      { submitPromoOrGiftCardCode: WithTypename<SubmitPromoCodeOrGiftCardResponseUnion> },
      MutationSubmitPromoOrGiftCardCodeArgs
    >;
    submitZeroTotalOrderWithLoyaltyASAP?: GraphCacheUpdateResolver<
      {
        submitZeroTotalOrderWithLoyaltyASAP: WithTypename<SubmitZeroTotalOrderWithLoyaltyResponseUnion>;
      },
      MutationSubmitZeroTotalOrderWithLoyaltyAsapArgs
    >;
    syncLocation?: GraphCacheUpdateResolver<
      { syncLocation: WithTypename<SyncLocationResult> },
      MutationSyncLocationArgs
    >;
    unlockOrder?: GraphCacheUpdateResolver<
      { unlockOrder: WithTypename<UnlockOrderResponseUnion> },
      Record<string, never>
    >;
    updateAddress?: GraphCacheUpdateResolver<
      { updateAddress: WithTypename<UpdateAddressResponseUnion> },
      MutationUpdateAddressArgs
    >;
    updateAddressV2?: GraphCacheUpdateResolver<
      { updateAddressV2: WithTypename<UpdateAddressResponseUnion> },
      MutationUpdateAddressV2Args
    >;
    updateAdminGroupOrderSettings?: GraphCacheUpdateResolver<
      { updateAdminGroupOrderSettings: WithTypename<AdminGroupOrderSettings> },
      MutationUpdateAdminGroupOrderSettingsArgs
    >;
    updateAdminPrintPriorityTemplate?: GraphCacheUpdateResolver<
      { updateAdminPrintPriorityTemplate: WithTypename<AdminPrintPriorityTemplate> },
      MutationUpdateAdminPrintPriorityTemplateArgs
    >;
    updateAdminProductUpsells?: GraphCacheUpdateResolver<
      { updateAdminProductUpsells: Array<WithTypename<AdminUpsellMasterProduct>> },
      MutationUpdateAdminProductUpsellsArgs
    >;
    updateAdminRestaurantEnabled?: GraphCacheUpdateResolver<
      { updateAdminRestaurantEnabled: WithTypename<AdminRestaurantSettings> },
      MutationUpdateAdminRestaurantEnabledArgs
    >;
    updateAdminRestaurantIngredientDates?: GraphCacheUpdateResolver<
      {
        updateAdminRestaurantIngredientDates: WithTypename<UpdateAdminRestaurantAvailabilityResponse>;
      },
      MutationUpdateAdminRestaurantIngredientDatesArgs
    >;
    updateAdminRestaurantIngredientStock?: GraphCacheUpdateResolver<
      {
        updateAdminRestaurantIngredientStock: WithTypename<UpdateAdminRestaurantAvailabilityResponse>;
      },
      MutationUpdateAdminRestaurantIngredientStockArgs
    >;
    updateAdminRestaurantMenuProductDates?: GraphCacheUpdateResolver<
      {
        updateAdminRestaurantMenuProductDates: WithTypename<UpdateAdminRestaurantAvailabilityResponse>;
      },
      MutationUpdateAdminRestaurantMenuProductDatesArgs
    >;
    updateAdminRestaurantMenuProductStock?: GraphCacheUpdateResolver<
      {
        updateAdminRestaurantMenuProductStock: WithTypename<UpdateAdminRestaurantAvailabilityResponse>;
      },
      MutationUpdateAdminRestaurantMenuProductStockArgs
    >;
    updateAdminRestaurantOrdering?: GraphCacheUpdateResolver<
      { updateAdminRestaurantOrdering: WithTypename<AdminRestaurantSettings> },
      MutationUpdateAdminRestaurantOrderingArgs
    >;
    updateAdminRestaurantProfile?: GraphCacheUpdateResolver<
      { updateAdminRestaurantProfile: WithTypename<AdminRestaurantSettings> },
      MutationUpdateAdminRestaurantProfileArgs
    >;
    updateAdminUpsellCategoryArrangement?: GraphCacheUpdateResolver<
      { updateAdminUpsellCategoryArrangement: Array<WithTypename<AdminUpsellCategory>> },
      MutationUpdateAdminUpsellCategoryArrangementArgs
    >;
    updateCustomer?: GraphCacheUpdateResolver<
      { updateCustomer: Maybe<WithTypename<UpdateCustomerResponse>> },
      MutationUpdateCustomerArgs
    >;
    updateKioskCustomer?: GraphCacheUpdateResolver<
      { updateKioskCustomer: Maybe<WithTypename<UpdateKioskCustomerResponse>> },
      MutationUpdateKioskCustomerArgs
    >;
    updatePaymentMethod?: GraphCacheUpdateResolver<
      { updatePaymentMethod: WithTypename<PaymentMethodCard> },
      MutationUpdatePaymentMethodArgs
    >;
    updatePreferences?: GraphCacheUpdateResolver<
      { updatePreferences: WithTypename<UpdateCustomerPreferencesUnion> },
      MutationUpdatePreferencesArgs
    >;
    updateRestaurantDeliveryChannels?: GraphCacheUpdateResolver<
      { updateRestaurantDeliveryChannels: WithTypename<RestaurantDeliveryChannels> },
      MutationUpdateRestaurantDeliveryChannelsArgs
    >;
    updateRestaurantThrottleLevers?: GraphCacheUpdateResolver<
      { updateRestaurantThrottleLevers: WithTypename<RestaurantThrottleLevers> },
      MutationUpdateRestaurantThrottleLeversArgs
    >;
    updateUseCredit?: GraphCacheUpdateResolver<
      { updateUseCredit: WithTypename<UpdateUseCreditResponse> },
      MutationUpdateUseCreditArgs
    >;
    validateAndRefreshGiftCardRedemptionTokenForCustomer?: GraphCacheUpdateResolver<
      {
        validateAndRefreshGiftCardRedemptionTokenForCustomer: WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>;
      },
      MutationValidateAndRefreshGiftCardRedemptionTokenForCustomerArgs
    >;
  };
  Subscription?: object;
  ActivePaymentMethodError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ActivePaymentMethodError>>,
      Record<string, never>
    >;
  };
  AddAddressSuccess?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AddAddressSuccess>>,
      Record<string, never>
    >;
  };
  AddLineItemToCartSuccess?: {
    cart?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AddLineItemToCartSuccess>>,
      Record<string, never>
    >;
  };
  Addons?: {
    products?: GraphCacheUpdateResolver<Maybe<WithTypename<Addons>>, Record<string, never>>;
  };
  Address?: {
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    country?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    deliveryPreference?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Address>>,
      Record<string, never>
    >;
    googlePlaceId?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    latitude?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    longitude?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    secondaryStreet?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    street?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
    zipCode?: GraphCacheUpdateResolver<Maybe<WithTypename<Address>>, Record<string, never>>;
  };
  AdminAppliedPrintTemplate?: {
    appliedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminAppliedPrintTemplate>>,
      Record<string, never>
    >;
    appliedBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminAppliedPrintTemplate>>,
      Record<string, never>
    >;
    templateId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminAppliedPrintTemplate>>,
      Record<string, never>
    >;
    templateName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminAppliedPrintTemplate>>,
      Record<string, never>
    >;
  };
  AdminGroupOrderSettingAudit?: {
    action?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
    after?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
    before?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
    changedBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettingAudit>>,
      Record<string, never>
    >;
  };
  AdminGroupOrderSettings?: {
    history?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettings>>,
      AdminGroupOrderSettingsHistoryArgs
    >;
    maxEntreeLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettings>>,
      Record<string, never>
    >;
    maxEntreeLimitIsDefault?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminGroupOrderSettings>>,
      Record<string, never>
    >;
  };
  AdminMasterZone?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminMasterZone>>, Record<string, never>>;
    index?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminMasterZone>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminMasterZone>>, Record<string, never>>;
  };
  AdminOrder?: {
    couponDiscountCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    creditAppliedCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    customer?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    delivery?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    discounts?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    externalReferenceId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    fees?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    fulfillmentRestaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    lineItems?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    orderSource?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    orderType?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    specialInstructions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    subtotalCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrder>>,
      Record<string, never>
    >;
    taxCents?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    timeZone?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    tipCents?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    totalCents?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    tracking?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
    wantedTime?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrder>>, Record<string, never>>;
  };
  AdminOrderAddress?: {
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderAddress>>, Record<string, never>>;
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderAddress>>, Record<string, never>>;
    secondaryStreet?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderAddress>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderAddress>>, Record<string, never>>;
    street?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderAddress>>,
      Record<string, never>
    >;
    zipCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderAddress>>,
      Record<string, never>
    >;
  };
  AdminOrderCustomer?: {
    email?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderCustomer>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderCustomer>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderCustomer>>, Record<string, never>>;
    phone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderCustomer>>,
      Record<string, never>
    >;
  };
  AdminOrderCustomerSummary?: {
    email?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderCustomerSummary>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderCustomerSummary>>,
      Record<string, never>
    >;
  };
  AdminOrderDelivery?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    courierTipCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    deliveredAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    deliveryFeeCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    estimatedDeliveryTime?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    terminalStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
    vendor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDelivery>>,
      Record<string, never>
    >;
  };
  AdminOrderDiscount?: {
    amountCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDiscount>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderDiscount>>,
      Record<string, never>
    >;
  };
  AdminOrderFee?: {
    amountCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderFee>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderFee>>,
      Record<string, never>
    >;
  };
  AdminOrderLineItem?: {
    costCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderLineItem>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderLineItem>>, Record<string, never>>;
    modifiers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderLineItem>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderLineItem>>, Record<string, never>>;
    quantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderLineItem>>,
      Record<string, never>
    >;
  };
  AdminOrderPage?: {
    nextCursor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderPage>>,
      Record<string, never>
    >;
    orders?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderPage>>, Record<string, never>>;
  };
  AdminOrderRestaurant?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderRestaurant>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderRestaurant>>,
      Record<string, never>
    >;
  };
  AdminOrderSummary?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderSummary>>, Record<string, never>>;
    orderSource?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    orderType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    restaurant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminOrderSummary>>, Record<string, never>>;
    timeZone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    totalCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    tracking?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
    wantedTime?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOrderSummary>>,
      Record<string, never>
    >;
  };
  AdminOutOfStockReason?: {
    key?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOutOfStockReason>>,
      Record<string, never>
    >;
    label?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminOutOfStockReason>>,
      Record<string, never>
    >;
  };
  AdminPrintOrderIngredient?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintOrderIngredient>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintOrderIngredient>>,
      Record<string, never>
    >;
    printName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintOrderIngredient>>,
      Record<string, never>
    >;
  };
  AdminPrintOrderZone?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminPrintOrderZone>>, Record<string, never>>;
    ingredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintOrderZone>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintOrderZone>>,
      Record<string, never>
    >;
  };
  AdminPrintPriorityIngredient?: {
    active?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityIngredient>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityIngredient>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityIngredient>>,
      Record<string, never>
    >;
  };
  AdminPrintPriorityTemplate?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplate>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplate>>,
      Record<string, never>
    >;
    updatedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplate>>,
      Record<string, never>
    >;
    zones?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplate>>,
      Record<string, never>
    >;
  };
  AdminPrintPriorityTemplateZone?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplateZone>>,
      Record<string, never>
    >;
    ingredientIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminPrintPriorityTemplateZone>>,
      Record<string, never>
    >;
  };
  AdminProductUpsellAudit?: {
    action?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    changedBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    changes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    recordId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    recordName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
    recordType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAudit>>,
      Record<string, never>
    >;
  };
  AdminProductUpsellAuditChange?: {
    after?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAuditChange>>,
      Record<string, never>
    >;
    before?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAuditChange>>,
      Record<string, never>
    >;
    field?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminProductUpsellAuditChange>>,
      Record<string, never>
    >;
  };
  AdminRestaurant?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminRestaurant>>, Record<string, never>>;
    isOutpost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurant>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminRestaurant>>, Record<string, never>>;
    printOrder?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurant>>,
      Record<string, never>
    >;
    printTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurant>>,
      Record<string, never>
    >;
  };
  AdminRestaurantAudit?: {
    action?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    changedBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    changes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    comment?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminRestaurantAudit>>, Record<string, never>>;
    recordId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    recordName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
    recordType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAudit>>,
      Record<string, never>
    >;
  };
  AdminRestaurantAuditChange?: {
    after?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditChange>>,
      Record<string, never>
    >;
    before?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditChange>>,
      Record<string, never>
    >;
    field?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditChange>>,
      Record<string, never>
    >;
  };
  AdminRestaurantAuditPage?: {
    entries?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditPage>>,
      Record<string, never>
    >;
    nextCursor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditPage>>,
      Record<string, never>
    >;
    timeZone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAuditPage>>,
      Record<string, never>
    >;
  };
  AdminRestaurantAvailability?: {
    canEdit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAvailability>>,
      Record<string, never>
    >;
    ingredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAvailability>>,
      Record<string, never>
    >;
    menuProducts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAvailability>>,
      Record<string, never>
    >;
    timeZone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantAvailability>>,
      Record<string, never>
    >;
  };
  AdminRestaurantIngredient?: {
    autoRestockAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    availableDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    imageUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    outOfStockBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    outOfStockSince?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    outOfStockSinceApproximate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
    records?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredient>>,
      Record<string, never>
    >;
  };
  AdminRestaurantIngredientRecord?: {
    ingredientId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredientRecord>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredientRecord>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredientRecord>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredientRecord>>,
      Record<string, never>
    >;
    outOfStockReasonKey?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantIngredientRecord>>,
      Record<string, never>
    >;
  };
  AdminRestaurantMenuProduct?: {
    autoRestockAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    availableDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    category?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    channels?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    imageUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    outOfStockBy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    outOfStockSince?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    outOfStockSinceApproximate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    records?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
    soldToday?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProduct>>,
      Record<string, never>
    >;
  };
  AdminRestaurantMenuProductRecord?: {
    category?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
    channels?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
    productId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
    soldToday?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantMenuProductRecord>>,
      Record<string, never>
    >;
  };
  AdminRestaurantOrdering?: {
    acceptingOrders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantOrdering>>,
      Record<string, never>
    >;
    enabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantOrdering>>,
      Record<string, never>
    >;
    hidden?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantOrdering>>,
      Record<string, never>
    >;
    notAcceptingOrdersReason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantOrdering>>,
      Record<string, never>
    >;
  };
  AdminRestaurantProfile?: {
    crossStreet?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantProfile>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantProfile>>,
      Record<string, never>
    >;
    flexMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantProfile>>,
      Record<string, never>
    >;
    pickupInstructions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantProfile>>,
      Record<string, never>
    >;
  };
  AdminRestaurantSettings?: {
    canEditEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    canEditOrdering?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    canEditProfile?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    isOutpost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    ordering?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    parentRestaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    profile?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminRestaurantSettings>>,
      Record<string, never>
    >;
  };
  AdminUpsellCategory?: {
    categoryRanking?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellCategory>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminUpsellCategory>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellCategory>>,
      Record<string, never>
    >;
    products?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellCategory>>,
      Record<string, never>
    >;
  };
  AdminUpsellMasterProduct?: {
    availableDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    imageUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    isUpsell?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    upsellCategoryId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    upsellCategoryRanking?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
    upsellRanking?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AdminUpsellMasterProduct>>,
      Record<string, never>
    >;
  };
  AllergenProperty?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AllergenProperty>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AllergenProperty>>, Record<string, never>>;
  };
  ApplyRewardFailureMetadata?: {
    requiredChannel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ApplyRewardFailureMetadata>>,
      Record<string, never>
    >;
    requiredDays?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ApplyRewardFailureMetadata>>,
      Record<string, never>
    >;
  };
  ApplyRewardSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ApplyRewardSuccess>>,
      Record<string, never>
    >;
  };
  Asset?: {
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<Asset>>, Record<string, never>>;
  };
  AsyncCancelFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AsyncCancelFailed>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AsyncCancelFailed>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AsyncCancelFailed>>,
      Record<string, never>
    >;
  };
  AvailableCustomerSupportPointsError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailableCustomerSupportPointsError>>,
      Record<string, never>
    >;
  };
  AvailableCustomerSupportPointsSuccess?: {
    points?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailableCustomerSupportPointsSuccess>>,
      Record<string, never>
    >;
  };
  AvailablePromotionFailure?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailablePromotionFailure>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailablePromotionFailure>>,
      Record<string, never>
    >;
  };
  AvailablePromotionsSuccess?: {
    promotions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailablePromotionsSuccess>>,
      Record<string, never>
    >;
  };
  AvailableWantedTime?: {
    deliveryOffset?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailableWantedTime>>,
      Record<string, never>
    >;
    time?: GraphCacheUpdateResolver<
      Maybe<WithTypename<AvailableWantedTime>>,
      Record<string, never>
    >;
  };
  BaseProduct?: {
    asset?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    calories?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    caloriesFromFat?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BaseProduct>>,
      Record<string, never>
    >;
    cholesterolMg?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BaseProduct>>,
      Record<string, never>
    >;
    contains?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    dietaryFiberG?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BaseProduct>>,
      Record<string, never>
    >;
    heading?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    isDeepLinkingEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BaseProduct>>,
      Record<string, never>
    >;
    isSeasonal?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    lineageKey?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    proteinG?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    saturatedFatG?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BaseProduct>>,
      Record<string, never>
    >;
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    sodiumMg?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    subheading?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    sugarsG?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    totalCarbsG?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    totalFatG?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
    transFatG?: GraphCacheUpdateResolver<Maybe<WithTypename<BaseProduct>>, Record<string, never>>;
  };
  BillingAccount?: {
    cardType?: GraphCacheUpdateResolver<Maybe<WithTypename<BillingAccount>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BillingAccount>>,
      Record<string, never>
    >;
    expirationState?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BillingAccount>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<BillingAccount>>, Record<string, never>>;
    isDefault?: GraphCacheUpdateResolver<
      Maybe<WithTypename<BillingAccount>>,
      Record<string, never>
    >;
    nickname?: GraphCacheUpdateResolver<Maybe<WithTypename<BillingAccount>>, Record<string, never>>;
  };
  CXCredit?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<CxCredit>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CxCredit>>, Record<string, never>>;
  };
  CanCancel?: {
    canCancel?: GraphCacheUpdateResolver<Maybe<WithTypename<CanCancel>>, Record<string, never>>;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<CanCancel>>, Record<string, never>>;
    timeToFire?: GraphCacheUpdateResolver<Maybe<WithTypename<CanCancel>>, Record<string, never>>;
  };
  CanCancelAlreadySent?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelAlreadySent>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelAlreadySent>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelAlreadySent>>,
      Record<string, never>
    >;
  };
  CanCancelFailed?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelFailed>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelFailed>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<CanCancelFailed>>, Record<string, never>>;
  };
  CanCancelNotFound?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelNotFound>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelNotFound>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelNotFound>>,
      Record<string, never>
    >;
  };
  CanCancelUnauthorized?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelUnauthorized>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelUnauthorized>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CanCancelUnauthorized>>,
      Record<string, never>
    >;
  };
  CanNotReorder?: {
    conflicts?: GraphCacheUpdateResolver<Maybe<WithTypename<CanNotReorder>>, Record<string, never>>;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CanNotReorder>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<CanNotReorder>>, Record<string, never>>;
  };
  CancelOrderFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderFailed>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderFailed>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderFailed>>,
      Record<string, never>
    >;
  };
  CancelOrderPaymentIntentResponse?: {
    paymentIntentId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderPaymentIntentResponse>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderPaymentIntentResponse>>,
      Record<string, never>
    >;
  };
  CancelOrderSuccess?: {
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccess>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccess>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccess>>,
      Record<string, never>
    >;
  };
  CancelOrderSuccessAsync?: {
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccessAsync>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccessAsync>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelOrderSuccessAsync>>,
      Record<string, never>
    >;
  };
  CancelSuccessRefundFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelSuccessRefundFailed>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelSuccessRefundFailed>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancelSuccessRefundFailed>>,
      Record<string, never>
    >;
  };
  CancellationFailedWithDelivery?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationFailedWithDelivery>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationFailedWithDelivery>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationFailedWithDelivery>>,
      Record<string, never>
    >;
  };
  CancellationLimitExceeded?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationLimitExceeded>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationLimitExceeded>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CancellationLimitExceeded>>,
      Record<string, never>
    >;
  };
  CantCancelAlreadyCanceled?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelAlreadyCanceled>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelAlreadyCanceled>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelAlreadyCanceled>>,
      Record<string, never>
    >;
  };
  CantCancelLimitExcceeded?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelLimitExcceeded>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelLimitExcceeded>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelLimitExcceeded>>,
      Record<string, never>
    >;
  };
  CantCancelOldOrders?: {
    canCancel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelOldOrders>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelOldOrders>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CantCancelOldOrders>>,
      Record<string, never>
    >;
  };
  CartNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CartNotFound>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CartNotFound>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<CartNotFound>>, Record<string, never>>;
  };
  CateringCustomer?: {
    first?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringCustomer>>, Record<string, never>>;
    last?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringCustomer>>, Record<string, never>>;
  };
  CateringIngredient?: {
    eightySixed?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
    gramsPerPortion?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringIngredient>>, Record<string, never>>;
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringIngredient>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringIngredient>>, Record<string, never>>;
    portion?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
    quantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
    regularCounterparts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
    totalGrams?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringIngredient>>,
      Record<string, never>
    >;
  };
  CateringLineItem?: {
    cost?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringLineItem>>, Record<string, never>>;
    eightySixed?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    ingredientAdditions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    ingredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    perItemCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    productId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    productName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    quantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    removedIngredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    specialInstructions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringLineItem>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringLineItem>>, Record<string, never>>;
  };
  CateringOrder?: {
    clientName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    clientPhone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    customer?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringOrder>>, Record<string, never>>;
    deliveryAddress1?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryAddress2?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryCity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryFee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryPostal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryState?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    deliveryType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    discount?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringOrder>>, Record<string, never>>;
    externalReferenceId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    gravyOrderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    isSubmitted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    isTaxExempt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    lineItems?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringOrder>>, Record<string, never>>;
    numberOfGuests?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    orderAcceptorCompany?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    orderAcceptorPhone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    orderSource?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    orderValidation?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    paymentMethod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    restaurantID?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    specialInstructions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    submissionWindowCloseAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    submissionWindowOpenAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
    timeReqd?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringOrder>>, Record<string, never>>;
    tip?: GraphCacheUpdateResolver<Maybe<WithTypename<CateringOrder>>, Record<string, never>>;
    wantedTimeAtStore?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrder>>,
      Record<string, never>
    >;
  };
  CateringOrderValidation?: {
    subtotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrderValidation>>,
      Record<string, never>
    >;
    tax?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrderValidation>>,
      Record<string, never>
    >;
    total?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrderValidation>>,
      Record<string, never>
    >;
  };
  CateringOrdersResponse?: {
    orders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringOrdersResponse>>,
      Record<string, never>
    >;
  };
  CateringRegularIngredient?: {
    gramsPerPortion?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringRegularIngredient>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringRegularIngredient>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CateringRegularIngredient>>,
      Record<string, never>
    >;
  };
  Challenge?: {
    achieved?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    assetUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    celebrationCopy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Challenge>>,
      Record<string, never>
    >;
    descriptiveTitle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Challenge>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Challenge>>,
      Record<string, never>
    >;
    goal?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    legalTerms?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    multipleBehaviorDetails?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Challenge>>,
      Record<string, never>
    >;
    percentageCompleted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Challenge>>,
      Record<string, never>
    >;
    permalink?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    progress?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    progressCopy?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    progressType?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    theme?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    themeV2?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<Challenge>>, Record<string, never>>;
  };
  ChallengeCelebration?: {
    celebrationCopy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebration>>,
      Record<string, never>
    >;
    challengesIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebration>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebration>>,
      Record<string, never>
    >;
    rewardUsageDisclaimer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebration>>,
      Record<string, never>
    >;
    title?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebration>>,
      Record<string, never>
    >;
  };
  ChallengeCelebrationV2?: {
    celebrationCopy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebrationV2>>,
      Record<string, never>
    >;
    challengesIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebrationV2>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebrationV2>>,
      Record<string, never>
    >;
    title?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeCelebrationV2>>,
      Record<string, never>
    >;
  };
  ChallengeReward?: {
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeReward>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ChallengeReward>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ChallengeReward>>, Record<string, never>>;
    redeemable?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeReward>>,
      Record<string, never>
    >;
    redeemableAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeReward>>,
      Record<string, never>
    >;
    redemptionChannel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeReward>>,
      Record<string, never>
    >;
    rewardType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChallengeReward>>,
      Record<string, never>
    >;
    terms?: GraphCacheUpdateResolver<Maybe<WithTypename<ChallengeReward>>, Record<string, never>>;
  };
  ChangeDetail?: {
    field?: GraphCacheUpdateResolver<Maybe<WithTypename<ChangeDetail>>, Record<string, never>>;
    newValue?: GraphCacheUpdateResolver<Maybe<WithTypename<ChangeDetail>>, Record<string, never>>;
    oldValue?: GraphCacheUpdateResolver<Maybe<WithTypename<ChangeDetail>>, Record<string, never>>;
  };
  ChatToken?: {
    token?: GraphCacheUpdateResolver<Maybe<WithTypename<ChatToken>>, Record<string, never>>;
  };
  ChildSyncResult?: {
    error?: GraphCacheUpdateResolver<Maybe<WithTypename<ChildSyncResult>>, Record<string, never>>;
    salesforceId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ChildSyncResult>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<Maybe<WithTypename<ChildSyncResult>>, Record<string, never>>;
  };
  ClaimLoyaltyPromotionFailure?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ClaimLoyaltyPromotionFailure>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ClaimLoyaltyPromotionFailure>>,
      Record<string, never>
    >;
  };
  ConsolidatedIngredient?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ConsolidatedIngredient>>,
      Record<string, never>
    >;
    isDressing?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ConsolidatedIngredient>>,
      Record<string, never>
    >;
    mdmId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ConsolidatedIngredient>>,
      Record<string, never>
    >;
    quantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ConsolidatedIngredient>>,
      Record<string, never>
    >;
  };
  ConvertToMultipartyOrderSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ConvertToMultipartyOrderSuccess>>,
      Record<string, never>
    >;
  };
  CourierDetails?: {
    latitude?: GraphCacheUpdateResolver<Maybe<WithTypename<CourierDetails>>, Record<string, never>>;
    longitude?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CourierDetails>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<CourierDetails>>, Record<string, never>>;
    phone?: GraphCacheUpdateResolver<Maybe<WithTypename<CourierDetails>>, Record<string, never>>;
  };
  CreateAccountSuccess?: {
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateAccountSuccess>>,
      Record<string, never>
    >;
  };
  CreateConnectionTokenResponse?: {
    secret?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateConnectionTokenResponse>>,
      Record<string, never>
    >;
  };
  CreateKioskReaderLocationIdResponse?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateKioskReaderLocationIdResponse>>,
      Record<string, never>
    >;
  };
  CreateLoyaltyProfileError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateLoyaltyProfileError>>,
      Record<string, never>
    >;
  };
  CreateLoyaltyProfileSuccess?: {
    loyaltyProfile?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateLoyaltyProfileSuccess>>,
      Record<string, never>
    >;
  };
  CreateOrderSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateOrderSuccess>>,
      Record<string, never>
    >;
  };
  CreateSetupIntent?: {
    clientSecret?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CreateSetupIntent>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSetupIntent>>, Record<string, never>>;
  };
  Credit?: {
    amount?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    creditType?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    expiresAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    remainingAmount?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
    storefrontEligibilityTitle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Credit>>,
      Record<string, never>
    >;
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<Credit>>, Record<string, never>>;
  };
  Customer?: {
    addresses?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    availableCredit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Customer>>,
      Record<string, never>
    >;
    billingAccounts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Customer>>,
      Record<string, never>
    >;
    birthday?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    credits?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    deletionInProgress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Customer>>,
      Record<string, never>
    >;
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    phoneNumber?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    qrCode?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    referralShareUrlEmail?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Customer>>,
      Record<string, never>
    >;
    trackingUuid?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    useCredit?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
    zipCode?: GraphCacheUpdateResolver<Maybe<WithTypename<Customer>>, Record<string, never>>;
  };
  CustomerNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerNotFound>>,
      Record<string, never>
    >;
  };
  CustomerNotOnboardedError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerNotOnboardedError>>,
      Record<string, never>
    >;
  };
  CustomerPass?: {
    authenticationToken?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPass>>,
      Record<string, never>
    >;
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomerPass>>, Record<string, never>>;
  };
  CustomerPaymentInfo?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomerPaymentInfo>>, Record<string, never>>;
    paymentEphemeralKey?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPaymentInfo>>,
      Record<string, never>
    >;
    paymentSessionId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPaymentInfo>>,
      Record<string, never>
    >;
  };
  CustomerPointsForCustomerSupportFailureError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPointsForCustomerSupportFailureError>>,
      Record<string, never>
    >;
  };
  CustomerPointsForCustomerSupportSuccessResponse?: {
    points?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPointsForCustomerSupportSuccessResponse>>,
      Record<string, never>
    >;
  };
  CustomerPreference?: {
    allergens?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPreference>>,
      Record<string, never>
    >;
    dietaryRestrictions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPreference>>,
      Record<string, never>
    >;
    hasSyncedRestrictions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerPreference>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomerPreference>>, Record<string, never>>;
  };
  CustomerSupportCreditsFailureError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerSupportCreditsFailureError>>,
      Record<string, never>
    >;
  };
  CustomerSupportCreditsSuccessResponse?: {
    credits?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerSupportCreditsSuccessResponse>>,
      Record<string, never>
    >;
  };
  CustomerSupportPoint?: {
    displayValue?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerSupportPoint>>,
      Record<string, never>
    >;
    value?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerSupportPoint>>,
      Record<string, never>
    >;
  };
  CustomerTokenError?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomerTokenError>>, Record<string, never>>;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<CustomerTokenError>>,
      Record<string, never>
    >;
  };
  DeclinedPaymentMethod?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeclinedPaymentMethod>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeclinedPaymentMethod>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeclinedPaymentMethod>>,
      Record<string, never>
    >;
  };
  DeleteAddressSuccess?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteAddressSuccess>>,
      Record<string, never>
    >;
  };
  DeleteAdminPrintPriorityTemplateResponse?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteAdminPrintPriorityTemplateResponse>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteAdminPrintPriorityTemplateResponse>>,
      Record<string, never>
    >;
  };
  DeleteAdminUpsellCategoryResponse?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteAdminUpsellCategoryResponse>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteAdminUpsellCategoryResponse>>,
      Record<string, never>
    >;
  };
  DeleteSubscriptionPaymentMethodSuccess?: {
    creditCards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeleteSubscriptionPaymentMethodSuccess>>,
      Record<string, never>
    >;
  };
  DeliveryAlreadyInFlight?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryAlreadyInFlight>>,
      Record<string, never>
    >;
  };
  DeliveryOrderDetail?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
    deliveryFee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
    estimatedDeliveryTime?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<DeliveryOrderDetail>>, Record<string, never>>;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
    tip?: GraphCacheUpdateResolver<Maybe<WithTypename<DeliveryOrderDetail>>, Record<string, never>>;
    vendor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
    vendorRestaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliveryOrderDetail>>,
      Record<string, never>
    >;
  };
  DeliverySpecifyAddress?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<DeliverySpecifyAddress>>,
      Record<string, never>
    >;
  };
  DietaryProperty?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<DietaryProperty>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<DietaryProperty>>, Record<string, never>>;
  };
  Discount?: {
    amount?: GraphCacheUpdateResolver<Maybe<WithTypename<Discount>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Discount>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Discount>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Discount>>, Record<string, never>>;
  };
  DropOffLocation?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<DropOffLocation>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<DropOffLocation>>, Record<string, never>>;
  };
  EditLineItemInCartSuccess?: {
    cart?: GraphCacheUpdateResolver<
      Maybe<WithTypename<EditLineItemInCartSuccess>>,
      Record<string, never>
    >;
  };
  EightySixResponse?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<EightySixResponse>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<EightySixResponse>>,
      Record<string, never>
    >;
  };
  EstimateRange?: {
    end?: GraphCacheUpdateResolver<Maybe<WithTypename<EstimateRange>>, Record<string, never>>;
    start?: GraphCacheUpdateResolver<Maybe<WithTypename<EstimateRange>>, Record<string, never>>;
  };
  ExpiredReceipt?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ExpiredReceipt>>,
      Record<string, never>
    >;
  };
  FailedToFetchPaymentIntent?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FailedToFetchPaymentIntent>>,
      Record<string, never>
    >;
  };
  FeedbackQuestion?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackQuestion>>, Record<string, never>>;
    responses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FeedbackQuestion>>,
      Record<string, never>
    >;
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackQuestion>>, Record<string, never>>;
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackQuestion>>, Record<string, never>>;
  };
  FeedbackResponse?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackResponse>>, Record<string, never>>;
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackResponse>>, Record<string, never>>;
  };
  FeedbackSuccess?: {
    success?: GraphCacheUpdateResolver<Maybe<WithTypename<FeedbackSuccess>>, Record<string, never>>;
  };
  FieldValidationError?: {
    field?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FieldValidationError>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FieldValidationError>>,
      Record<string, never>
    >;
  };
  FlexCustomerAlreadyExistsError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexCustomerAlreadyExistsError>>,
      Record<string, never>
    >;
  };
  FlexCustomerData?: {
    flexPaymentMethods?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexCustomerData>>,
      Record<string, never>
    >;
  };
  FlexOnboardingSession?: {
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexOnboardingSession>>,
      Record<string, never>
    >;
    redirectUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexOnboardingSession>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexOnboardingSession>>,
      Record<string, never>
    >;
  };
  FlexPaymentMethod?: {
    brand?: GraphCacheUpdateResolver<Maybe<WithTypename<FlexPaymentMethod>>, Record<string, never>>;
    expMonth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexPaymentMethod>>,
      Record<string, never>
    >;
    expYear?: GraphCacheUpdateResolver<
      Maybe<WithTypename<FlexPaymentMethod>>,
      Record<string, never>
    >;
    last4?: GraphCacheUpdateResolver<Maybe<WithTypename<FlexPaymentMethod>>, Record<string, never>>;
  };
  ForbiddenError?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<ForbiddenError>>, Record<string, never>>;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ForbiddenError>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<ForbiddenError>>, Record<string, never>>;
  };
  GetKioskPaymentsForCurrentDateResponse?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GetKioskPaymentsForCurrentDateResponse>>,
      Record<string, never>
    >;
    payments?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GetKioskPaymentsForCurrentDateResponse>>,
      Record<string, never>
    >;
  };
  GetKioskReaderLocationIdResponse?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GetKioskReaderLocationIdResponse>>,
      Record<string, never>
    >;
  };
  GiftCardAssociatedWithAnotherAccountError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardAssociatedWithAnotherAccountError>>,
      Record<string, never>
    >;
  };
  GiftCardBalance?: {
    customerId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardBalance>>,
      Record<string, never>
    >;
    giftCardBalance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardBalance>>,
      Record<string, never>
    >;
  };
  GiftCardDeliveryDetail?: {
    deliveryDateTime?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardDeliveryDetail>>,
      Record<string, never>
    >;
    deliveryMethods?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardDeliveryDetail>>,
      Record<string, never>
    >;
    isAsap?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardDeliveryDetail>>,
      Record<string, never>
    >;
  };
  GiftCardNotFoundError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardNotFoundError>>,
      Record<string, never>
    >;
  };
  GiftCardOrderDetail?: {
    deliveryDetail?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardOrderDetail>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<GiftCardOrderDetail>>, Record<string, never>>;
    purchasedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardOrderDetail>>,
      Record<string, never>
    >;
    userGiftCards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardOrderDetail>>,
      Record<string, never>
    >;
  };
  GiftCardOrderNotFoundError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardOrderNotFoundError>>,
      Record<string, never>
    >;
  };
  GiftCardPurchaseHistory?: {
    customerId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardPurchaseHistory>>,
      Record<string, never>
    >;
    giftCardOrders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardPurchaseHistory>>,
      Record<string, never>
    >;
  };
  GiftCardRedemptionDetailSuccess?: {
    assetId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    balance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    cardNumber?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    cardRegCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    recipientMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    recipientName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    redeemId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
    senderName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<GiftCardRedemptionDetailSuccess>>,
      Record<string, never>
    >;
  };
  Guest?: {
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<Guest>>, Record<string, never>>;
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<Guest>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Guest>>, Record<string, never>>;
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<Guest>>, Record<string, never>>;
  };
  HasUnseenChallenges?: {
    hasUnseenChallenges?: GraphCacheUpdateResolver<
      Maybe<WithTypename<HasUnseenChallenges>>,
      Record<string, never>
    >;
  };
  HurdleBehavior?: {
    achieved?: GraphCacheUpdateResolver<Maybe<WithTypename<HurdleBehavior>>, Record<string, never>>;
    goal?: GraphCacheUpdateResolver<Maybe<WithTypename<HurdleBehavior>>, Record<string, never>>;
    outcome?: GraphCacheUpdateResolver<Maybe<WithTypename<HurdleBehavior>>, Record<string, never>>;
    progress?: GraphCacheUpdateResolver<Maybe<WithTypename<HurdleBehavior>>, Record<string, never>>;
  };
  HurdleBehaviorDetails?: {
    hurdleBehaviors?: GraphCacheUpdateResolver<
      Maybe<WithTypename<HurdleBehaviorDetails>>,
      Record<string, never>
    >;
  };
  IdentifyAndClaimInStoreOrderSuccess?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IdentifyAndClaimInStoreOrderSuccess>>,
      Record<string, never>
    >;
  };
  InStoreOrder?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
    isPendingFeedback?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrder>>,
      Record<string, never>
    >;
    ledger?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
    lineItems?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
    orderStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrder>>,
      Record<string, never>
    >;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
    vendorId?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
    wantedTime?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrder>>, Record<string, never>>;
  };
  InStoreOrderDiscount?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderDiscount>>,
      Record<string, never>
    >;
    isLoyalty?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderDiscount>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderDiscount>>,
      Record<string, never>
    >;
  };
  InStoreOrderLedger?: {
    discounts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLedger>>,
      Record<string, never>
    >;
    payments?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLedger>>,
      Record<string, never>
    >;
    subtotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLedger>>,
      Record<string, never>
    >;
    tax?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrderLedger>>, Record<string, never>>;
    tip?: GraphCacheUpdateResolver<Maybe<WithTypename<InStoreOrderLedger>>, Record<string, never>>;
    total?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLedger>>,
      Record<string, never>
    >;
  };
  InStoreOrderLineItem?: {
    asset?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    brinkId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    isCustom?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    isCustomProduct?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    price?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
    quantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItem>>,
      Record<string, never>
    >;
  };
  InStoreOrderLineItemAsset?: {
    url?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderLineItemAsset>>,
      Record<string, never>
    >;
  };
  InStoreOrderPayment?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderPayment>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderPayment>>,
      Record<string, never>
    >;
  };
  InStoreOrderRestaurant?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    city?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    entityId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    latitude?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    longitude?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
    zipCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrderRestaurant>>,
      Record<string, never>
    >;
  };
  InStoreOrdersResponse?: {
    inStoreOrders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrdersResponse>>,
      Record<string, never>
    >;
    pagination?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InStoreOrdersResponse>>,
      Record<string, never>
    >;
  };
  IncorrectPaymentMethod?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IncorrectPaymentMethod>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IncorrectPaymentMethod>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IncorrectPaymentMethod>>,
      Record<string, never>
    >;
  };
  Ingredient?: {
    allergenProperties?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    asset?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, IngredientAssetArgs>;
    availableDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    calories?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, IngredientCaloriesArgs>;
    caloriesFromFat?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    cholesterolMg?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    co2eKg?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    dietaryFiberG?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    dietaryProperties?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    isGrain?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    isMixable?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    isWarmBase?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    lineageKey?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    proteinG?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    saturatedFatG?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    servingMeasure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    servingUnitOfMeasure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Ingredient>>,
      Record<string, never>
    >;
    sodiumMg?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    sugarsG?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    totalCarbsG?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    totalFatG?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
    transFatG?: GraphCacheUpdateResolver<Maybe<WithTypename<Ingredient>>, Record<string, never>>;
  };
  IngredientModification?: {
    additionCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    calories?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    ingredient?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    isGrain?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    mixable?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    removalCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    subKind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
    substitutionCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModification>>,
      Record<string, never>
    >;
  };
  IngredientModificationKind?: {
    allowMultipleQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModificationKind>>,
      Record<string, never>
    >;
    freeAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModificationKind>>,
      Record<string, never>
    >;
    maxAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModificationKind>>,
      Record<string, never>
    >;
    minAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModificationKind>>,
      Record<string, never>
    >;
    modifications?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModificationKind>>,
      Record<string, never>
    >;
  };
  IngredientModifications?: {
    bases?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifications>>,
      Record<string, never>
    >;
    bread?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifications>>,
      Record<string, never>
    >;
    dressings?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifications>>,
      Record<string, never>
    >;
    premiums?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifications>>,
      Record<string, never>
    >;
    toppings?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifications>>,
      Record<string, never>
    >;
  };
  IngredientModifier?: {
    additionCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    brinkPlu?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<IngredientModifier>>, Record<string, never>>;
    ingredient?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    ingredientId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<IngredientModifier>>, Record<string, never>>;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    removalCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    subKind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
    substitutionCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IngredientModifier>>,
      Record<string, never>
    >;
  };
  InvalidAddress?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidAddress>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidAddress>>, Record<string, never>>;
  };
  InvalidBillingAccount?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidBillingAccount>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidBillingAccount>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidBillingAccount>>,
      Record<string, never>
    >;
  };
  InvalidCreditCard?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidCreditCard>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidCreditCard>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidCreditCard>>,
      Record<string, never>
    >;
  };
  InvalidCustomerPhone?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidCustomerPhone>>,
      Record<string, never>
    >;
  };
  InvalidGiftCardError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidGiftCardError>>,
      Record<string, never>
    >;
  };
  InvalidInput?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidInput>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidInput>>, Record<string, never>>;
  };
  InvalidOrder?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidOrder>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidOrder>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidOrder>>, Record<string, never>>;
  };
  InvalidPromoCode?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidPromoCode>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidPromoCode>>, Record<string, never>>;
  };
  InvalidRefundAmount?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<InvalidRefundAmount>>,
      Record<string, never>
    >;
  };
  InvalidTip?: {
    errorMessage?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidTip>>, Record<string, never>>;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidTip>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<InvalidTip>>, Record<string, never>>;
  };
  IssueCustomerSupportCreditResult?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IssueCustomerSupportCreditResult>>,
      Record<string, never>
    >;
  };
  IssueCustomerSupportPointsFailureError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IssueCustomerSupportPointsFailureError>>,
      Record<string, never>
    >;
  };
  IssueCustomerSupportPointsSuccessResponse?: {
    credits?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IssueCustomerSupportPointsSuccessResponse>>,
      Record<string, never>
    >;
  };
  JoinMultipartyOrderSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<JoinMultipartyOrderSuccess>>,
      Record<string, never>
    >;
  };
  KioskCustomerProfile?: {
    firstName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerProfile>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskCustomerProfile>>, Record<string, never>>;
    lastName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerProfile>>,
      Record<string, never>
    >;
    loyaltyId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerProfile>>,
      Record<string, never>
    >;
  };
  KioskCustomerScanPaymentInfo?: {
    cardBrand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfo>>,
      Record<string, never>
    >;
    cardLast4?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfo>>,
      Record<string, never>
    >;
    creditBalance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfo>>,
      Record<string, never>
    >;
  };
  KioskCustomerScanPaymentInfoError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfoError>>,
      Record<string, never>
    >;
  };
  KioskCustomerScanPaymentInfoSuccess?: {
    payment?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfoSuccess>>,
      Record<string, never>
    >;
    purpose?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskCustomerScanPaymentInfoSuccess>>,
      Record<string, never>
    >;
  };
  KioskPayment?: {
    amount?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    cardBrand?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    cardholderName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskPayment>>,
      Record<string, never>
    >;
    created?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    last4?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    receiptUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    refunded?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
    refundedAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<KioskPayment>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<KioskPayment>>, Record<string, never>>;
  };
  Kustomer?: {
    token?: GraphCacheUpdateResolver<Maybe<WithTypename<Kustomer>>, Record<string, never>>;
  };
  LeaveOrderSuccess?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LeaveOrderSuccess>>,
      Record<string, never>
    >;
  };
  Ledger?: {
    credits?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    creditsTotal?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    discounts?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    discountsTotal?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    fees?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    feesTotal?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    selectedRewards?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    subtotal?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    tax?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
    tip?: GraphCacheUpdateResolver<Maybe<WithTypename<Ledger>>, Record<string, never>>;
  };
  LedgerItem?: {
    amount?: GraphCacheUpdateResolver<Maybe<WithTypename<LedgerItem>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<LedgerItem>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LedgerItem>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<LedgerItem>>, Record<string, never>>;
  };
  LineItem?: {
    addedIngredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    calories?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    canEdit?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    canReorderAtRestaurant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      LineItemCanReorderAtRestaurantArgs
    >;
    consolidatedIngredientIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    consolidatedIngredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    cost?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    customName?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    customerName?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    dressingMode?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    favorited?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    ingredients?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    isCustom?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    mixedDressingDetails?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    orderParticipant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    perItemCost?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    product?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    quantity?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
    removedIngredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    selectedModifiers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItem>>,
      Record<string, never>
    >;
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItem>>, Record<string, never>>;
  };
  LineItemModificationsInvalidException?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemModificationsInvalidException>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemModificationsInvalidException>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemModificationsInvalidException>>,
      Record<string, never>
    >;
  };
  LineItemNotFound?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemNotFound>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<LineItemNotFound>>, Record<string, never>>;
  };
  LineItemRecommendation?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    ingredientIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    ingredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
    recommendationType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemRecommendation>>,
      Record<string, never>
    >;
  };
  LineItemSuccess?: {
    lineItem?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LineItemSuccess>>,
      Record<string, never>
    >;
  };
  Location?: {
    estimateRange?: GraphCacheUpdateResolver<Maybe<WithTypename<Location>>, Record<string, never>>;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<Location>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<Location>>, Record<string, never>>;
    vendor?: GraphCacheUpdateResolver<Maybe<WithTypename<Location>>, Record<string, never>>;
  };
  LocationClosed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LocationClosed>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<LocationClosed>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<LocationClosed>>, Record<string, never>>;
  };
  LockOrderFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LockOrderFailed>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<LockOrderFailed>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<LockOrderFailed>>, Record<string, never>>;
  };
  LockOrderSuccess?: {
    order?: GraphCacheUpdateResolver<Maybe<WithTypename<LockOrderSuccess>>, Record<string, never>>;
  };
  LogoutSuccess?: {
    csrf?: GraphCacheUpdateResolver<Maybe<WithTypename<LogoutSuccess>>, Record<string, never>>;
  };
  LoyaltyAccessToken?: {
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyAccessToken>>,
      Record<string, never>
    >;
    token?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyAccessToken>>,
      Record<string, never>
    >;
  };
  LoyaltyOptInFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyOptInFailed>>,
      Record<string, never>
    >;
  };
  LoyaltyProfile?: {
    customerId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    customerToken?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      LoyaltyProfileCustomerTokenArgs
    >;
    hasPaidTierHistory?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    joinDate?: GraphCacheUpdateResolver<Maybe<WithTypename<LoyaltyProfile>>, Record<string, never>>;
    loyaltyId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    points?: GraphCacheUpdateResolver<Maybe<WithTypename<LoyaltyProfile>>, Record<string, never>>;
    pointsRewards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    rewards?: GraphCacheUpdateResolver<Maybe<WithTypename<LoyaltyProfile>>, Record<string, never>>;
    rewardsPremiumStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<LoyaltyProfile>>, Record<string, never>>;
    tierStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
    trialEligible?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyProfile>>,
      Record<string, never>
    >;
  };
  LoyaltyScanPaymentTokenInvalid?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanPaymentTokenInvalid>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanPaymentTokenInvalid>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanPaymentTokenInvalid>>,
      Record<string, never>
    >;
  };
  LoyaltyScanTokenExpired?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanTokenExpired>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanTokenExpired>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<LoyaltyScanTokenExpired>>,
      Record<string, never>
    >;
  };
  MaxEntreeReached?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MaxEntreeReached>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MaxEntreeReached>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<MaxEntreeReached>>, Record<string, never>>;
  };
  MaxModificationsExceeded?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MaxModificationsExceeded>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MaxModificationsExceeded>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MaxModificationsExceeded>>,
      Record<string, never>
    >;
  };
  Menu?: {
    categories?: GraphCacheUpdateResolver<Maybe<WithTypename<Menu>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Menu>>, Record<string, never>>;
  };
  MenuCategory?: {
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCategory>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCategory>>, Record<string, never>>;
    isCustom?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCategory>>, Record<string, never>>;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCategory>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCategory>>, Record<string, never>>;
    products?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCategory>>, Record<string, never>>;
  };
  MenuCollection?: {
    color?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCollection>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCollection>>, Record<string, never>>;
    primaryDescription?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCollection>>,
      Record<string, never>
    >;
    primaryImageUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCollection>>,
      Record<string, never>
    >;
    primaryTitle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCollection>>,
      Record<string, never>
    >;
    products?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuCollection>>, Record<string, never>>;
    secondaryDescription?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCollection>>,
      Record<string, never>
    >;
    secondaryTitle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuCollection>>,
      Record<string, never>
    >;
  };
  MenuNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MenuNotFound>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuNotFound>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<MenuNotFound>>, Record<string, never>>;
  };
  MinimumDeliverySubtotalNotMet?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MinimumDeliverySubtotalNotMet>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MinimumDeliverySubtotalNotMet>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MinimumDeliverySubtotalNotMet>>,
      Record<string, never>
    >;
  };
  MixedDressingDetails?: {
    ingredientId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MixedDressingDetails>>,
      Record<string, never>
    >;
    weight?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MixedDressingDetails>>,
      Record<string, never>
    >;
  };
  ModifierGroup?: {
    allowMultipleQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    displayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    encourageAboveMinSelection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    encourageMaxSelection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    freeAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    groupRole?: GraphCacheUpdateResolver<Maybe<WithTypename<ModifierGroup>>, Record<string, never>>;
    hasDynamicMax?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    helperText?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ModifierGroup>>, Record<string, never>>;
    maxAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<ModifierGroup>>, Record<string, never>>;
    minAggregateQuantity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    modifications?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ModifierGroup>>, Record<string, never>>;
    pairedGroupId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ModifierGroup>>,
      Record<string, never>
    >;
    variation?: GraphCacheUpdateResolver<Maybe<WithTypename<ModifierGroup>>, Record<string, never>>;
  };
  MultipartyDetail?: {
    displayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyDetail>>,
      Record<string, never>
    >;
    joinCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyDetail>>,
      Record<string, never>
    >;
  };
  MultipartyOrderAlreadyJoined?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderAlreadyJoined>>,
      Record<string, never>
    >;
  };
  MultipartyOrderNotEnabled?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderNotEnabled>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderNotEnabled>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderNotEnabled>>,
      Record<string, never>
    >;
  };
  MultipartyOrderNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderNotFound>>,
      Record<string, never>
    >;
  };
  MultipartyOrderPreviewSuccess?: {
    deliveryAddressSummary?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderPreviewSuccess>>,
      Record<string, never>
    >;
    hostDisplayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderPreviewSuccess>>,
      Record<string, never>
    >;
    orderDisplayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderPreviewSuccess>>,
      Record<string, never>
    >;
    restaurant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<MultipartyOrderPreviewSuccess>>,
      Record<string, never>
    >;
  };
  NoBalanceGiftCardError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NoBalanceGiftCardError>>,
      Record<string, never>
    >;
  };
  NoValidRestaurants?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NoValidRestaurants>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NoValidRestaurants>>,
      Record<string, never>
    >;
  };
  NotificationCategory?: {
    displayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NotificationCategory>>,
      Record<string, never>
    >;
    emailSubscribe?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NotificationCategory>>,
      Record<string, never>
    >;
    hasResolved?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NotificationCategory>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationCategory>>, Record<string, never>>;
    pushSubscribe?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NotificationCategory>>,
      Record<string, never>
    >;
  };
  NotificationPreferencesError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<NotificationPreferencesError>>,
      Record<string, never>
    >;
  };
  OptOutLoyaltyForCustomerSuccessResponse?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OptOutLoyaltyForCustomerSuccessResponse>>,
      Record<string, never>
    >;
  };
  OptOutLoyaltySuccessResponse?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OptOutLoyaltySuccessResponse>>,
      Record<string, never>
    >;
  };
  Order?: {
    asset?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    availableRewards?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    availableRewardsByLoyaltyId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      OrderAvailableRewardsByLoyaltyIdArgs
    >;
    availableRewardsWithLoyalty?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      OrderAvailableRewardsWithLoyaltyArgs
    >;
    availableWantedTimes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    canCancel?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    canTrackOrderStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    currentUserOrderPermissions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    deliveryOrderDetail?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    dropoffLocation?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    eligiblePointRewards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    eligiblePointRewardsByLoyaltyId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      OrderEligiblePointRewardsByLoyaltyIdArgs
    >;
    eligiblePointRewardsWithLoyalty?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      OrderEligiblePointRewardsWithLoyaltyArgs
    >;
    hasEarnedLoyaltyPoints?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    includeUtensils?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    isCanceled?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    isInFlight?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    isInFlightDelivery?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      Record<string, never>
    >;
    isPendingFeedback?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    ledger?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    lineItems?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    multipartyDetails?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    orderSource?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    orderState?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    orderType?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    payments?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    total?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    transactionPlan?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Order>>,
      OrderTransactionPlanArgs
    >;
    vendorId?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
    wantedTime?: GraphCacheUpdateResolver<Maybe<WithTypename<Order>>, Record<string, never>>;
  };
  OrderAlreadyCanceled?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadyCanceled>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadyCanceled>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadyCanceled>>,
      Record<string, never>
    >;
  };
  OrderAlreadySentToKitchen?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadySentToKitchen>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadySentToKitchen>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderAlreadySentToKitchen>>,
      Record<string, never>
    >;
  };
  OrderConflict?: {
    product?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderConflict>>, Record<string, never>>;
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderConflict>>, Record<string, never>>;
    unavailableIngredients?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderConflict>>,
      Record<string, never>
    >;
  };
  OrderLocked?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderLocked>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderLocked>>, Record<string, never>>;
    reason?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderLocked>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderLocked>>, Record<string, never>>;
  };
  OrderMissingTotalError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderMissingTotalError>>,
      Record<string, never>
    >;
  };
  OrderNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderNotFound>>,
      Record<string, never>
    >;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderNotFound>>, Record<string, never>>;
    success?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderNotFound>>, Record<string, never>>;
  };
  OrderParticipant?: {
    displayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderParticipant>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderParticipant>>, Record<string, never>>;
    isMe?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderParticipant>>, Record<string, never>>;
  };
  OrderPaymentState?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderPaymentState>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderPaymentState>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderPaymentState>>, Record<string, never>>;
    paymentIntentId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderPaymentState>>,
      Record<string, never>
    >;
    paymentIntentSecret?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderPaymentState>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderPaymentState>>,
      Record<string, never>
    >;
    updatedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderPaymentState>>,
      Record<string, never>
    >;
  };
  OrderStatus?: {
    canceledStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    courierDetails?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    customerId?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderStatus>>, Record<string, never>>;
    deliveryAddressName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    flattenedOrderStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    gravyStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderStatus>>, Record<string, never>>;
    gravyUpdatedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    order?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderStatus>>, Record<string, never>>;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderStatus>>, Record<string, never>>;
    orderOccasion?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    orderStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<OrderStatus>>, Record<string, never>>;
    orderWantedTime?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
    restaurantName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderStatus>>,
      Record<string, never>
    >;
  };
  OrderTotalNotZero?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderTotalNotZero>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderTotalNotZero>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrderTotalNotZero>>,
      Record<string, never>
    >;
  };
  OrdersResponseSuccess?: {
    orders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrdersResponseSuccess>>,
      Record<string, never>
    >;
    pagination?: GraphCacheUpdateResolver<
      Maybe<WithTypename<OrdersResponseSuccess>>,
      Record<string, never>
    >;
  };
  Pagination?: {
    last?: GraphCacheUpdateResolver<Maybe<WithTypename<Pagination>>, Record<string, never>>;
    page?: GraphCacheUpdateResolver<Maybe<WithTypename<Pagination>>, Record<string, never>>;
    take?: GraphCacheUpdateResolver<Maybe<WithTypename<Pagination>>, Record<string, never>>;
    total?: GraphCacheUpdateResolver<Maybe<WithTypename<Pagination>>, Record<string, never>>;
  };
  Payment?: {
    amountEligibleForPoints?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Payment>>,
      Record<string, never>
    >;
    amountInCents?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    last4?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    paymentTime?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    processor?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    refunded?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    refundedAmount?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<Payment>>, Record<string, never>>;
  };
  PaymentAlreadyRefunded?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentAlreadyRefunded>>,
      Record<string, never>
    >;
  };
  PaymentIntent?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentIntent>>, Record<string, never>>;
    orderId?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentIntent>>, Record<string, never>>;
    secret?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentIntent>>, Record<string, never>>;
  };
  PaymentMethodBillingAccount?: {
    cardType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
    expirationState?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
    isDefault?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
    nickname?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodBillingAccount>>,
      Record<string, never>
    >;
  };
  PaymentMethodCard?: {
    cardType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodCard>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodCard>>,
      Record<string, never>
    >;
    expirationState?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodCard>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentMethodCard>>, Record<string, never>>;
    isDefault?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodCard>>,
      Record<string, never>
    >;
    nickname?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentMethodCard>>,
      Record<string, never>
    >;
  };
  PaymentPlan?: {
    braintreePlanId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentPlan>>,
      Record<string, never>
    >;
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentPlan>>, Record<string, never>>;
  };
  PaymentProfile?: {
    defaultCardId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentProfile>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentProfile>>, Record<string, never>>;
  };
  PaymentSubscription?: {
    balance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    billingFrequencyUnit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    billingHistory?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    billingPeriodEndDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    billingPeriodStartDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    billingRecurrence?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    firstBillingDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    hasFreeTrial?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PaymentSubscription>>, Record<string, never>>;
    isTrialActive?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    nextBillingDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    nextBillingPeriodAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    paidThroughDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    planId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    price?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscription>>,
      Record<string, never>
    >;
  };
  PaymentSubscriptionProfile?: {
    creditCards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscriptionProfile>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscriptionProfile>>,
      Record<string, never>
    >;
    transactionHistory?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PaymentSubscriptionProfile>>,
      Record<string, never>
    >;
  };
  PersonalizedUpsell?: {
    customerId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PersonalizedUpsell>>,
      Record<string, never>
    >;
    products?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PersonalizedUpsell>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PersonalizedUpsell>>,
      Record<string, never>
    >;
  };
  PointExpirationEntry?: {
    amountExpiring?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointExpirationEntry>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PointExpirationEntry>>, Record<string, never>>;
    numOfDaysUntilExpiration?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointExpirationEntry>>,
      Record<string, never>
    >;
  };
  PointHistoryEntry?: {
    date?: GraphCacheUpdateResolver<Maybe<WithTypename<PointHistoryEntry>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PointHistoryEntry>>, Record<string, never>>;
    source?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryEntry>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<PointHistoryEntry>>, Record<string, never>>;
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<PointHistoryEntry>>, Record<string, never>>;
  };
  PointHistoryForUserError?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryForUserError>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryForUserError>>,
      Record<string, never>
    >;
  };
  PointHistoryForUserSuccess?: {
    pagination?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryForUserSuccess>>,
      Record<string, never>
    >;
    pointExpirationEntries?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryForUserSuccess>>,
      Record<string, never>
    >;
    pointHistoryEntries?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointHistoryForUserSuccess>>,
      Record<string, never>
    >;
  };
  PointsReward?: {
    assetUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<PointsReward>>, Record<string, never>>;
    displayName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PointsReward>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PointsReward>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<PointsReward>>, Record<string, never>>;
    points?: GraphCacheUpdateResolver<Maybe<WithTypename<PointsReward>>, Record<string, never>>;
    redeemable?: GraphCacheUpdateResolver<Maybe<WithTypename<PointsReward>>, Record<string, never>>;
  };
  Product?: {
    allergenProperties?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    asset?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    availableDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    baseProduct?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    calorieOverrideText?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    calories?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    categoryId?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    categoryName?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    channelCost?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, ProductChannelCostArgs>;
    cost?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    customType?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    dietaryProperties?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    enableDressingDetails?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    expirationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    ingredientModifications?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    ingredients?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, ProductIngredientsArgs>;
    isCustom?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    isMixable?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    isModifiable?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    isSalad?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    masterProductId?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    maxModifications?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      Record<string, never>
    >;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    modifierGroups?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Product>>,
      ProductModifierGroupsArgs
    >;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    outOfStock?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    restaurantId?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
    throttleItem?: GraphCacheUpdateResolver<Maybe<WithTypename<Product>>, Record<string, never>>;
  };
  ProductLabel?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProductLabel>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProductLabel>>, Record<string, never>>;
  };
  ProductOutOfStock?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductOutOfStock>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductOutOfStock>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductOutOfStock>>,
      Record<string, never>
    >;
  };
  ProductUnavailable?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductUnavailable>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductUnavailable>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ProductUnavailable>>,
      Record<string, never>
    >;
  };
  PromoCodeAlreadyApplied?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<PromoCodeAlreadyApplied>>,
      Record<string, never>
    >;
  };
  Receipt?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Receipt>>, Record<string, never>>;
    isClaimed?: GraphCacheUpdateResolver<Maybe<WithTypename<Receipt>>, Record<string, never>>;
    order?: GraphCacheUpdateResolver<Maybe<WithTypename<Receipt>>, Record<string, never>>;
    restaurant?: GraphCacheUpdateResolver<Maybe<WithTypename<Receipt>>, Record<string, never>>;
  };
  ReceiptAlreadyClaimed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReceiptAlreadyClaimed>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReceiptAlreadyClaimed>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReceiptAlreadyClaimed>>,
      Record<string, never>
    >;
  };
  ReceiptAlreadyClaimedError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReceiptAlreadyClaimedError>>,
      Record<string, never>
    >;
  };
  ReceiptNotFound?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReceiptNotFound>>,
      Record<string, never>
    >;
  };
  RefundKioskPaymentResponse?: {
    failureReason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RefundKioskPaymentResponse>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RefundKioskPaymentResponse>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RefundKioskPaymentResponse>>,
      Record<string, never>
    >;
  };
  RefundOrderSuccess?: {
    refundResults?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RefundOrderSuccess>>,
      Record<string, never>
    >;
  };
  RefundResult?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<RefundResult>>, Record<string, never>>;
    reason?: GraphCacheUpdateResolver<Maybe<WithTypename<RefundResult>>, Record<string, never>>;
    success?: GraphCacheUpdateResolver<Maybe<WithTypename<RefundResult>>, Record<string, never>>;
  };
  RegisterGuestFailed?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RegisterGuestFailed>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RegisterGuestFailed>>,
      Record<string, never>
    >;
  };
  RegisterGuestSuccess?: {
    csrf?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RegisterGuestSuccess>>,
      Record<string, never>
    >;
    guest?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RegisterGuestSuccess>>,
      Record<string, never>
    >;
  };
  RemoveFromCartSuccess?: {
    cart?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RemoveFromCartSuccess>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RemoveFromCartSuccess>>,
      Record<string, never>
    >;
  };
  RemoveRewardSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RemoveRewardSuccess>>,
      Record<string, never>
    >;
  };
  ReorderConflict?: {
    conflicts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReorderConflict>>,
      Record<string, never>
    >;
    isNothingAvailable?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReorderConflict>>,
      Record<string, never>
    >;
  };
  ReorderSuccess?: {
    cart?: GraphCacheUpdateResolver<Maybe<WithTypename<ReorderSuccess>>, Record<string, never>>;
    isMixingSupported?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ReorderSuccess>>,
      Record<string, never>
    >;
  };
  RequestAccountDeletionFailed?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RequestAccountDeletionFailed>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RequestAccountDeletionFailed>>,
      Record<string, never>
    >;
  };
  RequestAccountDeletionSuccess?: {
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RequestAccountDeletionSuccess>>,
      Record<string, never>
    >;
  };
  Restaurant?: {
    address?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    asset?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    availableDropOffLocations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    deliveryFee?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    deliveryMinSubtotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    entityId?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    flexMessage?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    hours?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    isAcceptingOrders?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    isOutpost?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    latitude?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    longitude?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    mdmId?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    menu?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    notAcceptingOrdersReason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    parentId?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    phone?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    sanitaryGradeDisplayText?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    sanitaryGradeUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    showDeliveryFeeDisclosure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    showDeliveryPriceDifferenciationDisclosure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    showOutpostPriceDifferenciationDisclosure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    showWarningDialog?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    utcOffset?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
    warningDialogDescription?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    warningDialogTimeout?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    warningDialogTitle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Restaurant>>,
      Record<string, never>
    >;
    zipCode?: GraphCacheUpdateResolver<Maybe<WithTypename<Restaurant>>, Record<string, never>>;
  };
  RestaurantCapacity?: {
    availableWantedTimes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacity>>,
      Record<string, never>
    >;
    restaurantAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacity>>,
      Record<string, never>
    >;
    restaurantHours?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacity>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacity>>,
      Record<string, never>
    >;
  };
  RestaurantCapacitySlot?: {
    availableLineItems?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacitySlot>>,
      Record<string, never>
    >;
    formatted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacitySlot>>,
      Record<string, never>
    >;
    maxLineItems?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacitySlot>>,
      Record<string, never>
    >;
    original?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantCapacitySlot>>,
      Record<string, never>
    >;
  };
  RestaurantDeliveryChannels?: {
    canEdit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    doorDashMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    foodaMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    grubhubMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    mealPalMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    nativeDeliveryEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    sharebiteMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
    uberEatsMarketplaceEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantDeliveryChannels>>,
      Record<string, never>
    >;
  };
  RestaurantHours?: {
    formatted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantHours>>,
      Record<string, never>
    >;
    permanent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantHours>>,
      Record<string, never>
    >;
    store?: GraphCacheUpdateResolver<Maybe<WithTypename<RestaurantHours>>, Record<string, never>>;
  };
  RestaurantHoursMissing?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantHoursMissing>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantHoursMissing>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantHoursMissing>>,
      Record<string, never>
    >;
  };
  RestaurantIsNotAcceptingOrders?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantIsNotAcceptingOrders>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantIsNotAcceptingOrders>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantIsNotAcceptingOrders>>,
      Record<string, never>
    >;
  };
  RestaurantMaxDeliveryQuantityExceeded?: {
    conflicts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxDeliveryQuantityExceeded>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxDeliveryQuantityExceeded>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxDeliveryQuantityExceeded>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxDeliveryQuantityExceeded>>,
      Record<string, never>
    >;
  };
  RestaurantMaxQuantityExceeded?: {
    conflicts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxQuantityExceeded>>,
      Record<string, never>
    >;
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxQuantityExceeded>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxQuantityExceeded>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantMaxQuantityExceeded>>,
      Record<string, never>
    >;
  };
  RestaurantStoreHours?: {
    day?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantStoreHours>>,
      Record<string, never>
    >;
    end?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantStoreHours>>,
      Record<string, never>
    >;
    start?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantStoreHours>>,
      Record<string, never>
    >;
  };
  RestaurantThrottle?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    brinkLocationToken?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    canEditLevers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<RestaurantThrottle>>, Record<string, never>>;
    date?: GraphCacheUpdateResolver<Maybe<WithTypename<RestaurantThrottle>>, Record<string, never>>;
    kioskThrottlePercentage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    kitchenSiteUid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    latitude?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    levers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    longitude?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    outpostCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    parentId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    phone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    restaurantName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    slots?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    throttleDefaultSize?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    throttleGridEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    timeZone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
    zipCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottle>>,
      Record<string, never>
    >;
  };
  RestaurantThrottleLevers?: {
    channels?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
    largeOrderThresholdPercent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
    maxBuildAheadWindows?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
    maxOrderSize?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
    reservePercent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
    resolvedFromRestaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleLevers>>,
      Record<string, never>
    >;
  };
  RestaurantThrottleSlot?: {
    availableCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    breakdown?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    defaultCapacity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    defaultFilledCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    filledCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    kioskCapacity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    kioskFilledCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    time?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    timeFormatted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
    totalCapacity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RestaurantThrottleSlot>>,
      Record<string, never>
    >;
  };
  Reward?: {
    assetUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    expirationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    isFeatured?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    redeemable?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    redeemableAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    redemptionChannel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Reward>>,
      Record<string, never>
    >;
    rewardType?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
    terms?: GraphCacheUpdateResolver<Maybe<WithTypename<Reward>>, Record<string, never>>;
  };
  RewardNotApplied?: {
    failureCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotApplied>>,
      Record<string, never>
    >;
    failureMetadata?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotApplied>>,
      Record<string, never>
    >;
    failureReasons?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotApplied>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotApplied>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<RewardNotApplied>>, Record<string, never>>;
  };
  RewardNotRemoved?: {
    failureCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotRemoved>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotRemoved>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<RewardNotRemoved>>, Record<string, never>>;
  };
  RewardNotValidated?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotValidated>>,
      Record<string, never>
    >;
    failureCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotValidated>>,
      Record<string, never>
    >;
    failureMetadata?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotValidated>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotValidated>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardNotValidated>>,
      Record<string, never>
    >;
  };
  RewardValidationGeneralError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardValidationGeneralError>>,
      Record<string, never>
    >;
  };
  RewardsPremiumStatus?: {
    expirationDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardsPremiumStatus>>,
      Record<string, never>
    >;
    isActive?: GraphCacheUpdateResolver<
      Maybe<WithTypename<RewardsPremiumStatus>>,
      Record<string, never>
    >;
  };
  SelectedModifier?: {
    cost?: GraphCacheUpdateResolver<Maybe<WithTypename<SelectedModifier>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SelectedModifier>>, Record<string, never>>;
    ingredient?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SelectedModifier>>,
      Record<string, never>
    >;
    modifierType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SelectedModifier>>,
      Record<string, never>
    >;
    parentId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SelectedModifier>>,
      Record<string, never>
    >;
  };
  Session?: {
    cart?: GraphCacheUpdateResolver<Maybe<WithTypename<Session>>, Record<string, never>>;
    csrf?: GraphCacheUpdateResolver<Maybe<WithTypename<Session>>, Record<string, never>>;
    inFlightDeliveryOrderId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<Session>>,
      Record<string, never>
    >;
    inFlightOrderId?: GraphCacheUpdateResolver<Maybe<WithTypename<Session>>, Record<string, never>>;
    isLoggedIn?: GraphCacheUpdateResolver<Maybe<WithTypename<Session>>, Record<string, never>>;
  };
  SignInFailed?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<SignInFailed>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<SignInFailed>>, Record<string, never>>;
  };
  SignInSuccess?: {
    customer?: GraphCacheUpdateResolver<Maybe<WithTypename<SignInSuccess>>, Record<string, never>>;
  };
  StoreOffline?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<StoreOffline>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<StoreOffline>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<StoreOffline>>, Record<string, never>>;
  };
  StripeRefundErrorResponse?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<StripeRefundErrorResponse>>,
      Record<string, never>
    >;
  };
  SubmitGiftCardCodeSuccess?: {
    totalCredit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitGiftCardCodeSuccess>>,
      Record<string, never>
    >;
  };
  SubmitGiftCardOrderError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitGiftCardOrderError>>,
      Record<string, never>
    >;
  };
  SubmitGiftCardOrderPaymentError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitGiftCardOrderPaymentError>>,
      Record<string, never>
    >;
  };
  SubmitOrderUsingPaymentMethodSuccess?: {
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitOrderUsingPaymentMethodSuccess>>,
      Record<string, never>
    >;
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitOrderUsingPaymentMethodSuccess>>,
      Record<string, never>
    >;
  };
  SubmitOrderWithPaymentMethodSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitOrderWithPaymentMethodSuccess>>,
      Record<string, never>
    >;
  };
  SubmitPromoCodeSuccessV2?: {
    placeholder?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubmitPromoCodeSuccessV2>>,
      Record<string, never>
    >;
  };
  SubscriptionCreditCard?: {
    cardType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    expirationMonth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    expirationState?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    expirationYear?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    isActive?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
    lastFour?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionCreditCard>>,
      Record<string, never>
    >;
  };
  SubscriptionPlan?: {
    billingDayOfMonth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    billingFrequency?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    billingFrequencyUnit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    billingRecurrence?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    currencyIsoCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    discounts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    hasFreeTrial?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionPlan>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionPlan>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionPlan>>, Record<string, never>>;
    price?: GraphCacheUpdateResolver<Maybe<WithTypename<SubscriptionPlan>>, Record<string, never>>;
  };
  SubscriptionTransactions?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
    creditCard?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
    date?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
    refund?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
    transactionCreditCard?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SubscriptionTransactions>>,
      Record<string, never>
    >;
  };
  SyncChanges?: {
    additions?: GraphCacheUpdateResolver<Maybe<WithTypename<SyncChanges>>, Record<string, never>>;
    deletions?: GraphCacheUpdateResolver<Maybe<WithTypename<SyncChanges>>, Record<string, never>>;
    updates?: GraphCacheUpdateResolver<Maybe<WithTypename<SyncChanges>>, Record<string, never>>;
  };
  SyncLocationResult?: {
    changes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    childSyncResults?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<SyncLocationResult>>, Record<string, never>>;
    errors?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    isPreview?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    salesforceId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
    syncedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<SyncLocationResult>>,
      Record<string, never>
    >;
  };
  ThrottleSlotBreakdown?: {
    categoryName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ThrottleSlotBreakdown>>,
      Record<string, never>
    >;
    count?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ThrottleSlotBreakdown>>,
      Record<string, never>
    >;
    orderSource?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ThrottleSlotBreakdown>>,
      Record<string, never>
    >;
    orderType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ThrottleSlotBreakdown>>,
      Record<string, never>
    >;
  };
  Tier?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
    nameV2?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
    nextTier?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
    tierGroup?: GraphCacheUpdateResolver<Maybe<WithTypename<Tier>>, Record<string, never>>;
  };
  TierGroup?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TierGroup>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TierGroup>>, Record<string, never>>;
  };
  TierStatus?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TierStatus>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TierStatus>>, Record<string, never>>;
  };
  TimeRestrictionError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TimeRestrictionError>>,
      Record<string, never>
    >;
  };
  TimeslotUnavailable?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TimeslotUnavailable>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TimeslotUnavailable>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TimeslotUnavailable>>,
      Record<string, never>
    >;
  };
  TransactionCreditCard?: {
    cardType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionCreditCard>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionCreditCard>>,
      Record<string, never>
    >;
    lastFour?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionCreditCard>>,
      Record<string, never>
    >;
  };
  TransactionNotFoundError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionNotFoundError>>,
      Record<string, never>
    >;
  };
  TransactionPlan?: {
    amountInCents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionPlan>>,
      Record<string, never>
    >;
    automaticCapture?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionPlan>>,
      Record<string, never>
    >;
    processor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionPlan>>,
      Record<string, never>
    >;
  };
  TransactionPlanResult?: {
    transactionPlan?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TransactionPlanResult>>,
      Record<string, never>
    >;
  };
  TrialEligibility?: {
    duration?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TrialEligibility>>,
      Record<string, never>
    >;
    durationUnit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<TrialEligibility>>,
      Record<string, never>
    >;
  };
  UnableToGetFlexCustomerDataError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnableToGetFlexCustomerDataError>>,
      Record<string, never>
    >;
  };
  UnableToGetGiftCardBalanceError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnableToGetGiftCardBalanceError>>,
      Record<string, never>
    >;
  };
  UnableToRedeemGiftCardError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnableToRedeemGiftCardError>>,
      Record<string, never>
    >;
  };
  UnauthorizedLineItemModification?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedLineItemModification>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedLineItemModification>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedLineItemModification>>,
      Record<string, never>
    >;
  };
  UnauthorizedOrderModification?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedOrderModification>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedOrderModification>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnauthorizedOrderModification>>,
      Record<string, never>
    >;
  };
  UnknownUserError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnknownUserError>>,
      Record<string, never>
    >;
  };
  UnlockOrderFailed?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnlockOrderFailed>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnlockOrderFailed>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnlockOrderFailed>>,
      Record<string, never>
    >;
  };
  UnlockOrderSuccess?: {
    order?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UnlockOrderSuccess>>,
      Record<string, never>
    >;
  };
  UpdateAddressSuccess?: {
    address?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateAddressSuccess>>,
      Record<string, never>
    >;
  };
  UpdateAdminRestaurantAvailabilityResponse?: {
    message?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateAdminRestaurantAvailabilityResponse>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateAdminRestaurantAvailabilityResponse>>,
      Record<string, never>
    >;
    updatedCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateAdminRestaurantAvailabilityResponse>>,
      Record<string, never>
    >;
  };
  UpdateCustomerPreferencesError?: {
    errorMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateCustomerPreferencesError>>,
      Record<string, never>
    >;
  };
  UpdateCustomerResponse?: {
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateCustomerResponse>>,
      Record<string, never>
    >;
  };
  UpdateKioskCustomerResponse?: {
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateKioskCustomerResponse>>,
      Record<string, never>
    >;
  };
  UpdateUseCreditResponse?: {
    customer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpdateUseCreditResponse>>,
      Record<string, never>
    >;
  };
  UpsellCategory?: {
    categoryRanking?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategory>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UpsellCategory>>, Record<string, never>>;
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<UpsellCategory>>, Record<string, never>>;
    products?: GraphCacheUpdateResolver<Maybe<WithTypename<UpsellCategory>>, Record<string, never>>;
    restaurantId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategory>>,
      Record<string, never>
    >;
  };
  UpsellCategoryProduct?: {
    channelCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      UpsellCategoryProductChannelCostArgs
    >;
    cost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
    imageUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
    menuId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
    outOfStock?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UpsellCategoryProduct>>,
      Record<string, never>
    >;
  };
  UserGiftCard?: {
    assetId?: GraphCacheUpdateResolver<Maybe<WithTypename<UserGiftCard>>, Record<string, never>>;
    balance?: GraphCacheUpdateResolver<Maybe<WithTypename<UserGiftCard>>, Record<string, never>>;
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserGiftCard>>, Record<string, never>>;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UserGiftCard>>, Record<string, never>>;
    recipientEmail?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserGiftCard>>,
      Record<string, never>
    >;
    recipientName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserGiftCard>>,
      Record<string, never>
    >;
    redemptionToken?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserGiftCard>>,
      Record<string, never>
    >;
  };
  UserNotificationPreferences?: {
    notificationCategories?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserNotificationPreferences>>,
      Record<string, never>
    >;
  };
  UserOrderPermission?: {
    canApplyRewards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserOrderPermission>>,
      Record<string, never>
    >;
    canSubmitOrder?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserOrderPermission>>,
      Record<string, never>
    >;
    canUpdateOrderDetails?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserOrderPermission>>,
      Record<string, never>
    >;
    isHost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserOrderPermission>>,
      Record<string, never>
    >;
  };
  UserPointsStatus?: {
    available?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserPointsStatus>>,
      Record<string, never>
    >;
    pending?: GraphCacheUpdateResolver<
      Maybe<WithTypename<UserPointsStatus>>,
      Record<string, never>
    >;
    total?: GraphCacheUpdateResolver<Maybe<WithTypename<UserPointsStatus>>, Record<string, never>>;
  };
  ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse?: {
    redemptionToken?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>>,
      Record<string, never>
    >;
    valid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse>>,
      Record<string, never>
    >;
  };
  ValidateRewardFailureMetadata?: {
    requiredChannel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ValidateRewardFailureMetadata>>,
      Record<string, never>
    >;
    requiredDays?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ValidateRewardFailureMetadata>>,
      Record<string, never>
    >;
  };
  ValidationError?: {
    fieldErrors?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ValidationError>>,
      Record<string, never>
    >;
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<ValidationError>>, Record<string, never>>;
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<ValidationError>>, Record<string, never>>;
  };
  Vendor?: {
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Vendor>>, Record<string, never>>;
    restaurantId?: GraphCacheUpdateResolver<Maybe<WithTypename<Vendor>>, Record<string, never>>;
  };
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters;
  keys?: GraphCacheKeysConfig;
  optimistic?: GraphCacheOptimisticUpdaters;
  resolvers?: GraphCacheResolvers;
};
